(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredc87"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredc87"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $bc4b82f252aed4aa$var$n, $bc4b82f252aed4aa$export$41c562ebe57d11e2, $bc4b82f252aed4aa$var$u, $bc4b82f252aed4aa$export$a8257692ac88316c, $bc4b82f252aed4aa$var$i, $bc4b82f252aed4aa$var$o, $bc4b82f252aed4aa$var$r, $bc4b82f252aed4aa$var$f, $bc4b82f252aed4aa$var$e, $bc4b82f252aed4aa$var$c, $bc4b82f252aed4aa$var$s, $bc4b82f252aed4aa$var$a, $bc4b82f252aed4aa$var$h = {}, $bc4b82f252aed4aa$var$v = [], $bc4b82f252aed4aa$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $bc4b82f252aed4aa$var$y = Array.isArray;
function $bc4b82f252aed4aa$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $bc4b82f252aed4aa$var$w(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $bc4b82f252aed4aa$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $bc4b82f252aed4aa$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $bc4b82f252aed4aa$var$g(l, f, i, o, null);
}
function $bc4b82f252aed4aa$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$bc4b82f252aed4aa$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $bc4b82f252aed4aa$export$41c562ebe57d11e2.vnode && $bc4b82f252aed4aa$export$41c562ebe57d11e2.vnode(f), f;
}
function $bc4b82f252aed4aa$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $bc4b82f252aed4aa$export$ffb0004e005737fa(n) {
    return n.children;
}
function $bc4b82f252aed4aa$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $bc4b82f252aed4aa$var$x(n, l) {
    if (null == l) return n.__ ? $bc4b82f252aed4aa$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $bc4b82f252aed4aa$var$x(n) : null;
}
function $bc4b82f252aed4aa$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $bc4b82f252aed4aa$var$C(n);
    }
}
function $bc4b82f252aed4aa$var$M(n) {
    (!n.__d && (n.__d = !0) && $bc4b82f252aed4aa$var$i.push(n) && !$bc4b82f252aed4aa$var$P.__r++ || $bc4b82f252aed4aa$var$o !== $bc4b82f252aed4aa$export$41c562ebe57d11e2.debounceRendering) && (($bc4b82f252aed4aa$var$o = $bc4b82f252aed4aa$export$41c562ebe57d11e2.debounceRendering) || $bc4b82f252aed4aa$var$r)($bc4b82f252aed4aa$var$P);
}
function $bc4b82f252aed4aa$var$P() {
    var n, u, t, o, r, e, c, s;
    for($bc4b82f252aed4aa$var$i.sort($bc4b82f252aed4aa$var$f); n = $bc4b82f252aed4aa$var$i.shift();)n.__d && (u = $bc4b82f252aed4aa$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $bc4b82f252aed4aa$var$d({}, r)).__v = r.__v + 1, $bc4b82f252aed4aa$export$41c562ebe57d11e2.vnode && $bc4b82f252aed4aa$export$41c562ebe57d11e2.vnode(o), $bc4b82f252aed4aa$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $bc4b82f252aed4aa$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $bc4b82f252aed4aa$var$j(c, o, s), o.__e != e && $bc4b82f252aed4aa$var$C(o)), $bc4b82f252aed4aa$var$i.length > u && $bc4b82f252aed4aa$var$i.sort($bc4b82f252aed4aa$var$f));
    $bc4b82f252aed4aa$var$P.__r = 0;
}
function $bc4b82f252aed4aa$var$S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, w, _ = t && t.__k || $bc4b82f252aed4aa$var$v, g = l.length;
    for(u.__d = e, $bc4b82f252aed4aa$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && (p = -1 === y.__i ? $bc4b82f252aed4aa$var$h : _[y.__i] || $bc4b82f252aed4aa$var$h, y.__i = a, $bc4b82f252aed4aa$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $bc4b82f252aed4aa$var$N(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || p.__k === y.__k ? e = $bc4b82f252aed4aa$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $bc4b82f252aed4aa$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = l[t]) && "boolean" != typeof i && "function" != typeof i ? (r = t + a, (i = n.__k[t] = "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $bc4b82f252aed4aa$var$g(null, i, null, null, null) : $bc4b82f252aed4aa$var$y(i) ? $bc4b82f252aed4aa$var$g($bc4b82f252aed4aa$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $bc4b82f252aed4aa$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i).__ = n, i.__b = n.__b + 1, o = null, -1 !== (f = i.__i = $bc4b82f252aed4aa$var$L(i, u, r, s)) && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : (f > r ? a-- : a++, i.__u |= 65536))) : i = n.__k[t] = null;
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $bc4b82f252aed4aa$var$x(o)), $bc4b82f252aed4aa$var$V(o, o));
}
function $bc4b82f252aed4aa$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $bc4b82f252aed4aa$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $bc4b82f252aed4aa$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $bc4b82f252aed4aa$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($bc4b82f252aed4aa$var$y(n) ? n.some(function(n) {
        $bc4b82f252aed4aa$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $bc4b82f252aed4aa$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $bc4b82f252aed4aa$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $bc4b82f252aed4aa$var$p.test(l) ? u : u + "px";
}
function $bc4b82f252aed4aa$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $bc4b82f252aed4aa$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $bc4b82f252aed4aa$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $bc4b82f252aed4aa$var$e, n.addEventListener(l, o ? $bc4b82f252aed4aa$var$s : $bc4b82f252aed4aa$var$c, o)) : n.removeEventListener(l, o ? $bc4b82f252aed4aa$var$s : $bc4b82f252aed4aa$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $bc4b82f252aed4aa$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $bc4b82f252aed4aa$var$e++;
            else if (u.t < t.u) return;
            return t($bc4b82f252aed4aa$export$41c562ebe57d11e2.event ? $bc4b82f252aed4aa$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $bc4b82f252aed4aa$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $bc4b82f252aed4aa$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new $bc4b82f252aed4aa$export$16fa2f45be04daa8(m, M), h.constructor = T, h.render = $bc4b82f252aed4aa$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $bc4b82f252aed4aa$var$d({}, h.__s)), $bc4b82f252aed4aa$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), p = h.props, w = h.state, h.__v = u, v) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = $bc4b82f252aed4aa$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $bc4b82f252aed4aa$var$d($bc4b82f252aed4aa$var$d({}, i), h.getChildContext())), x && !v && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(p, w)), $bc4b82f252aed4aa$var$S(n, $bc4b82f252aed4aa$var$y(L = null != a && a.type === $bc4b82f252aed4aa$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 32; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $bc4b82f252aed4aa$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $bc4b82f252aed4aa$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $bc4b82f252aed4aa$export$41c562ebe57d11e2.diffed) && a(u);
}
function $bc4b82f252aed4aa$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$bc4b82f252aed4aa$var$N(t[i], t[++i], t[++i]);
    $bc4b82f252aed4aa$export$41c562ebe57d11e2.__c && $bc4b82f252aed4aa$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $bc4b82f252aed4aa$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $bc4b82f252aed4aa$var$z(u, t, i, o, r, f, e, c, s) {
    var a, v, p, d, _, g, m, b = i.props, k = t.props, C = t.type;
    if ("svg" === C ? r = "http://www.w3.org/2000/svg" : "math" === C ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != f) {
        for(a = 0; a < f.length; a++)if ((_ = f[a]) && "setAttribute" in _ == !!C && (C ? _.localName === C : 3 === _.nodeType)) {
            u = _, f[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null === C) return document.createTextNode(k);
        u = document.createElementNS(r, C, k.is && k), c && ($bc4b82f252aed4aa$export$41c562ebe57d11e2.__m && $bc4b82f252aed4aa$export$41c562ebe57d11e2.__m(t, f), c = !1), f = null;
    }
    if (null === C) b === k || c && u.data === k || (u.data = k);
    else {
        if (f = f && $bc4b82f252aed4aa$var$n.call(u.childNodes), b = i.props || $bc4b82f252aed4aa$var$h, !c && null != f) for(b = {}, a = 0; a < u.attributes.length; a++)b[(_ = u.attributes[a]).name] = _.value;
        for(a in b)if (_ = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) p = _;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $bc4b82f252aed4aa$var$A(u, a, null, _, r);
        }
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? m = _ : c && "function" != typeof _ || b[a] === _ || $bc4b82f252aed4aa$var$A(u, a, _, b[a], r);
        if (v) c || p && (v.__html === p.__html || v.__html === u.innerHTML) || (u.innerHTML = v.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $bc4b82f252aed4aa$var$S(u, $bc4b82f252aed4aa$var$y(d) ? d : [
            d
        ], t, i, o, "foreignObject" === C ? "http://www.w3.org/1999/xhtml" : r, f, e, f ? f[0] : i.__k && $bc4b82f252aed4aa$var$x(i, 0), c, s), null != f) for(a = f.length; a--;)$bc4b82f252aed4aa$var$w(f[a]);
        c || (a = "value", "progress" === C && null == g ? u.removeAttribute("value") : void 0 !== g && (g !== u[a] || "progress" === C && !g || "option" === C && g !== b[a]) && $bc4b82f252aed4aa$var$A(u, a, g, b[a], r), a = "checked", void 0 !== m && m !== u[a] && $bc4b82f252aed4aa$var$A(u, a, m, b[a], r));
    }
    return u;
}
function $bc4b82f252aed4aa$var$N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $bc4b82f252aed4aa$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $bc4b82f252aed4aa$var$V(n, u, t) {
    var i, o;
    if ($bc4b82f252aed4aa$export$41c562ebe57d11e2.unmount && $bc4b82f252aed4aa$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $bc4b82f252aed4aa$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $bc4b82f252aed4aa$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $bc4b82f252aed4aa$var$V(i[o], u, t || "function" != typeof n.type);
    t || $bc4b82f252aed4aa$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $bc4b82f252aed4aa$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $bc4b82f252aed4aa$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $bc4b82f252aed4aa$export$41c562ebe57d11e2.__ && $bc4b82f252aed4aa$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $bc4b82f252aed4aa$var$O(t, u = (!o && i || t).__k = $bc4b82f252aed4aa$export$c8a8987d4410bf2d($bc4b82f252aed4aa$export$ffb0004e005737fa, null, [
        u
    ]), r || $bc4b82f252aed4aa$var$h, $bc4b82f252aed4aa$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $bc4b82f252aed4aa$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $bc4b82f252aed4aa$var$j(f, u, e);
}
function $bc4b82f252aed4aa$export$fa8d919ba61d84db(n, l) {
    $bc4b82f252aed4aa$export$b3890eb0ae9dca99(n, l, $bc4b82f252aed4aa$export$fa8d919ba61d84db);
}
function $bc4b82f252aed4aa$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $bc4b82f252aed4aa$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $bc4b82f252aed4aa$var$n.call(arguments, 2) : t), $bc4b82f252aed4aa$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $bc4b82f252aed4aa$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $bc4b82f252aed4aa$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $bc4b82f252aed4aa$var$M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$bc4b82f252aed4aa$var$n = $bc4b82f252aed4aa$var$v.slice, $bc4b82f252aed4aa$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $bc4b82f252aed4aa$var$u = 0, $bc4b82f252aed4aa$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $bc4b82f252aed4aa$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $bc4b82f252aed4aa$var$d({}, this.state), "function" == typeof n && (n = n($bc4b82f252aed4aa$var$d({}, u), this.props)), n && $bc4b82f252aed4aa$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $bc4b82f252aed4aa$var$M(this));
}, $bc4b82f252aed4aa$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $bc4b82f252aed4aa$var$M(this));
}, $bc4b82f252aed4aa$export$16fa2f45be04daa8.prototype.render = $bc4b82f252aed4aa$export$ffb0004e005737fa, $bc4b82f252aed4aa$var$i = [], $bc4b82f252aed4aa$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $bc4b82f252aed4aa$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $bc4b82f252aed4aa$var$P.__r = 0, $bc4b82f252aed4aa$var$e = 0, $bc4b82f252aed4aa$var$c = $bc4b82f252aed4aa$var$F(!1), $bc4b82f252aed4aa$var$s = $bc4b82f252aed4aa$var$F(!0), $bc4b82f252aed4aa$var$a = 0;



const $965d8b034b5a035b$var$alert = {
    remove: (id)=>document.getElementById(id).outerHTML = "",
    add: (text, alertStyle = "alert-success", countdown = 5000)=>{
        if (!text) return;
        let alertNode = document.createElement("DIV");
        alertNode.id = $965d8b034b5a035b$var$alert.hash(text);
        alertNode.innerHTML = text;
        alertNode.classList.add("global-alert", "alert", alertStyle);
        document.body.appendChild(alertNode);
        setTimeout(()=>$965d8b034b5a035b$var$alert.remove(alertNode.id), countdown);
    },
    hash: (str)=>{
        let hash = 0;
        if (str.length == 0) return hash;
        for(let i = 0; i < str.length; i++){
            let char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
};
var $965d8b034b5a035b$export$2e2bcd8739ae039 = $965d8b034b5a035b$var$alert;



const $15bf00c5a9ebafaa$var$storage = {
    usage: ()=>{
        let total = 0;
        let k;
        for(k in localStorage)if (Object.prototype.hasOwnProperty.call(localStorage, k)) total += (localStorage[k].length + k.length) * 2;
        return total;
    },
    createStorageBox: (data, metadata = null)=>({
            data: data,
            createdAt: Date.now(),
            metadata: metadata
        }),
    remove: (id)=>localStorage.removeItem(id),
    set: (id, data, metadata = null)=>{
        localStorage.setItem(id, JSON.stringify($15bf00c5a9ebafaa$var$storage.createStorageBox(data, metadata)));
        return Promise.resolve(id);
    },
    get: (id)=>{
        let data = localStorage.getItem(id);
        if (data != null) {
            data = JSON.parse(data);
            if (Object.prototype.hasOwnProperty.call(data, "data")) return new Promise((r)=>r(data.data));
        }
        return new Promise((r)=>r(null));
    },
    reset: ()=>localStorage.clear() && window.dispatchEvent(new CustomEvent("resetStorage"))
};
var $15bf00c5a9ebafaa$export$2e2bcd8739ae039 = $15bf00c5a9ebafaa$var$storage;




let $491ff7c3dd9b8d76$export$5f80af4e66cab974 = (modules)=>{
    let events = {};
    let state = {};
    let store = {
        dispatch (event, data) {
            if (event !== "@dispatch") store.dispatch("@dispatch", [
                event,
                data,
                events[event]
            ]);
            if (events[event]) {
                let changes;
                events[event].forEach((i)=>{
                    let diff = events[event].includes(i) && i(state, data, store);
                    if (diff && typeof diff.then !== "function") {
                        state = {
                            ...state,
                            ...diff
                        };
                        changes = {
                            ...changes,
                            ...diff
                        };
                    }
                });
                if (changes) store.dispatch("@changed", changes);
            }
        },
        get: ()=>state,
        on (event, cb) {
            (events[event] || (events[event] = [])).push(cb);
            return ()=>{
                events[event] = events[event].filter((i)=>i !== cb);
            };
        }
    };
    modules.forEach((i)=>{
        if (i) i(store);
    });
    store.dispatch("@init");
    return store;
};


//import { http } from "/src/core";
const $35d12cd49d83bbb5$export$bd17ce0bf3001bf8 = (store)=>{
    store.on("@init", ()=>({
            me: {}
        }));
    store.on("me/update", (state, me)=>{
        return {
            me: me
        };
    });
};


const $5b06cd5848fcf3de$export$10417fa5fd48c90a = (store)=>{
    store.on("@init", ()=>({
            api: {}
        }));
    store.on("api/update", (state, api)=>{
        return {
            api: api
        };
    });
};


const $fe332474b2073912$export$1a062524560abcaa = (store)=>{
    store.on("@init", ()=>({
            route: "",
            id: "",
            action: "",
            backUrl: "",
            entityType: "",
            search: "",
            entity: {}
        }));
    store.on("router/update", (_, newState)=>{
        return {
            entity: newState.entity,
            backUrl: newState.backUrl
        };
    });
};


const $466d4c407aaa4ef8$export$21b66e234e71aa95 = (store)=>{
    store.on("@init", ()=>({
            notifications: []
        }));
    store.on("notifications/update", (state, notifications = [])=>{
        return {
            notifications: notifications
        };
    });
    store.on("notifications/remove", (state, notification)=>{
        return {
            notifications: state.notifications.filter((n)=>n.id != notification.id)
        };
    });
    store.on("notifications/read", (state, notification)=>{
        return {
            notifications: state.notifications.map((n)=>n.id === notification.id ? Object.assign(n, {
                    read: true
                }) : n)
        };
    });
};



const $cc0bd27b7507f491$export$336a589663e3f2e0 = (store)=>{
    store.on("@init", ()=>({
            bookmarks: []
        }));
    store.on("bookmarks/update", (state, bookmarks = [])=>{
        return {
            bookmarks: bookmarks
        };
    });
    store.on("bookmark/remove", (state, bookmark)=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).delete(`/api/bookmarks/${bookmark.id}`);
        return {
            bookmarks: state.bookmarks.filter((b)=>b.id != bookmark.id)
        };
    });
    store.on("bookmark/add", (state, message_id)=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post("/api/bookmarks", {
            message_id: message_id
        }).then((bookmark)=>{
            store.dispatch("bookmarks/update", [
                ...state.bookmarks,
                bookmark
            ]);
        });
    });
};


const $5e4e939c48db0130$var$store = (0, $491ff7c3dd9b8d76$export$5f80af4e66cab974)([
    (0, $5b06cd5848fcf3de$export$10417fa5fd48c90a),
    (0, $35d12cd49d83bbb5$export$bd17ce0bf3001bf8),
    (0, $fe332474b2073912$export$1a062524560abcaa),
    (0, $466d4c407aaa4ef8$export$21b66e234e71aa95),
    (0, $cc0bd27b7507f491$export$336a589663e3f2e0)
]);
var $5e4e939c48db0130$export$2e2bcd8739ae039 = $5e4e939c48db0130$var$store;


const $d7301ad24121e92e$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $d7301ad24121e92e$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $d7301ad24121e92e$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $d7301ad24121e92e$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $d7301ad24121e92e$var$Logger(this.logger, options);
    }
}
var $d7301ad24121e92e$var$baseLogger = new $d7301ad24121e92e$var$Logger();
class $d7301ad24121e92e$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = Array.from(this.observers["*"].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
const $d7301ad24121e92e$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $d7301ad24121e92e$var$makeString = (object)=>{
    if (object == null) return "";
    return "" + object;
};
const $d7301ad24121e92e$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $d7301ad24121e92e$var$lastOfPathSeparatorRegExp = /###/g;
const $d7301ad24121e92e$var$cleanKey = (key)=>key && key.indexOf("###") > -1 ? key.replace($d7301ad24121e92e$var$lastOfPathSeparatorRegExp, ".") : key;
const $d7301ad24121e92e$var$canNotTraverseDeeper = (object)=>!object || typeof object === "string";
const $d7301ad24121e92e$var$getLastOfPath = (object, path, Empty)=>{
    const stack = typeof path !== "string" ? path : path.split(".");
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($d7301ad24121e92e$var$canNotTraverseDeeper(object)) return {};
        const key = $d7301ad24121e92e$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($d7301ad24121e92e$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $d7301ad24121e92e$var$cleanKey(stack[stackIndex])
    };
};
const $d7301ad24121e92e$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $d7301ad24121e92e$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $d7301ad24121e92e$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $d7301ad24121e92e$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $d7301ad24121e92e$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $d7301ad24121e92e$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $d7301ad24121e92e$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $d7301ad24121e92e$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $d7301ad24121e92e$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $d7301ad24121e92e$var$getPath(data, key);
    if (value !== undefined) return value;
    return $d7301ad24121e92e$var$getPath(defaultData, key);
};
const $d7301ad24121e92e$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $d7301ad24121e92e$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $d7301ad24121e92e$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var $d7301ad24121e92e$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
const $d7301ad24121e92e$var$escape = (data)=>{
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$d7301ad24121e92e$var$_entityMap[s]);
    return data;
};
class $d7301ad24121e92e$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $d7301ad24121e92e$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
const $d7301ad24121e92e$var$looksLikeObjectPathRegExpCache = new $d7301ad24121e92e$var$RegExpCache(20);
const $d7301ad24121e92e$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $d7301ad24121e92e$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $d7301ad24121e92e$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $d7301ad24121e92e$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== "object") return undefined;
        let next;
        let nextPath = "";
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    "string",
                    "number",
                    "boolean"
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $d7301ad24121e92e$var$getCleanedCode = (code)=>code && code.replace("_", "-");
class $d7301ad24121e92e$var$ResourceStore extends $d7301ad24121e92e$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf(".") > -1) path = lng.split(".");
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (typeof key === "string" && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $d7301ad24121e92e$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf(".") > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join(".");
        }
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $d7301ad24121e92e$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $d7301ad24121e92e$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $d7301ad24121e92e$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $d7301ad24121e92e$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $d7301ad24121e92e$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $d7301ad24121e92e$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $d7301ad24121e92e$var$checkedLoadedFor = {};
class $d7301ad24121e92e$var$Translator extends $d7301ad24121e92e$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $d7301ad24121e92e$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $d7301ad24121e92e$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$d7301ad24121e92e$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $d7301ad24121e92e$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $d7301ad24121e92e$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$d7301ad24121e92e$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $d7301ad24121e92e$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
const $d7301ad24121e92e$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class $d7301ad24121e92e$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $d7301ad24121e92e$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $d7301ad24121e92e$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $d7301ad24121e92e$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            if (typeof Intl !== "undefined" && typeof Intl.getCanonicalLocales !== "undefined") try {
                let formattedCode = Intl.getCanonicalLocales(code)[0];
                if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                if (formattedCode) return formattedCode;
            } catch (e) {}
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $d7301ad24121e92e$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $d7301ad24121e92e$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $d7301ad24121e92e$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $d7301ad24121e92e$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $d7301ad24121e92e$var$_rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const $d7301ad24121e92e$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $d7301ad24121e92e$var$intlVersions = [
    "v4"
];
const $d7301ad24121e92e$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $d7301ad24121e92e$var$createRules = ()=>{
    const rules = {};
    $d7301ad24121e92e$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $d7301ad24121e92e$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class $d7301ad24121e92e$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $d7301ad24121e92e$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $d7301ad24121e92e$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $d7301ad24121e92e$var$createRules();
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            const cleanedCode = $d7301ad24121e92e$var$getCleanedCode(code === "dev" ? "en" : code);
            const type = options.ordinal ? "ordinal" : "cardinal";
            const cacheKey = JSON.stringify({
                cleanedCode: cleanedCode,
                type: type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            const rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$d7301ad24121e92e$var$suffixesOrder[pluralCategory1] - $d7301ad24121e92e$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$d7301ad24121e92e$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
const $d7301ad24121e92e$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $d7301ad24121e92e$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $d7301ad24121e92e$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $d7301ad24121e92e$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $d7301ad24121e92e$var$regexSafe = (val)=>val.replace(/\$/g, "$$$$");
class $d7301ad24121e92e$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $d7301ad24121e92e$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $d7301ad24121e92e$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $d7301ad24121e92e$var$regexEscape(prefix) : prefixEscaped || "{{";
        this.suffix = suffix ? $d7301ad24121e92e$var$regexEscape(suffix) : suffixEscaped || "}}";
        this.formatSeparator = formatSeparator || ",";
        this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
        this.nestingPrefix = nestingPrefix ? $d7301ad24121e92e$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $d7301ad24121e92e$var$regexEscape("$t(");
        this.nestingSuffix = nestingSuffix ? $d7301ad24121e92e$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $d7301ad24121e92e$var$regexEscape(")");
        this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, "g");
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $d7301ad24121e92e$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($d7301ad24121e92e$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$d7301ad24121e92e$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $d7301ad24121e92e$var$regexSafe(this.escape(val)) : $d7301ad24121e92e$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $d7301ad24121e92e$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $d7301ad24121e92e$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $d7301ad24121e92e$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(":");
                    const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === "false") formatOptions[trimmedKey] = false;
                    if (val === "true") formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $d7301ad24121e92e$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($d7301ad24121e92e$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $d7301ad24121e92e$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $d7301ad24121e92e$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $d7301ad24121e92e$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $d7301ad24121e92e$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $d7301ad24121e92e$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $d7301ad24121e92e$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $d7301ad24121e92e$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $d7301ad24121e92e$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf("(") > 1 && formats[0].indexOf(")") < 0 && formats.find((f)=>f.indexOf(")") > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(")") > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $d7301ad24121e92e$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $d7301ad24121e92e$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $d7301ad24121e92e$var$Connector extends $d7301ad24121e92e$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $d7301ad24121e92e$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $d7301ad24121e92e$var$pushPath(q.loaded, [
                lng
            ], ns);
            $d7301ad24121e92e$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $d7301ad24121e92e$var$get = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $d7301ad24121e92e$var$transformOptions = (options)=>{
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
};
const $d7301ad24121e92e$var$noop = ()=>{};
const $d7301ad24121e92e$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
};
class $d7301ad24121e92e$var$I18n extends $d7301ad24121e92e$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $d7301ad24121e92e$var$transformOptions(options);
        this.services = {};
        this.logger = $d7301ad24121e92e$var$baseLogger;
        this.modules = {
            external: []
        };
        $d7301ad24121e92e$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $d7301ad24121e92e$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$d7301ad24121e92e$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $d7301ad24121e92e$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $d7301ad24121e92e$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $d7301ad24121e92e$var$Formatter;
            const lu = new $d7301ad24121e92e$var$LanguageUtil(this.options);
            this.store = new $d7301ad24121e92e$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $d7301ad24121e92e$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $d7301ad24121e92e$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $d7301ad24121e92e$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $d7301ad24121e92e$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $d7301ad24121e92e$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $d7301ad24121e92e$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $d7301ad24121e92e$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d7301ad24121e92e$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $d7301ad24121e92e$var$defer();
        if (typeof lngs === "function") {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === "function") {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $d7301ad24121e92e$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $d7301ad24121e92e$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $d7301ad24121e92e$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== "") options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $d7301ad24121e92e$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $d7301ad24121e92e$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $d7301ad24121e92e$var$LanguageUtil($d7301ad24121e92e$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $d7301ad24121e92e$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d7301ad24121e92e$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $d7301ad24121e92e$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $d7301ad24121e92e$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $d7301ad24121e92e$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $d7301ad24121e92e$export$2e2bcd8739ae039 = $d7301ad24121e92e$var$I18n.createInstance();
$d7301ad24121e92e$export$2e2bcd8739ae039.createInstance = $d7301ad24121e92e$var$I18n.createInstance;
const $d7301ad24121e92e$export$99152e8d49ca4e7d = $d7301ad24121e92e$export$2e2bcd8739ae039.createInstance;
const $d7301ad24121e92e$export$147ec2801e896265 = $d7301ad24121e92e$export$2e2bcd8739ae039.dir;
const $d7301ad24121e92e$export$2cd8252107eb640b = $d7301ad24121e92e$export$2e2bcd8739ae039.init;
const $d7301ad24121e92e$export$d3d08d944062d7e = $d7301ad24121e92e$export$2e2bcd8739ae039.loadResources;
const $d7301ad24121e92e$export$a5d9bf5d83fcab09 = $d7301ad24121e92e$export$2e2bcd8739ae039.reloadResources;
const $d7301ad24121e92e$export$1f96ae73734a86cc = $d7301ad24121e92e$export$2e2bcd8739ae039.use;
const $d7301ad24121e92e$export$61465194746e7fd2 = $d7301ad24121e92e$export$2e2bcd8739ae039.changeLanguage;
const $d7301ad24121e92e$export$f90d180fc7da3b3b = $d7301ad24121e92e$export$2e2bcd8739ae039.getFixedT;
const $d7301ad24121e92e$export$625550452a3fa3ec = $d7301ad24121e92e$export$2e2bcd8739ae039.t;
const $d7301ad24121e92e$export$f7e9f41ea797a17 = $d7301ad24121e92e$export$2e2bcd8739ae039.exists;
const $d7301ad24121e92e$export$2b4b218e406d2d00 = $d7301ad24121e92e$export$2e2bcd8739ae039.setDefaultNamespace;
const $d7301ad24121e92e$export$93d9ee97c1ad3f31 = $d7301ad24121e92e$export$2e2bcd8739ae039.hasLoadedNamespace;
const $d7301ad24121e92e$export$83be934b53fff43b = $d7301ad24121e92e$export$2e2bcd8739ae039.loadNamespaces;
const $d7301ad24121e92e$export$8cd7e7a54fa865bc = $d7301ad24121e92e$export$2e2bcd8739ae039.loadLanguages;


const $1747d3542bece520$var$me = {
    get () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.me;
    },
    get data () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.me?.data;
    },
    get lang () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.me?.data?.lang;
    },
    get groups () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.me?.groups;
    },
    get id () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.me?.id;
    },
    get avatar () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.me?.avatar;
    },
    getGroupName (id) {
        let group = (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()["groups"]?.find((g)=>g["id"] == id);
        return group ? group["name"] : "";
    },
    update () {
        return (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).get("/api/me", true).then((r)=>{
            if (!r || !r?.id) {
                (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("update", {});
                return;
            }
            Promise.all(r.groups.map((g)=>(0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).get(`/api/groups/${g.id}`).then((group)=>group))).then((groups)=>{
                r.groups = groups;
                (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("me/update", Object.assign({
                    loaded: true
                }, r));
            });
            (0, $d7301ad24121e92e$export$2e2bcd8739ae039).changeLanguage(r?.data?.lang);
            return r;
        });
    },
    fetch () {
        if ((0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()["loaded"]) return new Promise((r)=>r((0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()));
        return $1747d3542bece520$var$me.update();
    },
    reset () {
        (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("@init");
    },
    logout () {
        (0, $15bf00c5a9ebafaa$export$2e2bcd8739ae039).reset();
    }
};
var $1747d3542bece520$export$2e2bcd8739ae039 = $1747d3542bece520$var$me;



var $c9d322eeb636f8e5$exports = {};

$parcel$defineInteropFlag($c9d322eeb636f8e5$exports);

$parcel$export($c9d322eeb636f8e5$exports, "PureComponent", function () { return $c9d322eeb636f8e5$export$221d75b3f55bb0bd; });
$parcel$export($c9d322eeb636f8e5$exports, "memo", function () { return $c9d322eeb636f8e5$export$7c73462e0d25e514; });
$parcel$export($c9d322eeb636f8e5$exports, "forwardRef", function () { return $c9d322eeb636f8e5$export$257a8862b851cb5b; });
$parcel$export($c9d322eeb636f8e5$exports, "Children", function () { return $c9d322eeb636f8e5$export$dca3b0875bd9a954; });
$parcel$export($c9d322eeb636f8e5$exports, "Suspense", function () { return $c9d322eeb636f8e5$export$74bf444e3cd11ea5; });
$parcel$export($c9d322eeb636f8e5$exports, "lazy", function () { return $c9d322eeb636f8e5$export$488013bae63b21da; });
$parcel$export($c9d322eeb636f8e5$exports, "SuspenseList", function () { return $c9d322eeb636f8e5$export$998bcd577473dd93; });
$parcel$export($c9d322eeb636f8e5$exports, "createPortal", function () { return $c9d322eeb636f8e5$export$d39a5bbd09211389; });
$parcel$export($c9d322eeb636f8e5$exports, "render", function () { return $c9d322eeb636f8e5$export$b3890eb0ae9dca99; });
$parcel$export($c9d322eeb636f8e5$exports, "hydrate", function () { return $c9d322eeb636f8e5$export$fa8d919ba61d84db; });
$parcel$export($c9d322eeb636f8e5$exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c9d322eeb636f8e5$export$ae55be85d98224ed; });
$parcel$export($c9d322eeb636f8e5$exports, "useDeferredValue", function () { return $c9d322eeb636f8e5$export$6a7bc4e911dc01cf; });
$parcel$export($c9d322eeb636f8e5$exports, "useInsertionEffect", function () { return $c9d322eeb636f8e5$export$aaabe4eda9ed9969; });
$parcel$export($c9d322eeb636f8e5$exports, "useSyncExternalStore", function () { return $c9d322eeb636f8e5$export$306c0aa65ff9ec16; });
$parcel$export($c9d322eeb636f8e5$exports, "useTransition", function () { return $c9d322eeb636f8e5$export$7b286972b8d8ccbf; });
$parcel$export($c9d322eeb636f8e5$exports, "version", function () { return $c9d322eeb636f8e5$export$83d89fbfd8236492; });
$parcel$export($c9d322eeb636f8e5$exports, "createFactory", function () { return $c9d322eeb636f8e5$export$d38cd72104c1f0e9; });
$parcel$export($c9d322eeb636f8e5$exports, "isValidElement", function () { return $c9d322eeb636f8e5$export$a8257692ac88316c; });
$parcel$export($c9d322eeb636f8e5$exports, "isFragment", function () { return $c9d322eeb636f8e5$export$9522e17588c12572; });
$parcel$export($c9d322eeb636f8e5$exports, "isMemo", function () { return $c9d322eeb636f8e5$export$56885ab8b9c456ab; });
$parcel$export($c9d322eeb636f8e5$exports, "cloneElement", function () { return $c9d322eeb636f8e5$export$e530037191fcd5d7; });
$parcel$export($c9d322eeb636f8e5$exports, "unmountComponentAtNode", function () { return $c9d322eeb636f8e5$export$502457920280e6be; });
$parcel$export($c9d322eeb636f8e5$exports, "findDOMNode", function () { return $c9d322eeb636f8e5$export$466bfc07425424d5; });
$parcel$export($c9d322eeb636f8e5$exports, "unstable_batchedUpdates", function () { return $c9d322eeb636f8e5$export$c78a37762a8d58e1; });
$parcel$export($c9d322eeb636f8e5$exports, "flushSync", function () { return $c9d322eeb636f8e5$export$cd75ccfd720a3cd4; });
$parcel$export($c9d322eeb636f8e5$exports, "StrictMode", function () { return $c9d322eeb636f8e5$export$5f8d39834fd61797; });
$parcel$export($c9d322eeb636f8e5$exports, "startTransition", function () { return $c9d322eeb636f8e5$export$7568632d0d33d16d; });
$parcel$export($c9d322eeb636f8e5$exports, "isElement", function () { return $c9d322eeb636f8e5$export$45a5e7f76e0caa8d; });
$parcel$export($c9d322eeb636f8e5$exports, "default", function () { return $c9d322eeb636f8e5$export$2e2bcd8739ae039; });
$parcel$export($c9d322eeb636f8e5$exports, "Component", function () { return $bc4b82f252aed4aa$export$16fa2f45be04daa8; });
$parcel$export($c9d322eeb636f8e5$exports, "Fragment", function () { return $bc4b82f252aed4aa$export$ffb0004e005737fa; });
$parcel$export($c9d322eeb636f8e5$exports, "createContext", function () { return $bc4b82f252aed4aa$export$fd42f52fd3ae1109; });
$parcel$export($c9d322eeb636f8e5$exports, "createElement", function () { return $bc4b82f252aed4aa$export$c8a8987d4410bf2d; });
$parcel$export($c9d322eeb636f8e5$exports, "createRef", function () { return $bc4b82f252aed4aa$export$7d1e3a5e95ceca43; });

var $35130c2d97e6777b$exports = {};

$parcel$export($35130c2d97e6777b$exports, "useState", function () { return $35130c2d97e6777b$export$60241385465d0a34; });
$parcel$export($35130c2d97e6777b$exports, "useReducer", function () { return $35130c2d97e6777b$export$13e3392192263954; });
$parcel$export($35130c2d97e6777b$exports, "useEffect", function () { return $35130c2d97e6777b$export$6d9c69b0de29b591; });
$parcel$export($35130c2d97e6777b$exports, "useLayoutEffect", function () { return $35130c2d97e6777b$export$e5c5a5f917a5871c; });
$parcel$export($35130c2d97e6777b$exports, "useRef", function () { return $35130c2d97e6777b$export$b8f5890fc79d6aca; });
$parcel$export($35130c2d97e6777b$exports, "useMemo", function () { return $35130c2d97e6777b$export$1538c33de8887b59; });
$parcel$export($35130c2d97e6777b$exports, "useImperativeHandle", function () { return $35130c2d97e6777b$export$d5a552a76deda3c2; });
$parcel$export($35130c2d97e6777b$exports, "useCallback", function () { return $35130c2d97e6777b$export$35808ee640e87ca7; });
$parcel$export($35130c2d97e6777b$exports, "useContext", function () { return $35130c2d97e6777b$export$fae74005e78b1a27; });
$parcel$export($35130c2d97e6777b$exports, "useDebugValue", function () { return $35130c2d97e6777b$export$dc8fbce3eb94dc1e; });
$parcel$export($35130c2d97e6777b$exports, "useErrorBoundary", function () { return $35130c2d97e6777b$export$c052f6604b7d51fe; });
$parcel$export($35130c2d97e6777b$exports, "useId", function () { return $35130c2d97e6777b$export$f680877a34711e37; });

var $35130c2d97e6777b$var$t, $35130c2d97e6777b$var$r, $35130c2d97e6777b$var$u, $35130c2d97e6777b$var$i, $35130c2d97e6777b$var$o = 0, $35130c2d97e6777b$var$f = [], $35130c2d97e6777b$var$c = (0, $bc4b82f252aed4aa$export$41c562ebe57d11e2), $35130c2d97e6777b$var$e = $35130c2d97e6777b$var$c.__b, $35130c2d97e6777b$var$a = $35130c2d97e6777b$var$c.__r, $35130c2d97e6777b$var$v = $35130c2d97e6777b$var$c.diffed, $35130c2d97e6777b$var$l = $35130c2d97e6777b$var$c.__c, $35130c2d97e6777b$var$m = $35130c2d97e6777b$var$c.unmount, $35130c2d97e6777b$var$s = $35130c2d97e6777b$var$c.__;
function $35130c2d97e6777b$var$d(n, t) {
    $35130c2d97e6777b$var$c.__h && $35130c2d97e6777b$var$c.__h($35130c2d97e6777b$var$r, n, $35130c2d97e6777b$var$o || t), $35130c2d97e6777b$var$o = 0;
    var u = $35130c2d97e6777b$var$r.__H || ($35130c2d97e6777b$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $35130c2d97e6777b$export$60241385465d0a34(n) {
    return $35130c2d97e6777b$var$o = 1, $35130c2d97e6777b$export$13e3392192263954($35130c2d97e6777b$var$D, n);
}
function $35130c2d97e6777b$export$13e3392192263954(n, u, i) {
    var o = $35130c2d97e6777b$var$d($35130c2d97e6777b$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $35130c2d97e6777b$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $35130c2d97e6777b$var$r, !$35130c2d97e6777b$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $35130c2d97e6777b$var$r.u = !0;
        var c = $35130c2d97e6777b$var$r.shouldComponentUpdate, e = $35130c2d97e6777b$var$r.componentWillUpdate;
        $35130c2d97e6777b$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $35130c2d97e6777b$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $35130c2d97e6777b$export$6d9c69b0de29b591(n, u) {
    var i = $35130c2d97e6777b$var$d($35130c2d97e6777b$var$t++, 3);
    !$35130c2d97e6777b$var$c.__s && $35130c2d97e6777b$var$C(i.__H, u) && (i.__ = n, i.i = u, $35130c2d97e6777b$var$r.__H.__h.push(i));
}
function $35130c2d97e6777b$export$e5c5a5f917a5871c(n, u) {
    var i = $35130c2d97e6777b$var$d($35130c2d97e6777b$var$t++, 4);
    !$35130c2d97e6777b$var$c.__s && $35130c2d97e6777b$var$C(i.__H, u) && (i.__ = n, i.i = u, $35130c2d97e6777b$var$r.__h.push(i));
}
function $35130c2d97e6777b$export$b8f5890fc79d6aca(n) {
    return $35130c2d97e6777b$var$o = 5, $35130c2d97e6777b$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $35130c2d97e6777b$export$d5a552a76deda3c2(n, t, r) {
    $35130c2d97e6777b$var$o = 6, $35130c2d97e6777b$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $35130c2d97e6777b$export$1538c33de8887b59(n, r) {
    var u = $35130c2d97e6777b$var$d($35130c2d97e6777b$var$t++, 7);
    return $35130c2d97e6777b$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $35130c2d97e6777b$export$35808ee640e87ca7(n, t) {
    return $35130c2d97e6777b$var$o = 8, $35130c2d97e6777b$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $35130c2d97e6777b$export$fae74005e78b1a27(n) {
    var u = $35130c2d97e6777b$var$r.context[n.__c], i = $35130c2d97e6777b$var$d($35130c2d97e6777b$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($35130c2d97e6777b$var$r)), u.props.value) : n.__;
}
function $35130c2d97e6777b$export$dc8fbce3eb94dc1e(n, t) {
    $35130c2d97e6777b$var$c.useDebugValue && $35130c2d97e6777b$var$c.useDebugValue(t ? t(n) : n);
}
function $35130c2d97e6777b$export$c052f6604b7d51fe(n) {
    var u = $35130c2d97e6777b$var$d($35130c2d97e6777b$var$t++, 10), i = $35130c2d97e6777b$export$60241385465d0a34();
    return u.__ = n, $35130c2d97e6777b$var$r.componentDidCatch || ($35130c2d97e6777b$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $35130c2d97e6777b$export$f680877a34711e37() {
    var n = $35130c2d97e6777b$var$d($35130c2d97e6777b$var$t++, 11);
    if (!n.__) {
        for(var u = $35130c2d97e6777b$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $35130c2d97e6777b$var$j() {
    for(var n; n = $35130c2d97e6777b$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($35130c2d97e6777b$var$z), n.__H.__h.forEach($35130c2d97e6777b$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $35130c2d97e6777b$var$c.__e(t, n.__v);
    }
}
$35130c2d97e6777b$var$c.__b = function(n) {
    $35130c2d97e6777b$var$r = null, $35130c2d97e6777b$var$e && $35130c2d97e6777b$var$e(n);
}, $35130c2d97e6777b$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $35130c2d97e6777b$var$s && $35130c2d97e6777b$var$s(n, t);
}, $35130c2d97e6777b$var$c.__r = function(n) {
    $35130c2d97e6777b$var$a && $35130c2d97e6777b$var$a(n), $35130c2d97e6777b$var$t = 0;
    var i = ($35130c2d97e6777b$var$r = n.__c).__H;
    i && ($35130c2d97e6777b$var$u === $35130c2d97e6777b$var$r ? (i.__h = [], $35130c2d97e6777b$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
    })) : (i.__h.forEach($35130c2d97e6777b$var$z), i.__h.forEach($35130c2d97e6777b$var$B), i.__h = [], $35130c2d97e6777b$var$t = 0)), $35130c2d97e6777b$var$u = $35130c2d97e6777b$var$r;
}, $35130c2d97e6777b$var$c.diffed = function(n) {
    $35130c2d97e6777b$var$v && $35130c2d97e6777b$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $35130c2d97e6777b$var$f.push(t) && $35130c2d97e6777b$var$i === $35130c2d97e6777b$var$c.requestAnimationFrame || (($35130c2d97e6777b$var$i = $35130c2d97e6777b$var$c.requestAnimationFrame) || $35130c2d97e6777b$var$w)($35130c2d97e6777b$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.i = void 0;
    })), $35130c2d97e6777b$var$u = $35130c2d97e6777b$var$r = null;
}, $35130c2d97e6777b$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($35130c2d97e6777b$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $35130c2d97e6777b$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $35130c2d97e6777b$var$c.__e(r, n.__v);
        }
    }), $35130c2d97e6777b$var$l && $35130c2d97e6777b$var$l(n, t);
}, $35130c2d97e6777b$var$c.unmount = function(n) {
    $35130c2d97e6777b$var$m && $35130c2d97e6777b$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $35130c2d97e6777b$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $35130c2d97e6777b$var$c.__e(t, r.__v));
};
var $35130c2d97e6777b$var$k = "function" == typeof requestAnimationFrame;
function $35130c2d97e6777b$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $35130c2d97e6777b$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $35130c2d97e6777b$var$k && (t = requestAnimationFrame(r));
}
function $35130c2d97e6777b$var$z(n) {
    var t = $35130c2d97e6777b$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $35130c2d97e6777b$var$r = t;
}
function $35130c2d97e6777b$var$B(n) {
    var t = $35130c2d97e6777b$var$r;
    n.__c = n.__(), $35130c2d97e6777b$var$r = t;
}
function $35130c2d97e6777b$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $35130c2d97e6777b$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $c9d322eeb636f8e5$var$g(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $c9d322eeb636f8e5$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $c9d322eeb636f8e5$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $c9d322eeb636f8e5$var$g(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($c9d322eeb636f8e5$export$221d75b3f55bb0bd.prototype = new (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8)).isPureReactComponent = !0, $c9d322eeb636f8e5$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $c9d322eeb636f8e5$var$g(this.props, n) || $c9d322eeb636f8e5$var$g(this.state, t);
};
var $c9d322eeb636f8e5$var$x = (0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).__b;
(0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $c9d322eeb636f8e5$var$x && $c9d322eeb636f8e5$var$x(n);
};
var $c9d322eeb636f8e5$var$R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $c9d322eeb636f8e5$export$257a8862b851cb5b(n) {
    function t(t) {
        if (!("ref" in t)) return n(t, null);
        var e = t.ref;
        delete t.ref;
        var r = n(t, e);
        return t.ref = e, r;
    }
    return t.$$typeof = $c9d322eeb636f8e5$var$R, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $c9d322eeb636f8e5$var$k = function(n, t) {
    return null == n ? null : (0, $bc4b82f252aed4aa$export$47e4c5b300681277)((0, $bc4b82f252aed4aa$export$47e4c5b300681277)(n).map(t));
}, $c9d322eeb636f8e5$export$dca3b0875bd9a954 = {
    map: $c9d322eeb636f8e5$var$k,
    forEach: $c9d322eeb636f8e5$var$k,
    count: function(n) {
        return n ? (0, $bc4b82f252aed4aa$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $bc4b82f252aed4aa$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $bc4b82f252aed4aa$export$47e4c5b300681277)
}, $c9d322eeb636f8e5$var$N = (0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).__e;
(0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $c9d322eeb636f8e5$var$N(n, t, e, r);
};
var $c9d322eeb636f8e5$var$M = (0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).unmount;
function $c9d322eeb636f8e5$var$T(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = function(n, t) {
        for(var e in t)n[e] = t[e];
        return n;
    }({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $c9d322eeb636f8e5$var$T(n, t, e);
    })), n;
}
function $c9d322eeb636f8e5$var$A(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $c9d322eeb636f8e5$var$A(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $c9d322eeb636f8e5$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $c9d322eeb636f8e5$var$L(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $c9d322eeb636f8e5$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $c9d322eeb636f8e5$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $c9d322eeb636f8e5$var$M && $c9d322eeb636f8e5$var$M(n);
}, ($c9d322eeb636f8e5$export$74bf444e3cd11ea5.prototype = new (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $c9d322eeb636f8e5$var$L(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(c) : c());
    };
    e.__R = i;
    var c = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $c9d322eeb636f8e5$var$A(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $c9d322eeb636f8e5$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $c9d322eeb636f8e5$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $c9d322eeb636f8e5$var$T(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $c9d322eeb636f8e5$var$U = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $c9d322eeb636f8e5$var$V(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $c9d322eeb636f8e5$var$W(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $bc4b82f252aed4aa$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        contains: function() {
            return !0;
        },
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $bc4b82f252aed4aa$export$b3890eb0ae9dca99)((0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)($c9d322eeb636f8e5$var$V, {
        context: e.context
    }, n.__v), e.l);
}
function $c9d322eeb636f8e5$export$d39a5bbd09211389(n, e) {
    var r = (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)($c9d322eeb636f8e5$var$W, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($c9d322eeb636f8e5$export$998bcd577473dd93.prototype = new (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $c9d322eeb636f8e5$var$L(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $c9d322eeb636f8e5$var$U(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $c9d322eeb636f8e5$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $bc4b82f252aed4aa$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $c9d322eeb636f8e5$export$998bcd577473dd93.prototype.componentDidUpdate = $c9d322eeb636f8e5$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $c9d322eeb636f8e5$var$U(n, e, t);
    });
};
var $c9d322eeb636f8e5$var$j = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $c9d322eeb636f8e5$var$z = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $c9d322eeb636f8e5$var$B = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $c9d322eeb636f8e5$var$H = /[A-Z0-9]/g, $c9d322eeb636f8e5$var$Z = "undefined" != typeof document, $c9d322eeb636f8e5$var$Y = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $c9d322eeb636f8e5$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $bc4b82f252aed4aa$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $c9d322eeb636f8e5$export$fa8d919ba61d84db(n, t, e) {
    return (0, $bc4b82f252aed4aa$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $bc4b82f252aed4aa$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $bc4b82f252aed4aa$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $c9d322eeb636f8e5$var$G = (0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).event;
function $c9d322eeb636f8e5$var$J() {}
function $c9d322eeb636f8e5$var$K() {
    return this.cancelBubble;
}
function $c9d322eeb636f8e5$var$Q() {
    return this.defaultPrevented;
}
(0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).event = function(n) {
    return $c9d322eeb636f8e5$var$G && (n = $c9d322eeb636f8e5$var$G(n)), n.persist = $c9d322eeb636f8e5$var$J, n.isPropagationStopped = $c9d322eeb636f8e5$var$K, n.isDefaultPrevented = $c9d322eeb636f8e5$var$Q, n.nativeEvent = n;
};
var $c9d322eeb636f8e5$var$X, $c9d322eeb636f8e5$var$nn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $c9d322eeb636f8e5$var$tn = (0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).vnode;
(0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var c = t[i];
            if (!("value" === i && "defaultValue" in t && null == c || $c9d322eeb636f8e5$var$Z && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var f = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === c ? c = "" : "translate" === f && "no" === c ? c = !1 : "o" === f[0] && "n" === f[1] ? "ondoubleclick" === f ? i = "ondblclick" : "onchange" !== f || "input" !== e && "textarea" !== e || $c9d322eeb636f8e5$var$Y(t.type) ? "onfocus" === f ? i = "onfocusin" : "onblur" === f ? i = "onfocusout" : $c9d322eeb636f8e5$var$B.test(i) && (i = f) : f = i = "oninput" : o && $c9d322eeb636f8e5$var$z.test(i) ? i = i.replace($c9d322eeb636f8e5$var$H, "-$&").toLowerCase() : null === c && (c = void 0), "oninput" === f && u[i = f] && (i = "oninputCapture"), u[i] = c;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $bc4b82f252aed4aa$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $bc4b82f252aed4aa$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $c9d322eeb636f8e5$var$nn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $c9d322eeb636f8e5$var$j, $c9d322eeb636f8e5$var$tn && $c9d322eeb636f8e5$var$tn(n);
};
var $c9d322eeb636f8e5$var$en = (0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).__r;
(0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).__r = function(n) {
    $c9d322eeb636f8e5$var$en && $c9d322eeb636f8e5$var$en(n), $c9d322eeb636f8e5$var$X = n.__c;
};
var $c9d322eeb636f8e5$var$rn = (0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).diffed;
(0, $bc4b82f252aed4aa$export$41c562ebe57d11e2).diffed = function(n) {
    $c9d322eeb636f8e5$var$rn && $c9d322eeb636f8e5$var$rn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $c9d322eeb636f8e5$var$X = null;
};
var $c9d322eeb636f8e5$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $c9d322eeb636f8e5$var$X.__n[n.__c].props.value;
            },
            useCallback: (0, $35130c2d97e6777b$export$35808ee640e87ca7),
            useContext: (0, $35130c2d97e6777b$export$fae74005e78b1a27),
            useDebugValue: (0, $35130c2d97e6777b$export$dc8fbce3eb94dc1e),
            useDeferredValue: $c9d322eeb636f8e5$export$6a7bc4e911dc01cf,
            useEffect: (0, $35130c2d97e6777b$export$6d9c69b0de29b591),
            useId: (0, $35130c2d97e6777b$export$f680877a34711e37),
            useImperativeHandle: (0, $35130c2d97e6777b$export$d5a552a76deda3c2),
            useInsertionEffect: $c9d322eeb636f8e5$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $35130c2d97e6777b$export$e5c5a5f917a5871c),
            useMemo: (0, $35130c2d97e6777b$export$1538c33de8887b59),
            useReducer: (0, $35130c2d97e6777b$export$13e3392192263954),
            useRef: (0, $35130c2d97e6777b$export$b8f5890fc79d6aca),
            useState: (0, $35130c2d97e6777b$export$60241385465d0a34),
            useSyncExternalStore: $c9d322eeb636f8e5$export$306c0aa65ff9ec16,
            useTransition: $c9d322eeb636f8e5$export$7b286972b8d8ccbf
        }
    }
}, $c9d322eeb636f8e5$export$83d89fbfd8236492 = "18.3.1";
function $c9d322eeb636f8e5$export$d38cd72104c1f0e9(n) {
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d).bind(null, n);
}
function $c9d322eeb636f8e5$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $c9d322eeb636f8e5$var$j;
}
function $c9d322eeb636f8e5$export$9522e17588c12572(n) {
    return $c9d322eeb636f8e5$export$a8257692ac88316c(n) && n.type === (0, $bc4b82f252aed4aa$export$ffb0004e005737fa);
}
function $c9d322eeb636f8e5$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $c9d322eeb636f8e5$export$e530037191fcd5d7(n) {
    return $c9d322eeb636f8e5$export$a8257692ac88316c(n) ? (0, $bc4b82f252aed4aa$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $c9d322eeb636f8e5$export$502457920280e6be(n) {
    return !!n.__k && ((0, $bc4b82f252aed4aa$export$b3890eb0ae9dca99)(null, n), !0);
}
function $c9d322eeb636f8e5$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $c9d322eeb636f8e5$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $c9d322eeb636f8e5$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $c9d322eeb636f8e5$export$5f8d39834fd61797 = (0, $bc4b82f252aed4aa$export$ffb0004e005737fa);
function $c9d322eeb636f8e5$export$7568632d0d33d16d(n) {
    n();
}
function $c9d322eeb636f8e5$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $c9d322eeb636f8e5$export$7b286972b8d8ccbf() {
    return [
        !1,
        $c9d322eeb636f8e5$export$7568632d0d33d16d
    ];
}
var $c9d322eeb636f8e5$export$aaabe4eda9ed9969 = (0, $35130c2d97e6777b$export$e5c5a5f917a5871c), $c9d322eeb636f8e5$export$45a5e7f76e0caa8d = $c9d322eeb636f8e5$export$a8257692ac88316c;
function $c9d322eeb636f8e5$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $35130c2d97e6777b$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $35130c2d97e6777b$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $c9d322eeb636f8e5$var$Cn(u) && o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(function() {
        return $c9d322eeb636f8e5$var$Cn(u) && o({
            h: u
        }), n(function() {
            $c9d322eeb636f8e5$var$Cn(u) && o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
function $c9d322eeb636f8e5$var$Cn(n) {
    var t, e, r = n.v, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
var $c9d322eeb636f8e5$export$2e2bcd8739ae039 = {
    useState: (0, $35130c2d97e6777b$export$60241385465d0a34),
    useId: (0, $35130c2d97e6777b$export$f680877a34711e37),
    useReducer: (0, $35130c2d97e6777b$export$13e3392192263954),
    useEffect: (0, $35130c2d97e6777b$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $35130c2d97e6777b$export$e5c5a5f917a5871c),
    useInsertionEffect: $c9d322eeb636f8e5$export$aaabe4eda9ed9969,
    useTransition: $c9d322eeb636f8e5$export$7b286972b8d8ccbf,
    useDeferredValue: $c9d322eeb636f8e5$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $c9d322eeb636f8e5$export$306c0aa65ff9ec16,
    startTransition: $c9d322eeb636f8e5$export$7568632d0d33d16d,
    useRef: (0, $35130c2d97e6777b$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $35130c2d97e6777b$export$d5a552a76deda3c2),
    useMemo: (0, $35130c2d97e6777b$export$1538c33de8887b59),
    useCallback: (0, $35130c2d97e6777b$export$35808ee640e87ca7),
    useContext: (0, $35130c2d97e6777b$export$fae74005e78b1a27),
    useDebugValue: (0, $35130c2d97e6777b$export$dc8fbce3eb94dc1e),
    version: "18.3.1",
    Children: $c9d322eeb636f8e5$export$dca3b0875bd9a954,
    render: $c9d322eeb636f8e5$export$b3890eb0ae9dca99,
    hydrate: $c9d322eeb636f8e5$export$fa8d919ba61d84db,
    unmountComponentAtNode: $c9d322eeb636f8e5$export$502457920280e6be,
    createPortal: $c9d322eeb636f8e5$export$d39a5bbd09211389,
    createElement: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d),
    createContext: (0, $bc4b82f252aed4aa$export$fd42f52fd3ae1109),
    createFactory: $c9d322eeb636f8e5$export$d38cd72104c1f0e9,
    cloneElement: $c9d322eeb636f8e5$export$e530037191fcd5d7,
    createRef: (0, $bc4b82f252aed4aa$export$7d1e3a5e95ceca43),
    Fragment: (0, $bc4b82f252aed4aa$export$ffb0004e005737fa),
    isValidElement: $c9d322eeb636f8e5$export$a8257692ac88316c,
    isElement: $c9d322eeb636f8e5$export$45a5e7f76e0caa8d,
    isFragment: $c9d322eeb636f8e5$export$9522e17588c12572,
    isMemo: $c9d322eeb636f8e5$export$56885ab8b9c456ab,
    findDOMNode: $c9d322eeb636f8e5$export$466bfc07425424d5,
    Component: (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8),
    PureComponent: $c9d322eeb636f8e5$export$221d75b3f55bb0bd,
    memo: $c9d322eeb636f8e5$export$7c73462e0d25e514,
    forwardRef: $c9d322eeb636f8e5$export$257a8862b851cb5b,
    flushSync: $c9d322eeb636f8e5$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $c9d322eeb636f8e5$export$c78a37762a8d58e1,
    StrictMode: $c9d322eeb636f8e5$export$5f8d39834fd61797,
    Suspense: $c9d322eeb636f8e5$export$74bf444e3cd11ea5,
    SuspenseList: $c9d322eeb636f8e5$export$998bcd577473dd93,
    lazy: $c9d322eeb636f8e5$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $c9d322eeb636f8e5$export$ae55be85d98224ed
};
$parcel$exportWildcard($c9d322eeb636f8e5$exports, $35130c2d97e6777b$exports);



var $957aeb9b5380fafb$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $957aeb9b5380fafb$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $c6e574caa354fd2a$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $c6e574caa354fd2a$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($957aeb9b5380fafb$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($c6e574caa354fd2a$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $c6e574caa354fd2a$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $c6e574caa354fd2a$var$i = /^\s*$/, $c6e574caa354fd2a$var$s = Object.create(null);
function $c6e574caa354fd2a$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($c6e574caa354fd2a$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $c6e574caa354fd2a$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $c6e574caa354fd2a$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($c6e574caa354fd2a$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $c6e574caa354fd2a$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $c6e574caa354fd2a$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $c6e574caa354fd2a$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $c6e574caa354fd2a$var$a("", t);
        }, "");
    }
};
var $c6e574caa354fd2a$export$2e2bcd8739ae039 = $c6e574caa354fd2a$var$c;


const $52be05fa2baefe83$export$c106dd0671a0fc2d = (...args)=>{
    if (console?.warn) {
        if ($52be05fa2baefe83$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
};
const $52be05fa2baefe83$var$alreadyWarned = {};
const $52be05fa2baefe83$export$5b28268982f175ba = (...args)=>{
    if ($52be05fa2baefe83$export$844ec244b1367d54(args[0]) && $52be05fa2baefe83$var$alreadyWarned[args[0]]) return;
    if ($52be05fa2baefe83$export$844ec244b1367d54(args[0])) $52be05fa2baefe83$var$alreadyWarned[args[0]] = new Date();
    $52be05fa2baefe83$export$c106dd0671a0fc2d(...args);
};
const $52be05fa2baefe83$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
const $52be05fa2baefe83$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $52be05fa2baefe83$var$loadedClb(i18n, cb));
};
const $52be05fa2baefe83$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($52be05fa2baefe83$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $52be05fa2baefe83$var$loadedClb(i18n, cb));
};
const $52be05fa2baefe83$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $52be05fa2baefe83$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n?.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $52be05fa2baefe83$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($52be05fa2baefe83$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : "Unknown");
const $52be05fa2baefe83$export$844ec244b1367d54 = (obj)=>typeof obj === "string";
const $52be05fa2baefe83$export$a6cdc56e425d0d0a = (obj)=>typeof obj === "object" && obj !== null;


const $a0179c60df6f1bb4$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $a0179c60df6f1bb4$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $a0179c60df6f1bb4$var$unescapeHtmlEntity = (m)=>$a0179c60df6f1bb4$var$htmlEntities[m];
const $a0179c60df6f1bb4$export$e8bacd2802a88316 = (text)=>text.replace($a0179c60df6f1bb4$var$matchHtmlEntity, $a0179c60df6f1bb4$var$unescapeHtmlEntity);


let $4ec6b5e5b6e9f8d7$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $a0179c60df6f1bb4$export$e8bacd2802a88316
};
const $4ec6b5e5b6e9f8d7$export$2e2366488d12e20d = (options = {})=>{
    $4ec6b5e5b6e9f8d7$var$defaultOptions = {
        ...$4ec6b5e5b6e9f8d7$var$defaultOptions,
        ...options
    };
};
const $4ec6b5e5b6e9f8d7$export$212bb2fc580a90a8 = ()=>$4ec6b5e5b6e9f8d7$var$defaultOptions;


let $3a9c5b0a2981242b$var$i18nInstance;
const $3a9c5b0a2981242b$export$a039134f2fc7e0 = (instance)=>{
    $3a9c5b0a2981242b$var$i18nInstance = instance;
};
const $3a9c5b0a2981242b$export$64af334f494c2f47 = ()=>$3a9c5b0a2981242b$var$i18nInstance;


const $a25339dd45d6990b$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $a25339dd45d6990b$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $a25339dd45d6990b$var$getAsArray(children) : children;
};
const $a25339dd45d6990b$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $c9d322eeb636f8e5$export$a8257692ac88316c));
const $a25339dd45d6990b$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $a25339dd45d6990b$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $a25339dd45d6990b$export$4f7a36dd898f1267 = (children, i18nOptions)=>{
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $a25339dd45d6990b$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $52be05fa2baefe83$export$844ec244b1367d54)(child)) stringNode += `${child}`;
        else if ((0, $c9d322eeb636f8e5$export$a8257692ac88316c)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) stringNode += `<${type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && (0, $52be05fa2baefe83$export$844ec244b1367d54)(childChildren)) stringNode += `<${type}>${childChildren}</${type}>`;
            else {
                const content = $a25339dd45d6990b$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $52be05fa2baefe83$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if ((0, $52be05fa2baefe83$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $52be05fa2baefe83$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $52be05fa2baefe83$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
};
const $a25339dd45d6990b$var$renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    const getData = (childs)=>{
        const childrenArray = $a25339dd45d6990b$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $52be05fa2baefe83$export$844ec244b1367d54)(child)) return;
            if ($a25339dd45d6990b$var$hasChildren(child)) getData($a25339dd45d6990b$var$getChildren(child));
            else if ((0, $52be05fa2baefe83$export$a6cdc56e425d0d0a)(child) && !(0, $c9d322eeb636f8e5$export$a8257692ac88316c)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $c6e574caa354fd2a$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $a25339dd45d6990b$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $a25339dd45d6990b$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $c9d322eeb636f8e5$export$e530037191fcd5d7)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $c9d322eeb636f8e5$export$dca3b0875bd9a954).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $a25339dd45d6990b$var$getAsArray(reactNode);
        const astNodes = $a25339dd45d6990b$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $a25339dd45d6990b$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $c9d322eeb636f8e5$export$a8257692ac88316c)(child);
                const isValidTranslationWithChildren = isElement && $a25339dd45d6990b$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $52be05fa2baefe83$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $52be05fa2baefe83$export$a6cdc56e425d0d0a)(children) && Object.hasOwnProperty.call(children, node.name);
                if ((0, $52be05fa2baefe83$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($a25339dd45d6990b$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $52be05fa2baefe83$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $a25339dd45d6990b$var$getAsArray(children || []));
    return $a25339dd45d6990b$var$getChildren(result[0]);
};
function $a25339dd45d6990b$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $3a9c5b0a2981242b$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $52be05fa2baefe83$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $4ec6b5e5b6e9f8d7$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $52be05fa2baefe83$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $a25339dd45d6990b$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === "function" || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, comp);
        }
        components[c] = (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(Componentized);
    });
    const content = $a25339dd45d6990b$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(useAsParent, additionalProps, content) : content;
}







const $dc44570447e3a989$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $4ec6b5e5b6e9f8d7$export$2e2366488d12e20d)(instance.options.react);
        (0, $3a9c5b0a2981242b$export$a039134f2fc7e0)(instance);
    }
};


const $a6a4853fe069bc1d$export$5603ab5ced17ce64 = (0, $bc4b82f252aed4aa$export$fd42f52fd3ae1109)();
class $a6a4853fe069bc1d$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $a6a4853fe069bc1d$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $a6a4853fe069bc1d$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $a6a4853fe069bc1d$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $3a9c5b0a2981242b$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $8b039b1917e34bb1$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $35130c2d97e6777b$export$fae74005e78b1a27)((0, $a6a4853fe069bc1d$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3a9c5b0a2981242b$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $a25339dd45d6990b$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}






const $829be5acfdd67d69$var$usePrevious = (value, ignore)=>{
    const ref = (0, $35130c2d97e6777b$export$b8f5890fc79d6aca)();
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $829be5acfdd67d69$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $829be5acfdd67d69$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $35130c2d97e6777b$export$35808ee640e87ca7)($829be5acfdd67d69$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $829be5acfdd67d69$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $35130c2d97e6777b$export$fae74005e78b1a27)((0, $a6a4853fe069bc1d$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3a9c5b0a2981242b$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $a6a4853fe069bc1d$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $52be05fa2baefe83$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $52be05fa2baefe83$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $52be05fa2baefe83$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $52be05fa2baefe83$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react?.wait) (0, $52be05fa2baefe83$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $4ec6b5e5b6e9f8d7$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options?.defaultNS;
    namespaces = (0, $52be05fa2baefe83$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    i18n.reportNamespaces.addUsedNamespaces?.(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $52be05fa2baefe83$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $829be5acfdd67d69$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$829be5acfdd67d69$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $35130c2d97e6777b$export$60241385465d0a34)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $829be5acfdd67d69$var$usePrevious(joinedNS);
    const isMounted = (0, $35130c2d97e6777b$export$b8f5890fc79d6aca)(true);
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $52be05fa2baefe83$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $52be05fa2baefe83$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n) i18n?.on(bindI18n, boundReset);
        if (bindI18nStore) i18n?.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (i18n) bindI18n?.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $52be05fa2baefe83$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $52be05fa2baefe83$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};





const $5fa4965e78bef7fc$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $52be05fa2baefe83$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $c9d322eeb636f8e5$export$257a8862b851cb5b)(forwardRef) : I18nextWithTranslation;
    };



const $b3f0d1298e473e74$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};




function $4bae5cbab0cb0a49$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $35130c2d97e6777b$export$1538c33de8887b59)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a6a4853fe069bc1d$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





const $21e25aedc73983d2$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $35130c2d97e6777b$export$fae74005e78b1a27)((0, $a6a4853fe069bc1d$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3a9c5b0a2981242b$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $569b2e3befd226ba$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $21e25aedc73983d2$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $a6a4853fe069bc1d$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $52be05fa2baefe83$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $8f3a55efb7d5aabe$export$324d90190a8b822a = ()=>"";
const $8f3a55efb7d5aabe$export$2da9be4cfdb689b1 = ()=>"";
const $8f3a55efb7d5aabe$export$98e628dec113755e = ()=>"";
const $8f3a55efb7d5aabe$export$2e6c959c16ff56b8 = ()=>"";
const $8f3a55efb7d5aabe$export$4e35d5c922a95490 = ()=>"";
const $8f3a55efb7d5aabe$export$720a3b9db04b7a0f = ()=>"";


var $2379d1524118d841$exports = {};
$2379d1524118d841$exports = JSON.parse('{"hourly":"Hodinov\xe1","next_coms":"Shl\xe9dnout dal\u0161\xed koment\xe1\u0159e","ago":"p\u0159ed {{duration}}","login_placeholder":"e-mail","password_placeholder":"heslo","new_password_placeholder":"nov\xe9 heslo","confirm_password_placeholder":"potvrdit heslo","connect":"P\u0159ipojen\xed","submit":"Odeslat","title_placeholder":"Nadpis zpr\xe1vy (voliteln\u011B)","text_placeholder":"Zde napi\u0161te svou zpr\xe1vu","upload_pdf":"Nahr\xe1t PDF","upload_image":"Nahr\xe1t fotky","upload_video":"Nahr\xe1t video","upload_music":"Nahr\xe1t hudbu","add_date":"Zadat datum","logout":"Odhl\xe1sit","settings":"Nastaven\xed","name":"Jm\xe9no","name_input":"Vybrat jm\xe9no","login":"Login","login_input":"Vybrat login","email":"E-mail","email_input":"Vypl\u0148te sem sv\u016Fj e-mail","save_changes":"Ulo\u017Eit zm\u011Bny","password":"Heslo","password_input":"Vypl\u0148te sem nov\xe9 heslo","Invalid login/password":"Neplatn\xfd login a/nebo heslo","edit":"Upravit","delete":"Smazat","ask_delete_message":"Opravdu chcete smazat tuto zpr\xe1vu?","account":"\xda\u010Det","forgot_password":"Zapom\u011Bli jste sv\xe9 heslo?","password_reset_mail_sent":"E-mail pro obnovu hesla byl odesl\xe1n!","User not found":"U\u017Eivatel nenalezen","reset_password_title":"Resetovat heslo","error":"Do\u0161lo k chyb\u011B","passwords_dont_match":"Hesla se neshoduj\xed","invitation_link":"Odkaz s pozv\xe1nkou","reset_invitation_link":"Resetovat odkaz s pozv\xe1nkou","invitation_welcome":"V\xedtejte na Zusam! P\u0159ed vstupem do skupiny se p\u0159ihla\u0161te.","signup":"Zalo\u017Eit \xfa\u010Det","create_a_group":"Vytvo\u0159it skupinu","create_the_group":"Vytvo\u0159it tuto skupinu","quit_group":"Opustit skupinu","settings_updated":"Nastaven\xed byla aktualizov\xe1na","group_updated":"Skupina byla aktualizov\xe1na!","group_left":"Opustili jste tuto skupinu!","multiple_photos_upload":"Do\u0161lo k chyb\u011B. Zkuste nahr\xe1t obr\xe1zky jeden po druh\xe9m (toto se ob\u010Das v n\u011Bkter\xfdch prohl\xed\u017Ee\u010D\xedch stane).","error_new_message":"Do\u0161lo k chyb\u011B b\u011Bhem odes\xedl\xe1n\xed zpr\xe1vy.","error_upload":"Do\u0161lo k chyb\u011B b\u011Bhem nahr\xe1v\xe1n\xed","cancel_write":"Opravdu chcete ukon\u010Dit psan\xed nov\xe9 zpr\xe1vy?","empty_message":"Pr\xe1zdnou zpr\xe1vu nelze odeslat!","cancel":"Zru\u0161it","just_now":"Pr\xe1v\u011B te\u010F","notification_emails":"E-mailov\xe1 upozorn\u011Bn\xed","monthly":"M\u011Bs\xed\u010Dn\xed","notification_emails_stopped":"E-mailov\xe1 upozorn\u011Bn\xed zastavena!","group_share_choice":"Do kter\xe9 skupiny chcete poslat tuto zpr\xe1vu?","public_link":"ve\u0159ejn\xfd odkaz","default_group":"V\xfdchoz\xed skupina","destroy_account":"Smazat \xfa\u010Det","destroy_account_explain":"Smaz\xe1n\xed \xfa\u010Dtu nelze vr\xe1tit zp\u011Bt. Bu\u010Fte si opravdu jisti.","are_you_sure":"Jste si opravdu jisti?","share_message":"sd\xedlet zpr\xe1vu","previous_coms":"Shl\xe9dnout p\u0159edchoz\xed koment\xe1\u0159e","users":"u\u017Eivatel\xe9","has_posted_in":"zve\u0159ejnili v","has_commented_on":"komentovali v","has_joined":"vstoupili","has_left":"opustili","the_message_from":"zpr\xe1vu od","in":"v","lang":"jazyk","reply":"odpov\u011B\u010F","replies_one":"{{count}} odpov\u011B\u010F","replies_other":"{{count}} odpov\u011Bd\xed","publish_in_group":"zve\u0159ejnit ve skupin\u011B","search_in_group":"hledat ve skupin\u011B","changed_group_name":"zm\u011Bnili jm\xe9no skupiny","to":"na","notifications":"upozorn\u011Bn\xed","mark_all_as_read":"ozna\u010Dit v\u0161e jako p\u0159e\u010Dten\xe9","search_without_result":"Hled\xe1n\xed nevr\xe1tilo \u017Eadn\xe9 odpov\xeddaj\xedc\xed zpr\xe1vy.","add_bookmark":"P\u0159idat zpr\xe1vu do z\xe1lo\u017Eek","remove_bookmark":"Smazat zpr\xe1vu ze z\xe1lo\u017Eek","bookmarks":"z\xe1lo\u017Eky","api_key":"API kl\xed\u010D","reset_api_key":"Resetovat API kl\xed\u010D (budete odpojeni)","video_not_ready":"Video je\u0161t\u011B nen\xed p\u0159ipraveno.","bookmark_added":"Zpr\xe1va p\u0159id\xe1na do z\xe1lo\u017Eek!","bookmark_removed":"Zpr\xe1va odstran\u011Bna ze z\xe1lo\u017Eek!","parent_message":"Nad\u0159azen\xe1 zpr\xe1va","groups":"Skupiny","none":"\u017D\xe1dn\xe1","daily":"Denn\xed","weekly":"T\xfddenn\xed","upload_audio":"","audio_not_ready":""}');


var $7227d2b4b58764da$exports = {};
$7227d2b4b58764da$exports = JSON.parse('{"edit":"Bearbeiten","add_date":"Ein Datum hinzuf\xfcgen","save_changes":"\xc4nderungen speichern","password_input":"Gib hier ein neues Passwort ein","next_coms":"N\xe4chste Kommentare ansehen","previous_coms":"Vorherige Kommentare ansehen","ago":"Vor {{duration}}","submit":"Senden","groups":"Gruppen","password_placeholder":"Passwort","title_placeholder":"Titel deiner Nachricht (optional)","text_placeholder":"Schreibe deine Nachricht hier","upload_video":"Video hinzuf\xfcgen","login_placeholder":"E-Mail","new_password_placeholder":"Neues Passwort","upload_music":"Musik hinzuf\xfcgen","upload_pdf":"PDF hinzuf\xfcgen","confirm_password_placeholder":"Passwort best\xe4tigen","delete":"L\xf6schen","upload_image":"Fotos hinzuf\xfcgen","logout":"Abmelden","name":"Name","connect":"Anmelden","name_input":"W\xe4hle einen Namen","settings":"Einstellungen","login_input":"W\xe4hle einen Benutzername","email":"E-Mail","login":"Benutzername","email_input":"Gib hier deine E-Mail-Adresse ein","password":"Passwort","Invalid login/password":"Ung\xfcltiges Benutzername oder Passwort","forgot_password":"Passwort vergessen?","ask_delete_message":"Diese Nachricht l\xf6schen?","account":"Konto","password_reset_mail_sent":"Die E-Mail zum Zur\xfccksetzen des Passworts wurde gesendet!","create_a_group":"Eine Gruppe erstellen","users":"Benutzer","to":"zu","remove_bookmark":"Nachricht aus den Lesezeichnen entfernen","bookmarks":"Lesezeichen","multiple_photos_upload":"Ein Fehler ist aufgetreten. Versuche, die Bilder nacheinander hochzuladen (dies kann bei einigen Browsern vorkommen)","passwords_dont_match":"Passw\xf6rter stimmen nicht \xfcberein","User not found":"Benutzer nicht gefunden","reset_password_title":"Dein Passwort zur\xfccksetzen","error":"Ein Fehler ist aufgetreten","invitation_link":"Einladungslink","reset_invitation_link":"Einladungslink zur\xfccksetzen","invitation_welcome":"Willkommen bei Zusam! Bitte melde dich an, bevor du der Gruppe beitrittst.","notification_emails_stopped":"E-Mail-Benachrichtigungen gestoppt!","the_message_from":"die Nachricht von","signup":"Registrieren","group_updated":"Die Gruppe wurde aktualisiert.","group_left":"Du hast die Gruppe verlassen.","create_the_group":"Die Gruppe erstellen","quit_group":"Die Gruppe verlassen","settings_updated":"Deine Einstellungen wurden aktualisiert","monthly":"Monatlich","error_new_message":"Beim Senden deiner Nachricht ist ein Fehler aufgetreten.","just_now":"Gerade jetzt","none":"Keine","weekly":"W\xf6chentlich","are_you_sure":"Bist du sicher?","error_upload":"Beim Hochladen ist ein Fehler aufgetreten","cancel_write":"Willst du das Schreiben einer neuen Nachricht wirklich abbrechen?","empty_message":"Die Nachricht ist leer und kann nicht gesendet werden.","cancel":"Abbrechen","notification_emails":"E-Mail-Benachrichtigungen","hourly":"St\xfcndlich","daily":"T\xe4glich","group_share_choice":"An welche Gruppe m\xf6chtest du diese Nachricht senden?","destroy_account":"Dein Konto l\xf6schen","has_left":"hat verlassen","publish_in_group":"in der Gruppe ver\xf6ffentlichen","public_link":"\xf6ffentlicher Link","default_group":"Standard-Gruppe","has_posted_in":"hat ver\xf6ffentlicht in","has_joined":"ist beigetreten","lang":"Sprache","reply":"antworten","destroy_account_explain":"Wenn du dein Konto einmal gel\xf6scht hast, gibt es keinen Weg zur\xfcck. Bitte sei sicher.","share_message":"die Nachricht teilen","search_in_group":"in dieser Gruppe suchen","mark_all_as_read":"alle als gelesen markieren","has_commented_on":"hat kommentiert","in":"in","replies_one":"{{count}} Antwort","replies_other":"{{count}} Antworten","changed_group_name":"hat den Gruppenamen ge\xe4ndert","notifications":"Benachrichtigungen","reset_api_key":"Setze den API-Schl\xfcssel zur\xfcck (die Verbindung wird unterbrochen)","video_not_ready":"Das Video ist noch nicht fertig.","bookmark_added":"Nachricht zu den Lesezeichen hinzugef\xfcgt.","search_without_result":"Deine Suche hat zu keiner Nachricht gef\xfchrt.","add_bookmark":"Nachricht zu den Lesezeichnen hinzuf\xfcgen","api_key":"API-Schl\xfcssel","bookmark_removed":"Nachricht aus den Lesezeichen entfernt.","parent_message":"Quellenachricht","audio_not_ready":"Audio ist noch nicht fertig.","upload_audio":"Audio hinzuf\xfcgen."}');


var $48c6d8cc49c1b9f6$exports = {};
$48c6d8cc49c1b9f6$exports = JSON.parse('{"previous_coms":"See previous comments","next_coms":"See next comments","ago":"{{duration}} ago","groups":"Groups","login_placeholder":"e-mail","password_placeholder":"password","new_password_placeholder":"new password","confirm_password_placeholder":"confirm password","connect":"Connection","submit":"Submit","title_placeholder":"Title of your message (optional)","text_placeholder":"Write your message here","upload_image":"Add photos","upload_video":"Add a video","upload_music":"Add music","upload_pdf":"Add PDF","add_date":"Add a date","logout":"Log out","settings":"Settings","name":"Name","name_input":"Choose a name","login":"Log in","login_input":"Choose a login","email":"E-mail","email_input":"Fill in your e-mail address here","save_changes":"Save changes","password":"Password","password_input":"Write a new password here","Invalid login/password":"Invalid login and/or password","edit":"Edit","delete":"Delete","ask_delete_message":"Delete this message?","account":"Account","forgot_password":"Forgot your password?","password_reset_mail_sent":"Look for the password reset e-mail in your inbox.","User not found":"User not found","reset_password_title":"Reset your password","error":"An error occurred","passwords_dont_match":"Passwords don\'t match","invitation_link":"Invitation link","reset_invitation_link":"Reset invitation link","invitation_welcome":"Welcome on Zusam. Please sign up before joining the group.","signup":"Sign up","create_a_group":"Create a group","create_the_group":"Create the group","quit_group":"Leave the group","settings_updated":"Your settings were updated","group_updated":"The group was updated.","group_left":"You left the group.","multiple_photos_upload":"An error ocurred. Try uploading images one by one (this can happen in some browsers)","error_new_message":"An error occurred while sending your message.","error_upload":"An error occurred during the upload","cancel_write":"Do you really want to cancel writing a new message?","empty_message":"The message is empty and cannot be sent.","cancel":"Cancel","just_now":"Just now","notification_emails":"E-mail notifications","none":"None","hourly":"Hourly","daily":"Daily","weekly":"Weekly","monthly":"Monthly","notification_emails_stopped":"E-mail notifications stopped!","group_share_choice":"Which group do you want to send this message to?","public_link":"public link","default_group":"Default group","destroy_account":"Delete your account","destroy_account_explain":"Once you delete your account, there is no going back. Please be certain.","are_you_sure":"Are you sure?","share_message":"share the message","users":"users","has_posted_in":"has posted in","has_commented_on":"has commented on","has_joined":"has joined","has_left":"has left","the_message_from":"the message from","in":"in","lang":"language","reply":"reply","replies_one":"{{count}} reply","replies_other":"{{count}} replies","publish_in_group":"publish in the group","search_in_group":"search in this group","changed_group_name":"changed the group\'s name","to":"to","notifications":"notifications","mark_all_as_read":"mark all as read","search_without_result":"Your search did not match any message.","add_bookmark":"Bookmark message","remove_bookmark":"Unbookmark message","bookmarks":"bookmarks","api_key":"API key","reset_api_key":"Reset the API key (you will be disconnected)","video_not_ready":"Video is not ready yet.","bookmark_added":"Message bookmarked.","bookmark_removed":"Message bookmark removed.","parent_message":"Parent message","audio_not_ready":"Audio is not ready yet.","upload_audio":"Add an audio file."}');


var $079440a674bdf1c9$exports = {};
$079440a674bdf1c9$exports = JSON.parse('{"previous_coms":"Ver los comentarios anteriores","next_coms":"Ver los siguientes comentarios","ago":"Hace {{duration}}","groups":"Grupos","login_placeholder":"correo electr\xf3nico","password_placeholder":"contrase\xf1a","new_password_placeholder":"nueva contrase\xf1a","confirm_password_placeholder":"confirmar contrase\xf1a","connect":"Conectarse","submit":"Enviar","title_placeholder":"Asunto (opcional)","text_placeholder":"Escribe tu mensaje aqu\xed","upload_image":"A\xf1adir fotos","upload_video":"A\xf1adir video","upload_music":"A\xf1adir m\xfasica","upload_pdf":"A\xf1adir PDF","add_date":"A\xf1adir una fecha","logout":"Desconectarse","settings":"Par\xe1metros","name":"Nombre","name_input":"Elige un nombre","login":"Iniciar sesi\xf3n","login_input":"Elige un usuario","email":"Correo electr\xf3nico","email_input":"Escriba aqu\xed su direcci\xf3n de correo electr\xf3nico","save_changes":"Guardar los cambios","password":"Contrase\xf1a","password_input":"Indicar una nueva contrase\xf1a","Invalid login/password":"Usuario o contrase\xf1a incorrecto","edit":"Editar","delete":"Borrar","ask_delete_message":"\xbfBorrar este mensaje?","account":"Cuenta","forgot_password":"\xbfOlvidaste tu contrase\xf1a?","password_reset_mail_sent":"Busque el correo electr\xf3nico de restablecimiento de la contrase\xf1a en su bandeja de entrada.","User not found":"El usuario no existe","reset_password_title":"Cambia tu contrase\xf1a","error":"Se ha producido un error","passwords_dont_match":"Las contrase\xf1as no coinciden","invitation_link":"Enlace de invitaci\xf3n","reset_invitation_link":"Cambiar el enlace de invitaci\xf3n","invitation_welcome":"Bienvenido a Zusam. Por favor, reg\xedstrate antes de unirte al grupo.","signup":"Inscribirse","create_a_group":"Crear un grupo","create_the_group":"Crear el grupo","quit_group":"Dejar el grupo","settings_updated":"Sus ajustes fueron actualizados","group_updated":"El grupo ha sido actualizado.","group_left":"Has dejado el grupo.","multiple_photos_upload":"Se ha producido un error. Intenta subir las im\xe1genes una a una (esto puede ocurrir en algunos navegadores)","error_new_message":"Se ha producido un error al enviar su mensaje.","error_upload":"Se ha producido un error durante la carga","cancel_write":"\xbfQuieres cancelar este nuevo mensaje?","empty_message":"El mensaje est\xe1 vac\xedo y no se puede enviar.","cancel":"Cancelar","just_now":"Ahora","notification_emails":"Notificaciones por correo electr\xf3nico","none":"Ninguno","hourly":"Cada hora","daily":"Diario","weekly":"Semanal","monthly":"Mensual","notification_emails_stopped":"\xa1Se han detenido las notificaciones por correo electr\xf3nico!","group_share_choice":"\xbfA qu\xe9 grupo quieres enviar este mensaje?","public_link":"enlace p\xfablico","default_group":"Grupo predeterminado","destroy_account":"Borrar la cuenta","destroy_account_explain":"Una vez que elimines tu cuenta, no hay vuelta atr\xe1s.","are_you_sure":"Est\xe1s seguro ?","share_message":"comparte el mensaje","users":"usuarios","has_posted_in":"ha publicado en","has_commented_on":"ha comentado","has_joined":"se has unido","has_left":"ha dejado","the_message_from":"el mensaje de","in":"en","lang":"idioma","reply":"responder","replies_one":"{{count}} respuesta","replies_other":"{{count}} respuestas","publish_in_group":"publicar en el grupo","search_in_group":"buscar en este grupo","changed_group_name":"cambi\xf3 el nombre del grupo","to":"a","notifications":"notificaciones","mark_all_as_read":"marcar todo como leido","search_without_result":"Su b\xfasqueda no coincide con ning\xfan mensaje.","add_bookmark":"Marcar este mensaje","remove_bookmark":"Desmarcar este mensaje","bookmarks":"marcadores","api_key":"Clave API","reset_api_key":"Restablecer la clave API (se desconectar\xe1)","video_not_ready":"El v\xeddeo a\xfan no est\xe1 listo.","bookmark_added":"Mensaje en favoritos.","bookmark_removed":"Se elimin\xf3 el marcador de mensajes.","parent_message":"Mensaje para padres","audio_not_ready":"El audio a\xfan no est\xe1 listo.","upload_audio":"A\xf1adir un archivo de audio."}');


var $b890f63bba07e3e3$exports = {};
$b890f63bba07e3e3$exports = JSON.parse('{"previous_coms":"Voir les commentaires pr\xe9c\xe9dents","next_coms":"Voir les commentaires suivants","ago":"Il y a {{duration}}","groups":"Groupes","login_placeholder":"courriel","password_placeholder":"mot de passe","new_password_placeholder":"nouveau mot de passe","confirm_password_placeholder":"confirmez le mot de passe","connect":"Connexion","submit":"Envoyer","title_placeholder":"Titre de votre message (optionnel)","text_placeholder":"\xc9crivez votre message ici","upload_image":"Ajouter des photos","upload_video":"Ajouter une vid\xe9o","upload_music":"Ajouter des musiques","upload_pdf":"Ajouter un PDF","add_date":"Pr\xe9ciser une date","logout":"Se d\xe9connecter","settings":"Param\xe8tres","name":"Nom","name_input":"Choisissez un nom","login":"Se connecter","login_input":"Choisissez un identifiant","email":"Courriel","email_input":"Saisissez votre adresse \xe9lectronique ici","save_changes":"Sauvegarder les changements","password":"Mot de passe","password_input":"Entrez un nouveau mot de passe","Invalid login/password":"Identifiant et/ou mot de passe invalide","edit":"Modifier","delete":"Supprimer","ask_delete_message":"\xcates-vous s\xfbr de vouloir supprimer ce message\u202F?","account":"Compte","forgot_password":"Mot de passe oubli\xe9 ?","password_reset_mail_sent":"Le courriel de r\xe9initialisation a bien \xe9t\xe9 envoy\xe9\xa0!","User not found":"Utilisateur inexistant","reset_password_title":"R\xe9initialisation de votre mot de passe","error":"Une erreur s\'est produite","passwords_dont_match":"Les mots de passe ne correspondent pas","invitation_link":"Lien d\'invitation","reset_invitation_link":"R\xe9initialiser le lien d\'invitation","invitation_welcome":"Bienvenue sur Zusam ! Veuillez vous inscrire avant de rejoindre le groupe.","signup":"S\'inscrire","create_a_group":"Cr\xe9er un groupe","create_the_group":"Cr\xe9er le groupe","quit_group":"Quitter le groupe","settings_updated":"Vos param\xe8tres ont \xe9t\xe9 mis \xe0 jour","group_updated":"Le groupe a \xe9t\xe9 mis \xe0 jour.","group_left":"Vous avez quitt\xe9 le groupe.","multiple_photos_upload":"Une erreur s\'est produite. Essayez de t\xe9l\xe9charger les images une par une (cela peut se produire dans certains navigateurs).","error_new_message":"Une erreur s\u2019est produite lors de l\u2019envoi de votre message.","error_upload":"Une erreur s\'est produite pendant le t\xe9l\xe9versement","cancel_write":"Voulez-vous annuler l\'\xe9criture d\'un nouveau message\xa0?","empty_message":"Le message est vide et ne peut \xeatre envoy\xe9\xa0!","cancel":"Annuler","just_now":"\xc0 l\'instant","notification_emails":"Courriel de notification","none":"Aucun","hourly":"Une fois par heure","daily":"Journalier","weekly":"Hebdomadaire","monthly":"Mensuel","notification_emails_stopped":"Notifications par courriel d\xe9sactiv\xe9es\xa0!","group_share_choice":"A quel groupe voulez-vous envoyer ce message ?","public_link":"lien public","default_group":"Groupe par d\xe9faut","destroy_account":"Supprimer votre compte","destroy_account_explain":"Une fois votre compte supprim\xe9, il sera impossible d\'annuler l\'op\xe9ration.","are_you_sure":"\xcates-vous s\xfbr ?","share_message":"partager le message","users":"utilisateurs","has_posted_in":"a post\xe9 dans","has_commented_on":"a comment\xe9","has_joined":"a rejoint","has_left":"a quitt\xe9","the_message_from":"le message de","in":"dans","lang":"langue","reply":"r\xe9pondre","replies_one":"{{count}} r\xe9ponse","replies_other":"{{count}} r\xe9ponses","publish_in_group":"promouvoir le message","search_in_group":"rechercher dans le groupe","changed_group_name":"a chang\xe9 le nom du groupe","to":"en","notifications":"notifications","mark_all_as_read":"tout marquer comme lu","search_without_result":"Votre recherche ne correspond \xe0 aucun message.","add_bookmark":"Ajouter aux marque-pages","remove_bookmark":"Supprimer des marque-pages","bookmarks":"marque-pages","api_key":"Clef d\'API","reset_api_key":"Changer votre clef d\'API (vous allez \xeatre d\xe9connect\xe9)","video_not_ready":"La vid\xe9o n\'est pas encore pr\xeate.","bookmark_added":"Message ajout\xe9 aux marque-pages !","bookmark_removed":"Message supprim\xe9 des marque-pages !","parent_message":"Message parent","audio_not_ready":"Le fichier audio n\'est pas pr\xeat.","upload_audio":"Ajouter un fichier audio."}');


var $ffbe0022c0047bec$exports = {};
$ffbe0022c0047bec$exports = JSON.parse('{"next_coms":"K\xf6vetkez\u0151 hozz\xe1sz\xf3l\xe1sok","ago":"{{duration}} ezel\xf6tt","groups":"Csoportok","new_password_placeholder":"\xfaj jelsz\xf3","connect":"Kapcsolat","submit":"K\xfcld\xe9s","title_placeholder":"\xdczenet c\xedme (nem k\xf6telez\u0151)","login_placeholder":"email","previous_coms":"Kor\xe1bbi hozz\xe1sz\xf3l\xe1sok","password_placeholder":"jelsz\xf3","confirm_password_placeholder":"jelsz\xf3 meger\u0151s\xedt\xe9se","text_placeholder":"\xcdrd ide az \xfczenetet","upload_image":"Fot\xf3k hozz\xe1ad\xe1sa","upload_video":"Vide\xf3 hozz\xe1ad\xe1sa","upload_music":"Zen\xe9k hozz\xe1ad\xe1sa","upload_pdf":"PDF hozz\xe1ad\xe1sa","add_date":"D\xe1tum hozz\xe1ad\xe1sa","logout":"Kijelentkez\xe9s","name_input":"V\xe1lassz egy nevet","login":"Bejelentkez\xe9s","login_input":"V\xe1lassz ki egy bejelentkez\xe9st","email":"Email","email_input":"\xcdrd az email c\xedmedet ide","save_changes":"V\xe1ltoz\xe1sok ment\xe9se","password":"Jelsz\xf3","Invalid login/password":"Hib\xe1s felhaszn\xe1l\xf3 \xe9s/vagy jelsz\xf3","delete":"T\xf6rl\xe9s","account":"Fi\xf3k","forgot_password":"Elfelejtetted a jelszavad?","password_reset_mail_sent":"A jelsz\xf3helyre\xe1ll\xedt\xf3 email el lett k\xfcldve!","User not found":"Felhaszn\xe1l\xf3 nem tal\xe1lhat\xf3","reset_password_title":"Jelsz\xf3 alaphelyzetbe \xe1ll\xedt\xe1s","error":"Hiba t\xf6rt\xe9nt","invitation_link":"Megh\xedv\xf3 link","invitation_welcome":"\xdcdv\xf6z\xf6l a Zusam ! Regisztr\xe1lj miel\xf6tt bel\xe9psz egy csoportba.","signup":"Regisztr\xe1ci\xf3","create_a_group":"Egy csoport l\xe9trehoz\xe1sa","create_the_group":"A csoport l\xe9trehoz\xe1sa","quit_group":"Kil\xe9p\xe9s a csoportb\xf3l","group_updated":"A csoport friss\xedtve !","group_left":"Elhagytad a csoportot !","error_new_message":"Hiba t\xf6rt\xe9nt az \xfczenet k\xfcld\xe9se k\xf6zben.","error_upload":"Hiba t\xf6rt\xe9nt a felt\xf6lt\xe9s k\xf6zben","empty_message":"Az \xfczenet \xfcres \xe9s \xedgy nem k\xfcldhet\u0151 el !","cancel":"M\xe9gsem","just_now":"Csak most","notification_emails":"Email \xe9rtes\xedt\xe9sek","none":"Egyik sem","hourly":"\xd3r\xe1nk\xe9nt","daily":"Napi","weekly":"Heti","monthly":"Havi","notification_emails_stopped":"Az e-mail \xe9rtes\xedt\xe9sek le\xe1lltak !","public_link":"nyilv\xe1nos link","default_group":"Alap\xe9rtelmezett csoport","destroy_account":"A fi\xf3k t\xf6rl\xe9se","are_you_sure":"Biztos vagy benne?","share_message":"Az \xfczenet megoszt\xe1sa","users":"felhaszn\xe1l\xf3k","has_posted_in":"k\xf6zz\xe9t\xe9ve","has_commented_on":"hozz\xe1szolt","has_joined":"csatlakozott","has_left":"kil\xe9pett","in":"ban","lang":"nyelv","reply":"v\xe1lasz","replies_other":"{{count}} v\xe1lasz","search_in_group":"keres\xe9s ebben a csoportban","changed_group_name":"megv\xe1ltoztatta a csoport nev\xe9t","mark_all_as_read":"\xf6sszes megjel\xf6l\xe9se olvasottk\xe9nt","search_without_result":"A keres\xe9s nem egyezett egyetlen \xfczenettel sem.","bookmarks":"k\xf6nyvjelz\u0151k","add_bookmark":"\xdczenet elrak\xe1sa a k\xf6nyvjelz\u0151kh\xf6z","api_key":"API kulcs","reset_api_key":"Az API-kulcs alaphelyzetbe \xe1ll\xedt\xe1sa (megszakad a kapcsolat)","video_not_ready":"A vide\xf3 m\xe9g nem \xe1ll k\xe9szen.","bookmark_added":"\xdczenet hozz\xe1adva a k\xf6nyvjelz\u0151kh\xf6z !","bookmark_removed":"Az \xfczenet elt\xe1vol\xedtva a k\xf6nyvjelz\u0151k k\xf6z\xfcl!","parent_message":"Sz\xfcl\u0151 \xfczenet","settings":"Be\xe1ll\xedt\xe1sok","name":"N\xe9v","password_input":"\xcdrd ide az \xfaj jelsz\xf3t","edit":"Szerkeszt\xe9s","ask_delete_message":"Biztos, hogy t\xf6rl\xf6d az \xfczenetet?","passwords_dont_match":"A jelszavak nem egyeznek","reset_invitation_link":"Megh\xedv\xf3 link alaphelyzetbe \xe1ll\xedt\xe1sa","settings_updated":"A be\xe1ll\xedt\xe1sok friss\xfcltek","multiple_photos_upload":"Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld a k\xe9peket egyes\xe9vel felt\xf6lteni ( n\xe9h\xe1ny b\xf6ng\xe9sz\u0151ben ez t\xf6rt\xe9nhet ).","cancel_write":"Biztos, hogy megszak\xedt\xf3d az \xfaj \xfczeneted \xedr\xe1s\xe1t?","group_share_choice":"Melyik csoportnak szeretn\xe9 elk\xfcldeni ezt az \xfczenetet?","destroy_account_explain":"Miut\xe1n t\xf6r\xf6lte a fi\xf3kj\xe1t, nincs vissza\xfat. K\xe9rlek, l\xe9gy biztos.","notifications":"\xe9rtes\xedt\xe9sek","the_message_from":"az \xfczenet k\xfcld\u0151je","replies_one":"{{count}} v\xe1lasz","publish_in_group":"k\xf6zz\xe9t\xe9tel a csoportban","to":"hoz","remove_bookmark":"\xdczenet k\xf6nyvjelz\u0151j\xe9nek t\xf6rl\xe9se","upload_audio":"","audio_not_ready":""}');


var $7fbc635ad01bd584$exports = {};
$7fbc635ad01bd584$exports = JSON.parse('{"groups":"\uADF8\uB8F9","new_password_placeholder":"\uC0C8\uB85C\uC6B4 \uBE44\uBC00\uBC88\uD638","confirm_password_placeholder":"\uBE44\uBC00\uBC88\uD638 \uD655\uC778","title_placeholder":"\uBA54\uC2DC\uC9C0 \uC81C\uBAA9 (\uC120\uD0DD\uC0AC\uD56D)","upload_pdf":"PDF \uCD94\uAC00","password":"\uBE44\uBC00\uBC88\uD638","password_input":"\uC5EC\uAE30\uC5D0 \uC0C8\uB85C\uC6B4 \uBE44\uBC00\uBC88\uD638 \uC791\uC131","password_reset_mail_sent":"\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815 \uC774\uBA54\uC77C\uC774 \uC804\uC1A1\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","settings_updated":"\uC124\uC815 \uC5C5\uB370\uC774\uD2B8\uB428","notification_emails_stopped":"\uC774\uBA54\uC77C \uC54C\uB9BC\uC774 \uC911\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","public_link":"\uACF5\uAC1C \uB9C1\uD06C","has_commented_on":"\uB313\uAE00 \uB4F1\uB85D\uB428","the_message_from":"\uBA54\uC138\uC9C0","previous_coms":"\uC774\uC804 \uB313\uAE00 \uBCF4\uAE30","next_coms":"\uB2E4\uC74C \uB313\uAE00 \uBCF4\uAE30","ago":"{{duration}} \uC804","name_input":"\uC774\uB984 \uC120\uD0DD","login_placeholder":"\uC774\uBA54\uC77C","submit":"\uC81C\uCD9C","add_date":"\uB0A0\uC9DC \uCD94\uAC00","name":"\uC774\uB984","password_placeholder":"\uBE44\uBC00\uBC88\uD638","upload_music":"\uC74C\uC545 \uCD94\uAC00","logout":"\uB85C\uADF8\uC544\uC6C3","connect":"\uC5F0\uACB0","text_placeholder":"\uC5EC\uAE30\uC5D0 \uBA54\uC2DC\uC9C0 \uC791\uC131","upload_video":"\uB3D9\uC601\uC0C1 \uCD94\uAC00","settings":"\uC124\uC815","login":"\uB85C\uADF8\uC778","login_input":"\uB85C\uADF8\uC778 \uC120\uD0DD","upload_image":"\uC0AC\uC9C4 \uCD94\uAC00","save_changes":"\uBCC0\uACBD \uC0AC\uD56D \uC800\uC7A5","email":"\uC774\uBA54\uC77C","email_input":"\uC5EC\uAE30\uC5D0 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD569\uB2C8\uB2E4","Invalid login/password":"\uC798\uBABB\uB41C \uB85C\uADF8\uC778 \uBC0F/\uB610\uB294 \uBE44\uBC00\uBC88\uD638","edit":"\uD3B8\uC9D1","delete":"\uC0AD\uC81C","ask_delete_message":"\uC774 \uBA54\uC2DC\uC9C0\uB97C \uC0AD\uC81C\uD558\uACA0\uC2B5\uB2C8\uAE4C?","account":"\uACC4\uC815","forgot_password":"\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC5B4\uBC84\uB838\uC2B5\uB2C8\uAE4C?","signup":"\uAC00\uC785\uD558\uAE30","notification_emails":"\uC774\uBA54\uC77C \uC54C\uB9BC","none":"\uC5C6\uC74C","User not found":"\uC0AC\uC6A9\uC790\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC74C","reset_password_title":"\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815","invitation_link":"\uCD08\uB300 \uB9C1\uD06C","reset_invitation_link":"\uCD08\uB300 \uB9C1\uD06C \uC7AC\uC124\uC815","error":"\uC624\uB958 \uBC1C\uC0DD","passwords_dont_match":"\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC74C","invitation_welcome":"Zusam\uC5D0 \uC624\uC2E0 \uAC83\uC744 \uD658\uC601\uD569\uB2C8\uB2E4. \uADF8\uB8F9\uC5D0 \uAC00\uC785\uD558\uAE30 \uC804\uC5D0 \uAC00\uC785\uD558\uC138\uC694.","create_a_group":"\uADF8\uB8F9 \uB9CC\uB4E4\uAE30","daily":"\uC77C\uAC04","create_the_group":"\uADF8\uB8F9 \uB9CC\uB4E4\uAE30","quit_group":"\uADF8\uB8F9 \uB098\uAC00\uAE30","group_updated":"\uADF8\uB8F9\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","multiple_photos_upload":"\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBBF8\uC9C0\uB97C \uD558\uB098\uC529 \uC5C5\uB85C\uB4DC\uD574 \uBCF4\uC138\uC694 (\uC77C\uBD80 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uBC1C\uC0DD\uD560 \uC218 \uC788\uC74C).","group_left":"\uADF8\uB8F9\uC744 \uB098\uAC14\uC2B5\uB2C8\uB2E4.","error_new_message":"\uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0B4\uB294 \uB3D9\uC548 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.","empty_message":"\uBA54\uC2DC\uC9C0\uAC00 \uBE44\uC5B4 \uC788\uC5B4 \uBCF4\uB0BC \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","default_group":"\uAE30\uBCF8 \uADF8\uB8F9","error_upload":"\uC5C5\uB85C\uB4DC \uC911 \uC624\uB958 \uBC1C\uC0DD","weekly":"\uC8FC\uAC04","monthly":"\uC6D4\uAC04","cancel_write":"\uC0C8\uB85C\uC6B4 \uBA54\uC2DC\uC9C0 \uC791\uC131\uC744 \uCDE8\uC18C\uD558\uACA0\uC2B5\uB2C8\uAE4C?","cancel":"\uCDE8\uC18C","group_share_choice":"\uC774 \uBA54\uC2DC\uC9C0\uB97C \uC5B4\uB290 \uADF8\uB8F9\uC5D0 \uBCF4\uB0B4\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","hourly":"\uB9E4 \uC2DC\uAC04","just_now":"\uC9C0\uAE08 \uB2F9\uC7A5","users":"\uC0AC\uC6A9\uC790","has_posted_in":"\uAC8C\uC2DC\uB428","destroy_account":"\uACC4\uC815 \uC0AD\uC81C","destroy_account_explain":"\uACC4\uC815\uC744 \uC0AD\uC81C\uD558\uBA74 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uD655\uC778 \uD574 \uC8FC\uC138\uC694.","are_you_sure":"\uD655\uC2E4\uD558\uB098\uC694?","share_message":"\uBA54\uC2DC\uC9C0 \uACF5\uC720","has_joined":"\uAC00\uC785\uB428","lang":"\uC5B8\uC5B4","reply":"\uB2F5\uAE00","replies_one":"{{count}} \uB2F5\uAE00","publish_in_group":"\uADF8\uB8F9\uC5D0 \uAC8C\uC2DC","search_in_group":"\uC774 \uADF8\uB8F9\uC5D0\uC11C \uAC80\uC0C9","to":"\uC5D0","search_without_result":"\uAC80\uC0C9\uC5B4\uC640 \uC77C\uCE58\uD558\uB294 \uBA54\uC2DC\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","bookmarks":"\uBD81\uB9C8\uD06C","video_not_ready":"\uB3D9\uC601\uC0C1\uC774 \uC544\uC9C1 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.","parent_message":"\uC0C1\uC704 \uBA54\uC2DC\uC9C0","in":"\uC758","changed_group_name":"\uADF8\uB8F9 \uC774\uB984 \uBCC0\uACBD\uB428","notifications":"\uC54C\uB9BC","mark_all_as_read":"\uBAA8\uB450 \uC77D\uC740 \uAC83\uC73C\uB85C \uD45C\uC2DC","reset_api_key":"API \uD0A4 \uC7AC\uC124\uC815 (\uC5F0\uACB0\uC774 \uB04A\uC5B4\uC9D0)","has_left":"\uB098\uAC14\uC74C","replies_other":"{{count}} \uB2F5\uAE00","remove_bookmark":"\uBD81\uB9C8\uD06C \uD574\uC81C \uBA54\uC2DC\uC9C0","api_key":"API \uD0A4","bookmark_added":"\uBD81\uB9C8\uD06C\uC5D0 \uBA54\uC2DC\uC9C0\uAC00 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","bookmark_removed":"\uBD81\uB9C8\uD06C\uC5D0\uC11C \uBA54\uC2DC\uC9C0\uAC00 \uC81C\uAC70\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","add_bookmark":"\uBD81\uB9C8\uD06C \uBA54\uC2DC\uC9C0","audio_not_ready":"\uC624\uB514\uC624\uAC00 \uC544\uC9C1 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.","upload_audio":"\uC624\uB514\uC624 \uD30C\uC77C\uC744 \uCD94\uAC00\uD569\uB2C8\uB2E4."}');


var $c59ffcac4eb96a5c$exports = {};
$c59ffcac4eb96a5c$exports = JSON.parse('{"login_placeholder":"e-post","password_placeholder":"passord","new_password_placeholder":"nytt passord","add_date":"Legg til en dato","logout":"Logg ut","upload_pdf":"Legg til PDF","email_input":"Fyll inn e-postadressen din her","save_changes":"Lagre endringer","password":"Passord","login_input":"Velg innloggingsnavn","password_input":"Skriv det nye passordet ditt her","ask_delete_message":"Slett meldingen?","account":"Konto","passwords_dont_match":"Passordene samsvarer ikke","reset_invitation_link":"Tilbakestill invitasjonslenke","password_reset_mail_sent":"Se etter e-post om tilbakestilling av passord i innboksen din.","invitation_welcome":"Velkommen til Zusam. Registrer deg f\xf8r du tar del i gruppen.","group_updated":"Gruppen ble oppdatert.","error_new_message":"En feil inntraff ved forsendelse av meldingen din","just_now":"Akkurat n\xe5","none":"Ingen","cancel_write":"Forkast den nye meldingen?","group_share_choice":"Hvilken gruppe vil du sende denne meldingen til?","share_message":"del meldingen","has_posted_in":"har postet i","destroy_account_explain":"N\xe5r du sletter kontoen din er permanent. V\xe6r sikker i din sak.","in":"i","has_joined":"har tatt del i","has_left":"har forlatt","has_commented_on":"har kommentert","publish_in_group":"offentliggj\xf8r i gruppen","search_in_group":"s\xf8k i denne gruppen","changed_group_name":"endret gruppenavnet","to":"til","notifications":"merknader","remove_bookmark":"Fjern meldingsbokmerke","search_without_result":"S\xf8ket ditt er resultatl\xf8st.","bookmarks":"bokmerker","reset_api_key":"Tilbakestill API-n\xf8kkelen (du vil bli frakoblet)","bookmark_added":"Melding bokmerket.","upload_audio":"Legg til en lydfil.","previous_coms":"Vis tidligere kommentarer","groups":"Grupper","connect":"Tilkobling","next_coms":"Vis videre kommentarer","ago":"{{duration}} siden","submit":"Send inn","text_placeholder":"Skriv meldingen din her","confirm_password_placeholder":"bekreft","title_placeholder":"Navn p\xe5 meldingen (valgfritt)","upload_image":"Legg til bilder","upload_video":"Legg til video","upload_music":"Legg til musikk","forgot_password":"Glemt passordet?","settings":"Innstillinger","name":"Navn","signup":"Registrer deg","name_input":"Velg et navn","login":"Logg inn","email":"E-post","edit":"Rediger","delete":"Slett","error":"En feil oppstod","User not found":"Fant ikke brukeren","public_link":"offentlig lenke","reset_password_title":"Tilbakestill passordet ditt","invitation_link":"Invitasjonslenke","create_a_group":"Opprett en gruppe","create_the_group":"Opprett gruppen","group_left":"Du forlot gruppen.","quit_group":"Forlat gruppen","destroy_account":"Slett kontoen din","lang":"spr\xe5k","replies_other":"{{count}} svar","daily":"Daglig","weekly":"Ukentlig","monthly":"M\xe5nedlig","default_group":"Forvalgt gruppe","are_you_sure":"Er du sikker?","the_message_from":"meldingen fra","users":"brukere","reply":"svar","replies_one":"{{count}} svar","video_not_ready":"Videoen er ikke klar enda.","api_key":"API-n\xf8kkel","audio_not_ready":"Lyden er ikke klar enda.","Invalid login/password":"Ugyldig brukernavn/eller passord","mark_all_as_read":"marker alt som lest","add_bookmark":"Bokmerk melding","settings_updated":"Innstillingene dine ble oppdatert","hourly":"Timevist","multiple_photos_upload":"En feil inntraff. Pr\xf8v \xe5 laste opp bilder enkeltvis. (N\xf8dvendig i noen nettlesere.)","error_upload":"En feil inntraff under opplasting","cancel":"Avbryt","empty_message":"Meldingen er tom og kan ikke sendes.","notification_emails":"E-postmerknader","notification_emails_stopped":"E-postmerknader stoppet.","bookmark_removed":"Meldingsbokmerke fjernet.","parent_message":"Inneholdende melding"}');


var $bfcb09c97b6918c1$exports = {};
$bfcb09c97b6918c1$exports = JSON.parse('{"previous_coms":"Zie vorige","next_coms":"Zie volgende","ago":"{{duration}} geleden","groups":"Groepen","login_placeholder":"e-mail","password_placeholder":"wachtwoord","new_password_placeholder":"nieuw wachtwoord","confirm_password_placeholder":"bevestig wachtwoord","connect":"Verbind","submit":"Verstuur","title_placeholder":"Titel van jouw bericht (optioneel)","text_placeholder":"Schrijf jouw bericht hier","upload_image":"Voeg foto\'s toe","upload_video":"Voeg filmpje toe","upload_music":"Voeg muziek toe","upload_pdf":"Voeg PDF toe","add_date":"Voeg een datum toe","logout":"Afmelden","settings":"Instellingen","name":"Naam","name_input":"Kies een naam","login":"Aanmelden","login_input":"Kies een aanmeldingsnaam","email":"E-mail","email_input":"Voeg uw e-mail adres hier in","save_changes":"Wijzigingen opslaan","password":"Wachtwoord","password_input":"Kies een nieuw wachtwoord","Invalid login/password":"Ongeldige aanmeldnaam/wachtwoord combinatie","edit":"Bewerken","delete":"Verwijderen","ask_delete_message":"Verwijder dit bericht?","account":"Account","forgot_password":"Wachtwoord vergeten?","password_reset_mail_sent":"Zoek in uw inbox naar de wachtwoordreset e-mail.","User not found":"Gebruiker niet gevonden","reset_password_title":"Reset uw wachtwoord","error":"Er is een fout opgetreden","passwords_dont_match":"Wachtwoorden komen niet overeen","invitation_link":"Uitnodigings link","reset_invitation_link":"Reset uitnodiging link","invitation_welcome":"Welkom op Zusam. Gelieve aan te melden vooraleer in een groep in te schrijven.","signup":"Inschrijven","create_a_group":"Maak een groep","create_the_group":"Maak de groep","quit_group":"Verlaat de groep","settings_updated":"Uw instellingen werden aangepast","group_updated":"De groep werd aangepast.","group_left":"U heeft de groep verlaten.","multiple_photos_upload":"Er is een fout opgetreden. Probeer foto\'s \xe9\xe9n voor \xe9\xe9n op te laden","error_new_message":"Er is een fout opgetreden bij het doorsturen van uw bericht.","error_upload":"Er is een fout opgetreden bij het uploaden","cancel_write":"Bent u zeker dat u dit bericht wil annuleren?","empty_message":"Dit bericht is leeg en kan niet worden verzonden.","cancel":"Annuleren","just_now":"Net","notification_emails":"E-mail meldingen","none":"Niets","hourly":"Elk uur","daily":"Elke dag","weekly":"Elke week","monthly":"Elke maand","notification_emails_stopped":"E-mail meldingen zijn gestopt !","group_share_choice":"Naar welke groep wenst u dit bericht te versturen?","public_link":"publieke link","default_group":"Standaard groep","destroy_account":"Verwijder jouw account","destroy_account_explain":"Indien u uw account verwijdert, kan deze niet meer worden teruggehaald.","are_you_sure":"Bent u zeker?","share_message":"Deel bericht","users":"gebruikers","has_posted_in":"heeft gepost in","has_commented_on":"heeft commentaar gegeven op","has_joined":"is erbij gekomen","has_left":"is weggegaan","the_message_from":"het bericht van","in":"in","lang":"taal","reply":"antwoorden","replies_one":"{{count}} antwoord","replies_other":"{{count}} antwoorden","publish_in_group":"gepubliseerd in de groep","search_in_group":"zoek in deze groep","changed_group_name":"verandert de groepsnaam","to":"aan","notifications":"notificaties","mark_all_as_read":"markeer als gelezen","search_without_result":"Er werd geen enkel bericht gevonden met deze criteria.","add_bookmark":"Bookmark bericht","remove_bookmark":"Unbookmark bericht","bookmarks":"bookmarks","api_key":"API key","reset_api_key":"Reset de API key (u zal worden gedeconnecteerd)","video_not_ready":"Video is nog niet klaar.","bookmark_added":"Bericht toegevoegd aan bladwijzers.","bookmark_removed":"Bericht verwijderd uit bladwijzers.","parent_message":"Parent bericht","upload_audio":"Voeg een audiobestand toe.","audio_not_ready":"Audio is nog niet klaar."}');


var $3def3210ee9fc9cd$exports = {};
$3def3210ee9fc9cd$exports = JSON.parse('{"next_coms":"Ver os pr\xf3ximos coment\xe1rios","ago":"{{duration}} atr\xe1s","new_password_placeholder":"nova senha","confirm_password_placeholder":"confirmar senha","connect":"Conex\xe3o","submit":"Enviar","text_placeholder":"Escreva sua mensagem aqui","upload_video":"Adicionar um v\xeddeo","upload_music":"Adicionar m\xfasica","upload_pdf":"Adicionar PDF","login":"Entrar","login_input":"Escolha um login","Invalid login/password":"Login e/ou senha inv\xe1lidos","edit":"Editar","ask_delete_message":"Deletar essa mensagem?","passwords_dont_match":"As senhas n\xe3o coincidem","invitation_welcome":"Bem-vindo ao Zusam. Registre-se antes de entrar no grupo.","create_the_group":"Criar o grupo","group_updated":"O grupo foi atualizado.","cancel_write":"Voc\xea realmente deseja cancelar a cria\xe7\xe3o de uma nova mensagem?","just_now":"Agora mesmo","hourly":"Por Hora","destroy_account":"Deletar sua conta","are_you_sure":"Voc\xea tem certeza?","share_message":"compartilhe a mensagem","has_commented_on":"comentou em","in":"em","lang":"idioma","publish_in_group":"publicar no grupo","remove_bookmark":"Remover mensagem dos favoritos","api_key":"Chave API","video_not_ready":"O v\xeddeo ainda n\xe3o est\xe1 pronto.","previous_coms":"Ver coment\xe1rios anteriores","groups":"Grupos","login_placeholder":"e-mail","password_placeholder":"senha","title_placeholder":"T\xedtulo da sua mensagem (opcional)","upload_image":"Adicionar fotos","logout":"Sair da sess\xe3o","add_date":"Adicionar uma data","settings":"Configura\xe7\xf5es","email":"E-mail","password":"Senha","name":"Nome","email_input":"Preencha seu endere\xe7o de e-mail aqui","name_input":"Escolher um nome","save_changes":"Salvar altera\xe7\xf5es","password_input":"Escreva uma nova senha aqui","delete":"Deletar","account":"Conta","forgot_password":"Esqueceu sua senha?","password_reset_mail_sent":"Procure o e-mail de redefini\xe7\xe3o de senha em sua caixa de entrada.","User not found":"Usu\xe1rio n\xe3o encontrado","reset_password_title":"Redefinir sua senha","error":"Um erro ocorreu","invitation_link":"Link de convite","reset_invitation_link":"Redefinir o link de convite","signup":"Registrar-se","create_a_group":"Criar um grupo","quit_group":"Sair do grupo","settings_updated":"Suas configura\xe7\xf5es foram atualizadas","group_left":"Voc\xea saiu do grupo.","multiple_photos_upload":"Ocorreu um erro. Tente fazer o upload das imagens uma a uma (isso pode ocorrer em alguns navegadores)","error_new_message":"Um erro ocorreu ao enviar sua mensagem.","error_upload":"Ocorreu um erro durante o envio","empty_message":"A mensagem est\xe1 vazia e n\xe3o pode ser enviada.","cancel":"Cancelar","notification_emails":"Notifica\xe7\xf5es de e-mail","none":"Nenhuma","daily":"Diariamente","weekly":"Semanalmente","monthly":"Mensal","notification_emails_stopped":"As notifica\xe7\xf5es de e-mail foram interrompidas!","group_share_choice":"Para qual grupo voc\xea deseja enviar essa mensagem?","public_link":"link p\xfablico","default_group":"Grupo padr\xe3o","destroy_account_explain":"Depois de excluir sua conta, n\xe3o h\xe1 como voltar atr\xe1s. Por favor, tenha certeza.","users":"usu\xe1rios","has_posted_in":"postou em","has_joined":"entrou","has_left":"saiu","the_message_from":"a mensagem de","reply":"responder","replies_one":"{{count}} responder","replies_other":"{{count}} respostas","search_in_group":"procurar neste grupo","changed_group_name":"mudou o nome do grupo","to":"para","notifications":"notifica\xe7\xf5es","mark_all_as_read":"marcar todos como lido","search_without_result":"Sua pesquisa n\xe3o correspondeu a nenhuma mensagem.","add_bookmark":"Adicionar mensagem aos favoritos","bookmarks":"Favoritos","reset_api_key":"Redefinir a chave API (voc\xea ser\xe1 desconectado)","bookmark_added":"Mensagem adicionada aos favoritos.","bookmark_removed":"Mensagem removida dos favoritos.","parent_message":"Mensagem relacionada","audio_not_ready":"O \xe1udio ainda n\xe3o est\xe1 pronto.","upload_audio":"Adicionar um arquivo de \xe1udio."}');


var $12b602ca54d45d9f$exports = {};
$12b602ca54d45d9f$exports = JSON.parse('{"add_bookmark":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0432 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438","add_date":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0430\u0442\u0443","api_key":"\u041A\u043B\u044E\u0447 API","are_you_sure":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B?","ask_delete_message":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435?","audio_not_ready":"\u0410\u0443\u0434\u0438\u043E \u0435\u0449\u0435 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u043E.","bookmark_added":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438 !","bookmark_removed":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0437\u0430\u043A\u043B\u0430\u0434\u043E\u043A !","bookmarks":"\u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438","cancel_write":"\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0443 \u043D\u043E\u0432\u043E\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F?","changed_group_name":"\u0438\u0437\u043C\u0435\u043D\u0438\u043B \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B","confirm_password_placeholder":"\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C","create_a_group":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443","default_group":"\u0413\u0440\u0443\u043F\u043F\u0430 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E","delete":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","destroy_account":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442","edit":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C","email_input":"\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0437\u0434\u0435\u0441\u044C","email":"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430","empty_message":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0443\u0441\u0442\u043E\u0435 \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E !","error_new_message":"\u041F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430.","error_upload":"\u0412\u043E \u0432\u0440\u0435\u043C\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430","error":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430","forgot_password":"\u0412\u044B \u0437\u0430\u0431\u044B\u043B\u0438 \u0441\u0432\u043E\u0439 \u043F\u0430\u0440\u043E\u043B\u044C?","group_left":"\u0422\u044B \u043F\u043E\u043A\u0438\u043D\u0443\u043B \u0433\u0440\u0443\u043F\u043F\u0443 !","group_share_choice":"\u041A\u0430\u043A\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u0435 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u044D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435?","groups":"\u0413\u0440\u0443\u043F\u043F\u044B","group_updated":"\u0413\u0440\u0443\u043F\u043F\u0430 \u0431\u044B\u043B\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430!","has_commented_on":"\u043F\u0440\u043E\u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043B","has_joined":"\u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F","has_left":"\u0443\u0448\u0435\u043B","has_posted_in":"\u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u043B \u0432","Invalid login/password":"\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043B\u043E\u0433\u0438\u043D \u0438/\u0438\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C","invitation_link":"\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430","invitation_welcome":"\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C \u043D\u0430 Zusam! \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C, \u043F\u0440\u0435\u0436\u0434\u0435 \u0447\u0435\u043C \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u0433\u0440\u0443\u043F\u043F\u0435.","in":"\u0432","lang":"\u044F\u0437\u044B\u043A","login_placeholder":"\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430","login":"\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F","logout":"\u0412\u044B\u0445\u043E\u0434 \u0438\u0437 \u0441\u0438\u0441\u0442\u0435\u043C\u044B","mark_all_as_read":"\u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435 \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u043E\u0435","multiple_photos_upload":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443 (\u044D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0442\u0438 \u0432 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430\u0445)","name_input":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0438\u043C\u044F","name":"\u0418\u043C\u044F","new_password_placeholder":"\u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C","notification_emails_stopped":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B !","notification_emails":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435","notifications":"\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F","password_input":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0437\u0434\u0435\u0441\u044C","password_placeholder":"\u043F\u0430\u0440\u043E\u043B\u044C","password_reset_mail_sent":"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u0441\u043E \u0441\u0431\u0440\u043E\u0441\u043E\u043C \u043F\u0430\u0440\u043E\u043B\u044F \u0431\u044B\u043B\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E !","passwords_dont_match":"\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442","password":"\u041F\u0430\u0440\u043E\u043B\u044C","public_link":"\u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430","publish_in_group":"\u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u0432 \u0433\u0440\u0443\u043F\u043F\u0435","quit_group":"\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443","remove_bookmark":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0438\u0437 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438","reset_api_key":"\u0421\u0431\u0440\u043E\u0441\u044C\u0442\u0435 \u043A\u043B\u044E\u0447 API (\u0432\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B)","reset_invitation_link":"\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435","save_changes":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F","search_in_group":"\u043F\u043E\u0438\u0441\u043A \u0432 \u044D\u0442\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u0435","search_without_result":"\u0412\u0430\u0448 \u043F\u043E\u0438\u0441\u043A \u043D\u0435 \u0432\u044B\u044F\u0432\u0438\u043B \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F.","settings_updated":"\u0412\u0430\u0448\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0431\u044B\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B","settings":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","share_message":"\u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C","signup":"\u0412\u043E\u0439\u0442\u0438","text_placeholder":"\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0437\u0434\u0435\u0441\u044C","the_message_from":"\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442","title_placeholder":"\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F (\u043E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E)","to":"\u043A","upload_audio":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0443\u0434\u0438\u043E\u0444\u0430\u0439\u043B.","upload_image":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438","upload_music":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0443\u0437\u044B\u043A\u0443","upload_pdf":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C PDF-\u0444\u0430\u0439\u043B","upload_video":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0438\u0434\u0435\u043E","User not found":"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D","users":"\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438","video_not_ready":"\u0412\u0438\u0434\u0435\u043E \u0435\u0449\u0435 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u043E."}');


var $43cf61491a662e98$exports = {};
$43cf61491a662e98$exports = JSON.parse('{"previous_coms":"Pozri predch\xe1dzaj\xface koment\xe1re","next_coms":"Pozri nasleduj\xface koment\xe1re","ago":"{{duration}} sp\xe4\u0165","groups":"Skupiny","login_placeholder":"email","password_placeholder":"heslo","new_password_placeholder":"nov\xe9 heslo","confirm_password_placeholder":"potvrdi\u0165 heslo","connect":"Pripojenie","submit":"Odosla\u0165","title_placeholder":"Nadpis v\xe1\u0161ho pr\xedspevku (nie je povinn\xe9)","text_placeholder":"Tu nap\xed\u0161 pr\xedspevok","upload_image":"Prida\u0165 fotografie","upload_video":"Pridajte video","upload_music":"Prida\u0165 hudbu","upload_pdf":"Prida\u0165 PDF","add_date":"Prida\u0165 d\xe1tum","logout":"Odhl\xe1si\u0165","settings":"Nastavenia","name":"Meno","name_input":"Zvo\u013E si nejak\xe9 meno","login":"Login","login_input":"Zvo\u013E si nejak\xe9 prihlasovacie meno","email":"Email","email_input":"Nap\xed\u0161 tvoj email sem","save_changes":"Ulo\u017Ei\u0165 zmeny","password":"Heslo","password_input":"Tu nap\xed\u0161 heslo","Invalid login/password":"Nespr\xe1vny login alebo heslo","edit":"Upravi\u0165","delete":"Zmaza\u0165","ask_delete_message":"Si si ist\xfd, \u017Ee chce\u0161 zmaza\u0165 tento pr\xedspevok?","account":"\xda\u010Det","forgot_password":"Zabudol si svoje heslo?","password_reset_mail_sent":"Email s inform\xe1ciami o nastaven\xed nov\xe9ho hesla bol odoslan\xfd!","User not found":"Neexistuj\xfaci u\u017E\xedvate\u013E","reset_password_title":"Zmena hesla","error":"Chyba","passwords_dont_match":"Hesl\xe1 sa nezhoduj\xfa","invitation_link":"Poz\xfdvac\xed odkaz","reset_invitation_link":"Obnovi\u0165 pozv\xe1nku odkaz","invitation_welcome":"Vitajte v Zusam ! Zaregistrujte sa pred pripojen\xedm sa ku skupine.","signup":"Prihl\xe1si\u0165","create_a_group":"Vytvori\u0165 skupinu","create_the_group":"Vytvori\u0165 skupinu","quit_group":"Opusti\u0165 skupinu","settings_updated":"Va\u0161e nastavenia boli zmenen\xe9","group_updated":"Nastavenia skupiny boli zmenen\xe9!","group_left":"Opustili ste skupinu!","multiple_photos_upload":"Objavila sa chyba. Sk\xfaste prilo\u017Ei\u0165 obr\xe1zky po jednom (t\xe1to chyba sa m\xf4\u017Ee objavova\u0165 v niektor\xfdch prehliada\u010Doch)","error_new_message":"Pri odosielan\xed va\u0161ej spr\xe1vy do\u0161lo k chybe.","error_upload":"Objavila sa chyba po\u010Das odosielania","cancel_write":"Chcete naozaj zru\u0161i\u0165 vytv\xe1ranie nov\xe9ho pr\xedspevku?","empty_message":"Spr\xe1va je pr\xe1zdna a nie je mo\u017En\xe1!","cancel":"Zru\u0161i\u0165","just_now":"Pr\xe1ve teraz","notification_emails":"Notifika\u010Dn\xfd email","none":"\u017Diadne","hourly":"Ka\u017Ed\xfa hodinu","daily":"Denne","weekly":"T\xfd\u017Edenne","monthly":"Mesa\u010Dne","notification_emails_stopped":"E-mailov\xe9 upozornenia sa zastavili!","group_share_choice":"Do ktorej skupiny chcete odosla\u0165 t\xfato spr\xe1vu ?","public_link":"verejn\xe9 spojenie","default_group":"Predvolen\xfa skupinu","destroy_account":"Odstr\xe1\u0148te svoj \xfa\u010Det","destroy_account_explain":"Potom, \u010Do vyma\u017Eete svoj \xfa\u010Det, nie je tam \u017Eiadny n\xe1vrat. Pros\xedm, uistite sa.","are_you_sure":"Si si ist\xfd ?","share_message":"zdie\u013Eajte spr\xe1vu","users":"u\u017E\xedvatelia","has_posted_in":"zverejnila v","has_commented_on":"komentoval","has_joined":"sa pripojil k","has_left":"opustil","the_message_from":"spr\xe1va od","in":"v","lang":"jazyk","reply":"odpove\u010F","replies_one":"{{count}} odpove\u010F","replies_other":"{{count}} odpoved\xed","publish_in_group":"publikova\u0165 v skupine","search_in_group":"h\u013Eada\u0165 v tejto skupine","changed_group_name":"zmenil n\xe1zov skupiny","to":"na","notifications":"ozn\xe1menia","mark_all_as_read":"ozna\u010Di\u0165 v\u0161etko ako pre\u010D\xedtan\xe9","search_without_result":"Va\u0161e vyh\u013Ead\xe1vanie nezhodla \u017Eiadne spr\xe1vy.","add_bookmark":"T\xfato spr\xe1vu ulo\u017Ei\u0165 medzi z\xe1lo\u017Eky","remove_bookmark":"Zru\u0161te ozna\u010Denie tejto spr\xe1vy","bookmarks":"z\xe1lo\u017Eky","api_key":"K\u013E\xfa\u010D API","reset_api_key":"Obnovte k\u013E\xfa\u010D rozhrania API (budete odpojen\xed)","video_not_ready":"Video e\u0161te nie je pripraven\xe9.","bookmark_added":"Spr\xe1va pridan\xe1 do z\xe1lo\u017Eiek !","bookmark_removed":"Spr\xe1va bola odstr\xe1nen\xe1 zo z\xe1lo\u017Eiek !","parent_message":"Spr\xe1va rodi\u010Da","audio_not_ready":"Audio e\u0161te nie je pripraven\xfd.","upload_audio":"Pridajte zvukov\xfd s\xfabor."}');


var $143e0a838b0cb819$exports = {};
$143e0a838b0cb819$exports = JSON.parse('{"previous_coms":"\u0BAE\u0BC1\u0BA8\u0BCD\u0BA4\u0BC8\u0BAF \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","upload_music":"\u0B87\u0B9A\u0BC8\u0BAF\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","upload_pdf":"PDF \u0B90\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","add_date":"\u0B92\u0BB0\u0BC1 \u0BA4\u0BC7\u0BA4\u0BBF\u0BAF\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","logout":"\u0BB5\u0BBF\u0B9F\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","settings":"\u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","login_input":"\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BB5\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0BB0\u0BCD\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0B95","reply":"\u0BAA\u0BA4\u0BBF\u0BB2\u0BCD","replies_one":"{{count}} \u0BAA\u0BA4\u0BBF\u0BB2\u0BCD","bookmark_added":"\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF \u0BAA\u0BC1\u0B95\u0BCD\u0BAE\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","next_coms":"\u0B85\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4 \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","ago":"{{\u0B95\u0BBE\u0BB2\u0BAE\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","groups":"\u0B95\u0BC1\u0BB4\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BCD","login_placeholder":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD","password_placeholder":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD","new_password_placeholder":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD","confirm_password_placeholder":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD\u0BB2\u0BC8 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD","connect":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","submit":"\u0B9A\u0BAE\u0BB0\u0BCD\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","title_placeholder":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BBF\u0BA9\u0BCD \u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 (\u0BB5\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BBF\u0BA9\u0BBE\u0BB2\u0BCD)","text_placeholder":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0B87\u0B99\u0BCD\u0B95\u0BC7 \u0B8E\u0BB4\u0BC1\u0BA4\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","upload_image":"\u0BAA\u0BC1\u0B95\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","upload_video":"\u0BB5\u0BC0\u0B9F\u0BBF\u0BAF\u0BCB\u0BB5\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","name":"\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD","name_input":"\u0B92\u0BB0\u0BC1 \u0BAA\u0BC6\u0BAF\u0BB0\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0BB0\u0BCD\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0B95","login":"\u0BAA\u0BC1\u0B95\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","email":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD","email_input":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF\u0BAF\u0BC8 \u0B87\u0B99\u0BCD\u0B95\u0BC7 \u0BA8\u0BBF\u0BB0\u0BAA\u0BCD\u0BAA\u0BB5\u0BC1\u0BAE\u0BCD","save_changes":"\u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAF\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","password":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD","password_input":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD\u0BB2\u0BC8 \u0B87\u0B99\u0BCD\u0B95\u0BC7 \u0B8E\u0BB4\u0BC1\u0BA4\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","Invalid login/password":"\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BB5\u0BC1 \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD/\u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD","edit":"\u0BA4\u0BC6\u0BBE\u0B95\u0BC1","delete":"\u0B85\u0BB4\u0BBF","ask_delete_message":"\u0B87\u0BA8\u0BCD\u0BA4 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BB5\u0BBE?","account":"\u0B95\u0BA3\u0B95\u0BCD\u0B95\u0BC1","forgot_password":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD\u0BB2\u0BC8 \u0BAE\u0BB1\u0BA8\u0BCD\u0BA4\u0BC1 \u0BB5\u0BBF\u0B9F\u0BCD\u0B9F\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BBE?","password_reset_mail_sent":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B87\u0BA9\u0BCD\u0BAA\u0BBE\u0B95\u0BCD\u0B9A\u0BBF\u0BB2\u0BCD \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD \u0BAE\u0BC0\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0B9F\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD.","User not found":"\u0BAA\u0BAF\u0BA9\u0BB0\u0BCD \u0B95\u0BA3\u0BCD\u0B9F\u0BC1\u0BAA\u0BBF\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","reset_password_title":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD\u0BB2\u0BC8 \u0BAE\u0BC0\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95","public_link":"\u0BAA\u0BCA\u0BA4\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","error":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","passwords_dont_match":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BCD \u0BAA\u0BCA\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","invitation_link":"\u0B85\u0BB4\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BA4\u0BB4\u0BCD \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","reset_invitation_link":"\u0B85\u0BB4\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BA4\u0BB4\u0BCD \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC8 \u0BAE\u0BC0\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","invitation_welcome":"\u0B9A\u0BC2\u0B9A\u0BBE\u0BAE\u0BBF\u0BB2\u0BCD \u0BB5\u0BB0\u0BB5\u0BC7\u0BB1\u0BCD\u0B95\u0BBF\u0BB1\u0BCB\u0BAE\u0BCD. \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BB2\u0BCD \u0B9A\u0BC7\u0BB0\u0BC1\u0BB5\u0BA4\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD \u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0BAA\u0BC6\u0BB1\u0BC1\u0B95.","signup":"\u0BAA\u0BA4\u0BBF\u0BB5\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0B95","create_a_group":"\u0B92\u0BB0\u0BC1 \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BC8 \u0B89\u0BB0\u0BC1\u0BB5\u0BBE\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","create_the_group":"\u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BC8 \u0B89\u0BB0\u0BC1\u0BB5\u0BBE\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","quit_group":"\u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BC8 \u0BB5\u0BBF\u0B9F\u0BCD\u0B9F\u0BC1 \u0BB5\u0BBF\u0B9F\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","settings_updated":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA9","group_updated":"\u0B95\u0BC1\u0BB4\u0BC1 \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","group_left":"\u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BC8 \u0BB5\u0BBF\u0B9F\u0BCD\u0B9F\u0BC1 \u0BB5\u0BC6\u0BB3\u0BBF\u0BAF\u0BC7\u0BB1\u0BBF\u0BA9\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD.","multiple_photos_upload":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1. \u0BAA\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B92\u0BB5\u0BCD\u0BB5\u0BCA\u0BA9\u0BCD\u0BB1\u0BBE\u0B95 \u0BAA\u0BA4\u0BBF\u0BB5\u0BC7\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0BAF\u0BB1\u0BCD\u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD (\u0B87\u0BA4\u0BC1 \u0B9A\u0BBF\u0BB2 \u0B89\u0BB2\u0BBE\u0BB5\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0B95\u0BB4\u0BB2\u0BBE\u0BAE\u0BCD)","error_new_message":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0B85\u0BA9\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0BAE\u0BCD\u0BAA\u0BCB\u0BA4\u0BC1 \u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","error_upload":"\u0BAA\u0BA4\u0BBF\u0BB5\u0BC7\u0BB1\u0BCD\u0BB1\u0BA4\u0BCD\u0BA4\u0BBF\u0BA9\u0BCD \u0BAA\u0BCB\u0BA4\u0BC1 \u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","cancel_write":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0B8E\u0BB4\u0BC1\u0BA4\u0BC1\u0BB5\u0BA4\u0BC8 \u0BB0\u0BA4\u0BCD\u0BA4\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF \u0BB5\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BC1\u0B95\u0BBF\u0BB1\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BBE?","empty_message":"\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF \u0B95\u0BBE\u0BB2\u0BBF\u0BAF\u0BBE\u0B95 \u0B89\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1 \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0B85\u0BA9\u0BC1\u0BAA\u0BCD\u0BAA \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1.","cancel":"\u0BB0\u0BA4\u0BCD\u0BA4\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD","just_now":"\u0B87\u0BAA\u0BCD\u0BAA\u0BCB\u0BA4\u0BC1","notification_emails":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0B85\u0BB1\u0BBF\u0BB5\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","none":"\u0B8E\u0BA4\u0BC1\u0BB5\u0BC1\u0BAE\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","hourly":"\u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1","daily":"\u0BA8\u0BBE\u0BB3\u0BCD\u0BA4\u0BCB\u0BB1\u0BC1\u0BAE\u0BCD","weekly":"\u0BB5\u0BBE\u0BB0\u0BBE\u0BA8\u0BCD\u0BA4\u0BBF\u0BB0","monthly":"\u0BAE\u0BBE\u0BA4\u0BBE\u0BA8\u0BCD\u0BA4\u0BBF\u0BB0","notification_emails_stopped":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0B85\u0BB1\u0BBF\u0BB5\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD \u0BA8\u0BBF\u0BB1\u0BC1\u0BA4\u0BCD\u0BA4\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA9!","group_share_choice":"\u0B87\u0BA8\u0BCD\u0BA4 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0B8E\u0BA8\u0BCD\u0BA4 \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0B85\u0BA9\u0BC1\u0BAA\u0BCD\u0BAA \u0BB5\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BC1\u0B95\u0BBF\u0BB1\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD?","default_group":"\u0B87\u0BAF\u0BB2\u0BCD\u0BAA\u0BC1\u0BA8\u0BBF\u0BB2\u0BC8 \u0B95\u0BC1\u0BB4\u0BC1","destroy_account":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BA3\u0B95\u0BCD\u0B95\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1","destroy_account_explain":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BA3\u0B95\u0BCD\u0B95\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BBF\u0BAF\u0BA4\u0BC1\u0BAE\u0BCD, \u0BA4\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BBF\u0B9A\u0BCD \u0B9A\u0BC6\u0BB2\u0BCD\u0BB5\u0BA4\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8. \u0BA4\u0BAF\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC1 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAF\u0BBE\u0B95 \u0B87\u0BB0\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD.","are_you_sure":"\u0BA8\u0BC0 \u0B9A\u0BC6\u0BBE\u0BB2\u0BCD\u0BB5\u0BA4\u0BC1 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAF\u0BBE?","share_message":"\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BB5\u0BC1\u0BAE\u0BCD","users":"\u0BAA\u0BAF\u0BA9\u0BB0\u0BCD\u0B95\u0BB3\u0BCD","has_posted_in":"\u0B87\u0B9F\u0BC1\u0B95\u0BC8\u0BAF\u0BBF\u0B9F\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BC1\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1","has_commented_on":"\u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1 \u0BA4\u0BC6\u0BB0\u0BBF\u0BB5\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1","has_joined":"\u0B9A\u0BC7\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BC1\u0BB3\u0BCD\u0BB3\u0BBE\u0BB0\u0BCD","has_left":"\u0BAA\u0BC7\u0BBE\u0BAF\u0BCD \u0BB5\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","the_message_from":"\u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF","in":"\u0B87\u0BB2\u0BCD","lang":"\u0BAE\u0BCA\u0BB4\u0BBF","replies_other":"{{count}} \u0BAA\u0BA4\u0BBF\u0BB2\u0BCD\u0B95\u0BB3\u0BCD","publish_in_group":"\u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BB2\u0BCD \u0BB5\u0BC6\u0BB3\u0BBF\u0BAF\u0BBF\u0B9F\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","search_in_group":"\u0B87\u0BA8\u0BCD\u0BA4 \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BB2\u0BCD \u0BA4\u0BC7\u0B9F\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","changed_group_name":"\u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BA9\u0BCD \u0BAA\u0BC6\u0BAF\u0BB0\u0BC8 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BBF\u0BAF\u0BA4\u0BC1","to":"\u0BAA\u0BC6\u0BB1\u0BC1\u0BA8\u0BB0\u0BCD","notifications":"\u0B85\u0BB1\u0BBF\u0BB5\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","mark_all_as_read":"\u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC8\u0BAF\u0BC1\u0BAE\u0BCD \u0BB5\u0BBE\u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BBE\u0B95 \u0B85\u0B9F\u0BC8\u0BAF\u0BBE\u0BB3\u0BAE\u0BBF\u0B9F\u0BC1","search_without_result":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BA4\u0BC7\u0B9F\u0BB2\u0BCD \u0B8E\u0BA8\u0BCD\u0BA4 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAA\u0BCA\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","add_bookmark":"\u0BAA\u0BC1\u0B95\u0BCD\u0BAE\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF","remove_bookmark":"\u0BAA\u0BC1\u0BA4\u0BCD\u0BA4\u0B95\u0BAE\u0BB0\u0BAE\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF","bookmarks":"\u0BAA\u0BC1\u0B95\u0BCD\u0BAE\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BC1\u0B95\u0BB3\u0BCD","api_key":"\u0BAA\u0BA8\u0BBF\u0B87 \u0BB5\u0BBF\u0B9A\u0BC8","reset_api_key":"\u0BAA\u0BA8\u0BBF\u0B87 \u0BB5\u0BBF\u0B9A\u0BC8\u0BAF\u0BC8 \u0BAE\u0BC0\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD (\u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BA4\u0BC1\u0BA3\u0BCD\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BB5\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD)","video_not_ready":"\u0BB5\u0BC0\u0B9F\u0BBF\u0BAF\u0BCB \u0B87\u0BA9\u0BCD\u0BA9\u0BC1\u0BAE\u0BCD \u0BA4\u0BAF\u0BBE\u0BB0\u0BBE\u0B95 \u0B87\u0BB2\u0BCD\u0BB2\u0BC8.","bookmark_removed":"\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF \u0BAA\u0BC1\u0B95\u0BCD\u0BAE\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BC1 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","parent_message":"\u0BAA\u0BC6\u0BB1\u0BCD\u0BB1\u0BCB\u0BB0\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF","audio_not_ready":"\u0B86\u0B9F\u0BBF\u0BAF\u0BCB \u0B87\u0BA9\u0BCD\u0BA9\u0BC1\u0BAE\u0BCD \u0BA4\u0BAF\u0BBE\u0BB0\u0BBE\u0B95 \u0B87\u0BB2\u0BCD\u0BB2\u0BC8.","upload_audio":"\u0B86\u0B9F\u0BBF\u0BAF\u0BCB \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD."}');


var $efa8f9784a788c7f$exports = {};
$efa8f9784a788c7f$exports = JSON.parse('{"login":"\u2D30\u2D3D\u2D5B\u2D30\u2D4E","login_input":"\u2D59\u2D5C\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D53\u2D3D\u2D5B\u2D30\u2D4E","email":"\u2D49\u2D4E\u2D30\u2D62\u2D4D","email_input":"\u2D59\u2D59\u2D49\u2D37\u2D3C \u2D49\u2D4E\u2D30\u2D62\u2D4D \u2D4F\u2D4F\u2D3D \u2D37\u2D30","save_changes":"\u2D43\u2D39\u2D53 \u2D49\u2D59\u2D4F\u2D3C\u2D30\u2D4D\u2D4F","password":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","password_input":"\u2D30\u2D54\u2D49 \u2D37\u2D30 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","delete":"\u2D59\u2D59\u2D3C\u2D39","account":"\u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F","name":"\u2D49\u2D59\u2D4E","name_input":"\u2D59\u2D5C\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D62\u2D49\u2D59\u2D4E","next_coms":"\u2D65\u2D55 \u2D49\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D\u2D4F \u2D49\u2D4E\u2D33\u2D33\u2D53\u2D54\u2D30","ago":"{{duration}} \u2D49\u2D63\u2D54\u2D49\u2D4F","previous_coms":"\u2D65\u2D55 \u2D49\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D\u2D4F \u2D49\u2D4E\u2D63\u2D61\u2D53\u2D54\u2D30","groups":"\u2D5C\u2D49\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30\u2D61\u2D49\u2D4F","login_placeholder":"\u2D49\u2D4E\u2D30\u2D62\u2D4D","password_placeholder":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","submit":"\u2D30\u2D63\u2D4F","new_password_placeholder":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","confirm_password_placeholder":"\u2D59\u2D37\u2D37\u2D49\u2D37 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","text_placeholder":"\u2D30\u2D54\u2D49 \u2D37\u2D30 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D","upload_music":"\u2D54\u2D4F\u2D53 \u2D49\u2D65\u2D30\u2D61\u2D30\u2D4F\u2D4F","connect":"\u2D30\u2D61\u2D30\u2D39","title_placeholder":"\u2D30\u2D63\u2D61\u2D4D \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D (\u2D30\u2D54\u2D53\u2D5B\u2D5B\u2D49\u2D4D)","upload_image":"\u2D54\u2D4F\u2D53 \u2D5C\u2D49\u2D61\u2D4D\u2D30\u2D3C\u2D49\u2D4F","upload_video":"\u2D54\u2D4F\u2D53 \u2D49\u2D3C\u2D49\u2D37\u2D62\u2D53\u2D5C\u2D4F","upload_pdf":"\u2D54\u2D4F\u2D53 PDF","add_date":"\u2D54\u2D4F\u2D53 \u2D3D\u2D54\u2D30 \u2D4F \u2D53\u2D59\u2D30\u2D3D\u2D53\u2D37","logout":"\u2D3C\u2D3C\u2D56","settings":"\u2D5C\u2D49\u2D59\u2D56\u2D30\u2D4D","edit":"\u2D59\u2D33\u2D33\u2D37","lang":"\u2D5C\u2D53\u2D5C\u2D4D\u2D30\u2D62\u2D5C","ask_delete_message":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37 \u2D30\u2D37 \u2D5C\u2D3D\u2D3D\u2D59\u2D37 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D37?","Invalid login/password":"\u2D49\u2D5C\u2D5C\u2D30\u2D61\u2D63\u2D33\u2D4D \u2D53\u2D3D\u2D5B\u2D30\u2D4E \u2D37/\u2D4F\u2D49\u2D56 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","forgot_password":"\u2D49\u2D59 \u2D5C\u2D3B\u2D5C\u2D5C\u2D53\u2D37 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C \u2D4F\u2D4F\u2D3D?","User not found":"\u2D30\u2D4F\u2D59\u2D59\u2D4E\u2D54\u2D59 \u2D53\u2D54 \u2D49\u2D4D\u2D4D\u2D49","group_left":"\u2D5C\u2D3C\u2D3C\u2D56\u2D37 \u2D59\u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 !","api_key":"\u2D5C\u2D30\u2D59\u2D30\u2D54\u2D53\u2D5C \u2D4F API","replies_other":"{{count}} \u2D5C\u2D49\u2D4E\u2D54\u2D30\u2D54\u2D53\u2D5C\u2D49\u2D4F","notifications":"\u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F","reset_password_title":"\u2D30\u2D4D\u2D59 \u2D30\u2D59\u2D4F\u2D53\u2D4E \u2D4F \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C \u2D4F\u2D4F\u2D3D","passwords_dont_match":"\u2D53\u2D54 \u2D49\u2D4E\u2D59\u2D30\u2D59\u2D30 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","invitation_link":"\u2D30\u2D59\u2D56\u2D53\u2D4F \u2D4F \u2D53\u2D59\u2D49\u2D33\u2D54","password_reset_mail_sent":"\u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D59\u2D59\u2D49\u2D3C\u2D39 \u2D49\u2D4E\u2D30\u2D62\u2D4D \u2D45\u2D3C \u2D61\u2D30\u2D4D\u2D30\u2D59 \u2D4F \u2D53\u2D59\u2D54\u2D53\u2D59 \u2D4F \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C!","error":"\u2D5C\u2D4D\u2D4D\u2D30 \u2D49\u2D5B\u2D5C \u2D4F \u2D5C\u2D63\u2D33\u2D4D\u2D5C","reset_invitation_link":"\u2D30\u2D4D\u2D59 \u2D30\u2D59\u2D4F\u2D53\u2D4E \u2D4F \u2D53\u2D59\u2D56\u2D53\u2D4F \u2D4F \u2D53\u2D59\u2D49\u2D33\u2D54","invitation_welcome":"\u2D30\u2D4F\u2D59\u2D53\u2D3C \u2D49\u2D59\u2D3D \u2D33 Zusam ! \u2D49\u2D45\u2D5A\u2D5A\u2D30 \u2D30\u2D3D \u2D53\u2D63\u2D4E\u2D4E\u2D3B\u2D4E \u2D37\u2D30\u2D5C \u2D4F \u2D53\u2D3D\u2D5B\u2D30\u2D4E \u2D56\u2D54 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30.","signup":"\u2D30\u2D63\u2D4E\u2D4E\u2D3B\u2D4E","create_a_group":"\u2D59\u2D3D\u2D54 \u2D3D\u2D54\u2D30 \u2D4F \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","create_the_group":"\u2D59\u2D3D\u2D54 \u2D5C\u2D30\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","quit_group":"\u2D3C\u2D3C\u2D56 \u2D59\u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","settings_updated":"\u2D5C\u2D5C\u2D53\u2D59\u2D4E\u2D30\u2D62\u2D4F\u2D53\u2D4F\u2D5C \u2D5C\u2D59\u2D56\u2D30\u2D4D \u2D4F\u2D4F\u2D3D","group_updated":"\u2D5C\u2D3B\u2D5C\u2D5C\u2D53\u2D59\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D4F\u2D4F\u2D3D !","publish_in_group":"\u2D3C\u2D59\u2D54 \u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","search_in_group":"\u2D54\u2D63\u2D53 \u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","changed_group_name":"\u2D5C\u2D59\u2D4F\u2D3C\u2D4D\u2D37 \u2D49\u2D59\u2D4E \u2D4F \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","to":"\u2D49","mark_all_as_read":"\u2D55\u2D5B\u2D4E \u2D4E\u2D30\u2D55\u2D55\u2D30 \u2D30\u2D4E \u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D56\u2D54\u2D4F","cancel":"\u2D59\u2D59\u2D54","notification_emails":"\u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F \u2D4F \u2D49\u2D4E\u2D30\u2D62\u2D4D","none":"\u2D53\u2D40\u2D53","hourly":"\u2D3D\u2D53 \u2D5C\u2D30\u2D59\u2D54\u2D30\u2D33\u2D5C","daily":"\u2D3D\u2D53 \u2D30\u2D59\u2D59","weekly":"\u2D3D\u2D53 \u2D49\u2D4E\u2D30\u2D4D\u2D30\u2D59\u2D59","monthly":"\u2D3D\u2D53 \u2D30\u2D62\u2D62\u2D53\u2D54","has_joined":"\u2D49\u2D3D\u2D5B\u2D4E","search_without_result":"\u2D53\u2D54 \u2D49\u2D4E\u2D59\u2D30\u2D59\u2D30 \u2D53\u2D54\u2D63\u2D53 \u2D4F\u2D4F\u2D3D \u2D30\u2D3D\u2D37 \u2D3D\u2D54\u2D30\u2D62\u2D33\u2D30\u2D5C\u2D5C \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C.","just_now":"\u2D37\u2D56\u2D49 \u2D4F\u2D4F\u2D49\u2D5C","notification_emails_stopped":"\u2D31\u2D37\u2D37\u2D4F \u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F \u2D4F \u2D49\u2D4E\u2D30\u2D62\u2D4D !","destroy_account":"\u2D3D\u2D3D\u2D59 \u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F \u2D4F\u2D4F\u2D3D","has_posted_in":"\u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D3C\u2D59\u2D54 \u2D33","has_commented_on":"\u2D49\u2D59\u2D3D\u2D54 \u2D30\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D \u2D45\u2D3C","has_left":"\u2D49\u2D3C\u2D3C\u2D56","the_message_from":"\u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D59\u2D33","in":"\u2D33","reply":"\u2D54\u2D30\u2D54","public_link":"\u2D30\u2D59\u2D56\u2D53\u2D4F \u2D30\u2D4E\u2D30\u2D5C\u2D30\u2D62","default_group":"\u2D5C\u2D30\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D5C\u2D30\u2D4E\u2D54\u2D37\u2D53\u2D5C","are_you_sure":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37?","users":"\u2D49\u2D4F\u2D59\u2D59\u2D4E\u2D54\u2D30\u2D59","share_message":"\u2D31\u2D39\u2D53 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D3C","multiple_photos_upload":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C. \u2D30\u2D4D\u2D59 \u2D30\u2D33\u2D30\u2D4E \u2D4F \u2D5C\u2D61\u2D4D\u2D30\u2D3C\u2D49\u2D4F \u2D49\u2D5B\u2D5C \u2D59 \u2D62\u2D49\u2D5B\u2D5C (\u2D49\u2D63\u2D4E\u2D54 \u2D30\u2D37 \u2D62\u2D49\u2D4D\u2D49 \u2D53\u2D62\u2D30\u2D37 \u2D37\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D49\u2D4E\u2D59\u2D59\u2D30\u2D54\u2D30\u2D5C\u2D4F).","error_new_message":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C \u2D33 \u2D53\u2D59\u2D49\u2D3C\u2D39 \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D.","cancel_write":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37 \u2D53\u2D54 \u2D5C\u2D54\u2D49\u2D37 \u2D30\u2D37 \u2D5C\u2D30\u2D54\u2D49\u2D37 \u2D3D\u2D54\u2D30 \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D5C\u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53\u2D5C?","empty_message":"\u2D5C\u2D45\u2D61\u2D30 \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D53\u2D54 \u2D49\u2D63\u2D54\u2D49 \u2D53\u2D59\u2D49\u2D3C\u2D39 \u2D4F\u2D4F\u2D59 !","group_share_choice":"\u2D4E\u2D30\u2D5C\u2D5C\u2D30 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D4F\u2D4F\u2D30 \u2D5C\u2D54\u2D49\u2D37 \u2D30\u2D37 \u2D30\u2D59 \u2D5C\u2D59\u2D59\u2D49\u2D3C\u2D39\u2D37 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D37?","destroy_account_explain":"\u2D4E\u2D5B \u2D5C\u2D3D\u2D3D\u2D59\u2D37 \u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F \u2D4F\u2D4F\u2D3D, \u2D53\u2D59\u2D30\u2D54 \u2D30\u2D37 \u2D37 \u2D5C\u2D30\u2D56\u2D53\u2D4D\u2D37. \u2D43\u2D47\u2D47\u2D30 \u2D59 \u2D53\u2D62\u2D30\u2D37.","replies_one":"{{count}} \u2D49\u2D54\u2D30\u2D54","error_upload":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C \u2D33 \u2D61\u2D30\u2D33\u2D30\u2D4E","add_bookmark":"\u2D54\u2D4F\u2D53 \u2D33 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","parent_message":"\u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D4F \u2D49\u2D4E\u2D30\u2D54\u2D30\u2D61\u2D4F","remove_bookmark":"\u2D3D\u2D3D\u2D59 \u2D5C\u2D30\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","bookmarks":"\u2D5C\u2D30\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","reset_api_key":"\u2D59\u2D4F\u2D3C\u2D4D \u2D5C\u2D30\u2D59\u2D30\u2D54\u2D53\u2D5C \u2D4F API (\u2D54\u2D30\u2D37 \u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D3D\u2D3D\u2D59 \u2D53\u2D4E\u2D62\u2D30\u2D61\u2D30\u2D39 \u2D4F\u2D4F\u2D3D)","video_not_ready":"\u2D49\u2D59\u2D53\u2D4D \u2D53\u2D54 \u2D49\u2D61\u2D4A\u2D49\u2D37 \u2D53\u2D3C\u2D49\u2D37\u2D62\u2D53.","bookmark_added":"\u2D5C\u2D53\u2D37\u2D3C \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D56\u2D54 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54 !","bookmark_removed":"\u2D5C\u2D3B\u2D5C\u2D5C\u2D61\u2D30\u2D3D\u2D3D\u2D59 \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D59\u2D33 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54 !","upload_audio":"","audio_not_ready":""}');


var $52450dc623adf41a$exports = {};
$52450dc623adf41a$exports = JSON.parse('{"password_placeholder":"\u5BC6\u7801","title_placeholder":"\u60A8\u6D88\u606F\u7684\u6807\u9898(\u53EF\u9009)","upload_image":"\u6DFB\u52A0\u56FE\u7247","text_placeholder":"\u5728\u8FD9\u91CC\u8F93\u5165\u60A8\u7684\u6D88\u606F","upload_music":"\u6DFB\u52A0\u97F3\u4E50","upload_pdf":"\u6DFB\u52A0PDF\u6587\u4EF6","add_date":"\u6DFB\u52A0\u65E5\u671F","logout":"\u6CE8\u9500","settings":"\u8BBE\u7F6E","name":"\u59D3\u540D","name_input":"\u9009\u62E9\u4E00\u4E2A\u540D\u79F0","login":"\u767B\u5F55","login_input":"\u9009\u62E9\u4E00\u4E2A\u4EE5\u767B\u5F55","email":"\u7535\u5B50\u90AE\u7BB1","email_input":"\u5728\u8FD9\u91CC\u8F93\u5165\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740","passwords_dont_match":"\u5BC6\u7801\u4E0D\u4E00\u81F4","invitation_link":"\u9080\u8BF7\u94FE\u63A5","reset_invitation_link":"\u91CD\u8BBE\u9080\u8BF7\u94FE\u63A5","invitation_welcome":"\u6B22\u8FCE\u6765\u5230Zusam ! \u5728\u52A0\u5165\u4E00\u4E2A\u7EC4\u524D,\u8BF7\u5148\u6CE8\u518C\u3002","signup":"\u6CE8\u518C","create_a_group":"\u521B\u5EFA\u7FA4\u7EC4","create_the_group":"\u521B\u5EFA\u7FA4\u7EC4","quit_group":"\u79BB\u5F00\u7FA4\u7EC4","settings_updated":"\u4F60\u7684\u8BBE\u7F6E\u5DF2\u66F4\u65B0","group_left":"\u4F60\u79BB\u5F00\u4E86\u7FA4\u7EC4!","group_updated":"\u7FA4\u7EC4\u5DF2\u66F4\u65B0!","multiple_photos_upload":"\u53D1\u751F\u9519\u8BEF\u3002 \u8BF7\u5C1D\u8BD5\u9010\u4E2A\u4E0A\u4F20\u56FE\u50CF(\u5728\u67D0\u4E9B\u6D4F\u89C8\u5668\u4E2D\u53EF\u80FD\u4F1A\u53D1\u751F\u8FD9\u79CD\u60C5\u51B5)\u3002","error_new_message":"\u53D1\u9001\u6D88\u606F\u65F6\u51FA\u9519\u3002","error_upload":"\u4E0A\u4F20\u51FA\u9519","cancel_write":"\u662F\u5426\u786E\u5B9E\u8981\u53D6\u6D88\u7F16\u5199\u65B0\u6D88\u606F?","empty_message":"\u65E0\u6CD5\u53D1\u9001\u7A7A\u6D88\u606F!","notification_emails":"\u7535\u5B50\u90AE\u4EF6\u901A\u77E5","destroy_account_explain":"\u4E00\u65E6\u60A8\u5220\u9664\u4E86\u8D26\u6237,\u60A8\u5C06\u65E0\u6CD5\u64A4\u9500\u672C\u64CD\u4F5C! \u8BF7\u786E\u8BA4\u3002","replies_one":"{{count}}\u56DE\u590D","replies_other":"{{count}}\u56DE\u590D\u4E86","publish_in_group":"\u5728\u7FA4\u7EC4\u91CC\u53D1\u5E03","search_in_group":"\u5728\u6B64\u7FA4\u7EC4\u4E2D\u641C\u7D22","changed_group_name":"\u66F4\u6539\u4E86\u7EC4\u7684\u540D\u79F0","to":"\u5230","notifications":"\u901A\u77E5","mark_all_as_read":"\u5168\u90E8\u5DF2\u8BFB","search_without_result":"\u6CA1\u6709\u5339\u914D\u7684\u6D88\u606F\u3002","add_bookmark":"\u4E3A\u6D88\u606F\u6DFB\u52A0\u4E66\u7B7E","previous_coms":"\u67E5\u770B\u4EE5\u524D\u7684\u8BC4\u8BBA","next_coms":"\u67E5\u770B\u4E0B\u4E00\u4E2A\u8BC4\u8BBA","ago":"{{duration}}\u524D","groups":"\u7EC4","login_placeholder":"\u7535\u5B50\u90AE\u7BB1","new_password_placeholder":"\u65B0\u5BC6\u7801","confirm_password_placeholder":"\u786E\u8BA4\u5BC6\u7801","connect":"\u8FDE\u63A5","submit":"\u63D0\u4EA4","save_changes":"\u4FDD\u5B58\u66F4\u6539","password":"\u5BC6\u7801","password_input":"\u5728\u6B64\u8F93\u5165\u60A8\u7684\u7684\u5BC6\u7801","Invalid login/password":"\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF","edit":"\u7F16\u8F91","delete":"\u5220\u9664","account":"\u8D26\u6237","forgot_password":"\u5FD8\u8BB0\u4F60\u7684\u5BC6\u7801\u4E86\u5417?","password_reset_mail_sent":"\u5BC6\u7801\u91CD\u7F6E\u90AE\u4EF6\u5DF2\u53D1\u9001!","User not found":"\u7528\u6237\u4E0D\u5B58\u5728","reset_password_title":"\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801","error":"\u51FA\u9519\u4E86","ask_delete_message":"\u4F60\u786E\u5B9A\u8981\u5220\u9664\u6B64\u6D88\u606F\u5417?","cancel":"\u53D6\u6D88","just_now":"\u521A\u521A","none":"\u65E0","hourly":"\u6BCF\u5C0F\u65F6","daily":"\u6BCF\u5929","weekly":"\u6BCF\u5468","monthly":"\u6BCF\u6708","notification_emails_stopped":"\u5DF2\u505C\u7528\u90AE\u4EF6\u63D0\u9192!","public_link":"\u516C\u5171\u94FE\u63A5","default_group":"\u9ED8\u8BA4\u7FA4\u7EC4","destroy_account":"\u5220\u9664\u60A8\u7684\u8D26\u6237","are_you_sure":"\u60A8\u786E\u5B9A\u5417?","share_message":"\u5206\u4EAB\u6B64\u6D88\u606F","users":"\u7528\u6237","has_posted_in":"\u5DF2\u53D1\u5E03\u4E8E","has_commented_on":"\u8BC4\u8BBA\u4E8E","has_joined":"\u5DF2\u52A0\u5165","has_left":"\u5DF2\u9000\u51FA","the_message_from":"\u6D88\u606F\u6765\u81EA","in":"\u91CC","lang":"\u8BED\u8A00","reply":"\u56DE\u590D","remove_bookmark":"\u4E3A\u6D88\u606F\u79FB\u9664\u4E66\u7B7E","bookmarks":"\u4E66\u7B7E","api_key":"API\u5BC6\u94A5","reset_api_key":"\u91CD\u7F6EAPI\u5BC6\u94A5(\u60A8\u5C06\u4F1A\u65AD\u5F00\u8FDE\u63A5)","video_not_ready":"\u89C6\u9891\u5C1A\u672A\u51C6\u5907\u597D\u3002","bookmark_added":"\u6D88\u606F\u5DF2\u6DFB\u52A0\u5230\u4E66\u7B7E!","bookmark_removed":"\u6D88\u606F\u5DF2\u4ECE\u4E66\u7B7E\u4E2D\u79FB\u9664!","parent_message":"\u7236\u6D88\u606F","group_share_choice":"\u60A8\u60F3\u5C06\u6B64\u6D88\u606F\u53D1\u9001\u5230\u54EA\u4E2A\u7FA4\u7EC4?","audio_not_ready":"\u97F3\u9891\u5C1A\u672A\u51C6\u5907\u597D\u3002","upload_video":"\u6DFB\u52A0\u89C6\u9891","upload_audio":"\u6DFB\u52A0\u97F3\u9891\u6587\u4EF6\u3002"}');


const $e61dc402a65410c5$export$9a771d6906431624 = {
    possibleLang: {
        cs_CZ: "\u010De\u0161tina",
        de_DE: "Deutsch",
        en_US: "english",
        es_ES: "espa\xf1ol",
        fr_FR: "fran\xe7ais",
        hu_HU: "magyar nyelv",
        ko_KR: "\uD55C\uAD6D\uC5B4",
        nb_NO: "Norge",
        nl_NL: "Nederlands",
        pt_BR: "Portugu\xeas",
        ru_RU: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        sk_SK: "Slovensk\xfd",
        ta_IN: "\u0939\u093F\u0902\u0926\u0942",
        zgh: "\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C",
        zh_Hans: "\u4E2D\u6587"
    },
    // possible dicts names to load
    getDefaultLang: ()=>(document.querySelector("meta[name='zusam:default-lang']") || {}).content || "en_US",
    getCurrentLang: ()=>(0, $1747d3542bece520$export$2e2bcd8739ae039).lang || $e61dc402a65410c5$export$9a771d6906431624.getDefaultLang()
};
(0, $d7301ad24121e92e$export$2e2bcd8739ae039).use((0, $dc44570447e3a989$export$ae7e14d40d89f296)).init({
    resources: {
        cs_CZ: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($2379d1524118d841$exports)))
        },
        de_DE: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($7227d2b4b58764da$exports)))
        },
        en: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($48c6d8cc49c1b9f6$exports)))
        },
        // backwards compatibility, remove for 0.6
        en_US: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($48c6d8cc49c1b9f6$exports)))
        },
        es_ES: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($079440a674bdf1c9$exports)))
        },
        es: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($079440a674bdf1c9$exports)))
        },
        // backwards compatibility, remove for 0.6
        fr_FR: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($b890f63bba07e3e3$exports)))
        },
        fr: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($b890f63bba07e3e3$exports)))
        },
        // backwards compatibility, remove for 0.6
        hu_HU: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($ffbe0022c0047bec$exports)))
        },
        ko_KR: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($7fbc635ad01bd584$exports)))
        },
        nb_NO: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($c59ffcac4eb96a5c$exports)))
        },
        nl_NL: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($bfcb09c97b6918c1$exports)))
        },
        nl: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($bfcb09c97b6918c1$exports)))
        },
        // backwards compatibility, remove for 0.6
        pt_BR: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($3def3210ee9fc9cd$exports)))
        },
        ru_RU: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($12b602ca54d45d9f$exports)))
        },
        sk_SK: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($43cf61491a662e98$exports)))
        },
        sk: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($43cf61491a662e98$exports)))
        },
        // backwards compatibility, remove for 0.6
        ta_IN: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($143e0a838b0cb819$exports)))
        },
        zgh: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($efa8f9784a788c7f$exports)))
        },
        zh_Hans: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($52450dc623adf41a$exports)))
        }
    },
    lng: $e61dc402a65410c5$export$9a771d6906431624.getCurrentLang(),
    // if you're using a language detector, do not define the lng option
    fallbackLng: $e61dc402a65410c5$export$9a771d6906431624.getDefaultLang(),
    interpolation: {
        escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
});


// Stateless utilities
// Should be agnostic of other components of zusam if possible
const $0d89305838e7d07e$var$util = {
    // check if the input is a valid URL
    isValidUrl: (url)=>{
        try {
            new URL(url);
            return true;
        } catch (_) {
            return false;
        }
    },
    limitLength: (string, size = 20)=>{
        return [
            ...string.split("").slice(0, Math.floor(size / 2)),
            string.length > size ? "..." : "",
            ...string.split("").slice(Math.floor(size / 2)).slice(Math.floor(size / 2) * -1)
        ].join("");
    },
    escapeRegex: (string)=>{
        return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
    },
    getSubpath: ()=>new URL(document.baseURI).pathname.replace(/\/$/, ""),
    // toApp transforms an api url into an "app" url that the user can naviate to
    toApp: (url)=>{
        if (!url || typeof url != "string") return "";
        if ($0d89305838e7d07e$var$util.isValidUrl(url)) return url;
        return location.origin + $0d89305838e7d07e$var$util.getSubpath() + url;
    },
    // genId starts with a letter to be DOM friendly
    // seed can be used to order ids
    // TODO improve using ideas from ai/nanoid
    genId: (seed)=>`z${seed || ""}-${Date.now().toString().slice(-5)}${Math.random().toString().slice(-5)}`,
    // transform an id into int for the API (TODO: revisit this on 0.5)
    id2Int: (id)=>parseInt(id.replace(/[^\d]/g, ""), 10),
    urlRegExp: /(\([^()]*)?https?:\/\/[^[\]\n\r ]*[-A-Za-z0-9+&@#/%=~_()|]/i,
    getUrl: (txt)=>{
        if (!txt) return "";
        let url = txt.match($0d89305838e7d07e$var$util.urlRegExp);
        if (url && url[0].startsWith("(")) {
            let link = url[0].match(/https?:\/\//i);
            url["index"] += link["index"];
            url[0] = url[0].slice(link["index"]);
            if (url[0].endsWith(")")) url[0] = url[0].slice(0, -1);
        }
        return url;
    },
    limitStrSize: (str, limit)=>str.length > limit ? `${str.slice(0, limit - 3)}...` : str,
    // full datetime as a string adapted to the users timezone
    humanFullDate: (timestamp)=>{
        if (!timestamp) return "";
        let d = new Date(timestamp * 1000);
        d = new Date(d.getTime() + d.getTimezoneOffset() * -60000);
        return d.toISOString().replace("T", " ").replace(/\..*$/, "");
    },
    // duration relative to event
    humanTime: (timestamp)=>{
        if (!timestamp) return null;
        const duration = Math.abs(Math.round((Date.now() / 1000 - timestamp) / 60));
        if (duration < 1) return (0, $d7301ad24121e92e$export$2e2bcd8739ae039).t("just_now");
        if (duration < 60) return (0, $d7301ad24121e92e$export$2e2bcd8739ae039).t("ago", {
            duration: `${duration}mn`
        });
        if (duration < 1440) return (0, $d7301ad24121e92e$export$2e2bcd8739ae039).t("ago", {
            duration: `${Math.floor(duration / 60)}h`
        });
        return $0d89305838e7d07e$var$util.humanFullDate(timestamp).split(" ")[0];
    },
    // get the id of an object from an url
    getId: (e)=>{
        switch(typeof e){
            case "object":
                return e ? e.id : null;
            case "string":
                return e.split("/").pop().replace(/\?.*$/, "").replace(/\.\w+$/, "");
            default:
                console.error(e);
                throw "Could not extract id !";
        }
    },
    // get the url to a thubmnail
    thumbnail: (id, width, height = 99999)=>typeof id == "string" && !id.startsWith("z") ? $0d89305838e7d07e$var$util.toApp(`/api/images/thumbnail/${width}/${height}/${id}`) : null,
    // same as http.thumbnail but for a crop
    crop: (id, width, height)=>typeof id == "string" && !id.startsWith("z") ? $0d89305838e7d07e$var$util.toApp(`/api/images/crop/${width}/${height}/${id}`) : null,
    // default avatar in base64
    defaultAvatar: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIAAQMAAADOtka5AAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlMA/iyWEiMAAAMJSURBVHja7ZtBjpwwEEWxmIhFFmiURZZEyi6HCLkZHCXr2eQKHIUjoEiRSGRRiWB6klaDU/hDF4z+W6LuNz3+ZRvbkCSEEEIIIYQQQgghhBBCCCGEEEIIITvwGfy+kxoTpNJigkw6TJBLjwkK8ZiglMFYUInAAqwQRKRBBR0q8FhXEKwVR0GLCvxCjeo6oyzkoIxnEvj5661acPO3yvFqpxdcV+Pj88VeNZ7cGB4ul1QFkv399KT4KBIpmGEwF4i9oL6DIN/3FzToL2ju8AvsBeE2aNFfQMFJBCkF0/R+bkHyCgSVuaDcVaC5zyvMBTkqyHYVaBZDKSpw5oJgLcMC5doXFBSoIMNutjcQBHJULmlhQYUKlmNQbs9kqGC5P2o3FqBBOVjMWkEOdcZQKam3dyqkkgP/g35zxmEpLhbjir0ZFz2tXHgbPR5deI+EMPKmig/hhU/fIkOYL4iYDbIyqpCXajp2Zy4yhNuxqUfbMCaEIraQZ9swJgQBQ0jBQr6eYXrzQrYIYdtC9uaFbDKayJajyTkL+VijyWA+mnBajGpDeFrMzAu5BNvwKoQBDaFHQ+jQEBo0hBoMYUBD8GgIHRpCi44mcAiJRQhoITvzQs63LGQxL2SOJnEhiHUI296bwNOixb1JYr5kz8yX7Odf6XDfBC9kd6yVzq+np69QIY/8AEJ45kt0T4hIM0VONm5CiLlVhLflS+CwdTGEVa2AnfOFTogaVAAfcg1QivpqzLFHD4LnrR0q8FAhqlux3PPUu0EFLSrooL6kLeaQwKMCTY4OfUjVoY+IOvTxSFiw81NtnbmgRwXeXDAg08IxBPIKBPX5BQ0FBxC0+wtSCg4gcBT853nruwiqfQXNHQT/LDiGD9Old6sEL2umn3MtqxDks9NotVbwfaG+FDfL6fznsjV32365cTXrtqoPdJKYrbmreIDvT42DCMYoIUEu4FvIKSpwgr6JvYEAfJm8QgUl+j58gb6Rn4Nvcv/p0jUmcODr8IQQQgghhBBCCCGEEEIIIYQQQgghs/wGp6uYgtiKODIAAAAASUVORK5CYII=",
    hash: (str)=>str.split("").reduce((a, c)=>(a << 5) - a + c.charCodeAt() | 0),
    colorHash: (str)=>[
            "#000000",
            "#333366",
            "#333399",
            "#3333CC",
            "#339933",
            "#339999",
            "#33CC33",
            "#33CC99",
            "#663333",
            "#663366",
            "#666633",
            "#666699",
            "#66CC33",
            "#66CCCC",
            "#993333",
            "#993366",
            "#993399",
            "#996633",
            "#999966",
            "#CC3333",
            "#CC3366",
            "#CC3399",
            "#CC33CC",
            "#CC6633",
            "#CC9933",
            "#CC99CC",
            "#CCCC33"
        ][Math.abs($0d89305838e7d07e$var$util.hash(str)) % 27],
    backgroundHash: (str)=>{
        if (!str) return "background-color: #aaa;";
        let c1 = $0d89305838e7d07e$var$util.colorHash(str);
        let c2 = $0d89305838e7d07e$var$util.colorHash(str.split("").reverse().join("."));
        let deg = 45 * (Math.abs($0d89305838e7d07e$var$util.hash(str)) % 4);
        return `background-color:${c1};background-image:linear-gradient(${deg}deg, ${c2} 15%, transparent 15% 30%, ${c2} 30% 45%, transparent 45% 60%, ${c2} 60% 75%, transparent 75% 90%, ${c2} 90%);`;
    },
    // Accepts a keydown event and checks if it's enter. Compatibility between browsers
    // We do it the permissive way
    is_it_enter: (e)=>{
        return e.keyCode == 13 || e.keyCode == 10 || e.key == "Enter" || e.key == "\u21B5" || e.code == "Enter";
    },
    getVersion: ()=>(document.querySelector("meta[name='zusam:version']") || {}).content || "unknown",
    getWidthBreakpoint: ()=>{
        if (window.innerWidth > 1800) return 1800;
        if (window.innerWidth > 1400) return 1400;
        if (window.innerWidth > 992) return 992;
        if (window.innerWidth > 768) return 768;
        if (window.innerWidth > 576) return 576;
        return window.innerWidth;
    }
};
var $0d89305838e7d07e$export$2e2bcd8739ae039 = $0d89305838e7d07e$var$util;


const $747de4a7b04ce4ba$var$http = {
    sendFile: (formData, loadFn, progressFn = null, errorFn = null)=>{
        return (0, $15bf00c5a9ebafaa$export$2e2bcd8739ae039).get("apiKey").then((apiKey)=>{
            let xhr = new XMLHttpRequest();
            xhr.open("POST", `${document.baseURI}api/files`, true);
            xhr.setRequestHeader("X-AUTH-TOKEN", apiKey);
            xhr.addEventListener("load", (e)=>{
                if (e.target.status > 199 && e.target.status < 300) loadFn(JSON.parse(e.target.response));
                else if (errorFn) errorFn(e.target.statusText);
                else console.error(e.target.statusText);
            });
            if (progressFn) xhr.upload.onprogress = (e)=>progressFn({
                    loaded: e.loaded,
                    total: e.total
                });
            if (errorFn) xhr.addEventListener("error", (e)=>errorFn(e));
            xhr.send(formData);
        }).catch((error)=>(0, $965d8b034b5a035b$export$2e2bcd8739ae039).add(error, "alert-danger"));
    },
    get: (url, nocache = false, delay = 0)=>{
        return (0, $15bf00c5a9ebafaa$export$2e2bcd8739ae039).get("apiKey").then((x)=>new Promise((resolve)=>setTimeout(()=>resolve(x), delay))).then((apiKey)=>{
            url = (0, $0d89305838e7d07e$export$2e2bcd8739ae039).toApp(url);
            if (!url) return;
            let h = {};
            if (apiKey) h["X-AUTH-TOKEN"] = apiKey;
            if (nocache) h["X-NOCACHE"] = "nocache";
            return fetch(url, {
                method: "GET",
                headers: new Headers(h)
            }).then((res)=>res.ok && res.json()).catch((err)=>console.warn(`ERROR for ${url}`, err));
        }).catch((error)=>(0, $965d8b034b5a035b$export$2e2bcd8739ae039).add(error, "alert-danger"));
    },
    post: (url, data, delay = 0, contentType = "application/json")=>$747de4a7b04ce4ba$var$http.request(url, data, "POST", delay, contentType),
    put: (url, data, delay = 0, contentType = "application/json")=>$747de4a7b04ce4ba$var$http.request(url, data, "PUT", delay, contentType),
    delete: (url, data, delay = 0, contentType = "application/json")=>$747de4a7b04ce4ba$var$http.request(url, null, "DELETE", delay, contentType),
    request: (url, data, method, delay = 0, contentType = "application/json")=>{
        return (0, $15bf00c5a9ebafaa$export$2e2bcd8739ae039).get("apiKey").then((x)=>new Promise((resolve)=>setTimeout(()=>resolve(x), delay))).then((apiKey)=>{
            url = (0, $0d89305838e7d07e$export$2e2bcd8739ae039).toApp(url);
            if (!url) return;
            let h = {};
            if (apiKey) h["X-AUTH-TOKEN"] = apiKey;
            if (contentType) h["Content-type"] = contentType;
            let fetchOptions = {
                method: method,
                headers: new Headers(h)
            };
            if (data) fetchOptions.body = typeof data == "object" && data.constructor.name == "Object" ? JSON.stringify(data) : data;
            return fetch(url, fetchOptions).then((res)=>{
                try {
                    if (method != "DELETE") return res.json();
                    return {};
                } catch (exception) {
                    console.warn(exception.message);
                    return Promise.reject(exception.message);
                }
            }).catch((err)=>console.warn(`ERROR for ${url}`, err));
        }).catch((error)=>(0, $965d8b034b5a035b$export$2e2bcd8739ae039).add(error, "alert-danger"));
    }
};
var $747de4a7b04ce4ba$export$2e2bcd8739ae039 = $747de4a7b04ce4ba$var$http;



const $df6632f9961dbefb$var$api = {
    get info () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.api;
    },
    update: ()=>(0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).get("/api/info", true).then((r)=>{
            if (!r) return;
            (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("api/update", Object.assign({}, r));
            setTimeout(dispatchEvent(new CustomEvent("apiStateChange")));
            return r;
        })
};
var $df6632f9961dbefb$export$2e2bcd8739ae039 = $df6632f9961dbefb$var$api;







const $ea4e56e50a26ecd6$var$notifications = {
    LIMIT: 20,
    get () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.notifications || [];
    },
    update () {
        return (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).get(`/api/me/notifications/${$ea4e56e50a26ecd6$var$notifications.LIMIT + 1}`).then((r)=>{
            (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("notifications/update", r);
        });
    },
    isNew (id) {
        let state = (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get();
        if (Array.isArray(state["notifications"])) return state.notifications.filter((n)=>!n.read).some((n)=>$ea4e56e50a26ecd6$var$notifications.matchNotification(n, id) || n.type == "new_comment" && n.fromMessage.id === id);
        return false;
    },
    removeAllNotifications () {
        let state = (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get();
        if (Array.isArray(state["notifications"])) state.notifications.forEach((n)=>{
            (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).delete(`/api/notifications/${n.id}`).then(()=>{
                (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("notifications/remove", n);
            });
        });
    },
    markAllNotificationsAsRead () {
        let state = (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get();
        if (Array.isArray(state["notifications"])) state.notifications.forEach((n)=>{
            (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).put(`/api/notifications/${n.id}`, {
                read: true
            }).then(()=>{
                (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("notifications/read", n);
            });
        });
    },
    removeMatchingNotifications (id) {
        return Promise.all((0, $5e4e939c48db0130$export$2e2bcd8739ae039).get().notifications.filter((n)=>$ea4e56e50a26ecd6$var$notifications.matchNotification(n, id)).map((n)=>{
            (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).delete(`/api/notifications/${n.id}`).then(()=>{
                (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("notifications/remove", n);
            });
        }));
    },
    markAsRead (id) {
        return Promise.all((0, $5e4e939c48db0130$export$2e2bcd8739ae039).get().notifications.filter((n)=>$ea4e56e50a26ecd6$var$notifications.matchNotification(n, id)).map((n)=>{
            (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).put(`/api/notifications/${n.id}`, {
                read: true
            }).then(()=>{
                (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("notifications/read", n);
            });
        }));
    },
    matchNotification (notif, id) {
        if (notif.id === id) return true;
        if (notif.target === id) return true;
        return false;
    }
};
var $ea4e56e50a26ecd6$export$2e2bcd8739ae039 = $ea4e56e50a26ecd6$var$notifications;




const $c493b830a498683a$var$bookmarks_utils = {
    LIMIT: 1000,
    get () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.bookmarks || [];
    },
    update () {
        return (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).get(`/api/me/bookmarks/${$c493b830a498683a$var$bookmarks_utils.LIMIT + 1}`).then((r)=>{
            (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("bookmarks/update", r);
        });
    }
};
var $c493b830a498683a$export$2e2bcd8739ae039 = $c493b830a498683a$var$bookmarks_utils;





const $715455f3b9e52ce9$var$router = {
    get () {
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get();
    },
    get route () {
        try {
            return $715455f3b9e52ce9$var$router.removeSubpath(location.pathname).slice(1).split("/")[0];
        } catch  {
            return "";
        }
    },
    get id () {
        try {
            return $715455f3b9e52ce9$var$router.removeSubpath(location.pathname).slice(1).split("/")[1];
        } catch  {
            return "";
        }
    },
    get action () {
        try {
            return $715455f3b9e52ce9$var$router.removeSubpath(location.pathname).slice(1).split("/")[2];
        } catch  {
            return "";
        }
    },
    get backUrl () {
        console.err("don't use backUrl");
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.backUrl;
    },
    get search () {
        return location.search.slice(1);
    },
    getEntity () {
        if ($715455f3b9e52ce9$var$router.isEntity($715455f3b9e52ce9$var$router.route)) return (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039).get(`/api/${$715455f3b9e52ce9$var$router.route}/${$715455f3b9e52ce9$var$router.id}`);
        return Promise.resolve(null);
    },
    get entity () {
        console.err("don't use entity");
        return (0, $5e4e939c48db0130$export$2e2bcd8739ae039).get()?.entity;
    },
    removeSubpath: (path)=>path ? path.replace(new RegExp(`^${(0, $0d89305838e7d07e$export$2e2bcd8739ae039).getSubpath()}`), "") : "",
    getParam: (param, searchParams = window.location.search.substring(1))=>{
        let res = searchParams.split("&").find((e)=>e.split("=")[0] === param);
        return res ? decodeURIComponent(res.split("=")[1]) : "";
    },
    getSegments: ()=>$715455f3b9e52ce9$var$router.removeSubpath(window.location.pathname).slice(1).split("?")[0].split("/"),
    // check if route is "outside": accessible to non connected user
    isOutside: ()=>[
            "login",
            "password-reset",
            "signup",
            "invitation",
            "stop-notification-emails",
            "public"
        ].includes($715455f3b9e52ce9$var$router.route || $715455f3b9e52ce9$var$router.getSegments()[0]),
    isEntity: ()=>[
            "messages",
            "groups",
            "users",
            "links",
            "files"
        ].includes($715455f3b9e52ce9$var$router.getSegments()[0]),
    getUrlComponents: (url)=>{
        let components = {};
        if (url) {
            components.url = new URL(url);
            components.path = components.url.pathname;
            components.search = components.url.search.slice(1);
            [components.route, components.id, components.action] = $715455f3b9e52ce9$var$router.removeSubpath(components.path).slice(1).split("/");
        }
        components.entityType = "";
        components.backUrl = "";
        return components;
    }
};
var $715455f3b9e52ce9$export$2e2bcd8739ae039 = $715455f3b9e52ce9$var$router;




const $ba05c0ef8a781e02$export$5ea928c9faf85bd3 = (0, $965d8b034b5a035b$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$644d8ea042df96a6 = (0, $df6632f9961dbefb$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$7d6f1c8842f9f527 = (0, $747de4a7b04ce4ba$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$9a771d6906431624 = (0, $e61dc402a65410c5$export$9a771d6906431624);
const $ba05c0ef8a781e02$export$a7357cdd1f0b0168 = (0, $d7301ad24121e92e$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$3e32638432616b6 = (0, $1747d3542bece520$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$6008d97729a90c74 = (0, $ea4e56e50a26ecd6$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$a4ea57bd994c1f0d = (0, $c493b830a498683a$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$5375cda95f0b0eb4 = (0, $715455f3b9e52ce9$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$ddcffe0146c8f882 = (0, $15bf00c5a9ebafaa$export$2e2bcd8739ae039);
const $ba05c0ef8a781e02$export$7debb50ef11d5e0b = (0, $0d89305838e7d07e$export$2e2bcd8739ae039);






/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $6b1a25b8319a72de$var$_extends() {
    $6b1a25b8319a72de$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6b1a25b8319a72de$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $6b1a25b8319a72de$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6b1a25b8319a72de$export$e19cd5f9376f8cee || ($6b1a25b8319a72de$export$e19cd5f9376f8cee = {}));
const $6b1a25b8319a72de$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $6b1a25b8319a72de$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $6b1a25b8319a72de$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $6b1a25b8319a72de$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6b1a25b8319a72de$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $6b1a25b8319a72de$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6b1a25b8319a72de$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $6b1a25b8319a72de$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $6b1a25b8319a72de$export$fe53371bee54353d(to);
    }
    return $6b1a25b8319a72de$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6b1a25b8319a72de$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $6b1a25b8319a72de$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $6b1a25b8319a72de$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $6b1a25b8319a72de$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $6b1a25b8319a72de$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $6b1a25b8319a72de$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $6b1a25b8319a72de$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $6b1a25b8319a72de$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $6b1a25b8319a72de$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $6b1a25b8319a72de$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $6b1a25b8319a72de$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $6b1a25b8319a72de$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $6b1a25b8319a72de$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $6b1a25b8319a72de$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $6b1a25b8319a72de$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $6b1a25b8319a72de$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $6b1a25b8319a72de$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($6b1a25b8319a72de$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Push;
        let location = $6b1a25b8319a72de$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $6b1a25b8319a72de$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Replace;
        let location = $6b1a25b8319a72de$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $6b1a25b8319a72de$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $6b1a25b8319a72de$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $6b1a25b8319a72de$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($6b1a25b8319a72de$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($6b1a25b8319a72de$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $6b1a25b8319a72de$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($6b1a25b8319a72de$var$ResultType || ($6b1a25b8319a72de$var$ResultType = {}));
const $6b1a25b8319a72de$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $6b1a25b8319a72de$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $6b1a25b8319a72de$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $6b1a25b8319a72de$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $6b1a25b8319a72de$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($6b1a25b8319a72de$var$isIndexRoute(route)) {
            let indexRoute = $6b1a25b8319a72de$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $6b1a25b8319a72de$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $6b1a25b8319a72de$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $6b1a25b8319a72de$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $6b1a25b8319a72de$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $6b1a25b8319a72de$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $6b1a25b8319a72de$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $6b1a25b8319a72de$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $6b1a25b8319a72de$var$flattenRoutes(routes);
    $6b1a25b8319a72de$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $6b1a25b8319a72de$export$30d21fd6d7295f52(pathname);
        matches = $6b1a25b8319a72de$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $6b1a25b8319a72de$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $6b1a25b8319a72de$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $6b1a25b8319a72de$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6b1a25b8319a72de$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $6b1a25b8319a72de$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $6b1a25b8319a72de$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6b1a25b8319a72de$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $6b1a25b8319a72de$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $6b1a25b8319a72de$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $6b1a25b8319a72de$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $6b1a25b8319a72de$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $6b1a25b8319a72de$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $6b1a25b8319a72de$var$paramRe = /^:[\w-]+$/;
const $6b1a25b8319a72de$var$dynamicSegmentValue = 3;
const $6b1a25b8319a72de$var$indexRouteValue = 2;
const $6b1a25b8319a72de$var$emptySegmentValue = 1;
const $6b1a25b8319a72de$var$staticSegmentValue = 10;
const $6b1a25b8319a72de$var$splatPenalty = -2;
const $6b1a25b8319a72de$var$isSplat = (s)=>s === "*";
function $6b1a25b8319a72de$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6b1a25b8319a72de$var$isSplat)) initialScore += $6b1a25b8319a72de$var$splatPenalty;
    if (index) initialScore += $6b1a25b8319a72de$var$indexRouteValue;
    return segments.filter((s)=>!$6b1a25b8319a72de$var$isSplat(s)).reduce((score, segment)=>score + ($6b1a25b8319a72de$var$paramRe.test(segment) ? $6b1a25b8319a72de$var$dynamicSegmentValue : segment === "" ? $6b1a25b8319a72de$var$emptySegmentValue : $6b1a25b8319a72de$var$staticSegmentValue), initialScore);
}
function $6b1a25b8319a72de$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $6b1a25b8319a72de$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6b1a25b8319a72de$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $6b1a25b8319a72de$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $6b1a25b8319a72de$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6b1a25b8319a72de$export$a5c6d149b50c1d86($6b1a25b8319a72de$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6b1a25b8319a72de$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $6b1a25b8319a72de$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $6b1a25b8319a72de$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $6b1a25b8319a72de$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $6b1a25b8319a72de$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $6b1a25b8319a72de$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6b1a25b8319a72de$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $6b1a25b8319a72de$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $6b1a25b8319a72de$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $6b1a25b8319a72de$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $6b1a25b8319a72de$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $6b1a25b8319a72de$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $6b1a25b8319a72de$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $6b1a25b8319a72de$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $6b1a25b8319a72de$var$normalizeSearch(search),
        hash: $6b1a25b8319a72de$var$normalizeHash(hash)
    };
}
function $6b1a25b8319a72de$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6b1a25b8319a72de$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $6b1a25b8319a72de$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $6b1a25b8319a72de$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $6b1a25b8319a72de$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $6b1a25b8319a72de$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $6b1a25b8319a72de$export$8ccf933b0513f8d0(toArg);
    else {
        to = $6b1a25b8319a72de$var$_extends({}, toArg);
        $6b1a25b8319a72de$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $6b1a25b8319a72de$var$getInvalidPathError("?", "pathname", "search", to));
        $6b1a25b8319a72de$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $6b1a25b8319a72de$var$getInvalidPathError("#", "pathname", "hash", to));
        $6b1a25b8319a72de$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $6b1a25b8319a72de$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6b1a25b8319a72de$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $6b1a25b8319a72de$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $6b1a25b8319a72de$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $6b1a25b8319a72de$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $6b1a25b8319a72de$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $6b1a25b8319a72de$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $6b1a25b8319a72de$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $6b1a25b8319a72de$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $6b1a25b8319a72de$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $6b1a25b8319a72de$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $6b1a25b8319a72de$export$4051a07651545597(data, init) {
    return new $6b1a25b8319a72de$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $6b1a25b8319a72de$export$42a99a7a4bc0e76a extends Error {
}
class $6b1a25b8319a72de$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $6b1a25b8319a72de$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $6b1a25b8319a72de$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $6b1a25b8319a72de$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $6b1a25b8319a72de$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $6b1a25b8319a72de$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $6b1a25b8319a72de$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $6b1a25b8319a72de$var$unwrapTrackedPromise(value) {
    if (!$6b1a25b8319a72de$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $6b1a25b8319a72de$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $6b1a25b8319a72de$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6b1a25b8319a72de$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $6b1a25b8319a72de$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6b1a25b8319a72de$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $6b1a25b8319a72de$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6b1a25b8319a72de$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $6b1a25b8319a72de$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $6b1a25b8319a72de$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $6b1a25b8319a72de$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $6b1a25b8319a72de$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $6b1a25b8319a72de$var$validMutationMethods = new Set($6b1a25b8319a72de$var$validMutationMethodsArr);
const $6b1a25b8319a72de$var$validRequestMethodsArr = [
    "get",
    ...$6b1a25b8319a72de$var$validMutationMethodsArr
];
const $6b1a25b8319a72de$var$validRequestMethods = new Set($6b1a25b8319a72de$var$validRequestMethodsArr);
const $6b1a25b8319a72de$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $6b1a25b8319a72de$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $6b1a25b8319a72de$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6b1a25b8319a72de$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6b1a25b8319a72de$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $6b1a25b8319a72de$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $6b1a25b8319a72de$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $6b1a25b8319a72de$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $6b1a25b8319a72de$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $6b1a25b8319a72de$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6b1a25b8319a72de$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $6b1a25b8319a72de$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $6b1a25b8319a72de$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $6b1a25b8319a72de$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $6b1a25b8319a72de$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $6b1a25b8319a72de$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $6b1a25b8319a72de$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$6b1a25b8319a72de$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$6b1a25b8319a72de$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $6b1a25b8319a72de$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $6b1a25b8319a72de$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $6b1a25b8319a72de$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $6b1a25b8319a72de$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$6b1a25b8319a72de$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $6b1a25b8319a72de$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $6b1a25b8319a72de$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $6b1a25b8319a72de$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $6b1a25b8319a72de$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $6b1a25b8319a72de$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $6b1a25b8319a72de$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $6b1a25b8319a72de$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($6b1a25b8319a72de$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $6b1a25b8319a72de$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $6b1a25b8319a72de$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $6b1a25b8319a72de$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $6b1a25b8319a72de$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $6b1a25b8319a72de$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $6b1a25b8319a72de$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $6b1a25b8319a72de$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $6b1a25b8319a72de$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $6b1a25b8319a72de$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $6b1a25b8319a72de$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $6b1a25b8319a72de$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $6b1a25b8319a72de$var$findNearestBoundary(matches).route.id,
            {
                type: $6b1a25b8319a72de$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $6b1a25b8319a72de$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($6b1a25b8319a72de$var$isErrorResult(result) && $6b1a25b8319a72de$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $6b1a25b8319a72de$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $6b1a25b8319a72de$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $6b1a25b8319a72de$var$_extends({
            matches: updatedMatches || matches
        }, $6b1a25b8319a72de$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $6b1a25b8319a72de$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $6b1a25b8319a72de$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $6b1a25b8319a72de$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $6b1a25b8319a72de$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $6b1a25b8319a72de$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $6b1a25b8319a72de$var$ResultType.error,
            error: $6b1a25b8319a72de$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($6b1a25b8319a72de$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $6b1a25b8319a72de$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($6b1a25b8319a72de$var$isDeferredResult(result)) throw $6b1a25b8319a72de$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($6b1a25b8319a72de$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $6b1a25b8319a72de$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $6b1a25b8319a72de$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $6b1a25b8319a72de$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $6b1a25b8319a72de$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($6b1a25b8319a72de$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $6b1a25b8319a72de$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $6b1a25b8319a72de$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $6b1a25b8319a72de$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $6b1a25b8319a72de$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $6b1a25b8319a72de$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $6b1a25b8319a72de$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $6b1a25b8319a72de$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6b1a25b8319a72de$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $6b1a25b8319a72de$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $6b1a25b8319a72de$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$6b1a25b8319a72de$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $6b1a25b8319a72de$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $6b1a25b8319a72de$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $6b1a25b8319a72de$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $6b1a25b8319a72de$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $6b1a25b8319a72de$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $6b1a25b8319a72de$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $6b1a25b8319a72de$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $6b1a25b8319a72de$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6b1a25b8319a72de$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6b1a25b8319a72de$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6b1a25b8319a72de$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $6b1a25b8319a72de$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($6b1a25b8319a72de$var$isRedirectResult(actionResult) || $6b1a25b8319a72de$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $6b1a25b8319a72de$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($6b1a25b8319a72de$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $6b1a25b8319a72de$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $6b1a25b8319a72de$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($6b1a25b8319a72de$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($6b1a25b8319a72de$var$isDeferredResult(actionResult)) throw $6b1a25b8319a72de$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $6b1a25b8319a72de$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $6b1a25b8319a72de$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $6b1a25b8319a72de$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $6b1a25b8319a72de$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $6b1a25b8319a72de$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $6b1a25b8319a72de$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $6b1a25b8319a72de$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $6b1a25b8319a72de$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6b1a25b8319a72de$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $6b1a25b8319a72de$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $6b1a25b8319a72de$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $6b1a25b8319a72de$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6b1a25b8319a72de$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6b1a25b8319a72de$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6b1a25b8319a72de$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $6b1a25b8319a72de$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($6b1a25b8319a72de$var$isDeferredResult(result)) result = await $6b1a25b8319a72de$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $6b1a25b8319a72de$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($6b1a25b8319a72de$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $6b1a25b8319a72de$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($6b1a25b8319a72de$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $6b1a25b8319a72de$export$3e9cee6b33872309(!$6b1a25b8319a72de$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $6b1a25b8319a72de$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $6b1a25b8319a72de$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $6b1a25b8319a72de$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $6b1a25b8319a72de$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($6b1a25b8319a72de$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $6b1a25b8319a72de$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $6b1a25b8319a72de$export$e19cd5f9376f8cee.Replace : $6b1a25b8319a72de$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $6b1a25b8319a72de$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($6b1a25b8319a72de$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $6b1a25b8319a72de$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $6b1a25b8319a72de$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $6b1a25b8319a72de$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $6b1a25b8319a72de$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $6b1a25b8319a72de$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($6b1a25b8319a72de$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $6b1a25b8319a72de$var$ResultType.redirect,
                response: $6b1a25b8319a72de$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $6b1a25b8319a72de$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $6b1a25b8319a72de$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $6b1a25b8319a72de$var$ResultType.error,
                    error: $6b1a25b8319a72de$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $6b1a25b8319a72de$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $6b1a25b8319a72de$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $6b1a25b8319a72de$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $6b1a25b8319a72de$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $6b1a25b8319a72de$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $6b1a25b8319a72de$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $6b1a25b8319a72de$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $6b1a25b8319a72de$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $6b1a25b8319a72de$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $6b1a25b8319a72de$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $6b1a25b8319a72de$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $6b1a25b8319a72de$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $6b1a25b8319a72de$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $6b1a25b8319a72de$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$6b1a25b8319a72de$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $6b1a25b8319a72de$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $6b1a25b8319a72de$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $6b1a25b8319a72de$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $6b1a25b8319a72de$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $6b1a25b8319a72de$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $6b1a25b8319a72de$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $6b1a25b8319a72de$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $6b1a25b8319a72de$export$4d0306f8f6a4585b = Symbol("deferred");
function $6b1a25b8319a72de$export$3336b097a6fbc59a(routes, opts) {
    $6b1a25b8319a72de$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6b1a25b8319a72de$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $6b1a25b8319a72de$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $6b1a25b8319a72de$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6b1a25b8319a72de$var$createLocation("", $6b1a25b8319a72de$export$fe53371bee54353d(url), null, "default");
        let matches = $6b1a25b8319a72de$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6b1a25b8319a72de$var$isValidMethod(method) && method !== "HEAD") {
            let error = $6b1a25b8319a72de$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $6b1a25b8319a72de$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $6b1a25b8319a72de$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6b1a25b8319a72de$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($6b1a25b8319a72de$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $6b1a25b8319a72de$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6b1a25b8319a72de$var$createLocation("", $6b1a25b8319a72de$export$fe53371bee54353d(url), null, "default");
        let matches = $6b1a25b8319a72de$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6b1a25b8319a72de$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $6b1a25b8319a72de$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $6b1a25b8319a72de$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $6b1a25b8319a72de$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $6b1a25b8319a72de$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $6b1a25b8319a72de$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($6b1a25b8319a72de$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$6b1a25b8319a72de$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $6b1a25b8319a72de$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($6b1a25b8319a72de$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $6b1a25b8319a72de$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $6b1a25b8319a72de$var$isResponse(result) ? result : $6b1a25b8319a72de$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($6b1a25b8319a72de$var$isDataStrategyResult(e) && $6b1a25b8319a72de$var$isResponse(e.result)) {
                if (e.type === $6b1a25b8319a72de$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($6b1a25b8319a72de$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $6b1a25b8319a72de$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6b1a25b8319a72de$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $6b1a25b8319a72de$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($6b1a25b8319a72de$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($6b1a25b8319a72de$var$isDeferredResult(result)) {
            let error = $6b1a25b8319a72de$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6b1a25b8319a72de$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($6b1a25b8319a72de$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($6b1a25b8319a72de$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $6b1a25b8319a72de$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $6b1a25b8319a72de$var$_extends({}, context, {
                statusCode: $6b1a25b8319a72de$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $6b1a25b8319a72de$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $6b1a25b8319a72de$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $6b1a25b8319a72de$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $6b1a25b8319a72de$var$isErrorResult(pendingActionResult[1]) ? $6b1a25b8319a72de$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $6b1a25b8319a72de$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $6b1a25b8319a72de$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $6b1a25b8319a72de$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $6b1a25b8319a72de$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $6b1a25b8319a72de$var$callDataStrategyImpl(dataStrategy || $6b1a25b8319a72de$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($6b1a25b8319a72de$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $6b1a25b8319a72de$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($6b1a25b8319a72de$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $6b1a25b8319a72de$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $6b1a25b8319a72de$export$fec11da027c70692(routes, context, error) {
    let newContext = $6b1a25b8319a72de$var$_extends({}, context, {
        statusCode: $6b1a25b8319a72de$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $6b1a25b8319a72de$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $6b1a25b8319a72de$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $6b1a25b8319a72de$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $6b1a25b8319a72de$export$cae722b0cc860f13(to ? to : ".", $6b1a25b8319a72de$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $6b1a25b8319a72de$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $6b1a25b8319a72de$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $6b1a25b8319a72de$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $6b1a25b8319a72de$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $6b1a25b8319a72de$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$6b1a25b8319a72de$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$6b1a25b8319a72de$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $6b1a25b8319a72de$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $6b1a25b8319a72de$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $6b1a25b8319a72de$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$6b1a25b8319a72de$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$6b1a25b8319a72de$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $6b1a25b8319a72de$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $6b1a25b8319a72de$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $6b1a25b8319a72de$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $6b1a25b8319a72de$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $6b1a25b8319a72de$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($6b1a25b8319a72de$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $6b1a25b8319a72de$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $6b1a25b8319a72de$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $6b1a25b8319a72de$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $6b1a25b8319a72de$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $6b1a25b8319a72de$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $6b1a25b8319a72de$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $6b1a25b8319a72de$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $6b1a25b8319a72de$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $6b1a25b8319a72de$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $6b1a25b8319a72de$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($6b1a25b8319a72de$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $6b1a25b8319a72de$var$shouldRevalidateLoader(match, $6b1a25b8319a72de$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $6b1a25b8319a72de$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $6b1a25b8319a72de$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $6b1a25b8319a72de$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $6b1a25b8319a72de$var$shouldRevalidateLoader(fetcherMatch, $6b1a25b8319a72de$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $6b1a25b8319a72de$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $6b1a25b8319a72de$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $6b1a25b8319a72de$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $6b1a25b8319a72de$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $6b1a25b8319a72de$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $6b1a25b8319a72de$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$6b1a25b8319a72de$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $6b1a25b8319a72de$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $6b1a25b8319a72de$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$6b1a25b8319a72de$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $6b1a25b8319a72de$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $6b1a25b8319a72de$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $6b1a25b8319a72de$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$6b1a25b8319a72de$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $6b1a25b8319a72de$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $6b1a25b8319a72de$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $6b1a25b8319a72de$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $6b1a25b8319a72de$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $6b1a25b8319a72de$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $6b1a25b8319a72de$var$ResultType.data,
                result: undefined
            });
        };
        return $6b1a25b8319a72de$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $6b1a25b8319a72de$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $6b1a25b8319a72de$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $6b1a25b8319a72de$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $6b1a25b8319a72de$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $6b1a25b8319a72de$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $6b1a25b8319a72de$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $6b1a25b8319a72de$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($6b1a25b8319a72de$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $6b1a25b8319a72de$var$ResultType.error,
                error: e
            };
        }
        if (type === $6b1a25b8319a72de$var$ResultType.error) return {
            type: $6b1a25b8319a72de$var$ResultType.error,
            error: new $6b1a25b8319a72de$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $6b1a25b8319a72de$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $6b1a25b8319a72de$var$ResultType.error) {
        if ($6b1a25b8319a72de$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $6b1a25b8319a72de$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $6b1a25b8319a72de$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $6b1a25b8319a72de$var$ResultType.error,
            error: result,
            statusCode: $6b1a25b8319a72de$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($6b1a25b8319a72de$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $6b1a25b8319a72de$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($6b1a25b8319a72de$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $6b1a25b8319a72de$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $6b1a25b8319a72de$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $6b1a25b8319a72de$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $6b1a25b8319a72de$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$6b1a25b8319a72de$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $6b1a25b8319a72de$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $6b1a25b8319a72de$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($6b1a25b8319a72de$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $6b1a25b8319a72de$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $6b1a25b8319a72de$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($6b1a25b8319a72de$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $6b1a25b8319a72de$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $6b1a25b8319a72de$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $6b1a25b8319a72de$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $6b1a25b8319a72de$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $6b1a25b8319a72de$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $6b1a25b8319a72de$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $6b1a25b8319a72de$export$3e9cee6b33872309(!$6b1a25b8319a72de$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($6b1a25b8319a72de$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $6b1a25b8319a72de$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $6b1a25b8319a72de$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($6b1a25b8319a72de$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $6b1a25b8319a72de$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $6b1a25b8319a72de$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $6b1a25b8319a72de$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($6b1a25b8319a72de$var$isErrorResult(result)) {
            let boundaryMatch = $6b1a25b8319a72de$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $6b1a25b8319a72de$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($6b1a25b8319a72de$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $6b1a25b8319a72de$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($6b1a25b8319a72de$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $6b1a25b8319a72de$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $6b1a25b8319a72de$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $6b1a25b8319a72de$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $6b1a25b8319a72de$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $6b1a25b8319a72de$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $6b1a25b8319a72de$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $6b1a25b8319a72de$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $6b1a25b8319a72de$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $6b1a25b8319a72de$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $6b1a25b8319a72de$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $6b1a25b8319a72de$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($6b1a25b8319a72de$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $6b1a25b8319a72de$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $6b1a25b8319a72de$export$8ccf933b0513f8d0(path) : path;
    return $6b1a25b8319a72de$export$fe53371bee54353d($6b1a25b8319a72de$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $6b1a25b8319a72de$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $6b1a25b8319a72de$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $6b1a25b8319a72de$var$ResultType.data || result.type === $6b1a25b8319a72de$var$ResultType.error);
}
function $6b1a25b8319a72de$var$isRedirectDataStrategyResultResult(result) {
    return $6b1a25b8319a72de$var$isResponse(result.result) && $6b1a25b8319a72de$var$redirectStatusCodes.has(result.result.status);
}
function $6b1a25b8319a72de$var$isDeferredResult(result) {
    return result.type === $6b1a25b8319a72de$var$ResultType.deferred;
}
function $6b1a25b8319a72de$var$isErrorResult(result) {
    return result.type === $6b1a25b8319a72de$var$ResultType.error;
}
function $6b1a25b8319a72de$var$isRedirectResult(result) {
    return (result && result.type) === $6b1a25b8319a72de$var$ResultType.redirect;
}
function $6b1a25b8319a72de$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $6b1a25b8319a72de$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $6b1a25b8319a72de$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $6b1a25b8319a72de$var$isRedirectResponse(result) {
    if (!$6b1a25b8319a72de$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $6b1a25b8319a72de$var$isValidMethod(method) {
    return $6b1a25b8319a72de$var$validRequestMethods.has(method.toLowerCase());
}
function $6b1a25b8319a72de$var$isMutationMethod(method) {
    return $6b1a25b8319a72de$var$validMutationMethods.has(method.toLowerCase());
}
async function $6b1a25b8319a72de$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$6b1a25b8319a72de$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($6b1a25b8319a72de$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $6b1a25b8319a72de$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $6b1a25b8319a72de$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($6b1a25b8319a72de$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $6b1a25b8319a72de$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $6b1a25b8319a72de$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $6b1a25b8319a72de$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $6b1a25b8319a72de$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $6b1a25b8319a72de$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $6b1a25b8319a72de$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $6b1a25b8319a72de$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $6b1a25b8319a72de$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $6b1a25b8319a72de$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $6b1a25b8319a72de$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $6b1a25b8319a72de$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $6b1a25b8319a72de$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $6b1a25b8319a72de$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $6b1a25b8319a72de$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $6b1a25b8319a72de$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $6b1a25b8319a72de$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $6b1a25b8319a72de$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $6b1a25b8319a72de$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($6b1a25b8319a72de$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $6b1a25b8319a72de$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($6b1a25b8319a72de$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $6b1a25b8319a72de$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $405e09292ddca27f$var$_extends() {
    $405e09292ddca27f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $405e09292ddca27f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $405e09292ddca27f$export$3add0d5dce533e2e = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext(null);
const $405e09292ddca27f$export$145dfa71566a64dc = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext(null);
const $405e09292ddca27f$var$AwaitContext = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $405e09292ddca27f$export$26749e8557646306 = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext(null);
const $405e09292ddca27f$export$c7914228fb69b0f5 = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext(null);
const $405e09292ddca27f$export$9072aa6dd1f93057 = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $405e09292ddca27f$var$RouteErrorContext = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $405e09292ddca27f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$405e09292ddca27f$export$9c954a9d03d32f4a() && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $405e09292ddca27f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $6b1a25b8319a72de$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $405e09292ddca27f$export$9c954a9d03d32f4a() {
    return $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $405e09292ddca27f$export$45d76561a5302f2b() {
    !$405e09292ddca27f$export$9c954a9d03d32f4a() && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    return $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $405e09292ddca27f$export$1b3f31771c5d07c() {
    return $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $405e09292ddca27f$export$6c330e8992e8a295(pattern) {
    !$405e09292ddca27f$export$9c954a9d03d32f4a() && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $405e09292ddca27f$export$45d76561a5302f2b();
    return $c9d322eeb636f8e5$exports.useMemo(()=>(0, $6b1a25b8319a72de$export$81336c211d5ff295)(pattern, (0, $6b1a25b8319a72de$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $405e09292ddca27f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $405e09292ddca27f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c9d322eeb636f8e5$exports.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $405e09292ddca27f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $405e09292ddca27f$var$useNavigateStable() : $405e09292ddca27f$var$useNavigateUnstable();
}
function $405e09292ddca27f$var$useNavigateUnstable() {
    !$405e09292ddca27f$export$9c954a9d03d32f4a() && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    let dataRouterContext = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$26749e8557646306);
    let { matches: matches } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $405e09292ddca27f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $6b1a25b8319a72de$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $c9d322eeb636f8e5$exports.useRef(false);
    $405e09292ddca27f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $c9d322eeb636f8e5$exports.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $6b1a25b8319a72de$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6b1a25b8319a72de$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $405e09292ddca27f$var$OutletContext = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $405e09292ddca27f$export$4138103a3ae699cc() {
    return $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $405e09292ddca27f$export$a3be3530d8e40d0b(context) {
    let outlet = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $405e09292ddca27f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $405e09292ddca27f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$26749e8557646306);
    let { matches: matches } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $405e09292ddca27f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $6b1a25b8319a72de$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $c9d322eeb636f8e5$exports.useMemo(()=>(0, $6b1a25b8319a72de$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $405e09292ddca27f$export$5d3fca4a98652595(routes, locationArg) {
    return $405e09292ddca27f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $405e09292ddca27f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$405e09292ddca27f$export$9c954a9d03d32f4a() && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$26749e8557646306);
    let { matches: parentMatches } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $405e09292ddca27f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $6b1a25b8319a72de$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $6b1a25b8319a72de$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $405e09292ddca27f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $6b1a25b8319a72de$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $6b1a25b8319a72de$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $405e09292ddca27f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $6b1a25b8319a72de$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $405e09292ddca27f$var$DefaultErrorComponent() {
    let error = $405e09292ddca27f$export$ed527bf60f6e05f2();
    let message = (0, $6b1a25b8319a72de$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($c9d322eeb636f8e5$exports.Fragment, null, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $405e09292ddca27f$var$defaultErrorElement = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$DefaultErrorComponent, null);
class $405e09292ddca27f$var$RenderErrorBoundary extends $c9d322eeb636f8e5$exports.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $405e09292ddca27f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $405e09292ddca27f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $405e09292ddca27f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $405e09292ddca27f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $405e09292ddca27f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($405e09292ddca27f$var$DataRouterHook || {});
var $405e09292ddca27f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($405e09292ddca27f$var$DataRouterStateHook || {});
function $405e09292ddca27f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $405e09292ddca27f$var$useDataRouterContext(hookName) {
    let ctx = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$3add0d5dce533e2e);
    !ctx && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    return ctx;
}
function $405e09292ddca27f$var$useDataRouterState(hookName) {
    let state = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$145dfa71566a64dc);
    !state && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    return state;
}
function $405e09292ddca27f$var$useRouteContext(hookName) {
    let route = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$9072aa6dd1f93057);
    !route && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $405e09292ddca27f$var$useCurrentRouteId(hookName) {
    let route = $405e09292ddca27f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $405e09292ddca27f$export$5fc8298006ad9e58() {
    return $405e09292ddca27f$var$useCurrentRouteId($405e09292ddca27f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $405e09292ddca27f$export$d0fd4b7106de2769() {
    let state = $405e09292ddca27f$var$useDataRouterState($405e09292ddca27f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $405e09292ddca27f$export$600dc272ed516c15() {
    let dataRouterContext = $405e09292ddca27f$var$useDataRouterContext($405e09292ddca27f$var$DataRouterHook.UseRevalidator);
    let state = $405e09292ddca27f$var$useDataRouterState($405e09292ddca27f$var$DataRouterStateHook.UseRevalidator);
    return $c9d322eeb636f8e5$exports.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $405e09292ddca27f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $405e09292ddca27f$var$useDataRouterState($405e09292ddca27f$var$DataRouterStateHook.UseMatches);
    return $c9d322eeb636f8e5$exports.useMemo(()=>matches.map((m)=>(0, $6b1a25b8319a72de$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $405e09292ddca27f$export$1448a5050d252c4d() {
    let state = $405e09292ddca27f$var$useDataRouterState($405e09292ddca27f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $405e09292ddca27f$var$useCurrentRouteId($405e09292ddca27f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $405e09292ddca27f$export$fd5d37484eab868d(routeId) {
    let state = $405e09292ddca27f$var$useDataRouterState($405e09292ddca27f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $405e09292ddca27f$export$fdc00f3f26066d5e() {
    let state = $405e09292ddca27f$var$useDataRouterState($405e09292ddca27f$var$DataRouterStateHook.UseActionData);
    let routeId = $405e09292ddca27f$var$useCurrentRouteId($405e09292ddca27f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $405e09292ddca27f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$var$RouteErrorContext);
    let state = $405e09292ddca27f$var$useDataRouterState($405e09292ddca27f$var$DataRouterStateHook.UseRouteError);
    let routeId = $405e09292ddca27f$var$useCurrentRouteId($405e09292ddca27f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $405e09292ddca27f$export$78a72ddb39bdd145() {
    let value = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $405e09292ddca27f$export$17f53340677d5831() {
    let value = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $405e09292ddca27f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $405e09292ddca27f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $405e09292ddca27f$var$useDataRouterContext($405e09292ddca27f$var$DataRouterHook.UseBlocker);
    let state = $405e09292ddca27f$var$useDataRouterState($405e09292ddca27f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $c9d322eeb636f8e5$exports.useState("");
    let blockerFunction = $c9d322eeb636f8e5$exports.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $405e09292ddca27f$var$_extends({}, currentLocation, {
                pathname: (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $405e09292ddca27f$var$_extends({}, nextLocation, {
                pathname: (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        let key = String(++$405e09292ddca27f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $6b1a25b8319a72de$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $405e09292ddca27f$var$useNavigateStable() {
    let { router: router } = $405e09292ddca27f$var$useDataRouterContext($405e09292ddca27f$var$DataRouterHook.UseNavigateStable);
    let id = $405e09292ddca27f$var$useCurrentRouteId($405e09292ddca27f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $c9d322eeb636f8e5$exports.useRef(false);
    $405e09292ddca27f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $c9d322eeb636f8e5$exports.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $405e09292ddca27f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $405e09292ddca27f$var$alreadyWarned = {};
function $405e09292ddca27f$var$warningOnce(key, cond, message) {
    if (!cond && !$405e09292ddca27f$var$alreadyWarned[key]) $405e09292ddca27f$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $405e09292ddca27f$var$START_TRANSITION = "startTransition";
const $405e09292ddca27f$var$startTransitionImpl = $c9d322eeb636f8e5$exports[$405e09292ddca27f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $405e09292ddca27f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $c9d322eeb636f8e5$exports.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $c9d322eeb636f8e5$exports.useCallback((newState)=>{
        if (v7_startTransition && $405e09292ddca27f$var$startTransitionImpl) $405e09292ddca27f$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $c9d322eeb636f8e5$exports.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $c9d322eeb636f8e5$exports.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $c9d322eeb636f8e5$exports.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $c9d322eeb636f8e5$exports.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($c9d322eeb636f8e5$exports.Fragment, null, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $405e09292ddca27f$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $405e09292ddca27f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $405e09292ddca27f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $c9d322eeb636f8e5$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6b1a25b8319a72de$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $c9d322eeb636f8e5$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $c9d322eeb636f8e5$exports.useCallback((newState)=>{
        v7_startTransition && $405e09292ddca27f$var$startTransitionImpl ? $405e09292ddca27f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $c9d322eeb636f8e5$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $405e09292ddca27f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$405e09292ddca27f$export$9c954a9d03d32f4a() && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$26749e8557646306);
    let { matches: matches } = $c9d322eeb636f8e5$exports.useContext($405e09292ddca27f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $405e09292ddca27f$export$45d76561a5302f2b();
    let navigate = $405e09292ddca27f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $6b1a25b8319a72de$export$cae722b0cc860f13)(to, (0, $6b1a25b8319a72de$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $c9d322eeb636f8e5$exports.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $405e09292ddca27f$export$910ae8079b2c2852(props) {
    return $405e09292ddca27f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $405e09292ddca27f$export$e7b0ac011bb776c6(_props) {
    (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $405e09292ddca27f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $6b1a25b8319a72de$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$405e09292ddca27f$export$9c954a9d03d32f4a() && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $c9d322eeb636f8e5$exports.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $405e09292ddca27f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $6b1a25b8319a72de$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $c9d322eeb636f8e5$exports.useMemo(()=>{
        let trailingPathname = (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $405e09292ddca27f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $405e09292ddca27f$export$5d3fca4a98652595($405e09292ddca27f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $405e09292ddca27f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$ResolveAwait, null, children));
}
var $405e09292ddca27f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($405e09292ddca27f$var$AwaitRenderStatus || {});
const $405e09292ddca27f$var$neverSettledPromise = new Promise(()=>{});
class $405e09292ddca27f$var$AwaitErrorBoundary extends $c9d322eeb636f8e5$exports.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $405e09292ddca27f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $405e09292ddca27f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $405e09292ddca27f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $405e09292ddca27f$var$AwaitRenderStatus.error : "_data" in promise ? $405e09292ddca27f$var$AwaitRenderStatus.success : $405e09292ddca27f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $405e09292ddca27f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $405e09292ddca27f$var$AwaitRenderStatus.error && promise._error instanceof (0, $6b1a25b8319a72de$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $405e09292ddca27f$var$neverSettledPromise;
        if (status === $405e09292ddca27f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $405e09292ddca27f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $405e09292ddca27f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($405e09292ddca27f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $405e09292ddca27f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $405e09292ddca27f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($c9d322eeb636f8e5$exports.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $405e09292ddca27f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $c9d322eeb636f8e5$exports.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $c9d322eeb636f8e5$exports.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $c9d322eeb636f8e5$exports.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $405e09292ddca27f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $405e09292ddca27f$export$e7b0ac011bb776c6) && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $405e09292ddca27f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $405e09292ddca27f$export$daf73786167a7f72(matches) {
    return $405e09292ddca27f$var$_renderMatches(matches);
}
function $405e09292ddca27f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $405e09292ddca27f$export$f30f7e456d254e83(routes, opts) {
    return (0, $6b1a25b8319a72de$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $405e09292ddca27f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6b1a25b8319a72de$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $405e09292ddca27f$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $4a6806eb551925a6$var$_extends() {
    $4a6806eb551925a6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a6806eb551925a6$var$_extends.apply(this, arguments);
}
function $4a6806eb551925a6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $4a6806eb551925a6$var$defaultMethod = "get";
const $4a6806eb551925a6$var$defaultEncType = "application/x-www-form-urlencoded";
function $4a6806eb551925a6$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $4a6806eb551925a6$var$isButtonElement(object) {
    return $4a6806eb551925a6$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $4a6806eb551925a6$var$isFormElement(object) {
    return $4a6806eb551925a6$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $4a6806eb551925a6$var$isInputElement(object) {
    return $4a6806eb551925a6$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $4a6806eb551925a6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $4a6806eb551925a6$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$4a6806eb551925a6$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $4a6806eb551925a6$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $4a6806eb551925a6$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $4a6806eb551925a6$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $4a6806eb551925a6$var$_formDataSupportsSubmitter = null;
function $4a6806eb551925a6$var$isFormDataSubmitterSupported() {
    if ($4a6806eb551925a6$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $4a6806eb551925a6$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $4a6806eb551925a6$var$_formDataSupportsSubmitter = true;
    }
    return $4a6806eb551925a6$var$_formDataSupportsSubmitter;
}
const $4a6806eb551925a6$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $4a6806eb551925a6$var$getFormEncType(encType) {
    if (encType != null && !$4a6806eb551925a6$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $4a6806eb551925a6$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($4a6806eb551925a6$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $4a6806eb551925a6$var$defaultMethod;
        encType = $4a6806eb551925a6$var$getFormEncType(target.getAttribute("enctype")) || $4a6806eb551925a6$var$defaultEncType;
        formData = new FormData(target);
    } else if ($4a6806eb551925a6$var$isButtonElement(target) || $4a6806eb551925a6$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $4a6806eb551925a6$var$defaultMethod;
        encType = $4a6806eb551925a6$var$getFormEncType(target.getAttribute("formenctype")) || $4a6806eb551925a6$var$getFormEncType(form.getAttribute("enctype")) || $4a6806eb551925a6$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$4a6806eb551925a6$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($4a6806eb551925a6$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $4a6806eb551925a6$var$defaultMethod;
        action = null;
        encType = $4a6806eb551925a6$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $4a6806eb551925a6$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $4a6806eb551925a6$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $4a6806eb551925a6$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $4a6806eb551925a6$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $4a6806eb551925a6$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $4a6806eb551925a6$export$1f3f55432a00e06d(routes, opts) {
    return (0, $6b1a25b8319a72de$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4a6806eb551925a6$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6b1a25b8319a72de$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $4a6806eb551925a6$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $405e09292ddca27f$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $4a6806eb551925a6$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $6b1a25b8319a72de$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4a6806eb551925a6$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6b1a25b8319a72de$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $4a6806eb551925a6$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $405e09292ddca27f$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $4a6806eb551925a6$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $4a6806eb551925a6$var$_extends({}, state, {
        errors: $4a6806eb551925a6$var$deserializeErrors(state.errors)
    });
    return state;
}
function $4a6806eb551925a6$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $6b1a25b8319a72de$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $4a6806eb551925a6$export$7ad602f0e94e62d1 = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext({
    isTransitioning: false
});
const $4a6806eb551925a6$export$148fd98d095596d4 = /*#__PURE__*/ $c9d322eeb636f8e5$exports.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $4a6806eb551925a6$var$START_TRANSITION = "startTransition";
const $4a6806eb551925a6$var$startTransitionImpl = $c9d322eeb636f8e5$exports[$4a6806eb551925a6$var$START_TRANSITION];
const $4a6806eb551925a6$var$FLUSH_SYNC = "flushSync";
const $4a6806eb551925a6$var$flushSyncImpl = $c9d322eeb636f8e5$exports[$4a6806eb551925a6$var$FLUSH_SYNC];
const $4a6806eb551925a6$var$USE_ID = "useId";
const $4a6806eb551925a6$var$useIdImpl = $c9d322eeb636f8e5$exports[$4a6806eb551925a6$var$USE_ID];
function $4a6806eb551925a6$var$startTransitionSafe(cb) {
    if ($4a6806eb551925a6$var$startTransitionImpl) $4a6806eb551925a6$var$startTransitionImpl(cb);
    else cb();
}
function $4a6806eb551925a6$var$flushSyncSafe(cb) {
    if ($4a6806eb551925a6$var$flushSyncImpl) $4a6806eb551925a6$var$flushSyncImpl(cb);
    else cb();
}
class $4a6806eb551925a6$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4a6806eb551925a6$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $c9d322eeb636f8e5$exports.useState(router.state);
    let [pendingState, setPendingState] = $c9d322eeb636f8e5$exports.useState();
    let [vtContext, setVtContext] = $c9d322eeb636f8e5$exports.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $c9d322eeb636f8e5$exports.useState();
    let [transition, setTransition] = $c9d322eeb636f8e5$exports.useState();
    let [interruption, setInterruption] = $c9d322eeb636f8e5$exports.useState();
    let fetcherData = $c9d322eeb636f8e5$exports.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $c9d322eeb636f8e5$exports.useCallback((cb)=>{
        if (v7_startTransition) $4a6806eb551925a6$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $c9d322eeb636f8e5$exports.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $4a6806eb551925a6$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $4a6806eb551925a6$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $4a6806eb551925a6$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $4a6806eb551925a6$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $4a6806eb551925a6$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $c9d322eeb636f8e5$exports.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $4a6806eb551925a6$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $c9d322eeb636f8e5$exports.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $c9d322eeb636f8e5$exports.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $c9d322eeb636f8e5$exports.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $c9d322eeb636f8e5$exports.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($c9d322eeb636f8e5$exports.Fragment, null, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement((0, $405e09292ddca27f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement((0, $405e09292ddca27f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($4a6806eb551925a6$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($4a6806eb551925a6$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement((0, $405e09292ddca27f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($4a6806eb551925a6$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $4a6806eb551925a6$var$MemoizedDataRoutes = /*#__PURE__*/ $c9d322eeb636f8e5$exports.memo($4a6806eb551925a6$var$DataRoutes);
function $4a6806eb551925a6$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $405e09292ddca27f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $4a6806eb551925a6$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $c9d322eeb636f8e5$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6b1a25b8319a72de$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $c9d322eeb636f8e5$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $c9d322eeb636f8e5$exports.useCallback((newState)=>{
        v7_startTransition && $4a6806eb551925a6$var$startTransitionImpl ? $4a6806eb551925a6$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $c9d322eeb636f8e5$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement((0, $405e09292ddca27f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $4a6806eb551925a6$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $c9d322eeb636f8e5$exports.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6b1a25b8319a72de$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $c9d322eeb636f8e5$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $c9d322eeb636f8e5$exports.useCallback((newState)=>{
        v7_startTransition && $4a6806eb551925a6$var$startTransitionImpl ? $4a6806eb551925a6$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $c9d322eeb636f8e5$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement((0, $405e09292ddca27f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $4a6806eb551925a6$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $c9d322eeb636f8e5$exports.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $c9d322eeb636f8e5$exports.useCallback((newState)=>{
        v7_startTransition && $4a6806eb551925a6$var$startTransitionImpl ? $4a6806eb551925a6$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $c9d322eeb636f8e5$exports.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement((0, $405e09292ddca27f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $4a6806eb551925a6$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $4a6806eb551925a6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $4a6806eb551925a6$export$a6c7ac8248d6e38a = /*#__PURE__*/ $c9d322eeb636f8e5$exports.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $4a6806eb551925a6$var$_objectWithoutPropertiesLoose(_ref7, $4a6806eb551925a6$var$_excluded);
    let { basename: basename } = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $4a6806eb551925a6$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($4a6806eb551925a6$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $405e09292ddca27f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $4a6806eb551925a6$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $c9d322eeb636f8e5$exports.createElement("a", $4a6806eb551925a6$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $4a6806eb551925a6$export$b0d92dbee9b5b60d = /*#__PURE__*/ $c9d322eeb636f8e5$exports.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $4a6806eb551925a6$var$_objectWithoutPropertiesLoose(_ref8, $4a6806eb551925a6$var$_excluded2);
    let path = (0, $405e09292ddca27f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $405e09292ddca27f$export$45d76561a5302f2b)();
    let routerState = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4a6806eb551925a6$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($4a6806eb551925a6$export$a6c7ac8248d6e38a, $4a6806eb551925a6$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $4a6806eb551925a6$export$a7fed597f4b8afd8 = /*#__PURE__*/ $c9d322eeb636f8e5$exports.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $4a6806eb551925a6$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $4a6806eb551925a6$var$_objectWithoutPropertiesLoose(_ref9, $4a6806eb551925a6$var$_excluded3);
    let submit = $4a6806eb551925a6$export$47c85c6e3a081d3();
    let formAction = $4a6806eb551925a6$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement("form", $4a6806eb551925a6$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $4a6806eb551925a6$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $4a6806eb551925a6$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $4a6806eb551925a6$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($4a6806eb551925a6$var$DataRouterHook || ($4a6806eb551925a6$var$DataRouterHook = {}));
var $4a6806eb551925a6$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($4a6806eb551925a6$var$DataRouterStateHook || ($4a6806eb551925a6$var$DataRouterStateHook = {}));
// Internal hooks
function $4a6806eb551925a6$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4a6806eb551925a6$var$useDataRouterContext(hookName) {
    let ctx = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$3add0d5dce533e2e));
    !ctx && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4a6806eb551925a6$var$useDataRouterState(hookName) {
    let state = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$145dfa71566a64dc));
    !state && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $4a6806eb551925a6$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    let location = (0, $405e09292ddca27f$export$45d76561a5302f2b)();
    let path = (0, $405e09292ddca27f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $c9d322eeb636f8e5$exports.useCallback((event)=>{
        if ($4a6806eb551925a6$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $6b1a25b8319a72de$export$fe53371bee54353d)(location) === (0, $6b1a25b8319a72de$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $4a6806eb551925a6$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $c9d322eeb636f8e5$exports.useRef($4a6806eb551925a6$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $c9d322eeb636f8e5$exports.useRef(false);
    let location = (0, $405e09292ddca27f$export$45d76561a5302f2b)();
    let searchParams = $c9d322eeb636f8e5$exports.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $4a6806eb551925a6$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    let setSearchParams = $c9d322eeb636f8e5$exports.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $4a6806eb551925a6$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $4a6806eb551925a6$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $4a6806eb551925a6$var$fetcherId = 0;
let $4a6806eb551925a6$var$getUniqueFetcherId = ()=>"__" + String(++$4a6806eb551925a6$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $4a6806eb551925a6$export$47c85c6e3a081d3() {
    let { router: router } = $4a6806eb551925a6$var$useDataRouterContext($4a6806eb551925a6$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$26749e8557646306));
    let currentRouteId = (0, $405e09292ddca27f$export$5fc8298006ad9e58)();
    return $c9d322eeb636f8e5$exports.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $4a6806eb551925a6$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $4a6806eb551925a6$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $4a6806eb551925a6$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $4a6806eb551925a6$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$26749e8557646306));
    let routeContext = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$9072aa6dd1f93057));
    !routeContext && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $4a6806eb551925a6$var$_extends({}, (0, $405e09292ddca27f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $405e09292ddca27f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6b1a25b8319a72de$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $6b1a25b8319a72de$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $4a6806eb551925a6$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $4a6806eb551925a6$var$useDataRouterContext($4a6806eb551925a6$var$DataRouterHook.UseFetcher);
    let state = $4a6806eb551925a6$var$useDataRouterState($4a6806eb551925a6$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $c9d322eeb636f8e5$exports.useContext($4a6806eb551925a6$export$148fd98d095596d4);
    let route = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    !route && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $4a6806eb551925a6$var$useIdImpl ? $4a6806eb551925a6$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $c9d322eeb636f8e5$exports.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($4a6806eb551925a6$var$getUniqueFetcherId());
    // Registration/cleanup
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $c9d322eeb636f8e5$exports.useCallback((href, opts)=>{
        !routeId && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $4a6806eb551925a6$export$47c85c6e3a081d3();
    let submit = $c9d322eeb636f8e5$exports.useCallback((target, opts)=>{
        submitImpl(target, $4a6806eb551925a6$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $c9d322eeb636f8e5$exports.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $c9d322eeb636f8e5$exports.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $c9d322eeb636f8e5$exports.createElement($4a6806eb551925a6$export$a7fed597f4b8afd8, $4a6806eb551925a6$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $6b1a25b8319a72de$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $c9d322eeb636f8e5$exports.useMemo(()=>$4a6806eb551925a6$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $4a6806eb551925a6$export$fa996778a3a31087() {
    let state = $4a6806eb551925a6$var$useDataRouterState($4a6806eb551925a6$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $4a6806eb551925a6$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $4a6806eb551925a6$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $4a6806eb551925a6$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $4a6806eb551925a6$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $4a6806eb551925a6$var$useDataRouterContext($4a6806eb551925a6$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $4a6806eb551925a6$var$useDataRouterState($4a6806eb551925a6$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $c9d322eeb636f8e5$exports.useContext((0, $405e09292ddca27f$export$26749e8557646306));
    let location = (0, $405e09292ddca27f$export$45d76561a5302f2b)();
    let matches = (0, $405e09292ddca27f$export$2378eb7f5ff86053)();
    let navigation = (0, $405e09292ddca27f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $4a6806eb551925a6$var$usePageHide($c9d322eeb636f8e5$exports.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $4a6806eb551925a6$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $4a6806eb551925a6$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($4a6806eb551925a6$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $c9d322eeb636f8e5$exports.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $4a6806eb551925a6$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $4a6806eb551925a6$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $c9d322eeb636f8e5$exports.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($4a6806eb551925a6$var$_extends({}, location, {
                    pathname: (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($4a6806eb551925a6$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $c9d322eeb636f8e5$exports.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $4a6806eb551925a6$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $4a6806eb551925a6$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $4a6806eb551925a6$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $405e09292ddca27f$export$b273b3273281a049)(when);
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $c9d322eeb636f8e5$exports.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $4a6806eb551925a6$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $c9d322eeb636f8e5$exports.useContext($4a6806eb551925a6$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $6b1a25b8319a72de$export$3e9cee6b33872309)(false);
    let { basename: basename } = $4a6806eb551925a6$var$useDataRouterContext($4a6806eb551925a6$var$DataRouterHook.useViewTransitionState);
    let path = (0, $405e09292ddca27f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $6b1a25b8319a72de$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $6b1a25b8319a72de$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $6b1a25b8319a72de$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $677ef6c80a73b7cc$exports = {};

$677ef6c80a73b7cc$exports = (parcelRequire("lpwGa")).getBundleURL("88FtB") + "zusam_logo.1eebfd28.svg";


function $0426dbc898a9b87d$export$2e2bcd8739ae039() {
    const [sending, setSending] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const [showResetPassword, setShowResetPassword] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        // reroute if already logged in
        (0, $ba05c0ef8a781e02$export$ddcffe0146c8f882).get("apiKey").then((apiKey)=>apiKey && navigate("/"));
        (0, $ba05c0ef8a781e02$export$ddcffe0146c8f882).reset();
    }, []);
    const sendPasswordReset = (e)=>{
        e.preventDefault();
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        setSending(true);
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post("/api/password-reset-mail", {
            mail: login
        }).then((res)=>{
            setSending(false);
            if (res && !res.message) (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("password_reset_mail_sent"));
            else (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t(res.message), "alert-danger");
        });
    };
    const sendLoginForm = (e)=>{
        e.preventDefault();
        setSending(true);
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        const password = document.getElementById("password").value;
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post("/api/login", {
            login: login,
            password: password
        }).then((res)=>{
            setSending(false);
            if (res && res.api_key) (0, $ba05c0ef8a781e02$export$ddcffe0146c8f882).set("apiKey", res.api_key).then(()=>{
                (0, $ba05c0ef8a781e02$export$3e32638432616b6).update().then((user)=>{
                    let redirect = "/create-group";
                    if (user.data?.default_group) redirect = `/groups/${user?.data["default_group"]}`;
                    else if (user?.groups[0]) redirect = `/groups/${user?.groups[0].id}`;
                    navigate(redirect);
                });
            });
            else if (res && res.message) (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t(res.message), "alert-danger");
            else (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
        });
    };
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "login"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "login-form"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
        src: new URL($677ef6c80a73b7cc$exports)
    }), !showResetPassword && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group mb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("password_placeholder")
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "forgot-password"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", {
        onClick: ()=>setShowResetPassword(true)
    }, t("forgot_password"))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendLoginForm(e),
        disabled: sending
    }, t("connect"))), !!showResetPassword && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group mb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendPasswordReset(e),
        disabled: sending
    }, t("submit")))));
}






function $d98633f34622d449$export$2e2bcd8739ae039() {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    const sendNewPassword = (e)=>{
        e.preventDefault();
        (0, $ba05c0ef8a781e02$export$ddcffe0146c8f882).set("apiKey", "");
        const password = document.getElementById("password").value || "";
        const passwordConfirmation = document.getElementById("password_confirmation").value || "";
        const mail = (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("mail");
        const key = (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("key");
        if (mail && password) {
            if (password != passwordConfirmation) {
                (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("passwords_dont_match"));
                return;
            }
            (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post("/api/new-password", {
                mail: mail,
                key: key,
                password: password
            }).then((res)=>{
                if (res.api_key) {
                    (0, $ba05c0ef8a781e02$export$ddcffe0146c8f882).set("apiKey", res.api_key);
                    setTimeout(()=>navigate("/"), 100);
                } else (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t(res.message));
            }).catch((res)=>console.warn(res));
        }
    };
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "login"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "login-form"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("h2", {
        class: "title"
    }, t("reset_password_title")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("new_password_placeholder")
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password_confirmation",
        placeholder: t("confirm_password_placeholder")
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendNewPassword(e)
    }, t("submit")))));
}







function $4b4c42fcf86b8acc$export$2e2bcd8739ae039() {
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const sendSignupForm = (e)=>{
        e.preventDefault();
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        const password = document.getElementById("password").value;
        (0, $ba05c0ef8a781e02$export$ddcffe0146c8f882).set("apiKey", "");
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post("/api/signup", {
            login: login,
            password: password,
            invite_key: (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("inviteKey")
        }).then((res)=>{
            if (res && !res.message) {
                (0, $ba05c0ef8a781e02$export$ddcffe0146c8f882).set("apiKey", res.api_key);
                setTimeout(()=>navigate("/"), 100);
            } else (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t(res.message));
        });
    };
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "signup"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "signup-form"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
        src: new URL($677ef6c80a73b7cc$exports)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "welcome lead"
    }, t("invitation_welcome")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("password_placeholder")
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendSignupForm(e)
    }, t("signup")))));
}





class $f79e9cb5c3dbdf1a$var$StopNotificationEmails extends (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8) {
    constructor(){
        super();
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api${window.location.pathname}`).then(()=>{
            this.setState({
                message: this.props.t("notification_emails_stopped")
            });
        }).catch((err)=>{
            console.warn(err);
            this.setState({
                message: this.props.t("error")
            });
        });
    }
    render() {
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null, this.state.message || "");
    }
}
var $f79e9cb5c3dbdf1a$export$2e2bcd8739ae039 = (0, $5fa4965e78bef7fc$export$2dcb0053efd21124)()($f79e9cb5c3dbdf1a$var$StopNotificationEmails);









function $c6a97b4c72e49883$export$2e2bcd8739ae039(props) {
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $30c5ca0a60c8316e$export$2e2bcd8739ae039), {
        id: props.id,
        isChild: true
    });
}




function $021afc89466d3c0c$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const [firstDisplayedChild, setFirstDisplayedChild] = (0, $35130c2d97e6777b$export$60241385465d0a34)(0);
    const [lastDisplayedChild, setLastDisplayedChild] = (0, $35130c2d97e6777b$export$60241385465d0a34)(0);
    const onNewChild = (event)=>{
        const newMsg = event.detail;
        if (newMsg.parent && (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getId(newMsg.parent) == props.id) // a big number to display all children until the new one. This is not elegant...
        // The issue is that we can't simply increment lastDisplayedChild as it is not defined here
        // Another issue is that a user could load a comment in the middle of the list and create a new one...
        // The real answer is to make a paginated list but that is for another time
        setLastDisplayedChild(1024);
    };
    const displayPreviousChildren = ()=>{
        setFirstDisplayedChild(Math.max(0, firstDisplayedChild - 10));
    };
    const displayNextChildren = ()=>{
        setLastDisplayedChild(Math.min(props.childMessages.length, lastDisplayedChild + 10));
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("newChild", onNewChild);
        let firstDisplayedChild = 0;
        let lastDisplayedChild = 0;
        if (props.childMessages.length) {
            let msgIndex = (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).action ? props.childMessages.findIndex((e)=>e && e.id === (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).action) : -1;
            if (msgIndex != -1) {
                firstDisplayedChild = Math.max(0, msgIndex - 1);
                lastDisplayedChild = Math.min(props.childMessages.length, msgIndex + 1);
            } else {
                firstDisplayedChild = props.childMessages && props.childMessages.length - 5; // display the last 5 children
                lastDisplayedChild = props.childMessages && props.childMessages.length;
            }
        }
        setFirstDisplayedChild(firstDisplayedChild);
        setLastDisplayedChild(lastDisplayedChild);
    }, []);
    if (lastDisplayedChild - firstDisplayedChild < 1 || !props.childMessages) return null;
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "children"
    }, firstDisplayedChild > 0 && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "d-flex"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "more-coms unselectable",
        onClick: ()=>displayPreviousChildren()
    }, t("previous_coms"))), props.childMessages.map((e, i)=>{
        if (i < firstDisplayedChild || i > lastDisplayedChild) return null;
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $c6a97b4c72e49883$export$2e2bcd8739ae039), {
            id: e.id,
            key: e.id
        });
    }), lastDisplayedChild + 1 < props.childMessages.length && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "d-flex"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", {
        class: "more-coms unselectable",
        onClick: ()=>displayNextChildren()
    }, t("next_coms"))));
}




function $9b716d635261f1d3$export$2e2bcd8739ae039(props) {
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message-head d-flex"
    }, !props.isPublic && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
        className: `rounded-circle material-shadow avatar${props.author && props.author.name ? "" : " removed-user"}`,
        style: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).backgroundHash(props.author && props.author.name ? props.author && props.author.id : ""),
        src: props.author && props.author.avatar ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.author.avatar.id, 100, 100) : (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar,
        title: props.author && props.author.name ? props.author.name : ""
    })), !props.isChild && !props.isPublic && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "infos"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", {
        class: "capitalize author"
    }, props.author && props.author.name ? props.author.name : "")));
}






// Fontawesome icons taken from https://raw.githubusercontent.com/FortAwesome/Font-Awesome/master/js/all.js
function $cdd1b69860eb1f87$var$FaIcon() {
    const icons = {
        regular: {
            comment: [
                512,
                512,
                [],
                "f075",
                "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
            ],
            bookmark: [
                384,
                512,
                [],
                "f02e",
                "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
            ],
            images: [
                576,
                512,
                [],
                "f302",
                "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
            ],
            "check-circle": [
                512,
                512,
                [],
                "f058",
                "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
            ],
            "file-pdf": [
                384,
                512,
                [],
                "f1c1",
                "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
            ],
            bell: [
                448,
                512,
                [],
                "f0f3",
                "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
            ],
            "level-down-alt": [
                320,
                512,
                [],
                "f3be",
                "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
            ]
        },
        solid: {
            bookmark: [
                384,
                512,
                [],
                "f02e",
                "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
            ],
            comment: [
                512,
                512,
                [],
                "f075",
                "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
            ],
            "pencil-alt": [
                512,
                512,
                [],
                "f303",
                "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
            ],
            "arrow-left": [
                448,
                512,
                [],
                "f060",
                "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
            ],
            "caret-down": [
                320,
                512,
                [],
                "f0d7",
                "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
            ],
            film: [
                512,
                512,
                [],
                "f008",
                "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
            ],
            times: [
                352,
                512,
                [],
                "f00d",
                "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
            ],
            bell: [
                448,
                512,
                [],
                "f0f3",
                "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
            ],
            "ellipsis-h": [
                512,
                512,
                [],
                "f141",
                "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
            ],
            search: [
                512,
                512,
                [],
                "f002",
                "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
            ]
        }
    };
    const icon = icons[this.props.family][this.props.icon];
    if (icon) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("svg", {
        style: this.props.rotation ? `transform: rotate(${this.props.rotation})` : null,
        className: `fa-icon ${this.props.family} ${this.props.icon}`,
        viewBox: `0 0 ${icon[0]} ${icon[1]}`
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("path", {
        fill: "currentColor",
        d: icon[4]
    }));
}
var $cdd1b69860eb1f87$export$2e2bcd8739ae039 = $cdd1b69860eb1f87$var$FaIcon;


const $85c05060c4c33f8a$export$8b29a4b6778bf7f = (0, $cdd1b69860eb1f87$export$2e2bcd8739ae039);










function $ef522b83495e3114$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const groupId = (0, $35130c2d97e6777b$export$60241385465d0a34)(props.id);
    const [loaded, setLoaded] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const [search, setSearch] = (0, $35130c2d97e6777b$export$60241385465d0a34)("");
    const [hashtags, setHashtags] = (0, $35130c2d97e6777b$export$60241385465d0a34)("");
    const [messages, setMessages] = (0, $35130c2d97e6777b$export$60241385465d0a34)([]);
    const loadMessages = ()=>{
        const search = (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("q");
        const hashtags = (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("hashtags");
        setSearch(search);
        setHashtags(hashtags);
        setLoaded(false);
        setMessages([]);
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post("/api/messages/search", {
            group: groupId,
            search: search,
            hashtags: hashtags
        }).then((res)=>{
            if (res && Array.isArray(res["messages"])) {
                setSearch(search);
                setMessages(res["messages"]);
                setLoaded(true);
            }
        });
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        loadMessages();
        window.addEventListener("groupSearch", loadMessages);
        return ()=>{
            window.removeEventListener("groupSearch", loadMessages);
        };
    }, []);
    if (!Array.isArray(messages)) return;
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "search-results-container container-fluid d-flex justify-content-center flex-wrap"
    }, messages.length == 0 && !loaded && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("p", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "mt-5 spinner orange-spinner"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null))), messages.length == 0 && loaded && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("p", null, t("search_without_result")), messages.map((msg, i)=>{
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $19924b6e568a4f60$export$423dfe6469a8e0dd), {
            tabindex: i + 1,
            key: msg.id,
            message: msg,
            groupId: groupId,
            search: search,
            hashtags: hashtags
        });
    }))));
}





function $cccc4ecb09949b4d$export$2e2bcd8739ae039() {
    let params = (0, $405e09292ddca27f$export$99eaa27ddbbb95ef)();
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$42cfbb80f7861e77), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        class: "mb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$8eb86eb08c0b5c12), {
        key: params.id,
        id: params.id
    })))));
}






function $9aa000d3d53c8f9f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, this.props.groups && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "nav-link dropdown groups unselectable",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "unselectable pr-1"
    }, t("groups"), " ", (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "caret-down"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-left"
    }, this.props.groups.filter((e)=>!!e).map((e)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
            key: e.id,
            to: `/groups/${e.id}`,
            class: "d-block seamless-link unselectable"
        }, e.name)), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        to: "/create-group",
        class: "seamless-link unselectable"
    }, `+ ${t("create_a_group")}`))));
}










let $5133ef8bc2964922$export$554ccc96b126a426 = (0, $bc4b82f252aed4aa$export$fd42f52fd3ae1109)();
let $5133ef8bc2964922$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $35130c2d97e6777b$export$e5c5a5f917a5871c) : (0, $35130c2d97e6777b$export$6d9c69b0de29b591);
let $5133ef8bc2964922$export$b5d7ee322abba39e = (context)=>(...keys)=>{
        let store = (0, $35130c2d97e6777b$export$fae74005e78b1a27)(context);
        let rerender = (0, $35130c2d97e6777b$export$60241385465d0a34)({});
        $5133ef8bc2964922$var$useIsomorphicLayoutEffect(()=>{
            return store.on("@changed", (_, changed)=>{
                let changesInKeys = keys.some((key)=>key in changed);
                if (changesInKeys) rerender[1]({});
            });
        }, []);
        return (0, $35130c2d97e6777b$export$1538c33de8887b59)(()=>{
            let state = store.get();
            let data = {};
            keys.forEach((key)=>{
                data[key] = state[key];
            });
            data.dispatch = store.dispatch;
            return data;
        }, [
            rerender[0]
        ]);
    };
let $5133ef8bc2964922$export$11aeef812f154e9e = $5133ef8bc2964922$export$b5d7ee322abba39e($5133ef8bc2964922$export$554ccc96b126a426);
let $5133ef8bc2964922$export$c8172487361f669f = (...keys)=>{
    let Component = keys.pop();
    return (0, $c9d322eeb636f8e5$export$257a8862b851cb5b)((originProps, ref)=>{
        let props = {
            ...originProps,
            ...$5133ef8bc2964922$export$11aeef812f154e9e(...keys),
            ref: ref
        };
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)(Component, props);
    });
};



function $9cd3479cd46259b1$export$2e2bcd8739ae039() {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const { bookmarks: bookmarks } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("bookmarks");
    const { me: me } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("me");
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "main-nav nav align-items-center z-index-100"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "navbar-block"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "menu dropdown cursor-pointer",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "rounded-circle avatar unselectable"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
        class: "rounded-circle",
        style: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me.avatar ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(me.avatar["id"], 80, 80) : (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar,
        onError: (e)=>e.currentTarget.src = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-right"
    }, bookmarks?.length > 0 && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: "/bookmarks"
    }, t("bookmarks")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: `/users/${me.id}/settings`
    }, t("settings")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: "/logout"
    }, t("logout")))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$2d8ae0bb40c793f6), null)), [
        "messages",
        "groups"
    ].includes((0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).route) && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$4b85d3515bd863a5), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "navbar-block"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$ffe0a8eecde78dfa), {
        groups: me.groups
    })));
}








function $5cdf1c2fc07a1db5$var$_extends() {
    return $5cdf1c2fc07a1db5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5cdf1c2fc07a1db5$var$_extends.apply(null, arguments);
}
function $5cdf1c2fc07a1db5$export$2e2bcd8739ae039() {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const { notifications: notifications } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("notifications");
    if (!notifications) return null;
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        className: `menu dropdown${notifications.length ? " cursor-pointer" : ""}`,
        title: t("notifications"),
        tabindex: "-1",
        onClick: (e)=>notifications.length && e.currentTarget.classList.toggle("active")
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "unselectable button-with-count"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: notifications.length ? "solid" : "regular",
        icon: "bell"
    }), !!notifications.filter((n)=>!n.read).length && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "unread-badge"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-right notifications-menu"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "notification-header"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("strong", {
        class: "capitalize"
    }, t("notifications")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "action capitalize",
        onClick: ()=>{
            (0, $ba05c0ef8a781e02$export$6008d97729a90c74).markAllNotificationsAsRead();
        }
    }, t("mark_all_as_read"))), notifications?.length && notifications.sort((a, b)=>b.createdAt - a.createdAt).slice(0, (0, $ba05c0ef8a781e02$export$6008d97729a90c74).LIMIT).map((e)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$14834abbfce3b8cd), $5cdf1c2fc07a1db5$var$_extends({
            key: e.id + e.read
        }, e)))));
}


const $a779245c27c6d4b9$export$8eb86eb08c0b5c12 = (0, $ef522b83495e3114$export$2e2bcd8739ae039);
const $a779245c27c6d4b9$export$5cc34a6155e65c0e = (0, $cccc4ecb09949b4d$export$2e2bcd8739ae039);
const $a779245c27c6d4b9$export$ffe0a8eecde78dfa = (0, $9aa000d3d53c8f9f$export$2e2bcd8739ae039);
const $a779245c27c6d4b9$export$42cfbb80f7861e77 = (0, $9cd3479cd46259b1$export$2e2bcd8739ae039);
const $a779245c27c6d4b9$export$2d8ae0bb40c793f6 = (0, $5cdf1c2fc07a1db5$export$2e2bcd8739ae039);



function $c6bf11b1e742cb38$export$2e2bcd8739ae039() {
    const { bookmarks: bookmarks } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("bookmarks");
    if (!bookmarks) return null;
    if (!Array.isArray(bookmarks) || bookmarks.length < 1) return;
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$42cfbb80f7861e77), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message-container container-fluid d-flex justify-content-center flex-wrap"
    }, bookmarks.map((b, i)=>{
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $19924b6e568a4f60$export$84c965ec8b6b0f92), {
            tabindex: i + 1,
            key: b.message.id,
            id: b.message.id
        });
    })))));
}






class $968c795b42e82a14$var$CreateGroup extends (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8) {
    constructor(){
        super();
        this.postNewGroup = this.postNewGroup.bind(this);
    }
    postNewGroup(event) {
        event.preventDefault();
        const name = document.querySelector("#create_group_form input[name='name']").value;
        let group = {};
        if (name) group.name = name;
        else return false;
        group.createdAt = Math.floor(Date.now() / 1000);
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post("/api/groups", group).then((res)=>{
            (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post(`/api/groups/invitation/${res.secretKey}`, {}).then((res)=>{
                window.location = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(`/groups/${res.id}`);
            });
        });
    }
    render() {
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$42cfbb80f7861e77), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "content"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "container mt-2"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "group-settings"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "card"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "card-body"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "container-fluid p-1"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "row"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "col-12 col-md-10"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", {
            id: "create_group_form",
            class: "mb-1"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "form-group"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
            for: "name"
        }, this.props.t("name"), ": "), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
            type: "text",
            name: "name",
            minlength: "1",
            maxlength: "128",
            placeholder: this.props.t("name_input"),
            class: "form-control",
            required: true
        })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
            onClick: (e)=>this.postNewGroup(e),
            class: "btn btn-primary"
        }, this.props.t("create_the_group"))))))))))));
    }
}
var $968c795b42e82a14$export$2e2bcd8739ae039 = (0, $5fa4965e78bef7fc$export$2dcb0053efd21124)()($968c795b42e82a14$var$CreateGroup);







function $e3f95cd8f7387e6c$export$2e2bcd8739ae039() {
    let params = (0, $405e09292ddca27f$export$99eaa27ddbbb95ef)();
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$42cfbb80f7861e77), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message-container container-fluid d-flex justify-content-center flex-wrap"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $19924b6e568a4f60$export$89085c7857c3f940), {
        key: params.id,
        id: params.id
    })))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        class: "write-button material-shadow seamless-link",
        to: `/groups/${params.id}/write`
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "pencil-alt"
    })))));
}





function $08392949ea77580a$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    // duration relative to event
    const humanTime = (timestamp)=>{
        if (!timestamp) return null;
        const duration = Math.abs(Math.round((Date.now() / 1000 - timestamp) / 60));
        if (duration < 1) return t("just_now");
        if (duration < 60) return t("ago", {
            duration: `${duration}mn`
        });
        if (duration < 1440) return t("ago", {
            duration: `${Math.floor(duration / 60)}h`
        });
        return (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).humanFullDate(timestamp).split(" ")[0];
    };
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, humanTime(props.timestamp));
}








function $31634567bd2e908e$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const [target, setTarget] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [action, setAction] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [title, setTitle] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [author, setAuthor] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [notification, setNotification] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const getMiniature = (notification)=>{
        let imgSrc = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar;
        if (notification?.miniature && notification.type != "global_notification") imgSrc = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(notification?.miniature?.id, 80, 80);
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            style: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).backgroundHash(notification?.fromUser?.id),
            src: imgSrc,
            onError: (e)=>setMiniatureOnError(e)
        });
    };
    const setMiniatureOnError = (event)=>{
        event.currentTarget.src = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar;
    };
    const getAction = (notification)=>{
        switch(notification?.type){
            case "new_message":
                return t("has_posted_in");
            case "new_comment":
                return t("has_commented_on");
            case "user_joined_group":
                return t("has_joined");
            case "user_left_group":
                return t("has_left");
            case "group_name_change":
                return t("changed_group_name");
            default:
                return "";
        }
    };
    const getObject = (notification)=>{
        switch(notification?.type){
            case "new_message":
                return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("strong", null, notification?.fromGroup.name), title && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("br", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("small", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("em", null, (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).limitStrSize(title, 50)))));
            case "new_comment":
                return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", null, `${t("the_message_from")} `, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("strong", null, notification?.parentAuthorName), title && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("br", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("small", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("em", null, (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).limitStrSize(title, 50)))));
            case "user_joined_group":
            case "user_left_group":
                return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("strong", null, notification?.fromGroup.name);
            case "group_name_change":
                return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("strong", null, notification.data["previousGroupName"]), ` ${t("to")} `, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("strong", null, notification.data["newGroupName"]));
            case "global_notification":
                return notification.data["text"];
            default:
                return "";
        }
    };
    const getTarget = (notification, message_id)=>{
        switch(notification?.type){
            case "user_joined_group":
            case "user_left_group":
            case "group_name_change":
                return `/groups/${notification.fromGroup.id}`;
            case "new_message":
                return `/messages/${notification.target}`;
            case "new_comment":
                return `/messages/${message_id}/${notification.target}`;
            case "global_notification":
                return notification.target;
            default:
                return "";
        }
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/notifications/${props.id}`, false, 100).then((n)=>{
            if (n) {
                setTarget(getTarget(n, n.fromMessage?.id));
                setAction(getAction(n));
                setTitle(n.title);
                if (n?.fromUser?.id) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/users/${n.fromUser.id}`).then((u)=>{
                    setAuthor(u);
                });
                setNotification(n);
            }
        });
    }, []);
    if (!notification) return null;
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        key: props.id,
        class: `notification seamless-link unselectable ${!notification.read ? "unread" : ""}`,
        to: target,
        title: title
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "miniature unselectable"
    }, getMiniature(notification)), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "infos"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "description"
    }, notification.type != "global_notification" && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("strong", null, author?.name || "--"), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", null, ` ${action} `)), getObject(notification)), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "date"
    }, (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).humanTime(notification.createdAt))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "options dropdown",
        onClick: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            e?.target?.closest(".dropdown")?.classList.toggle("active");
        }
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "none-if-follows-empty"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "ellipsis-h"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-options"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>(0, $ba05c0ef8a781e02$export$6008d97729a90c74).removeMatchingNotifications(notification.id)
    }, t("delete")))));
}






function $b86bbf00e8622c6b$export$2e2bcd8739ae039() {
    const params = (0, $405e09292ddca27f$export$99eaa27ddbbb95ef)();
    const [message, setMessage] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/groups/${params.id}/random`).then((m)=>{
            setMessage(m);
        });
    }, []);
    if (message) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$444b3ab0cb9aec40), {
        to: `/messages/${message.id}`,
        replace: true
    });
}







function $5df68f20e9e897ff$export$2e2bcd8739ae039() {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    function search(evt) {
        evt.preventDefault();
        (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getEntity().then((entity)=>{
            let group_id = null;
            switch(entity.entityType){
                case "group":
                    group_id = entity.id;
                    break;
                case "message":
                    group_id = entity.group.id;
                    break;
                default:
            }
            // https://stackoverflow.com/a/37511463
            let searchTerms = document.getElementById("search").value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(" ");
            navigate(`/groups/${group_id}/search?q=${searchTerms.join("+")}`);
            window.dispatchEvent(new CustomEvent("groupSearch"));
        });
    }
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", {
        class: "navbar-block search-block",
        onSubmit: (e)=>search(e)
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "input-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        class: "form-control",
        type: "text",
        id: "search",
        placeholder: t("search_in_group"),
        value: (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("q").replace(/\+/g, " ")
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "input-group-append"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        class: "btn btn-secondary",
        type: "submit"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "search"
    })))));
}








function $6aca12e4c56a7a76$export$2e2bcd8739ae039() {
    let params = (0, $405e09292ddca27f$export$99eaa27ddbbb95ef)();
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$42cfbb80f7861e77), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        class: "mb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $017da47328f74ae1$export$d7a960146e1a269e), {
        focus: true,
        group: params.id
    })))));
}








// trick from https://stackoverflow.com/a/53837442
function $21521b54b609d5fa$var$useForceUpdate() {
    const setValue = (0, $35130c2d97e6777b$export$60241385465d0a34)(0)[1]; // integer state
    return ()=>setValue((value)=>value + 1); // update state to force render
}
function $21521b54b609d5fa$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    const [files, setFiles] = (0, $35130c2d97e6777b$export$60241385465d0a34)(props?.files || []);
    const [sending, setSending] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const [uploading, setUploading] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const forceUpdate = $21521b54b609d5fa$var$useForceUpdate();
    const writerId = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).genId();
    // This allows to have the latest state of files in callbacks
    // https://stackoverflow.com/a/60643670
    const currentFiles = (0, $35130c2d97e6777b$export$b8f5890fc79d6aca)();
    currentFiles.current = files;
    const setForm = (writerForm, files = [], title = "", text = "")=>{
        setFiles(files);
        Array.from(writerForm.current.getElementsByClassName("title-input")).map((e)=>e.value = title);
        Array.from(writerForm.current.getElementsByClassName("text-input")).map((e)=>e.value = text);
    };
    const updateFile = (id, file)=>{
        setFiles(currentFiles.current.map((f)=>f.id === id ? Object.assign(f, file) : f));
    };
    const invertFiles = (id_a, id_b)=>{
        const index_a = files.findIndex((e)=>e.id === id_a);
        const index_b = files.findIndex((e)=>e.id === id_b);
        [files[index_a], files[index_b]] = [
            files[index_b],
            files[index_a]
        ];
        setFiles(files);
        forceUpdate();
    };
    const removeFile = (id)=>{
        setFiles(files.filter((f)=>f.id != id));
    };
    const uploadFile = (fileId)=>{
        const formData = new FormData();
        let file = files.find((e)=>e.id == fileId);
        if (!file || !file.inputFile) {
            // TODO handle this properly
            console.error(files, file, fileId);
            throw "error";
        }
        formData.append("file", file.inputFile);
        updateFile(fileId, Object.assign(file, {
            status: "uploading"
        }));
        setUploading(true);
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).sendFile(formData, (file)=>{
            setUploading(false);
            updateFile(fileId, Object.assign({
                status: "ready"
            }, file));
        }, (e)=>{
            updateFile(fileId, {
                status: "uploading",
                progress: Math.floor(e.loaded / e.total * 100)
            });
        }, (e)=>{
            setUploading(false);
            console.warn(e);
            (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("error_upload"), "alert-danger");
            removeFile(fileId);
        });
    };
    const putMessage = (msg, writerForm)=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).put(`/api/messages/${props.messageId}`, msg).then((res)=>{
            setForm(writerForm, [], "", "");
            setSending(false);
            if (!res) {
                (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("error_new_message"), "alert-danger");
                return;
            }
            window.dispatchEvent(new CustomEvent("editMessage", {
                detail: res
            }));
        });
        setSending(true);
    };
    const postMessage = (msg, writerForm)=>{
        msg = Object.assign(msg, {
            createdAt: Math.floor(Date.now() / 1000),
            author: (0, $ba05c0ef8a781e02$export$3e32638432616b6).id,
            group: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getId(props.group),
            children: [],
            lastActivityDate: Math.floor(Date.now() / 1000)
        });
        if (props.parent) msg.parent = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getId(props.parent);
        // don't post if there is nothing to post
        if (!msg.files.length && !msg.data.text && !msg.data.title) {
            (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("empty_message"), "alert-danger");
            return;
        }
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post("/api/messages", msg).then((res)=>{
            if (!res) {
                setSending(false);
                (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("error_new_message"), "alert-danger");
                return;
            }
            if (props.isChild) {
                setSending(false);
                window.dispatchEvent(new CustomEvent("newChild", {
                    detail: res
                }));
            } else navigate(`/messages/${res.id}`);
            setForm(writerForm, [], "", "");
        });
        setSending(true);
    };
    const sendMessage = (writerForm, data)=>{
        let msg = {
            files: files.filter((e)=>!e?.removed).filter((e)=>[
                    "ready",
                    "raw"
                ].includes(e?.status)).map((e)=>e?.id).filter((e)=>!!e),
            data: {
                title: data?.title,
                text: data?.text
            }
        };
        if (props.messageId) putMessage(msg, writerForm);
        else postMessage(msg, writerForm);
    };
    // toggle state (removed or not) of a file
    const toggleFile = (id)=>{
        setFiles(files.map((f)=>{
            if (f.id == id) f.removed = !f.removed;
            return f;
        }));
    };
    const addFiles = (mimetype, input_files)=>{
        let list = Array.from(input_files).map((e)=>({
                inputFile: e,
                type: mimetype,
                id: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).genId(),
                progress: 0,
                status: "initial"
            }));
        setFiles([
            ...files,
            ...list
        ]);
    };
    const inputFile = (mimetype, multiple = false)=>{
        const input = document.createElement("input");
        document.body.appendChild(input);
        input.style.display = "none";
        input.type = "file";
        input.accept = mimetype;
        if (multiple) input.multiple = "multiple";
        input.addEventListener("change", (event)=>{
            addFiles(mimetype, event.target.files);
        });
        input.click();
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        if (files.filter((e)=>e.status === "uploading").length < 2) {
            for(let i = 0; i < files.length; i++)if (files[i].status == "initial" && !!files[i].inputFile) {
                uploadFile(files[i].id);
                break;
            }
        }
    }, [
        files
    ]);
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $017da47328f74ae1$export$29beae8571dce55f), {
        id: writerId,
        sending: sending,
        uploading: uploading,
        inputFile: inputFile,
        sendMessage: sendMessage,
        cancel: props.cancel,
        files: files,
        toggleFile: toggleFile,
        invertFiles: invertFiles,
        addFiles: addFiles,
        group: props.group,
        isChild: props.isChild,
        text: props.text,
        title: props.title
    });
}









class $0d6022fefd5ea3cb$export$2e2bcd8739ae039 extends (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8) {
    render() {
        const embedUrl = `${this.props.url}/size=large/bgcol=f5f5f5/linkcol=0687f5/minimal=true/tracklist=false/`;
        if (this.state.revealed) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "bandcamp-embed embed-responsive embed-responsive-1by1"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("iframe", {
            class: "embed-responsive-item",
            src: embedUrl
        }));
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "embed-preview",
            onClick: ()=>this.setState({
                    revealed: true
                })
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "bandcamp"
        }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            src: this.props.preview
        }));
    }
}



class $339cc4f4e8c01c65$export$2e2bcd8739ae039 extends (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8) {
    render() {
        if (this.state.revealed) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "embed-responsive embed-responsive-16by9"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("iframe", {
            allowfullscreen: true,
            class: "embed-responsive-item",
            src: this.props.url
        }));
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "embed-preview",
            onClick: ()=>this.setState({
                    revealed: true
                })
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            className: this.props.playBtnClass
        }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            src: this.props.preview
        }));
    }
}


var $91f4924d9b614d55$exports = {};
!function(e, t) {
    $91f4924d9b614d55$exports = t();
}($91f4924d9b614d55$exports, function() {
    "use strict";
    function e(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
                var n = i.call(e, t || "default");
                if ("object" != typeof n) return n;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }
    function t(e) {
        return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    function i(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function n(t, i) {
        for(var n = 0; n < i.length; n++){
            var s = i[n];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, e(s.key), s);
        }
    }
    function s(e, t, i) {
        return t && n(e.prototype, t), i && n(e, i), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    var l = Date.now();
    function o() {
        var e = {}, t = !0, i = 0, n = arguments.length;
        "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (t = arguments[0], i++);
        for(var s = function(i) {
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t && "[object Object]" === Object.prototype.toString.call(i[n]) ? e[n] = o(!0, e[n], i[n]) : e[n] = i[n]);
        }; i < n; i++){
            var l = arguments[i];
            s(l);
        }
        return e;
    }
    function r(e, t) {
        if ((E(e) || e === window || e === document) && (e = [
            e
        ]), L(e) || I(e) || (e = [
            e
        ]), 0 != M(e)) {
            if (L(e) && !I(e)) for(var i = e.length, n = 0; n < i && !1 !== t.call(e[n], e[n], n, e); n++);
            else if (I(e)) {
                for(var s in e)if (P(e, s) && !1 === t.call(e[s], e[s], s, e)) break;
            }
        }
    }
    function a(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = e[l] = e[l] || [], s = {
            all: n,
            evt: null,
            found: null
        };
        return t && i && M(n) > 0 && r(n, function(e, n) {
            if (e.eventName == t && e.fn.toString() == i.toString()) return s.found = !0, s.evt = n, !1;
        }), s;
    }
    function h(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = t.onElement, n = t.withCallback, s = t.avoidDuplicate, l = void 0 === s || s, o = t.once, h = void 0 !== o && o, d = t.useCapture, c = void 0 !== d && d, u = arguments.length > 2 ? arguments[2] : void 0, g = i || [];
        function v(e) {
            C(n) && n.call(u, e, this), h && v.destroy();
        }
        return k(g) && (g = document.querySelectorAll(g)), v.destroy = function() {
            r(g, function(t) {
                var i = a(t, e, v);
                i.found && i.all.splice(i.evt, 1), t.removeEventListener && t.removeEventListener(e, v, c);
            });
        }, r(g, function(t) {
            var i = a(t, e, v);
            (t.addEventListener && l && !i.found || !l) && (t.addEventListener(e, v, c), i.all.push({
                eventName: e,
                fn: v
            }));
        }), v;
    }
    function d(e, t) {
        r(t.split(" "), function(t) {
            return e.classList.add(t);
        });
    }
    function c(e, t) {
        r(t.split(" "), function(t) {
            return e.classList.remove(t);
        });
    }
    function u(e, t) {
        return e.classList.contains(t);
    }
    function g(e, t) {
        for(; e !== document.body;){
            if (!(e = e.parentElement)) return !1;
            if ("function" == typeof e.matches ? e.matches(t) : e.msMatchesSelector(t)) return e;
        }
    }
    function v(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!e || "" === t) return !1;
        if ("none" === t) return C(i) && i(), !1;
        var n = b(), s = t.split(" ");
        r(s, function(t) {
            d(e, "g" + t);
        }), h(n, {
            onElement: e,
            avoidDuplicate: !1,
            once: !0,
            withCallback: function(e, t) {
                r(s, function(e) {
                    c(t, "g" + e);
                }), C(i) && i();
            }
        });
    }
    function f(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if ("" === t) return e.style.webkitTransform = "", e.style.MozTransform = "", e.style.msTransform = "", e.style.OTransform = "", e.style.transform = "", !1;
        e.style.webkitTransform = t, e.style.MozTransform = t, e.style.msTransform = t, e.style.OTransform = t, e.style.transform = t;
    }
    function p(e) {
        e.style.display = "block";
    }
    function m(e) {
        e.style.display = "none";
    }
    function y(e) {
        var t = document.createDocumentFragment(), i = document.createElement("div");
        for(i.innerHTML = e; i.firstChild;)t.appendChild(i.firstChild);
        return t;
    }
    function x() {
        return {
            width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        };
    }
    function b() {
        var e, t = document.createElement("fakeelement"), i = {
            animation: "animationend",
            OAnimation: "oAnimationEnd",
            MozAnimation: "animationend",
            WebkitAnimation: "webkitAnimationEnd"
        };
        for(e in i)if (void 0 !== t.style[e]) return i[e];
    }
    function S(e, t, i, n) {
        if (e()) t();
        else {
            var s;
            i || (i = 100);
            var l = setInterval(function() {
                e() && (clearInterval(l), s && clearTimeout(s), t());
            }, i);
            n && (s = setTimeout(function() {
                clearInterval(l);
            }, n));
        }
    }
    function w(e, t, i) {
        if (O(e)) console.error("Inject assets error");
        else if (C(t) && (i = t, t = !1), k(t) && t in window) C(i) && i();
        else {
            var n;
            if (-1 !== e.indexOf(".css")) {
                if ((n = document.querySelectorAll('link[href="' + e + '"]')) && n.length > 0) return void (C(i) && i());
                var s = document.getElementsByTagName("head")[0], l = s.querySelectorAll('link[rel="stylesheet"]'), o = document.createElement("link");
                return o.rel = "stylesheet", o.type = "text/css", o.href = e, o.media = "all", l ? s.insertBefore(o, l[0]) : s.appendChild(o), void (C(i) && i());
            }
            if ((n = document.querySelectorAll('script[src="' + e + '"]')) && n.length > 0) {
                if (C(i)) {
                    if (k(t)) return S(function() {
                        return void 0 !== window[t];
                    }, function() {
                        i();
                    }), !1;
                    i();
                }
            } else {
                var r = document.createElement("script");
                r.type = "text/javascript", r.src = e, r.onload = function() {
                    if (C(i)) {
                        if (k(t)) return S(function() {
                            return void 0 !== window[t];
                        }, function() {
                            i();
                        }), !1;
                        i();
                    }
                }, document.body.appendChild(r);
            }
        }
    }
    function T() {
        return "navigator" in window && window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i);
    }
    function C(e) {
        return "function" == typeof e;
    }
    function k(e) {
        return "string" == typeof e;
    }
    function E(e) {
        return !(!e || !e.nodeType || 1 != e.nodeType);
    }
    function A(e) {
        return Array.isArray(e);
    }
    function L(e) {
        return e && e.length && isFinite(e.length);
    }
    function I(e) {
        return "object" === t(e) && null != e && !C(e) && !A(e);
    }
    function O(e) {
        return null == e;
    }
    function P(e, t) {
        return null !== e && hasOwnProperty.call(e, t);
    }
    function M(e) {
        if (I(e)) {
            if (e.keys) return e.keys().length;
            var t = 0;
            for(var i in e)P(e, i) && t++;
            return t;
        }
        return e.length;
    }
    function z(e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
    }
    function X() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1, t = document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");
        if (!t.length) return !1;
        if (1 == t.length) return t[0];
        "string" == typeof e && (e = parseInt(e));
        var i = [];
        r(t, function(e) {
            i.push(e.getAttribute("data-taborder"));
        });
        var n = Math.max.apply(Math, i.map(function(e) {
            return parseInt(e);
        })), s = e < 0 ? 1 : e + 1;
        s > n && (s = "1");
        var l = i.filter(function(e) {
            return e >= parseInt(s);
        }), o = l.sort()[0];
        return document.querySelector('.gbtn[data-taborder="'.concat(o, '"]'));
    }
    function Y(e) {
        if (e.events.hasOwnProperty("keyboard")) return !1;
        e.events.keyboard = h("keydown", {
            onElement: window,
            withCallback: function(t, i) {
                var n = (t = t || window.event).keyCode;
                if (9 == n) {
                    var s = document.querySelector(".gbtn.focused");
                    if (!s) {
                        var l = !(!document.activeElement || !document.activeElement.nodeName) && document.activeElement.nodeName.toLocaleLowerCase();
                        if ("input" == l || "textarea" == l || "button" == l) return;
                    }
                    t.preventDefault();
                    var o = document.querySelectorAll(".gbtn[data-taborder]");
                    if (!o || o.length <= 0) return;
                    if (!s) {
                        var r = X();
                        return void (r && (r.focus(), d(r, "focused")));
                    }
                    var a = X(s.getAttribute("data-taborder"));
                    c(s, "focused"), a && (a.focus(), d(a, "focused"));
                }
                39 == n && e.nextSlide(), 37 == n && e.prevSlide(), 27 == n && e.close();
            }
        });
    }
    var q = s(function e(t, n) {
        var s = this, l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        if (i(this, e), this.img = t, this.slide = n, this.onclose = l, this.img.setZoomEvents) return !1;
        this.active = !1, this.zoomedIn = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.img.addEventListener("mousedown", function(e) {
            return s.dragStart(e);
        }, !1), this.img.addEventListener("mouseup", function(e) {
            return s.dragEnd(e);
        }, !1), this.img.addEventListener("mousemove", function(e) {
            return s.drag(e);
        }, !1), this.img.addEventListener("click", function(e) {
            return s.slide.classList.contains("dragging-nav") ? (s.zoomOut(), !1) : s.zoomedIn ? void (s.zoomedIn && !s.dragging && s.zoomOut()) : s.zoomIn();
        }, !1), this.img.setZoomEvents = !0;
    }, [
        {
            key: "zoomIn",
            value: function() {
                var e = this.widowWidth();
                if (!(this.zoomedIn || e <= 768)) {
                    var t = this.img;
                    if (t.setAttribute("data-style", t.getAttribute("style")), t.style.maxWidth = t.naturalWidth + "px", t.style.maxHeight = t.naturalHeight + "px", t.naturalWidth > e) {
                        var i = e / 2 - t.naturalWidth / 2;
                        this.setTranslate(this.img.parentNode, i, 0);
                    }
                    this.slide.classList.add("zoomed"), this.zoomedIn = !0;
                }
            }
        },
        {
            key: "zoomOut",
            value: function() {
                this.img.parentNode.setAttribute("style", ""), this.img.setAttribute("style", this.img.getAttribute("data-style")), this.slide.classList.remove("zoomed"), this.zoomedIn = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.onclose && "function" == typeof this.onclose && this.onclose();
            }
        },
        {
            key: "dragStart",
            value: function(e) {
                e.preventDefault(), this.zoomedIn ? ("touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset), e.target === this.img && (this.active = !0, this.img.classList.add("dragging"))) : this.active = !1;
            }
        },
        {
            key: "dragEnd",
            value: function(e) {
                var t = this;
                e.preventDefault(), this.initialX = this.currentX, this.initialY = this.currentY, this.active = !1, setTimeout(function() {
                    t.dragging = !1, t.img.isDragging = !1, t.img.classList.remove("dragging");
                }, 100);
            }
        },
        {
            key: "drag",
            value: function(e) {
                this.active && (e.preventDefault(), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.img.isDragging = !0, this.dragging = !0, this.setTranslate(this.img, this.currentX, this.currentY));
            }
        },
        {
            key: "onMove",
            value: function(e) {
                if (this.zoomedIn) {
                    var t = e.clientX - this.img.naturalWidth / 2, i = e.clientY - this.img.naturalHeight / 2;
                    this.setTranslate(this.img, t, i);
                }
            }
        },
        {
            key: "setTranslate",
            value: function(e, t, i) {
                e.style.transform = "translate3d(" + t + "px, " + i + "px, 0)";
            }
        },
        {
            key: "widowWidth",
            value: function() {
                return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            }
        }
    ]), N = s(function e() {
        var t = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        i(this, e);
        var s = n.dragEl, l = n.toleranceX, o = void 0 === l ? 40 : l, r = n.toleranceY, a = void 0 === r ? 65 : r, h = n.slide, d = void 0 === h ? null : h, c = n.instance, u = void 0 === c ? null : c;
        this.el = s, this.active = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.direction = null, this.lastDirection = null, this.toleranceX = o, this.toleranceY = a, this.toleranceReached = !1, this.dragContainer = this.el, this.slide = d, this.instance = u, this.el.addEventListener("mousedown", function(e) {
            return t.dragStart(e);
        }, !1), this.el.addEventListener("mouseup", function(e) {
            return t.dragEnd(e);
        }, !1), this.el.addEventListener("mousemove", function(e) {
            return t.drag(e);
        }, !1);
    }, [
        {
            key: "dragStart",
            value: function(e) {
                if (this.slide.classList.contains("zoomed")) this.active = !1;
                else {
                    "touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset);
                    var t = e.target.nodeName.toLowerCase();
                    e.target.classList.contains("nodrag") || g(e.target, ".nodrag") || -1 !== [
                        "input",
                        "select",
                        "textarea",
                        "button",
                        "a"
                    ].indexOf(t) ? this.active = !1 : (e.preventDefault(), (e.target === this.el || "img" !== t && g(e.target, ".gslide-inline")) && (this.active = !0, this.el.classList.add("dragging"), this.dragContainer = g(e.target, ".ginner-container")));
                }
            }
        },
        {
            key: "dragEnd",
            value: function(e) {
                var t = this;
                e && e.preventDefault(), this.initialX = 0, this.initialY = 0, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.active = !1, this.doSlideChange && (this.instance.preventOutsideClick = !0, "right" == this.doSlideChange && this.instance.prevSlide(), "left" == this.doSlideChange && this.instance.nextSlide()), this.doSlideClose && this.instance.close(), this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, !0), setTimeout(function() {
                    t.instance.preventOutsideClick = !1, t.toleranceReached = !1, t.lastDirection = null, t.dragging = !1, t.el.isDragging = !1, t.el.classList.remove("dragging"), t.slide.classList.remove("dragging-nav"), t.dragContainer.style.transform = "", t.dragContainer.style.transition = "";
                }, 100);
            }
        },
        {
            key: "drag",
            value: function(e) {
                if (this.active) {
                    e.preventDefault(), this.slide.classList.add("dragging-nav"), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.el.isDragging = !0, this.dragging = !0, this.doSlideChange = !1, this.doSlideClose = !1;
                    var t = Math.abs(this.currentX), i = Math.abs(this.currentY);
                    if (t > 0 && t >= Math.abs(this.currentY) && (!this.lastDirection || "x" == this.lastDirection)) {
                        this.yOffset = 0, this.lastDirection = "x", this.setTranslate(this.dragContainer, this.currentX, 0);
                        var n = this.shouldChange();
                        if (!this.instance.settings.dragAutoSnap && n && (this.doSlideChange = n), this.instance.settings.dragAutoSnap && n) return this.instance.preventOutsideClick = !0, this.toleranceReached = !0, this.active = !1, this.instance.preventOutsideClick = !0, this.dragEnd(null), "right" == n && this.instance.prevSlide(), void ("left" == n && this.instance.nextSlide());
                    }
                    if (this.toleranceY > 0 && i > 0 && i >= t && (!this.lastDirection || "y" == this.lastDirection)) {
                        this.xOffset = 0, this.lastDirection = "y", this.setTranslate(this.dragContainer, 0, this.currentY);
                        var s = this.shouldClose();
                        return !this.instance.settings.dragAutoSnap && s && (this.doSlideClose = !0), void (this.instance.settings.dragAutoSnap && s && this.instance.close());
                    }
                }
            }
        },
        {
            key: "shouldChange",
            value: function() {
                var e = !1;
                if (Math.abs(this.currentX) >= this.toleranceX) {
                    var t = this.currentX > 0 ? "right" : "left";
                    ("left" == t && this.slide !== this.slide.parentNode.lastChild || "right" == t && this.slide !== this.slide.parentNode.firstChild) && (e = t);
                }
                return e;
            }
        },
        {
            key: "shouldClose",
            value: function() {
                var e = !1;
                return Math.abs(this.currentY) >= this.toleranceY && (e = !0), e;
            }
        },
        {
            key: "setTranslate",
            value: function(e, t, i) {
                var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                e.style.transition = n ? "all .2s ease" : "", e.style.transform = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
            }
        }
    ]);
    function D(e, t, i, n) {
        var s = e.querySelector(".gslide-media"), l = new Image, o = "gSlideTitle_" + i, r = "gSlideDesc_" + i;
        l.addEventListener("load", function() {
            C(n) && n();
        }, !1), l.src = t.href, "" != t.sizes && "" != t.srcset && (l.sizes = t.sizes, l.srcset = t.srcset), l.alt = "", O(t.alt) || "" === t.alt || (l.alt = t.alt), "" !== t.title && l.setAttribute("aria-labelledby", o), "" !== t.description && l.setAttribute("aria-describedby", r), t.hasOwnProperty("_hasCustomWidth") && t._hasCustomWidth && (l.style.width = t.width), t.hasOwnProperty("_hasCustomHeight") && t._hasCustomHeight && (l.style.height = t.height), s.insertBefore(l, s.firstChild);
    }
    function _(e, t, i, n) {
        var s = this, l = e.querySelector(".ginner-container"), o = "gvideo" + i, r = e.querySelector(".gslide-media"), a = this.getAllPlayers();
        d(l, "gvideo-container"), r.insertBefore(y('<div class="gvideo-wrapper"></div>'), r.firstChild);
        var h = e.querySelector(".gvideo-wrapper");
        w(this.settings.plyr.css, "Plyr");
        var c = t.href, u = null == t ? void 0 : t.videoProvider, g = !1;
        r.style.maxWidth = t.width, w(this.settings.plyr.js, "Plyr", function() {
            if (!u && c.match(/vimeo\.com\/([0-9]*)/) && (u = "vimeo"), !u && (c.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || c.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || c.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || c.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/)) && (u = "youtube"), "local" === u || !u) {
                u = "local";
                var l = '<video id="' + o + '" ';
                l += 'style="background:#000; max-width: '.concat(t.width, ';" '), l += 'preload="metadata" ', l += 'x-webkit-airplay="allow" ', l += "playsinline ", l += "controls ", l += 'class="gvideo-local">', l += '<source src="'.concat(c, '">'), g = y(l += "</video>");
            }
            var r = g || y('<div id="'.concat(o, '" data-plyr-provider="').concat(u, '" data-plyr-embed-id="').concat(c, '"></div>'));
            d(h, "".concat(u, "-video gvideo")), h.appendChild(r), h.setAttribute("data-id", o), h.setAttribute("data-index", i);
            var v = P(s.settings.plyr, "config") ? s.settings.plyr.config : {}, f = new Plyr("#" + o, v);
            f.on("ready", function(e) {
                a[o] = e.detail.plyr, C(n) && n();
            }), S(function() {
                return e.querySelector("iframe") && "true" == e.querySelector("iframe").dataset.ready;
            }, function() {
                s.resize(e);
            }), f.on("enterfullscreen", W), f.on("exitfullscreen", W);
        });
    }
    function W(e) {
        var t = g(e.target, ".gslide-media");
        "enterfullscreen" === e.type && d(t, "fullscreen"), "exitfullscreen" === e.type && c(t, "fullscreen");
    }
    function B(e, t, i, n) {
        var s, l = this, o = e.querySelector(".gslide-media"), r = !(!P(t, "href") || !t.href) && t.href.split("#").pop().trim(), a = !(!P(t, "content") || !t.content) && t.content;
        if (a && (k(a) && (s = y('<div class="ginlined-content">'.concat(a, "</div>"))), E(a))) {
            "none" == a.style.display && (a.style.display = "block");
            var c = document.createElement("div");
            c.className = "ginlined-content", c.appendChild(a), s = c;
        }
        if (r) {
            var u = document.getElementById(r);
            if (!u) return !1;
            var g = u.cloneNode(!0);
            g.style.height = t.height, g.style.maxWidth = t.width, d(g, "ginlined-content"), s = g;
        }
        if (!s) return console.error("Unable to append inline slide content", t), !1;
        o.style.height = t.height, o.style.width = t.width, o.appendChild(s), this.events["inlineclose" + r] = h("click", {
            onElement: o.querySelectorAll(".gtrigger-close"),
            withCallback: function(e) {
                e.preventDefault(), l.close();
            }
        }), C(n) && n();
    }
    function H(e, t, i, n) {
        var s = e.querySelector(".gslide-media"), l = function(e) {
            var t = e.url, i = e.allow, n = e.callback, s = e.appendTo, l = document.createElement("iframe");
            return l.className = "vimeo-video gvideo", l.src = t, l.style.width = "100%", l.style.height = "100%", i && l.setAttribute("allow", i), l.onload = function() {
                l.onload = null, d(l, "node-ready"), C(n) && n();
            }, s && s.appendChild(l), l;
        }({
            url: t.href,
            callback: n
        });
        s.parentNode.style.maxWidth = t.width, s.parentNode.style.height = t.height, s.appendChild(l);
    }
    var j = s(function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        i(this, e), this.defaults = {
            href: "",
            sizes: "",
            srcset: "",
            title: "",
            type: "",
            videoProvider: "",
            description: "",
            alt: "",
            descPosition: "bottom",
            effect: "",
            width: "",
            height: "",
            content: !1,
            zoomable: !0,
            draggable: !0
        }, I(t) && (this.defaults = o(this.defaults, t));
    }, [
        {
            key: "sourceType",
            value: function(e) {
                var t = e;
                return null !== (e = e.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/) ? "image" : e.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/) || e.match(/vimeo\.com\/([0-9]*)/) || null !== e.match(/\.(mp4|ogg|webm|mov)/) ? "video" : null !== e.match(/\.(mp3|wav|wma|aac|ogg)/) ? "audio" : e.indexOf("#") > -1 && "" !== t.split("#").pop().trim() ? "inline" : e.indexOf("goajax=true") > -1 ? "ajax" : "external";
            }
        },
        {
            key: "parseConfig",
            value: function(e, t) {
                var i = this, n = o({
                    descPosition: t.descPosition
                }, this.defaults);
                if (I(e) && !E(e)) {
                    P(e, "type") || (P(e, "content") && e.content ? e.type = "inline" : P(e, "href") && (e.type = this.sourceType(e.href)));
                    var s = o(n, e);
                    return this.setSize(s, t), s;
                }
                var l = "", a = e.getAttribute("data-glightbox"), h = e.nodeName.toLowerCase();
                if ("a" === h && (l = e.href), "img" === h && (l = e.src, n.alt = e.alt), n.href = l, r(n, function(s, l) {
                    P(t, l) && "width" !== l && (n[l] = t[l]);
                    var o = e.dataset[l];
                    O(o) || (n[l] = i.sanitizeValue(o));
                }), n.content && (n.type = "inline"), !n.type && l && (n.type = this.sourceType(l)), O(a)) {
                    if (!n.title && "a" == h) {
                        var d = e.title;
                        O(d) || "" === d || (n.title = d);
                    }
                    if (!n.title && "img" == h) {
                        var c = e.alt;
                        O(c) || "" === c || (n.title = c);
                    }
                } else {
                    var u = [];
                    r(n, function(e, t) {
                        u.push(";\\s?" + t);
                    }), u = u.join("\\s?:|"), "" !== a.trim() && r(n, function(e, t) {
                        var s = a, l = new RegExp("s?" + t + "s?:s?(.*?)(" + u + "s?:|$)"), o = s.match(l);
                        if (o && o.length && o[1]) {
                            var r = o[1].trim().replace(/;\s*$/, "");
                            n[t] = i.sanitizeValue(r);
                        }
                    });
                }
                if (n.description && "." === n.description.substring(0, 1)) {
                    var g;
                    try {
                        g = document.querySelector(n.description).innerHTML;
                    } catch (e) {
                        if (!(e instanceof DOMException)) throw e;
                    }
                    g && (n.description = g);
                }
                if (!n.description) {
                    var v = e.querySelector(".glightbox-desc");
                    v && (n.description = v.innerHTML);
                }
                return this.setSize(n, t, e), this.slideConfig = n, n;
            }
        },
        {
            key: "setSize",
            value: function(e, t) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = "video" == e.type ? this.checkSize(t.videosWidth) : this.checkSize(t.width), s = this.checkSize(t.height);
                return e.width = P(e, "width") && "" !== e.width ? this.checkSize(e.width) : n, e.height = P(e, "height") && "" !== e.height ? this.checkSize(e.height) : s, i && "image" == e.type && (e._hasCustomWidth = !!i.dataset.width, e._hasCustomHeight = !!i.dataset.height), e;
            }
        },
        {
            key: "checkSize",
            value: function(e) {
                return z(e) ? "".concat(e, "px") : e;
            }
        },
        {
            key: "sanitizeValue",
            value: function(e) {
                return "true" !== e && "false" !== e ? e : "true" === e;
            }
        }
    ]), V = s(function e(t, n, s) {
        i(this, e), this.element = t, this.instance = n, this.index = s;
    }, [
        {
            key: "setContent",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (u(t, "loaded")) return !1;
                var n = this.instance.settings, s = this.slideConfig, l = T();
                C(n.beforeSlideLoad) && n.beforeSlideLoad({
                    index: this.index,
                    slide: t,
                    player: !1
                });
                var o = s.type, r = s.descPosition, a = t.querySelector(".gslide-media"), h = t.querySelector(".gslide-title"), c = t.querySelector(".gslide-desc"), g = t.querySelector(".gdesc-inner"), v = i, f = "gSlideTitle_" + this.index, p = "gSlideDesc_" + this.index;
                if (C(n.afterSlideLoad) && (v = function() {
                    C(i) && i(), n.afterSlideLoad({
                        index: e.index,
                        slide: t,
                        player: e.instance.getSlidePlayerInstance(e.index)
                    });
                }), "" == s.title && "" == s.description ? g && g.parentNode.parentNode.removeChild(g.parentNode) : (h && "" !== s.title ? (h.id = f, h.innerHTML = s.title) : h.parentNode.removeChild(h), c && "" !== s.description ? (c.id = p, l && n.moreLength > 0 ? (s.smallDescription = this.slideShortDesc(s.description, n.moreLength, n.moreText), c.innerHTML = s.smallDescription, this.descriptionEvents(c, s)) : c.innerHTML = s.description) : c.parentNode.removeChild(c), d(a.parentNode, "desc-".concat(r)), d(g.parentNode, "description-".concat(r))), d(a, "gslide-".concat(o)), d(t, "loaded"), "video" !== o) {
                    if ("external" !== o) return "inline" === o ? (B.apply(this.instance, [
                        t,
                        s,
                        this.index,
                        v
                    ]), void (s.draggable && new N({
                        dragEl: t.querySelector(".gslide-inline"),
                        toleranceX: n.dragToleranceX,
                        toleranceY: n.dragToleranceY,
                        slide: t,
                        instance: this.instance
                    }))) : void ("image" !== o ? C(v) && v() : D(t, s, this.index, function() {
                        var i = t.querySelector("img");
                        s.draggable && new N({
                            dragEl: i,
                            toleranceX: n.dragToleranceX,
                            toleranceY: n.dragToleranceY,
                            slide: t,
                            instance: e.instance
                        }), s.zoomable && i.naturalWidth > i.offsetWidth && (d(i, "zoomable"), new q(i, t, function() {
                            e.instance.resize();
                        })), C(v) && v();
                    }));
                    H.apply(this, [
                        t,
                        s,
                        this.index,
                        v
                    ]);
                } else _.apply(this.instance, [
                    t,
                    s,
                    this.index,
                    v
                ]);
            }
        },
        {
            key: "slideShortDesc",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50, i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = document.createElement("div");
                n.innerHTML = e;
                var s = n.innerText, l = i;
                if ((e = s.trim()).length <= t) return e;
                var o = e.substr(0, t - 1);
                return l ? (n = null, o + '... <a href="#" class="desc-more">' + i + "</a>") : o;
            }
        },
        {
            key: "descriptionEvents",
            value: function(e, t) {
                var i = this, n = e.querySelector(".desc-more");
                if (!n) return !1;
                h("click", {
                    onElement: n,
                    withCallback: function(e, n) {
                        e.preventDefault();
                        var s = document.body, l = g(n, ".gslide-desc");
                        if (!l) return !1;
                        l.innerHTML = t.description, d(s, "gdesc-open");
                        var o = h("click", {
                            onElement: [
                                s,
                                g(l, ".gslide-description")
                            ],
                            withCallback: function(e, n) {
                                "a" !== e.target.nodeName.toLowerCase() && (c(s, "gdesc-open"), d(s, "gdesc-closed"), l.innerHTML = t.smallDescription, i.descriptionEvents(l, t), setTimeout(function() {
                                    c(s, "gdesc-closed");
                                }, 400), o.destroy());
                            }
                        });
                    }
                });
            }
        },
        {
            key: "create",
            value: function() {
                return y(this.instance.settings.slideHTML);
            }
        },
        {
            key: "getConfig",
            value: function() {
                E(this.element) || this.element.hasOwnProperty("draggable") || (this.element.draggable = this.instance.settings.draggable);
                var e = new j(this.instance.settings.slideExtraAttributes);
                return this.slideConfig = e.parseConfig(this.element, this.instance.settings), this.slideConfig;
            }
        }
    ]);
    function F(e) {
        return Math.sqrt(e.x * e.x + e.y * e.y);
    }
    function R(e, t) {
        var i = function(e, t) {
            var i = F(e) * F(t);
            if (0 === i) return 0;
            var n = function(e, t) {
                return e.x * t.x + e.y * t.y;
            }(e, t) / i;
            return n > 1 && (n = 1), Math.acos(n);
        }(e, t);
        return function(e, t) {
            return e.x * t.y - t.x * e.y;
        }(e, t) > 0 && (i *= -1), 180 * i / Math.PI;
    }
    var G = s(function e(t) {
        i(this, e), this.handlers = [], this.el = t;
    }, [
        {
            key: "add",
            value: function(e) {
                this.handlers.push(e);
            }
        },
        {
            key: "del",
            value: function(e) {
                e || (this.handlers = []);
                for(var t = this.handlers.length; t >= 0; t--)this.handlers[t] === e && this.handlers.splice(t, 1);
            }
        },
        {
            key: "dispatch",
            value: function() {
                for(var e = 0, t = this.handlers.length; e < t; e++){
                    var i = this.handlers[e];
                    "function" == typeof i && i.apply(this.el, arguments);
                }
            }
        }
    ]);
    function Z(e, t) {
        var i = new G(e);
        return i.add(t), i;
    }
    var U = s(function e(t, n) {
        i(this, e), this.element = "string" == typeof t ? document.querySelector(t) : t, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, !1), this.element.addEventListener("touchmove", this.move, !1), this.element.addEventListener("touchend", this.end, !1), this.element.addEventListener("touchcancel", this.cancel, !1), this.preV = {
            x: null,
            y: null
        }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = !1;
        var s = function() {};
        this.rotate = Z(this.element, n.rotate || s), this.touchStart = Z(this.element, n.touchStart || s), this.multipointStart = Z(this.element, n.multipointStart || s), this.multipointEnd = Z(this.element, n.multipointEnd || s), this.pinch = Z(this.element, n.pinch || s), this.swipe = Z(this.element, n.swipe || s), this.tap = Z(this.element, n.tap || s), this.doubleTap = Z(this.element, n.doubleTap || s), this.longTap = Z(this.element, n.longTap || s), this.singleTap = Z(this.element, n.singleTap || s), this.pressMove = Z(this.element, n.pressMove || s), this.twoFingerPressMove = Z(this.element, n.twoFingerPressMove || s), this.touchMove = Z(this.element, n.touchMove || s), this.touchEnd = Z(this.element, n.touchEnd || s), this.touchCancel = Z(this.element, n.touchCancel || s), this.translateContainer = this.element, this._cancelAllHandler = this.cancelAll.bind(this), window.addEventListener("scroll", this._cancelAllHandler), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = {
            x: null,
            y: null
        };
    }, [
        {
            key: "start",
            value: function(e) {
                if (e.touches) {
                    if (e.target && e.target.nodeName && [
                        "a",
                        "button",
                        "input"
                    ].indexOf(e.target.nodeName.toLowerCase()) >= 0) console.log("ignore drag for this touched element", e.target.nodeName.toLowerCase());
                    else {
                        this.now = Date.now(), this.x1 = e.touches[0].pageX, this.y1 = e.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(e, this.element), null !== this.preTapPosition.x && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30, this.isDoubleTap && clearTimeout(this.singleTapTimeout)), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;
                        var t = this.preV;
                        if (e.touches.length > 1) {
                            this._cancelLongTap(), this._cancelSingleTap();
                            var i = {
                                x: e.touches[1].pageX - this.x1,
                                y: e.touches[1].pageY - this.y1
                            };
                            t.x = i.x, t.y = i.y, this.pinchStartLen = F(t), this.multipointStart.dispatch(e, this.element);
                        }
                        this._preventTap = !1, this.longTapTimeout = setTimeout((function() {
                            this.longTap.dispatch(e, this.element), this._preventTap = !0;
                        }).bind(this), 750);
                    }
                }
            }
        },
        {
            key: "move",
            value: function(e) {
                if (e.touches) {
                    var t = this.preV, i = e.touches.length, n = e.touches[0].pageX, s = e.touches[0].pageY;
                    if (this.isDoubleTap = !1, i > 1) {
                        var l = e.touches[1].pageX, o = e.touches[1].pageY, r = {
                            x: e.touches[1].pageX - n,
                            y: e.touches[1].pageY - s
                        };
                        null !== t.x && (this.pinchStartLen > 0 && (e.zoom = F(r) / this.pinchStartLen, this.pinch.dispatch(e, this.element)), e.angle = R(r, t), this.rotate.dispatch(e, this.element)), t.x = r.x, t.y = r.y, null !== this.x2 && null !== this.sx2 ? (e.deltaX = (n - this.x2 + l - this.sx2) / 2, e.deltaY = (s - this.y2 + o - this.sy2) / 2) : (e.deltaX = 0, e.deltaY = 0), this.twoFingerPressMove.dispatch(e, this.element), this.sx2 = l, this.sy2 = o;
                    } else {
                        if (null !== this.x2) {
                            e.deltaX = n - this.x2, e.deltaY = s - this.y2;
                            var a = Math.abs(this.x1 - this.x2), h = Math.abs(this.y1 - this.y2);
                            (a > 10 || h > 10) && (this._preventTap = !0);
                        } else e.deltaX = 0, e.deltaY = 0;
                        this.pressMove.dispatch(e, this.element);
                    }
                    this.touchMove.dispatch(e, this.element), this._cancelLongTap(), this.x2 = n, this.y2 = s, i > 1 && e.preventDefault();
                }
            }
        },
        {
            key: "end",
            value: function(e) {
                if (e.changedTouches) {
                    this._cancelLongTap();
                    var t = this;
                    e.touches.length < 2 && (this.multipointEnd.dispatch(e, this.element), this.sx2 = this.sy2 = null), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (e.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout(function() {
                        t.swipe.dispatch(e, t.element);
                    }, 0)) : (this.tapTimeout = setTimeout(function() {
                        t._preventTap || t.tap.dispatch(e, t.element), t.isDoubleTap && (t.doubleTap.dispatch(e, t.element), t.isDoubleTap = !1);
                    }, 0), t.isDoubleTap || (t.singleTapTimeout = setTimeout(function() {
                        t.singleTap.dispatch(e, t.element);
                    }, 250))), this.touchEnd.dispatch(e, this.element), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null;
                }
            }
        },
        {
            key: "cancelAll",
            value: function() {
                this._preventTap = !0, clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout);
            }
        },
        {
            key: "cancel",
            value: function(e) {
                this.cancelAll(), this.touchCancel.dispatch(e, this.element);
            }
        },
        {
            key: "_cancelLongTap",
            value: function() {
                clearTimeout(this.longTapTimeout);
            }
        },
        {
            key: "_cancelSingleTap",
            value: function() {
                clearTimeout(this.singleTapTimeout);
            }
        },
        {
            key: "_swipeDirection",
            value: function(e, t, i, n) {
                return Math.abs(e - t) >= Math.abs(i - n) ? e - t > 0 ? "Left" : "Right" : i - n > 0 ? "Up" : "Down";
            }
        },
        {
            key: "on",
            value: function(e, t) {
                this[e] && this[e].add(t);
            }
        },
        {
            key: "off",
            value: function(e, t) {
                this[e] && this[e].del(t);
            }
        },
        {
            key: "destroy",
            value: function() {
                return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.twoFingerPressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null, window.removeEventListener("scroll", this._cancelAllHandler), null;
            }
        }
    ]);
    function $(e) {
        var t = function() {
            var e, t = document.createElement("fakeelement"), i = {
                transition: "transitionend",
                OTransition: "oTransitionEnd",
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd"
            };
            for(e in i)if (void 0 !== t.style[e]) return i[e];
        }(), i = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, n = u(e, "gslide-media") ? e : e.querySelector(".gslide-media"), s = g(n, ".ginner-container"), l = e.querySelector(".gslide-description");
        i > 769 && (n = s), d(n, "greset"), f(n, "translate3d(0, 0, 0)"), h(t, {
            onElement: n,
            once: !0,
            withCallback: function(e, t) {
                c(n, "greset");
            }
        }), n.style.opacity = "", l && (l.style.opacity = "");
    }
    function J(e) {
        if (e.events.hasOwnProperty("touch")) return !1;
        var t, i, n, s = x(), l = s.width, o = s.height, r = !1, a = null, h = null, v = null, p = !1, m = 1, y = 1, b = !1, S = !1, w = null, T = null, C = null, k = null, E = 0, A = 0, L = !1, I = !1, O = {}, P = {}, M = 0, z = 0, X = document.getElementById("glightbox-slider"), Y = document.querySelector(".goverlay"), q = new U(X, {
            touchStart: function(t) {
                if (r = !0, (u(t.targetTouches[0].target, "ginner-container") || g(t.targetTouches[0].target, ".gslide-desc") || "a" == t.targetTouches[0].target.nodeName.toLowerCase()) && (r = !1), g(t.targetTouches[0].target, ".gslide-inline") && !u(t.targetTouches[0].target.parentNode, "gslide-inline") && (r = !1), r) {
                    if (P = t.targetTouches[0], O.pageX = t.targetTouches[0].pageX, O.pageY = t.targetTouches[0].pageY, M = t.targetTouches[0].clientX, z = t.targetTouches[0].clientY, a = e.activeSlide, h = a.querySelector(".gslide-media"), n = a.querySelector(".gslide-inline"), v = null, u(h, "gslide-image") && (v = h.querySelector("img")), (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 769 && (h = a.querySelector(".ginner-container")), c(Y, "greset"), t.pageX > 20 && t.pageX < window.innerWidth - 20) return;
                    t.preventDefault();
                }
            },
            touchMove: function(s) {
                if (r && (P = s.targetTouches[0], !b && !S)) {
                    if (n && n.offsetHeight > o) {
                        var a = O.pageX - P.pageX;
                        if (Math.abs(a) <= 13) return !1;
                    }
                    p = !0;
                    var d, c = s.targetTouches[0].clientX, u = s.targetTouches[0].clientY, g = M - c, m = z - u;
                    if (Math.abs(g) > Math.abs(m) ? (L = !1, I = !0) : (I = !1, L = !0), t = P.pageX - O.pageX, E = 100 * t / l, i = P.pageY - O.pageY, A = 100 * i / o, L && v && (d = 1 - Math.abs(i) / o, Y.style.opacity = d, e.settings.touchFollowAxis && (E = 0)), I && (d = 1 - Math.abs(t) / l, h.style.opacity = d, e.settings.touchFollowAxis && (A = 0)), !v) return f(h, "translate3d(".concat(E, "%, 0, 0)"));
                    f(h, "translate3d(".concat(E, "%, ").concat(A, "%, 0)"));
                }
            },
            touchEnd: function() {
                if (r) {
                    if (p = !1, S || b) return C = w, void (k = T);
                    var t = Math.abs(parseInt(A)), i = Math.abs(parseInt(E));
                    if (!(t > 29 && v)) return t < 29 && i < 25 ? (d(Y, "greset"), Y.style.opacity = 1, $(h)) : void 0;
                    e.close();
                }
            },
            multipointEnd: function() {
                setTimeout(function() {
                    b = !1;
                }, 50);
            },
            multipointStart: function() {
                b = !0, m = y || 1;
            },
            pinch: function(e) {
                if (!v || p) return !1;
                b = !0, v.scaleX = v.scaleY = m * e.zoom;
                var t = m * e.zoom;
                if (S = !0, t <= 1) return S = !1, t = 1, k = null, C = null, w = null, T = null, void v.setAttribute("style", "");
                t > 4.5 && (t = 4.5), v.style.transform = "scale3d(".concat(t, ", ").concat(t, ", 1)"), y = t;
            },
            pressMove: function(e) {
                if (S && !b) {
                    var t = P.pageX - O.pageX, i = P.pageY - O.pageY;
                    C && (t += C), k && (i += k), w = t, T = i;
                    var n = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
                    y && (n += " scale3d(".concat(y, ", ").concat(y, ", 1)")), f(v, n);
                }
            },
            swipe: function(t) {
                if (!S) {
                    if (b) b = !1;
                    else {
                        if ("Left" == t.direction) {
                            if (e.index == e.elements.length - 1) return $(h);
                            e.nextSlide();
                        }
                        if ("Right" == t.direction) {
                            if (0 == e.index) return $(h);
                            e.prevSlide();
                        }
                    }
                }
            }
        });
        e.events.touch = q;
    }
    var K = T(), Q = null !== T() || void 0 !== document.createTouch || "ontouchstart" in window || "onmsgesturechange" in window || navigator.msMaxTouchPoints, ee = document.getElementsByTagName("html")[0], te = {
        selector: ".glightbox",
        elements: null,
        skin: "clean",
        theme: "clean",
        closeButton: !0,
        startAt: null,
        autoplayVideos: !0,
        autofocusVideos: !0,
        descPosition: "bottom",
        width: "900px",
        height: "506px",
        videosWidth: "960px",
        beforeSlideChange: null,
        afterSlideChange: null,
        beforeSlideLoad: null,
        afterSlideLoad: null,
        slideInserted: null,
        slideRemoved: null,
        slideExtraAttributes: null,
        onOpen: null,
        onClose: null,
        loop: !1,
        zoomable: !0,
        draggable: !0,
        dragAutoSnap: !1,
        dragToleranceX: 40,
        dragToleranceY: 65,
        preload: !0,
        oneSlidePerOpen: !1,
        touchNavigation: !0,
        touchFollowAxis: !0,
        keyboardNavigation: !0,
        closeOnOutsideClick: !0,
        plugins: !1,
        plyr: {
            css: "https://cdn.plyr.io/3.6.12/plyr.css",
            js: "https://cdn.plyr.io/3.6.12/plyr.js",
            config: {
                ratio: "16:9",
                fullscreen: {
                    enabled: !0,
                    iosNative: !0
                },
                youtube: {
                    noCookie: !0,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3
                },
                vimeo: {
                    byline: !1,
                    portrait: !1,
                    title: !1,
                    transparent: !1
                }
            }
        },
        openEffect: "zoom",
        closeEffect: "zoom",
        slideEffect: "slide",
        moreText: "See more",
        moreLength: 60,
        cssEfects: {
            fade: {
                in: "fadeIn",
                out: "fadeOut"
            },
            zoom: {
                in: "zoomIn",
                out: "zoomOut"
            },
            slide: {
                in: "slideInRight",
                out: "slideOutLeft"
            },
            slideBack: {
                in: "slideInLeft",
                out: "slideOutRight"
            },
            none: {
                in: "none",
                out: "none"
            }
        },
        svg: {
            close: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',
            next: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',
            prev: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>'
        },
        slideHTML: '<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>',
        lightboxHTML: '<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>\n    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>\n    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>\n</div>\n</div>'
    }, ie = s(function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        i(this, e), this.customOptions = t, this.settings = o(te, t), this.effectsClasses = this.getAnimationClasses(), this.videoPlayers = {}, this.apiEvents = [], this.fullElementsList = !1;
    }, [
        {
            key: "init",
            value: function() {
                var e = this, t = this.getSelector();
                t && (this.baseEvents = h("click", {
                    onElement: t,
                    withCallback: function(t, i) {
                        t.preventDefault(), e.open(i);
                    }
                })), this.elements = this.getElements();
            }
        },
        {
            key: "open",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                if (0 === this.elements.length) return !1;
                this.activeSlide = null, this.prevActiveSlideIndex = null, this.prevActiveSlide = null;
                var i = z(t) ? t : this.settings.startAt;
                if (E(e)) {
                    var n = e.getAttribute("data-gallery");
                    n && (this.fullElementsList = this.elements, this.elements = this.getGalleryElements(this.elements, n)), O(i) && (i = this.getElementIndex(e)) < 0 && (i = 0);
                }
                z(i) || (i = 0), this.build(), v(this.overlay, "none" === this.settings.openEffect ? "none" : this.settings.cssEfects.fade.in);
                var s = document.body, l = window.innerWidth - document.documentElement.clientWidth;
                if (l > 0) {
                    var o = document.createElement("style");
                    o.type = "text/css", o.className = "gcss-styles", o.innerText = ".gscrollbar-fixer {margin-right: ".concat(l, "px}"), document.head.appendChild(o), d(s, "gscrollbar-fixer");
                }
                d(s, "glightbox-open"), d(ee, "glightbox-open"), K && (d(document.body, "glightbox-mobile"), this.settings.slideEffect = "slide"), this.showSlide(i, !0), 1 === this.elements.length ? (d(this.prevButton, "glightbox-button-hidden"), d(this.nextButton, "glightbox-button-hidden")) : (c(this.prevButton, "glightbox-button-hidden"), c(this.nextButton, "glightbox-button-hidden")), this.lightboxOpen = !0, this.trigger("open"), C(this.settings.onOpen) && this.settings.onOpen(), Q && this.settings.touchNavigation && J(this), this.settings.keyboardNavigation && Y(this);
            }
        },
        {
            key: "openAt",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                this.open(null, e);
            }
        },
        {
            key: "showSlide",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                p(this.loader), this.index = parseInt(t);
                var n = this.slidesContainer.querySelector(".current");
                n && c(n, "current"), this.slideAnimateOut();
                var s = this.slidesContainer.querySelectorAll(".gslide")[t];
                if (u(s, "loaded")) this.slideAnimateIn(s, i), m(this.loader);
                else {
                    p(this.loader);
                    var l = this.elements[t], o = {
                        index: this.index,
                        slide: s,
                        slideNode: s,
                        slideConfig: l.slideConfig,
                        slideIndex: this.index,
                        trigger: l.node,
                        player: null
                    };
                    this.trigger("slide_before_load", o), l.instance.setContent(s, function() {
                        m(e.loader), e.resize(), e.slideAnimateIn(s, i), e.trigger("slide_after_load", o);
                    });
                }
                this.slideDescription = s.querySelector(".gslide-description"), this.slideDescriptionContained = this.slideDescription && u(this.slideDescription.parentNode, "gslide-media"), this.settings.preload && (this.preloadSlide(t + 1), this.preloadSlide(t - 1)), this.updateNavigationClasses(), this.activeSlide = s;
            }
        },
        {
            key: "preloadSlide",
            value: function(e) {
                var t = this;
                if (e < 0 || e > this.elements.length - 1) return !1;
                if (O(this.elements[e])) return !1;
                var i = this.slidesContainer.querySelectorAll(".gslide")[e];
                if (u(i, "loaded")) return !1;
                var n = this.elements[e], s = n.type, l = {
                    index: e,
                    slide: i,
                    slideNode: i,
                    slideConfig: n.slideConfig,
                    slideIndex: e,
                    trigger: n.node,
                    player: null
                };
                this.trigger("slide_before_load", l), "video" === s || "external" === s ? setTimeout(function() {
                    n.instance.setContent(i, function() {
                        t.trigger("slide_after_load", l);
                    });
                }, 200) : n.instance.setContent(i, function() {
                    t.trigger("slide_after_load", l);
                });
            }
        },
        {
            key: "prevSlide",
            value: function() {
                this.goToSlide(this.index - 1);
            }
        },
        {
            key: "nextSlide",
            value: function() {
                this.goToSlide(this.index + 1);
            }
        },
        {
            key: "goToSlide",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (this.prevActiveSlide = this.activeSlide, this.prevActiveSlideIndex = this.index, !this.loop() && (e < 0 || e > this.elements.length - 1)) return !1;
                e < 0 ? e = this.elements.length - 1 : e >= this.elements.length && (e = 0), this.showSlide(e);
            }
        },
        {
            key: "insertSlide",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                t < 0 && (t = this.elements.length);
                var i = new V(e, this, t), n = i.getConfig(), s = o({}, n), l = i.create(), r = this.elements.length - 1;
                s.index = t, s.node = !1, s.instance = i, s.slideConfig = n, this.elements.splice(t, 0, s);
                var a = null, h = null;
                if (this.slidesContainer) {
                    if (t > r) this.slidesContainer.appendChild(l);
                    else {
                        var d = this.slidesContainer.querySelectorAll(".gslide")[t];
                        this.slidesContainer.insertBefore(l, d);
                    }
                    (this.settings.preload && 0 == this.index && 0 == t || this.index - 1 == t || this.index + 1 == t) && this.preloadSlide(t), 0 === this.index && 0 === t && (this.index = 1), this.updateNavigationClasses(), a = this.slidesContainer.querySelectorAll(".gslide")[t], h = this.getSlidePlayerInstance(t), s.slideNode = a;
                }
                this.trigger("slide_inserted", {
                    index: t,
                    slide: a,
                    slideNode: a,
                    slideConfig: n,
                    slideIndex: t,
                    trigger: null,
                    player: h
                }), C(this.settings.slideInserted) && this.settings.slideInserted({
                    index: t,
                    slide: a,
                    player: h
                });
            }
        },
        {
            key: "removeSlide",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1;
                if (e < 0 || e > this.elements.length - 1) return !1;
                var t = this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e];
                t && (this.getActiveSlideIndex() == e && (e == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()), t.parentNode.removeChild(t)), this.elements.splice(e, 1), this.trigger("slide_removed", e), C(this.settings.slideRemoved) && this.settings.slideRemoved(e);
            }
        },
        {
            key: "slideAnimateIn",
            value: function(e, t) {
                var i = this, n = e.querySelector(".gslide-media"), s = e.querySelector(".gslide-description"), l = {
                    index: this.prevActiveSlideIndex,
                    slide: this.prevActiveSlide,
                    slideNode: this.prevActiveSlide,
                    slideIndex: this.prevActiveSlide,
                    slideConfig: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                    trigger: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                    player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                }, o = {
                    index: this.index,
                    slide: this.activeSlide,
                    slideNode: this.activeSlide,
                    slideConfig: this.elements[this.index].slideConfig,
                    slideIndex: this.index,
                    trigger: this.elements[this.index].node,
                    player: this.getSlidePlayerInstance(this.index)
                };
                if (n.offsetWidth > 0 && s && (m(s), s.style.display = ""), c(e, this.effectsClasses), t) v(e, this.settings.cssEfects[this.settings.openEffect].in, function() {
                    i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                        prev: l,
                        current: o
                    }), C(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [
                        l,
                        o
                    ]);
                });
                else {
                    var r = this.settings.slideEffect, a = "none" !== r ? this.settings.cssEfects[r].in : r;
                    this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (a = this.settings.cssEfects.slideBack.in), v(e, a, function() {
                        i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                            prev: l,
                            current: o
                        }), C(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [
                            l,
                            o
                        ]);
                    });
                }
                setTimeout(function() {
                    i.resize(e);
                }, 100), d(e, "current");
            }
        },
        {
            key: "slideAnimateOut",
            value: function() {
                if (!this.prevActiveSlide) return !1;
                var e = this.prevActiveSlide;
                c(e, this.effectsClasses), d(e, "prev");
                var t = this.settings.slideEffect, i = "none" !== t ? this.settings.cssEfects[t].out : t;
                this.slidePlayerPause(e), this.trigger("slide_before_change", {
                    prev: {
                        index: this.prevActiveSlideIndex,
                        slide: this.prevActiveSlide,
                        slideNode: this.prevActiveSlide,
                        slideIndex: this.prevActiveSlideIndex,
                        slideConfig: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                        trigger: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                        player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                    },
                    current: {
                        index: this.index,
                        slide: this.activeSlide,
                        slideNode: this.activeSlide,
                        slideIndex: this.index,
                        slideConfig: this.elements[this.index].slideConfig,
                        trigger: this.elements[this.index].node,
                        player: this.getSlidePlayerInstance(this.index)
                    }
                }), C(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [
                    {
                        index: this.prevActiveSlideIndex,
                        slide: this.prevActiveSlide,
                        player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                    },
                    {
                        index: this.index,
                        slide: this.activeSlide,
                        player: this.getSlidePlayerInstance(this.index)
                    }
                ]), this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (i = this.settings.cssEfects.slideBack.out), v(e, i, function() {
                    var t = e.querySelector(".ginner-container"), i = e.querySelector(".gslide-media"), n = e.querySelector(".gslide-description");
                    t.style.transform = "", i.style.transform = "", c(i, "greset"), i.style.opacity = "", n && (n.style.opacity = ""), c(e, "prev");
                });
            }
        },
        {
            key: "getAllPlayers",
            value: function() {
                return this.videoPlayers;
            }
        },
        {
            key: "getSlidePlayerInstance",
            value: function(e) {
                var t = "gvideo" + e, i = this.getAllPlayers();
                return !(!P(i, t) || !i[t]) && i[t];
            }
        },
        {
            key: "stopSlideVideo",
            value: function(e) {
                if (E(e)) {
                    var t = e.querySelector(".gvideo-wrapper");
                    t && (e = t.getAttribute("data-index"));
                }
                console.log("stopSlideVideo is deprecated, use slidePlayerPause");
                var i = this.getSlidePlayerInstance(e);
                i && i.playing && i.pause();
            }
        },
        {
            key: "slidePlayerPause",
            value: function(e) {
                if (E(e)) {
                    var t = e.querySelector(".gvideo-wrapper");
                    t && (e = t.getAttribute("data-index"));
                }
                var i = this.getSlidePlayerInstance(e);
                i && i.playing && i.pause();
            }
        },
        {
            key: "playSlideVideo",
            value: function(e) {
                if (E(e)) {
                    var t = e.querySelector(".gvideo-wrapper");
                    t && (e = t.getAttribute("data-index"));
                }
                console.log("playSlideVideo is deprecated, use slidePlayerPlay");
                var i = this.getSlidePlayerInstance(e);
                i && !i.playing && i.play();
            }
        },
        {
            key: "slidePlayerPlay",
            value: function(e) {
                var t;
                if (!K || null !== (t = this.settings.plyr.config) && void 0 !== t && t.muted) {
                    if (E(e)) {
                        var i = e.querySelector(".gvideo-wrapper");
                        i && (e = i.getAttribute("data-index"));
                    }
                    var n = this.getSlidePlayerInstance(e);
                    n && !n.playing && (n.play(), this.settings.autofocusVideos && n.elements.container.focus());
                }
            }
        },
        {
            key: "setElements",
            value: function(e) {
                var t = this;
                this.settings.elements = !1;
                var i = [];
                e && e.length && r(e, function(e, n) {
                    var s = new V(e, t, n), l = s.getConfig(), r = o({}, l);
                    r.slideConfig = l, r.instance = s, r.index = n, i.push(r);
                }), this.elements = i, this.lightboxOpen && (this.slidesContainer.innerHTML = "", this.elements.length && (r(this.elements, function() {
                    var e = y(t.settings.slideHTML);
                    t.slidesContainer.appendChild(e);
                }), this.showSlide(0, !0)));
            }
        },
        {
            key: "getElementIndex",
            value: function(e) {
                var t = !1;
                return r(this.elements, function(i, n) {
                    if (P(i, "node") && i.node == e) return t = n, !0;
                }), t;
            }
        },
        {
            key: "getElements",
            value: function() {
                var e = this, t = [];
                this.elements = this.elements ? this.elements : [], !O(this.settings.elements) && A(this.settings.elements) && this.settings.elements.length && r(this.settings.elements, function(i, n) {
                    var s = new V(i, e, n), l = s.getConfig(), r = o({}, l);
                    r.node = !1, r.index = n, r.instance = s, r.slideConfig = l, t.push(r);
                });
                var i = !1;
                return this.getSelector() && (i = document.querySelectorAll(this.getSelector())), i ? (r(i, function(i, n) {
                    var s = new V(i, e, n), l = s.getConfig(), r = o({}, l);
                    r.node = i, r.index = n, r.instance = s, r.slideConfig = l, r.gallery = i.getAttribute("data-gallery"), t.push(r);
                }), t) : t;
            }
        },
        {
            key: "getGalleryElements",
            value: function(e, t) {
                return e.filter(function(e) {
                    return e.gallery == t;
                });
            }
        },
        {
            key: "getSelector",
            value: function() {
                return !this.settings.elements && (this.settings.selector && "data-" == this.settings.selector.substring(0, 5) ? "*[".concat(this.settings.selector, "]") : this.settings.selector);
            }
        },
        {
            key: "getActiveSlide",
            value: function() {
                return this.slidesContainer.querySelectorAll(".gslide")[this.index];
            }
        },
        {
            key: "getActiveSlideIndex",
            value: function() {
                return this.index;
            }
        },
        {
            key: "getAnimationClasses",
            value: function() {
                var e = [];
                for(var t in this.settings.cssEfects)if (this.settings.cssEfects.hasOwnProperty(t)) {
                    var i = this.settings.cssEfects[t];
                    e.push("g".concat(i.in)), e.push("g".concat(i.out));
                }
                return e.join(" ");
            }
        },
        {
            key: "build",
            value: function() {
                var e = this;
                if (this.built) return !1;
                var t = document.body.childNodes, i = [];
                r(t, function(e) {
                    e.parentNode == document.body && "#" !== e.nodeName.charAt(0) && e.hasAttribute && !e.hasAttribute("aria-hidden") && (i.push(e), e.setAttribute("aria-hidden", "true"));
                });
                var n = P(this.settings.svg, "next") ? this.settings.svg.next : "", s = P(this.settings.svg, "prev") ? this.settings.svg.prev : "", l = P(this.settings.svg, "close") ? this.settings.svg.close : "", o = this.settings.lightboxHTML;
                o = y(o = (o = (o = o.replace(/{nextSVG}/g, n)).replace(/{prevSVG}/g, s)).replace(/{closeSVG}/g, l)), document.body.appendChild(o);
                var a = document.getElementById("glightbox-body");
                this.modal = a;
                var c = a.querySelector(".gclose");
                this.prevButton = a.querySelector(".gprev"), this.nextButton = a.querySelector(".gnext"), this.overlay = a.querySelector(".goverlay"), this.loader = a.querySelector(".gloader"), this.slidesContainer = document.getElementById("glightbox-slider"), this.bodyHiddenChildElms = i, this.events = {}, d(this.modal, "glightbox-" + this.settings.skin), this.settings.closeButton && c && (this.events.close = h("click", {
                    onElement: c,
                    withCallback: function(t, i) {
                        t.preventDefault(), e.close();
                    }
                })), c && !this.settings.closeButton && c.parentNode.removeChild(c), this.nextButton && (this.events.next = h("click", {
                    onElement: this.nextButton,
                    withCallback: function(t, i) {
                        t.preventDefault(), e.nextSlide();
                    }
                })), this.prevButton && (this.events.prev = h("click", {
                    onElement: this.prevButton,
                    withCallback: function(t, i) {
                        t.preventDefault(), e.prevSlide();
                    }
                })), this.settings.closeOnOutsideClick && (this.events.outClose = h("click", {
                    onElement: a,
                    withCallback: function(t, i) {
                        e.preventOutsideClick || u(document.body, "glightbox-mobile") || g(t.target, ".ginner-container") || g(t.target, ".gbtn") || u(t.target, "gnext") || u(t.target, "gprev") || e.close();
                    }
                })), r(this.elements, function(t, i) {
                    e.slidesContainer.appendChild(t.instance.create()), t.slideNode = e.slidesContainer.querySelectorAll(".gslide")[i];
                }), Q && d(document.body, "glightbox-touch"), this.events.resize = h("resize", {
                    onElement: window,
                    withCallback: function() {
                        e.resize();
                    }
                }), this.built = !0;
            }
        },
        {
            key: "resize",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if ((e = e || this.activeSlide) && !u(e, "zoomed")) {
                    var t = x(), i = e.querySelector(".gvideo-wrapper"), n = e.querySelector(".gslide-image"), s = this.slideDescription, l = t.width, o = t.height;
                    if (l <= 768 ? d(document.body, "glightbox-mobile") : c(document.body, "glightbox-mobile"), i || n) {
                        var r = !1;
                        if (s && (u(s, "description-bottom") || u(s, "description-top")) && !u(s, "gabsolute") && (r = !0), n) {
                            if (l <= 768) n.querySelector("img");
                            else if (r) {
                                var a, h = s.offsetHeight, g = n.querySelector("img"), v = this.elements[this.index].node, f = null !== (a = v.getAttribute("data-height")) && void 0 !== a ? a : "100vh";
                                g.setAttribute("style", "max-height: calc(".concat(f, " - ").concat(h, "px)")), s.setAttribute("style", "max-width: ".concat(g.offsetWidth, "px;"));
                            }
                        }
                        if (i) {
                            var p = P(this.settings.plyr.config, "ratio") ? this.settings.plyr.config.ratio : "";
                            if (!p) {
                                var m = i.clientWidth, y = i.clientHeight, b = m / y;
                                p = "".concat(m / b, ":").concat(y / b);
                            }
                            var S = p.split(":"), w = this.settings.videosWidth, T = this.settings.videosWidth, C = (T = z(w) || -1 !== w.indexOf("px") ? parseInt(w) : -1 !== w.indexOf("vw") ? l * parseInt(w) / 100 : -1 !== w.indexOf("vh") ? o * parseInt(w) / 100 : -1 !== w.indexOf("%") ? l * parseInt(w) / 100 : parseInt(i.clientWidth)) / (parseInt(S[0]) / parseInt(S[1]));
                            if (C = Math.floor(C), r && (o -= s.offsetHeight), T > l || C > o || o < C && l > T) {
                                var k = i.offsetWidth, E = i.offsetHeight, A = o / E, L = {
                                    width: k * A,
                                    height: E * A
                                };
                                i.parentNode.setAttribute("style", "max-width: ".concat(L.width, "px")), r && s.setAttribute("style", "max-width: ".concat(L.width, "px;"));
                            } else i.parentNode.style.maxWidth = "".concat(w), r && s.setAttribute("style", "max-width: ".concat(w, ";"));
                        }
                    }
                }
            }
        },
        {
            key: "reload",
            value: function() {
                this.init();
            }
        },
        {
            key: "updateNavigationClasses",
            value: function() {
                var e = this.loop();
                c(this.nextButton, "disabled"), c(this.prevButton, "disabled"), 0 == this.index && this.elements.length - 1 == 0 ? (d(this.prevButton, "disabled"), d(this.nextButton, "disabled")) : 0 !== this.index || e ? this.index !== this.elements.length - 1 || e || d(this.nextButton, "disabled") : d(this.prevButton, "disabled");
            }
        },
        {
            key: "loop",
            value: function() {
                var e = P(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
                return e = P(this.settings, "loop") ? this.settings.loop : e, e;
            }
        },
        {
            key: "close",
            value: function() {
                var e = this;
                if (!this.lightboxOpen) {
                    if (this.events) {
                        for(var t in this.events)this.events.hasOwnProperty(t) && this.events[t].destroy();
                        this.events = null;
                    }
                    return !1;
                }
                if (this.closing) return !1;
                this.closing = !0, this.slidePlayerPause(this.activeSlide), this.fullElementsList && (this.elements = this.fullElementsList), this.bodyHiddenChildElms.length && r(this.bodyHiddenChildElms, function(e) {
                    e.removeAttribute("aria-hidden");
                }), d(this.modal, "glightbox-closing"), v(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.out), v(this.activeSlide, this.settings.cssEfects[this.settings.closeEffect].out, function() {
                    if (e.activeSlide = null, e.prevActiveSlideIndex = null, e.prevActiveSlide = null, e.built = !1, e.events) {
                        for(var t in e.events)e.events.hasOwnProperty(t) && e.events[t].destroy();
                        e.events = null;
                    }
                    var i = document.body;
                    c(ee, "glightbox-open"), c(i, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"), e.modal.parentNode.removeChild(e.modal), e.trigger("close"), C(e.settings.onClose) && e.settings.onClose();
                    var n = document.querySelector(".gcss-styles");
                    n && n.parentNode.removeChild(n), e.lightboxOpen = !1, e.closing = null;
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.close(), this.clearAllEvents(), this.baseEvents && this.baseEvents.destroy();
            }
        },
        {
            key: "on",
            value: function(e, t) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if (!e || !C(t)) throw new TypeError("Event name and callback must be defined");
                this.apiEvents.push({
                    evt: e,
                    once: i,
                    callback: t
                });
            }
        },
        {
            key: "once",
            value: function(e, t) {
                this.on(e, t, !0);
            }
        },
        {
            key: "trigger",
            value: function(e) {
                var t = this, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = [];
                r(this.apiEvents, function(t, s) {
                    var l = t.evt, o = t.once, r = t.callback;
                    l == e && (r(i), o && n.push(s));
                }), n.length && r(n, function(e) {
                    return t.apiEvents.splice(e, 1);
                });
            }
        },
        {
            key: "clearAllEvents",
            value: function() {
                this.apiEvents.splice(0, this.apiEvents.length);
            }
        },
        {
            key: "version",
            value: function() {
                return "3.3.0";
            }
        }
    ]);
    return function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = new ie(e);
        return t.init(), t;
    };
});


function $ae435fb76acade86$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($91f4924d9b614d55$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
            const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                const r = {
                    href: e.href
                };
                if (e?.dataset?.width) r.width = e?.dataset?.width;
                if (e?.dataset?.height) r.height = e?.dataset?.height;
                if (e?.dataset?.type) r.type = e?.dataset?.type;
                if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                return r;
            });
            lightbox.setElements(elements);
            lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
        }
    };
    const getPreview = ()=>{
        if (props?.data?.exception) console.warn(props.data);
        if (props.data["providerName"]) {
            if ("peertube" == props.data["providerName"].toLowerCase()) {
                // default embed code
                if (props.data["code"]) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                    class: "embed-container",
                    dangerouslySetInnerHTML: {
                        __html: props.data["code"]
                    }
                });
            }
            if ("soundcloud" == props.data["providerName"].toLowerCase()) {
                if (props.data["code"]) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $339cc4f4e8c01c65$export$2e2bcd8739ae039), {
                    preview: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                    url: `${props.data["code"].match(/https:\/\/[^"\s]+/)[0]}&auto_play=true`,
                    playBtnClass: "soundcloud"
                });
            }
            if ("bandcamp" == props.data["providerName"].toLowerCase()) {
                if (props.data["code"]) {
                    let id = props.data["code"].match(/https:\/\/.*album=\d+/);
                    if (!id) id = props.data["code"].match(/https:\/\/.*track=\d+/);
                    if (id) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $0d6022fefd5ea3cb$export$2e2bcd8739ae039), {
                        preview: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: id[0]
                    });
                }
            }
            if ("lichess.org" == props.data["providerName"].toLowerCase()) {
                let url = props?.data?.url && typeof props?.data.url == "string" ? props.data?.url : props.url;
                if ((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).isValidUrl(url) && !url.match(/embed/) && !url.match(/study/) && !url.match(/blog/)) {
                    url = new URL(url.replace("lichess.org/", "lichess.org/embed/"));
                    let id;
                    try {
                        id = url.pathname.split("/").slice(-1)[0];
                    } catch (e) {
                        id = "";
                    }
                    url = new URL(url.href.replace(id, id.slice(0, 8)));
                    if (id) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $339cc4f4e8c01c65$export$2e2bcd8739ae039), {
                        preview: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.preview.id, 270, 270),
                        url: url,
                        playBtnClass: "lichess"
                    });
                }
            }
            if ("youtube" == props.data["providerName"].toLowerCase()) {
                let url = props.url;
                if (props?.preview?.id && url) {
                    url = new URL(url);
                    let video_id;
                    let playlist_id;
                    if (url.host == "www.youtube.com" || url.host == "m.youtube.com" || url.host == "youtube.com" || url.host == "music.youtube.com") {
                        if (url.pathname.match(/shorts/)) {
                            video_id = [
                                `v=${url.pathname.split("/").slice(-1)[0]}`
                            ];
                            playlist_id = [];
                        } else if (url.pathname.match(/embed/)) {
                            video_id = [
                                `v=${url.pathname.split("/").slice(-1)[0]}`
                            ];
                            playlist_id = [];
                        } else {
                            video_id = url.search.substring(1).split("&").filter((e)=>e.match(/^v=/));
                            playlist_id = url.search.substring(1).split("&").filter((e)=>e.match(/^list=/));
                        }
                    }
                    if (url.host == "youtu.be") {
                        video_id = [
                            `v=${url.pathname.slice(1)}`
                        ];
                        playlist_id = [];
                    }
                    let timecode = (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("t", url.search.substring(1));
                    if (playlist_id.length && video_id.length) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $339cc4f4e8c01c65$export$2e2bcd8739ae039), {
                        preview: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/${video_id[0].split("=")[1]}?autoplay=1&controls=2&wmode=opaque&list=${playlist_id[0].split("=")[1]}${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                    if (playlist_id.length) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $339cc4f4e8c01c65$export$2e2bcd8739ae039), {
                        preview: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/videoseries?list=${playlist_id[0].split("=")[1]}&autoplay=1&controls=2&wmode=opaque${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                    if (video_id.length) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $339cc4f4e8c01c65$export$2e2bcd8739ae039), {
                        preview: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/${video_id[0].split("=")[1]}?autoplay=1&controls=2&wmode=opaque${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                }
            }
        }
        if (props.data["content-type"] == "image/gif") return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            href: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(props.url),
            class: "img-fluid",
            "data-origin": props.url,
            "data-src": props.url,
            src: props.url
        }));
        if (/image/.test(props.data["content-type"])) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
            href: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(props.url),
            class: "glightbox",
            "data-type": "image",
            "data-srcset": `${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 720)} 720w, ${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 1366)} 1366w, ${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 2048)} 2048w`,
            "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
            onClick: (e)=>openLightbox(e)
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            href: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(props.url),
            class: "img-fluid cursor-pointer",
            "data-origin": props.url,
            "data-src": (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 1366),
            src: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 2048)
        })));
        // application/ogg: https://developer.mozilla.org/en-US/docs/Web/HTTP/Configuring_servers_for_Ogg_media
        if (/video/.test(props.data["content-type"]) || props.data["content-type"] == "application/ogg") return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("video", {
            class: "img-fluid",
            controls: true,
            src: props.url
        }));
        if (/audio/.test(props.data["content-type"])) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("audio", {
            class: "w-100",
            controls: true
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("source", {
            src: props.url
        })));
        if (props.data["title"] && (props.preview || props.data["description"])) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
            class: "preview-card seamless-link d-inline-block",
            target: "_blank",
            rel: "noreferrer",
            href: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(props.url)
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "card",
            style: "max-width: 480px"
        }, props.preview && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            class: "card-img-top",
            src: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.preview.id, 320, 180)
        }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "card-body p-1"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("h5", null, props.data["title"]), props.data["description"] && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("p", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("small", null, props.data["description"].slice(0, 500))))));
        return null;
    };
    if (!props.url || !props.data) return null;
    let preview = getPreview();
    if (preview) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("p", {
        class: "text-center card-text"
    }, preview);
    return null;
}




function $ed1226fc20dc713f$export$2e2bcd8739ae039(props) {
    const toggleFile = (evt)=>{
        evt.stopPropagation();
        evt.preventDefault();
        if (typeof props.toggleFile == "function") props.toggleFile(evt.target.closest(".file-embed").id);
    };
    if (!props.files || props.files.length === 0) return null;
    if (props.files && props.files.length > 3) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "file-grid"
    }, props.files.map((e)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $b3b214e33ef17c7d$export$40e4fb50d87564f1), {
            key: e.id,
            invertFiles: props.invertFiles,
            toggleFile: toggleFile,
            file: e,
            inWriter: props.inWriter
        })));
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "d-flex justify-content-center flex-wrap"
    }, props.files.map((e)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $b3b214e33ef17c7d$export$48621228a997a4e0), {
            key: e.id,
            toggleFile: toggleFile,
            invertFiles: props.invertFiles,
            file: e,
            inWriter: props.inWriter
        })));
}








function $567a6a3c17f0a386$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const filePath = props.file.contentUrl ? `/files/${props.file.contentUrl}` : null;
    let url = filePath;
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($91f4924d9b614d55$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        if (!props.inWriter) {
            evt.preventDefault();
            evt.stopPropagation();
            if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
                const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                    const r = {
                        href: e.href
                    };
                    if (e?.dataset?.width) r.width = e?.dataset?.width;
                    if (e?.dataset?.height) r.height = e?.dataset?.height;
                    if (e?.dataset?.type) r.type = e?.dataset?.type;
                    if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                    if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                    return r;
                });
                lightbox.setElements(elements);
                lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
            }
        }
    };
    if (props.file.contentUrl) {
        if (/video/.test(props.file.type)) {
            if (props.file.status == "ready") return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("video", {
                draggable: "false",
                poster: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1280, 720),
                class: "file-embed img-fluid contained-height video",
                controls: "true",
                src: url,
                id: props.file.id
            });
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                class: "file-embed file-loading image video-uploaded",
                id: props.file.id
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
                class: "img-fluid video-raw",
                src: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.file.id, 320, 180)
            }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "video-not-ready"
            }, t("video_not_ready")));
        }
        if (/pdf/.test(props.file.type)) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
            "data-origin": (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath),
            draggable: "false",
            href: !props.inWriter ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(url) : undefined,
            className: `glightbox file-embed pdf-outline image${props.file.removed ? " removed" : ""}`,
            id: props.file.id,
            "data-width": "calc(90vw - 10px)",
            "data-height": "100vh",
            onClick: (e)=>openLightbox(e)
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            class: "img-fluid",
            src: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 420, 994)
        }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "remove-button",
            style: props.file.removed ? "color:red" : "",
            onClick: (e)=>props.toggleFile(e)
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
            family: "solid",
            icon: "times"
        })));
        if (/image/.test(props.file.type)) {
            if (props.file.type == "image/gif") return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                "data-origin": (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath),
                draggable: "false",
                href: !props.inWriter ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                className: `glightbox file-embed image${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                "data-type": "image",
                onClick: (e)=>openLightbox(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
                class: "img-fluid",
                src: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath)
            }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                "data-origin": (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath),
                draggable: "false",
                "data-type": "image",
                "data-srcset": `${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)} 720w, ${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1366)} 1366w, ${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 2048)} 2048w`,
                "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
                href: !props.inWriter ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                className: `glightbox file-embed image${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                onClick: (e)=>openLightbox(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
                class: "img-fluid",
                src: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)
            }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
        }
    }
    if (props.file.status == "loading") return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "file-embed file-placeholder",
        id: props.file.id
    });
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "file-embed file-placeholder",
        id: props.file.id
    }, props.file["error"] ? (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "orange-error"
    }, "\xd7") : (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "spinner orange-spinner"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null)), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "progress-bar"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        style: {
            width: `${props.file.progress}%`
        }
    })));
}






var $26a1e2577cffdf19$exports = {};
/*! mobile-drag-drop 3.0.0-rc.0 | Copyright (c) 2022 Tim Ruffles | MIT License */ !function(t, i) {
    i($26a1e2577cffdf19$exports);
}($26a1e2577cffdf19$exports, function(t) {
    "use strict";
    var c = "dnd-poly-", s = [
        "none",
        "copy",
        "copyLink",
        "copyMove",
        "link",
        "linkMove",
        "move",
        "all"
    ], f = [
        "none",
        "copy",
        "move",
        "link"
    ];
    function i() {
        var t = !1;
        try {
            var i = Object.defineProperty({}, "passive", {
                get: function() {
                    t = !0;
                }
            });
            window.addEventListener("test", null, i);
        } catch (t) {}
        return t;
    }
    var e = i();
    function l(t) {
        return t && t.tagName;
    }
    function h(t, i, s) {
        void 0 === s && (s = !0), document.addEventListener(t, i, !!e && {
            passive: s
        });
    }
    function n(t, i) {
        document.removeEventListener(t, i);
    }
    function u(t, i, s, n) {
        void 0 === n && (n = !1);
        var h = e ? {
            passive: !0,
            capture: n
        } : n;
        return t.addEventListener(i, s, h), {
            off: function() {
                t.removeEventListener(i, s, h);
            }
        };
    }
    function o(t) {
        return 0 === t.length ? 0 : t.reduce(function(t, i) {
            return i + t;
        }, 0) / t.length;
    }
    function r(t, i) {
        for(var s = 0; s < t.changedTouches.length; s++)if (t.changedTouches[s].identifier === i) return !0;
        return !1;
    }
    function a(t, i, s) {
        for(var n = [], h = [], e = 0; e < i.touches.length; e++){
            var r = i.touches[e];
            n.push(r[t + "X"]), h.push(r[t + "Y"]);
        }
        s.x = o(n), s.y = o(h);
    }
    var d = [
        "",
        "-webkit-"
    ];
    function v(t, i, s, n, h) {
        var e = i.x, i = i.y;
        n && (e += n.x, i += n.y), (h = void 0 === h || h) && (e -= parseInt(t.offsetWidth, 10) / 2, i -= parseInt(t.offsetHeight, 10) / 2);
        for(var r = "translate3d(" + e + "px," + i + "px, 0)", o = 0; o < d.length; o++){
            var u = d[o] + "transform";
            t.style[u] = r + " " + s[o];
        }
    }
    var p = (Object.defineProperty(g.prototype, "dropEffect", {
        get: function() {
            return this.t;
        },
        set: function(t) {
            0 !== this.i.mode && -1 < s.indexOf(t) && (this.t = t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(g.prototype, "types", {
        get: function() {
            if (0 !== this.i.mode) return Object.freeze(this.i.types);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(g.prototype, "effectAllowed", {
        get: function() {
            return this.i.effectAllowed;
        },
        set: function(t) {
            2 === this.i.mode && -1 < s.indexOf(t) && (this.i.effectAllowed = t);
        },
        enumerable: !1,
        configurable: !0
    }), g.prototype.setData = function(t, i) {
        if (2 === this.i.mode) {
            if (-1 < t.indexOf(" ")) throw new Error("illegal arg: type contains space");
            this.i.data[t] = i, -1 === this.i.types.indexOf(t) && this.i.types.push(t);
        }
    }, g.prototype.getData = function(t) {
        if (1 === this.i.mode || 2 === this.i.mode) return this.i.data[t] || "";
    }, g.prototype.clearData = function(t) {
        2 === this.i.mode && (t && this.i.data[t] ? (delete this.i.data[t], -1 < (t = this.i.types.indexOf(t)) && this.i.types.splice(t, 1)) : (this.i.data = {}, this.i.types = []));
    }, g.prototype.setDragImage = function(t, i, s) {
        2 === this.i.mode && this.h(t, i, s);
    }, g);
    function g(t, i) {
        this.i = t, this.h = i, this.t = f[0];
    }
    function m(t, i) {
        return t ? t === s[0] ? f[0] : 0 === t.indexOf(s[1]) || t === s[7] ? f[1] : 0 === t.indexOf(s[4]) ? f[3] : t === s[6] ? f[2] : f[1] : 3 === i.nodeType && "A" === i.tagName ? f[3] : f[1];
    }
    function y(u, t, a, i, s, n, c) {
        void 0 === c && (c = null);
        s = function(t, i, s, n, h, e, r) {
            void 0 === c && (r = null);
            var o = a.changedTouches[0], n = new Event(u, {
                bubbles: !0,
                cancelable: n
            });
            n.dataTransfer = e, n.relatedTarget = r, n.screenX = o.screenX, n.screenY = o.screenY, n.clientX = o.clientX, n.clientY = o.clientY, n.pageX = o.pageX, n.pageY = o.pageY;
            t = t.getBoundingClientRect();
            return n.offsetX = n.clientX - t.left, n.offsetY = n.clientY - t.top, n;
        }(t, 0, 0, n = void 0 === n || n, document.defaultView, s, c), s = !t.dispatchEvent(s);
        return i.mode = 0, s;
    }
    function b(t, i) {
        if (!t || t === s[7]) return i;
        if (i === f[1]) {
            if (0 === t.indexOf(f[1])) return f[1];
        } else if (i === f[3]) {
            if (0 === t.indexOf(f[3]) || -1 < t.indexOf("Link")) return f[3];
        } else if (i === f[2] && (0 === t.indexOf(f[2]) || -1 < t.indexOf("Move"))) return f[2];
        return f[0];
    }
    var w = (x.prototype.o = function() {
        var n = this;
        this.u = 1, this.l = f[0], this.v = {
            data: {},
            effectAllowed: void 0,
            mode: 3,
            types: []
        }, this.p = {
            x: null,
            y: null
        }, this.g = {
            x: null,
            y: null
        };
        var h = this.m;
        if (this.I = new p(this.v, function(t, i, s) {
            h = t, "number" != typeof i && "number" != typeof s || (n.j = {
                x: i || 0,
                y: s || 0
            });
        }), this.v.mode = 2, this.I.dropEffect = f[0], y("dragstart", this.m, this.k, this.v, this.I)) return this.u = 3, this.C(), !1;
        a("page", this.k, this.g);
        var i, t, s = this.S.dragImageSetup(h);
        return this.A = (i = s, d.map(function(t) {
            t = i.style[t + "transform"];
            return t && "none" !== t ? t.replace(/translate\(\D*\d+[^,]*,\D*\d+[^,]*\)\s*/g, "") : "";
        })), s.style.position = "absolute", s.style.left = "0px", s.style.top = "0px", s.style.zIndex = "999999", s.classList.add("dnd-poly-drag-image"), s.classList.add("dnd-poly-icon"), this.O = s, this.j || (this.S.dragImageOffset ? this.j = {
            x: this.S.dragImageOffset.x,
            y: this.S.dragImageOffset.y
        } : this.S.dragImageCenterOnTouch ? (t = getComputedStyle(h), this.j = {
            x: 0 - parseInt(t.marginLeft, 10),
            y: 0 - parseInt(t.marginTop, 10)
        }) : (s = h.getBoundingClientRect(), t = getComputedStyle(h), this.j = {
            x: s.left - this.M.clientX - parseInt(t.marginLeft, 10) + s.width / 2,
            y: s.top - this.M.clientY - parseInt(t.marginTop, 10) + s.height / 2
        })), v(this.O, this.g, this.A, this.j, this.S.dragImageCenterOnTouch), document.body.appendChild(this.O), this.D = window.setInterval(function() {
            n.F || (n.F = !0, n.N(), n.F = !1);
        }, this.S.iterationInterval), !0;
    }, x.prototype.C = function() {
        this.D && (clearInterval(this.D), this.D = null), n("touchmove", this.P), n("touchend", this.T), n("touchcancel", this.T), this.O && (this.O.parentNode.removeChild(this.O), this.O = null), this.L(this.S, this.k, this.u);
    }, x.prototype._ = function(t) {
        var s = this;
        if (!1 !== r(t, this.M.identifier)) {
            if (this.k = t, 0 === this.u) {
                var i = void 0;
                if (this.S.dragStartConditionOverride) try {
                    i = this.S.dragStartConditionOverride(t);
                } catch (t) {
                    i = !1;
                }
                else i = 1 === t.touches.length;
                return i ? void (!0 === this.o() && (this.H.preventDefault(), t.preventDefault())) : void this.C();
            }
            if (t.preventDefault(), a("client", t, this.p), a("page", t, this.g), this.S.dragImageTranslateOverride) try {
                var n = !1;
                if (this.S.dragImageTranslateOverride(t, {
                    x: this.p.x,
                    y: this.p.y
                }, this.V, function(t, i) {
                    s.O && (n = !0, s.p.x += t, s.p.y += i, s.g.x += t, s.g.y += i, v(s.O, s.g, s.A, s.j, s.S.dragImageCenterOnTouch));
                }), n) return;
            } catch (t) {}
            v(this.O, this.g, this.A, this.j, this.S.dragImageCenterOnTouch);
        }
    }, x.prototype.X = function(t) {
        if (!1 !== r(t, this.M.identifier)) {
            if (this.S.dragImageTranslateOverride) try {
                this.S.dragImageTranslateOverride(void 0, void 0, void 0, function() {});
            } catch (t) {}
            0 !== this.u ? (t.preventDefault(), this.u = "touchcancel" === t.type ? 3 : 2) : this.C();
        }
    }, x.prototype.N = function() {
        var t = this, i = this.l;
        this.v.mode = 3, this.I.dropEffect = f[0];
        var s, n, h, e, r, o = y("drag", this.m, this.k, this.v, this.I);
        if (o && (this.l = f[0]), o || 2 === this.u || 3 === this.u) return this.Y(this.u) ? (e = this.m, s = this.O, n = this.A, a = function() {
            t.q();
        }, void ("hidden" !== (r = getComputedStyle(e)).visibility && "none" !== r.display ? (s.classList.add("dnd-poly-snapback"), h = getComputedStyle(s), o = parseFloat(h.transitionDuration), isNaN(o) || 0 === o ? a() : ((e = {
            x: (u = e.getBoundingClientRect()).left,
            y: u.top
        }).x += document.body.scrollLeft || document.documentElement.scrollLeft, e.y += document.body.scrollTop || document.documentElement.scrollTop, e.x -= parseInt(r.marginLeft, 10), e.y -= parseInt(r.marginTop, 10), u = parseFloat(h.transitionDelay), u = Math.round(1e3 * (o + u)), v(s, e, n, void 0, !1), setTimeout(a, u))) : a())) : void this.q();
        var u = this.S.elementFromPoint(this.p.x, this.p.y), a = this.B;
        u !== this.V && u !== this.B && (this.V = u, null !== this.B && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragexit", this.B, this.k, this.v, this.I, !1)), null === this.V ? this.B = this.V : (this.v.mode = 3, this.I.dropEffect = m(this.v.effectAllowed, this.m), y("dragenter", this.V, this.k, this.v, this.I) ? (this.B = this.V, this.l = b(this.I.effectAllowed, this.I.dropEffect)) : this.V !== document.body && (this.B = document.body))), a !== this.B && l(a) && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragleave", a, this.k, this.v, this.I, !1, this.B)), l(this.B) && (this.v.mode = 3, this.I.dropEffect = m(this.v.effectAllowed, this.m), !1 === y("dragover", this.B, this.k, this.v, this.I) ? this.l = f[0] : this.l = b(this.I.effectAllowed, this.I.dropEffect)), i !== this.l && this.O.classList.remove(c + i);
        i = c + this.l;
        this.O.classList.add(i);
    }, x.prototype.Y = function(t) {
        t = this.l === f[0] || null === this.B || 3 === t;
        return t ? l(this.B) && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragleave", this.B, this.k, this.v, this.I, !1)) : l(this.B) && (this.v.mode = 1, this.I.dropEffect = this.l, !0 === y("drop", this.B, this.k, this.v, this.I) ? this.l = this.I.dropEffect : this.l = f[0]), t;
    }, x.prototype.q = function() {
        this.v.mode = 3, this.I.dropEffect = this.l, y("dragend", this.m, this.k, this.v, this.I, !1), this.u = 2, this.C();
    }, x);
    function x(t, i, s, n) {
        this.H = t, this.S = i, this.m = s, this.L = n, this.u = 0, this.V = null, this.B = null, this.k = t, this.M = t.changedTouches[0], this.P = this._.bind(this), this.T = this.X.bind(this), h("touchmove", this.P, !1), h("touchend", this.T, !1), h("touchcancel", this.T, !1);
    }
    var I, j = {
        iterationInterval: 150,
        tryFindDraggableTarget: function(t) {
            for(var i = 0, s = t.composedPath(); i < s.length; i++){
                var n = s[i];
                do if (!1 !== n.draggable) {
                    if (!0 === n.draggable) return n;
                    if (n.getAttribute && "true" === n.getAttribute("draggable")) return n;
                }
                while ((n = n.parentNode) && n !== document.body);
            }
        },
        dragImageSetup: function(t) {
            var i = t.cloneNode(!0);
            return function t(i, s) {
                if (1 === i.nodeType) {
                    for(var n, h, e = getComputedStyle(i), r = 0; r < e.length; r++){
                        var o = e[r];
                        s.style.setProperty(o, e.getPropertyValue(o), e.getPropertyPriority(o));
                    }
                    s.style.pointerEvents = "none", s.removeAttribute("id"), s.removeAttribute("class"), s.removeAttribute("draggable"), "CANVAS" === s.nodeName && (n = s, h = (h = i).getContext("2d").getImageData(0, 0, h.width, h.height), n.getContext("2d").putImageData(h, 0, 0));
                }
                if (i.hasChildNodes()) for(r = 0; r < i.childNodes.length; r++)t(i.childNodes[r], s.childNodes[r]);
                !function t(i) {
                    if (i instanceof HTMLElement && (i.style.pointerEvents = "none"), i.children && i.children.length) for(var s = 0; s < i.children.length; s++)t(i.children[s]);
                    if (i.shadowRoot && i.shadowRoot.children.length) for(s = 0; s < i.shadowRoot.children.length; s++)t(i.shadowRoot.children[s]);
                }(s);
            }(t, i), i;
        },
        elementFromPoint: function(t, i) {
            var s = document.elementFromPoint(t, i);
            if (s) {
                for(; s.shadowRoot;){
                    var n = s.shadowRoot.elementFromPoint(t, i);
                    if (null === n || n === s) break;
                    s = n;
                }
                return s;
            }
        }
    };
    function k(i) {
        if (!I) {
            var t = j.tryFindDraggableTarget(i);
            if (t) try {
                I = new w(i, j, t, S);
            } catch (t) {
                throw S(j, i, 3), t;
            }
        }
    }
    function C(t) {
        function i(t) {
            h.off(), e.off(), r.off(), o.off(), s && s.dispatchEvent(new CustomEvent("dnd-poly-dragstart-cancel", {
                bubbles: !0,
                cancelable: !0
            })), clearTimeout(n);
        }
        var s = t.target;
        s && s.dispatchEvent(new CustomEvent("dnd-poly-dragstart-pending", {
            bubbles: !0,
            cancelable: !0
        }));
        var n = window.setTimeout(function() {
            h.off(), e.off(), r.off(), o.off(), k(t);
        }, j.holdToDrag), h = u(s, "touchend", i), e = u(s, "touchcancel", i), r = u(s, "touchmove", i), o = u(window, "scroll", i, !0);
    }
    function S(t, i, s) {
        if (0 === s && t.defaultActionOverride) try {
            t.defaultActionOverride(i), i.defaultPrevented;
        } catch (t) {}
        I = null;
    }
    t.polyfill = function(i) {
        if (i && Object.keys(i).forEach(function(t) {
            j[t] = i[t];
        }), !j.forceApply) {
            t = (t = !!window.chrome || /chrome/i.test(navigator.userAgent), {
                dragEvents: "ondragstart" in document.documentElement,
                draggable: "draggable" in document.documentElement,
                userAgentSupportingNativeDnD: !(/iPad|iPhone|iPod|Android/.test(navigator.userAgent) || t && "ontouchstart" in document.documentElement)
            });
            if (t.userAgentSupportingNativeDnD && t.draggable && t.dragEvents) return !1;
        }
        var t;
        return j.holdToDrag ? h("touchstart", C, !1) : h("touchstart", k, !1), !0;
    }, t.supportsPassiveEventListener = i, Object.defineProperty(t, "G", {
        value: !0
    });
});



function $b2fc78b113401134$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const filePath = props.file.contentUrl ? `/files/${props.file.contentUrl}` : null;
    let url = filePath;
    const innerRef = (0, $35130c2d97e6777b$export$b8f5890fc79d6aca)(null);
    (0, $26a1e2577cffdf19$exports.polyfill)({
        tryFindDraggableTarget: (e)=>{
            if (!props.inWriter) return undefined;
            const cp = e.composedPath();
            for (const o of cp){
                let el = o;
                do {
                    if (el.draggable === false) continue;
                    if (el.draggable === true) return el;
                    if (el.getAttribute && el.getAttribute("draggable") === "true") return el;
                }while ((el = el.parentNode) && el !== document.body);
            }
        }
    });
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($91f4924d9b614d55$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        if (!props.inWriter) {
            evt.preventDefault();
            evt.stopPropagation();
            if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
                const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                    const r = {
                        href: e.href
                    };
                    if (e?.dataset?.width) r.width = e?.dataset?.width;
                    if (e?.dataset?.height) r.height = e?.dataset?.height;
                    if (e?.dataset?.type) r.type = e?.dataset?.type;
                    if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                    if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                    return r;
                });
                lightbox.setElements(elements);
                lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
            }
        }
    };
    const fileDragStart = (e)=>{
        e.target.style.opacity = "0.4";
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("id", props.file.id);
        document.querySelectorAll(".remove-button").forEach((e)=>e.style.display = "none");
    };
    const fileDragEnd = (e)=>{
        e.target.style.opacity = "1";
        document.querySelectorAll(".remove-button").forEach((e)=>e.style.display = "block");
        document.querySelectorAll(".drag-over").forEach((e)=>e.classList.remove("drag-over"));
    };
    const fileDragEnter = (e)=>{
        e.preventDefault();
        innerRef.current.classList.add("drag-over");
        return false;
    };
    const fileDragLeave = (e)=>{
        e.preventDefault();
        innerRef.current.classList.remove("drag-over");
        return false;
    };
    // necessary to declare a drop target
    const fileDragOver = (e)=>{
        e.preventDefault();
        return false;
    };
    const fileDrop = (e)=>{
        // stops the browser from redirecting.
        e.preventDefault();
        props.invertFiles(e.dataTransfer.getData("id"), props.file.id);
        return false;
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        if (props.inWriter && props.file.status == "ready" && innerRef && innerRef.current) {
            innerRef.current.addEventListener("dragstart", fileDragStart);
            innerRef.current.addEventListener("dragend", fileDragEnd);
            innerRef.current.addEventListener("dragover", fileDragOver);
            innerRef.current.addEventListener("dragenter", fileDragEnter);
            innerRef.current.addEventListener("dragleave", fileDragLeave);
            innerRef.current.addEventListener("drop", fileDrop);
            return ()=>{
                innerRef.current.removeEventListener("dragstart", fileDragStart);
                innerRef.current.removeEventListener("dragend", fileDragEnd);
                innerRef.current.removeEventListener("dragover", fileDragOver);
                innerRef.current.removeEventListener("dragenter", fileDragEnter);
                innerRef.current.removeEventListener("dragleave", fileDragLeave);
                innerRef.current.removeEventListener("drop", fileDrop);
            };
        }
    }, []);
    switch(props.file.status){
        case "raw":
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "miniature"
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
                family: "regular",
                icon: "check-circle"
            })));
        case "loading":
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "miniature"
            }));
        case "uploading":
        case "initial":
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "miniature video-raw",
                style: `background-image:url("${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "spinner orange-spinner"
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null)), props.file && props.file.progress > 0 && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "progress-bar"
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                style: {
                    width: `${props.file.progress}%`
                }
            })));
        case "ready":
        default:
            if (/pdf/.test(props.file.type) || /video/.test(props.file.type)) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath),
                href: !props.inWriter ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(url) : undefined,
                className: `${!props.inWriter ? "glightbox " : ""}file-embed rounded ${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                "data-width": "calc(90vw - 10px)",
                "data-height": "100vh",
                onClick: (e)=>openLightbox(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            if (props.file.type == "image/gif") return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath),
                href: !props.inWriter ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                class: `${!props.inWriter ? "glightbox " : ""}file-embed rounded`,
                id: props.file.id,
                "data-type": "image",
                onClick: (e)=>openLightbox(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            if (/image/.test(props.file.type)) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath),
                "data-type": "image",
                "data-srcset": `${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)} 720w, ${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1366)} 1366w, ${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).thumbnail(props.file.id, 2048)} 2048w`,
                "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
                href: !props.inWriter ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                class: `${!props.inWriter ? "glightbox " : ""}file-embed rounded`,
                id: props.file.id,
                onClick: (e)=>openLightbox(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
    }
}


const $b3b214e33ef17c7d$export$330d558700ffa676 = (0, $ae435fb76acade86$export$2e2bcd8739ae039);
const $b3b214e33ef17c7d$export$ca445ff2f74d7dc4 = (0, $ed1226fc20dc713f$export$2e2bcd8739ae039);
const $b3b214e33ef17c7d$export$48621228a997a4e0 = (0, $567a6a3c17f0a386$export$2e2bcd8739ae039);
const $b3b214e33ef17c7d$export$40e4fb50d87564f1 = (0, $b2fc78b113401134$export$2e2bcd8739ae039);




function $ecd01d0bd55f75ef$var$_extends() {
    return $ecd01d0bd55f75ef$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ecd01d0bd55f75ef$var$_extends.apply(null, arguments);
}
function $ecd01d0bd55f75ef$export$2e2bcd8739ae039(props) {
    const [preview, setPreview] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [link, setLink] = (0, $35130c2d97e6777b$export$60241385465d0a34)("");
    const [text, setText] = (0, $35130c2d97e6777b$export$60241385465d0a34)(props.text || "");
    const [title, setTitle] = (0, $35130c2d97e6777b$export$60241385465d0a34)(props.title || "");
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const writerForm = (0, $35130c2d97e6777b$export$b8f5890fc79d6aca)(null);
    const cleanForm = ()=>{
        setPreview(null);
        setLink(null);
        setText("");
        setTitle("");
    };
    const sendMessage = (writerForm)=>{
        props.sendMessage(writerForm, {
            // we get the raw value here because onChange() does not capture all possible inputs
            // and then the values of text/title could not be up to date
            title: writerForm?.current?.querySelector(".title-input")?.value,
            text: writerForm?.current?.querySelector(".text-input")?.value
        });
        cleanForm();
    };
    const genPreview = (t)=>{
        if (!t) return;
        t.style.height = "1px";
        t.style.height = `${25 + t.scrollHeight}px`;
        // waiting for the dom to be updated
        setTimeout(()=>{
            const text = t.value;
            let links = text.match(/(https?:\/\/[^\s]+)/gi);
            if (links && links[0] != link) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(links[0])}`).then((r)=>{
                if (r && t.value.indexOf(links[0]) >= 0) {
                    setLink(links[0]);
                    setPreview(r);
                }
            });
        }, 0);
    };
    const onKeyPress = (event, doGenPreview = false)=>{
        if (event.ctrlKey && (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).is_it_enter(event)) {
            sendMessage(writerForm);
            return;
        }
        if (![
            " ",
            "Enter",
            "v"
        ].includes(event.key)) return;
        if (doGenPreview) genPreview(event.currentTarget);
    };
    const onPaste = (event)=>{
        props.addFiles("image/jpeg", event.clipboardData.files);
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        genPreview(document?.getElementById(props.id)?.querySelector(".text-input"));
    }, []);
    if (props.sending) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message-placeholder"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "spinner orange-spinner"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null)));
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        id: props.id,
        class: "writer",
        ref: writerForm
    }, !props.isChild && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "text",
        class: "title-input",
        onKeyPress: (e)=>onKeyPress(e),
        placeholder: t("title_placeholder"),
        value: title,
        onChange: (e)=>setTitle(e.target.value)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("textarea", {
        onKeyPress: (e)=>onKeyPress(e, true),
        onPaste: (e)=>onPaste(e),
        class: "text-input",
        rows: "5",
        autocomplete: "off",
        autofocus: props.focus,
        placeholder: t("text_placeholder"),
        maxlength: "50000",
        value: text,
        onChange: (e)=>setText(e.target.value)
    }), !!preview && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $b3b214e33ef17c7d$export$330d558700ffa676), $ecd01d0bd55f75ef$var$_extends({
        inWriter: true
    }, preview)), !!props.files.length && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $b3b214e33ef17c7d$export$ca445ff2f74d7dc4), {
        files: props.files,
        toggleFile: props.toggleFile,
        invertFiles: props.invertFiles,
        inWriter: true
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "options"
    }, (0, $ba05c0ef8a781e02$export$644d8ea042df96a6)?.info?.upload?.image && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        class: "option",
        onClick: ()=>props.inputFile("image/*", true),
        title: t("upload_image")
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: "regular",
        icon: "images"
    })), (0, $ba05c0ef8a781e02$export$644d8ea042df96a6)?.info?.upload?.video && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        class: "option",
        onClick: ()=>props.inputFile("video/*"),
        title: t("upload_video")
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "film"
    })), (0, $ba05c0ef8a781e02$export$644d8ea042df96a6)?.info?.upload?.pdf && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        class: "option",
        onClick: ()=>props.inputFile("application/pdf"),
        title: t("upload_pdf")
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: "regular",
        icon: "file-pdf"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "actions"
    }, !!props.cancel && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        class: "cancel",
        onClick: (e)=>props.cancel(e)
    }, t("cancel")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        disabled: !props.group || props.uploading,
        type: "submit",
        class: "submit",
        onClick: ()=>sendMessage(writerForm)
    }, t("submit")))));
}


const $017da47328f74ae1$export$29913b8f065577b2 = (0, $6aca12e4c56a7a76$export$2e2bcd8739ae039);
const $017da47328f74ae1$export$d7a960146e1a269e = (0, $21521b54b609d5fa$export$2e2bcd8739ae039);
const $017da47328f74ae1$export$29beae8571dce55f = (0, $ecd01d0bd55f75ef$export$2e2bcd8739ae039);







function $e5d5ff45104628e8$export$2e2bcd8739ae039() {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("me");
    const location = (0, $405e09292ddca27f$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(location.search);
    const [loaded, setLoaded] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const [title, setTitle] = (0, $35130c2d97e6777b$export$60241385465d0a34)(searchParams.get("title") || "");
    const [text, setText] = (0, $35130c2d97e6777b$export$60241385465d0a34)(searchParams.get("text") || "");
    const [url, setUrl] = (0, $35130c2d97e6777b$export$60241385465d0a34)(searchParams.get("url") || "");
    const parent = searchParams.get("parent") || "";
    const [files, setFiles] = (0, $35130c2d97e6777b$export$60241385465d0a34)([]);
    const [group, setGroup] = (0, $35130c2d97e6777b$export$60241385465d0a34)("");
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        setTimeout(()=>{
            (0, $ba05c0ef8a781e02$export$3e32638432616b6).fetch().then((user)=>{
                if (user.data["default_group"]) setGroup(user.data["default_group"]);
                else if (user.groups.length == 1) setGroup(user.groups[0]["id"]);
                if (searchParams.get("message")) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/messages/${searchParams.get("message")}`).then((m)=>{
                    if (m?.files?.length) Promise.all(m.files.map((f)=>(0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/files/${f.id}`).then((f)=>f))).then((files)=>{
                        setFiles(files);
                        setTitle(m?.data?.title || "");
                        setText(m?.data?.text || "");
                        setUrl("");
                        setLoaded(true);
                    });
                    else {
                        setTitle(m?.data?.title || "");
                        setText(m?.data?.text || "");
                        setUrl("");
                        setLoaded(true);
                    }
                });
                else setLoaded(true);
            });
        }, 100);
    }, []);
    if (!loaded) return;
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$42cfbb80f7861e77), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        class: "mt-2"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container"
    }, !parent && me?.groups?.length > 1 && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "mb-1"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        class: "px-1",
        for: "group_share_choice"
    }, t("group_share_choice")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("select", {
        value: group,
        class: "form-select",
        name: "group_share_choice",
        onChange: (e)=>setGroup(e.target.value),
        required: true
    }, me?.groups.map((e)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("option", {
            key: e["id"],
            value: e["id"]
        }, e.name)))), !!parent && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "apiKey"
    }, t("parent_message"), ":", " "), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "parent_message",
        value: parent,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $017da47328f74ae1$export$d7a960146e1a269e), {
        focus: true,
        group: group,
        title: title,
        parent: parent,
        text: text || url ? `${text}\n${url}` : "",
        files: files
    })))));
}


const $e4fc23afeade3f60$export$9c257beea3dbd13a = (0, $c6bf11b1e742cb38$export$2e2bcd8739ae039);
const $e4fc23afeade3f60$export$1a13290ec7702c7 = (0, $968c795b42e82a14$export$2e2bcd8739ae039);
const $e4fc23afeade3f60$export$959a4441e74dcd2b = (0, $e3f95cd8f7387e6c$export$2e2bcd8739ae039);
const $e4fc23afeade3f60$export$35f3ae0a16fef81 = (0, $08392949ea77580a$export$2e2bcd8739ae039);
const $e4fc23afeade3f60$export$14834abbfce3b8cd = (0, $31634567bd2e908e$export$2e2bcd8739ae039);
const $e4fc23afeade3f60$export$4b31f5af7c5f8dee = (0, $b86bbf00e8622c6b$export$2e2bcd8739ae039);
const $e4fc23afeade3f60$export$4b85d3515bd863a5 = (0, $5df68f20e9e897ff$export$2e2bcd8739ae039);
const $e4fc23afeade3f60$export$c9915453de10000b = (0, $e5d5ff45104628e8$export$2e2bcd8739ae039);




function $ad65ccb0e164de06$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const { bookmarks: bookmarks } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("bookmarks");
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message-footer"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "infos"
    }, !props?.isPublic && props?.author && props?.author?.id === (0, $ba05c0ef8a781e02$export$3e32638432616b6).id && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "action seamless-link font-size-90 capitalize d-none d-sm-block",
        onClick: (e)=>props.editMessage(e)
    }, t("edit")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dot d-none d-sm-block"
    }, "\u2022")), !props?.isPublic && props?.isChild && props?.message && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        class: "action seamless-link font-size-90 capitalize",
        to: `/messages/${props?.message.id}${props?.message?.children.length ? "" : "?focus=reply"}`
    }, props?.message?.children.length ? props.message.children.some((e)=>(0, $ba05c0ef8a781e02$export$6008d97729a90c74).isNew(e.id)) ? (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("b", null, t("replies", {
        count: props.message.children.length
    })) : t("replies", {
        count: props.message.children.length
    }) : t("reply")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dot"
    }, "\u2022")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "date font-size-90",
        title: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).humanFullDate(props?.message.createdAt)
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$35f3ae0a16fef81), {
        timestamp: props?.message.createdAt
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dot"
    }, "\u2022"), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "font-size-90"
    }, props?.author && props?.author?.name ? props.author.name : "--"))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null, !props?.isPublic && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "options dropdown",
        onClick: (e)=>e?.target?.closest(".dropdown")?.classList.toggle("active")
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "none-if-follows-empty"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "ellipsis-h"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu dropdown-options"
    }, props?.author && props?.author?.id === (0, $ba05c0ef8a781e02$export$3e32638432616b6).id && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.deleteMessage(e)
    }, t("delete")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.openPublicLink(e)
    }, t("public_link")), (0, $ba05c0ef8a781e02$export$3e32638432616b6).groups?.length > 1 && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.shareMessage(e)
    }, t("share_message")), !props?.message?.isInFront && props?.author && props?.author.id == (0, $ba05c0ef8a781e02$export$3e32638432616b6).id && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.publishInGroup(e)
    }, t("publish_in_group")), !bookmarks.some((b)=>b.message.id === props?.message.id) && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>{
            (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("bookmark_added"));
            (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("bookmark/add", props.message.id);
        }
    }, t("add_bookmark")), bookmarks.some((b)=>b.message.id === props?.message.id) && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>{
            (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("bookmark_removed"));
            (0, $5e4e939c48db0130$export$2e2bcd8739ae039).dispatch("bookmark/remove", bookmarks.find((b)=>b.message.id === props.message.id));
        }
    }, t("remove_bookmark")), props?.author?.id == (0, $ba05c0ef8a781e02$export$3e32638432616b6).id && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.editMessage(e)
    }, t("edit"))))));
}






function $7128f2b1295b6a89$export$2e2bcd8739ae039(props) {
    const [preview, setPreview] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const displayMessageText = ()=>{
        if (!props.message.data) return "";
        // escape html a little (just enough to avoid xss I hope)
        let txt = props.message.data["text"].replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // replace url by real links
        let shift = 0;
        let match = null;
        while(match = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getUrl(txt.slice(shift))){
            let url = match[0];
            if (url.length >= 50) url = `${url.slice(0, 25)}...${url.slice(-24)}`;
            let link = `<a href="${match[0]}" target="_blank">${url}</a>`;
            txt = txt.slice(0, match["index"] + shift) + link + txt.slice(match["index"] + shift + match[0].length);
            shift += match["index"] + link.length;
        }
        // replace line returns
        txt = txt.replace(/\n/g, "<br/>");
        return {
            __html: txt
        };
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        if (!preview && props.message) {
            if (props.message.data) {
                let previewUrl = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getUrl(props.message.data["text"]);
                if (previewUrl) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(previewUrl[0])}`).then((r)=>setPreview(r));
            }
        }
    });
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message-body"
    }, props.message.data && props.message.data.title && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "title"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", null, props.message.data.title)), props.message.data && props.message.data.text && props.message.data.text.trim() && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("p", {
        class: "card-text",
        dangerouslySetInnerHTML: displayMessageText()
    }), preview && (!props.message.data || !props.message.data["no_embed"]) && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $b3b214e33ef17c7d$export$330d558700ffa676), {
        key: preview.url,
        url: preview.url,
        preview: preview.preview,
        data: preview.data
    }), props.files && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $b3b214e33ef17c7d$export$ca445ff2f74d7dc4), {
        files: props.files
    }));
}






function $0329eb4a81e3801e$export$2e2bcd8739ae039(props) {
    const stack = [
        props.message.id,
        ...props.message.lineage
    ].reverse();
    const [breadcrumbs, setBreadcrumbs] = (0, $35130c2d97e6777b$export$60241385465d0a34)([]);
    const [group, setGroup] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const getTitle = (message, previewLink)=>{
        if (message) {
            if (message["data"] && message["data"]["title"]) return message["data"]["title"];
            if (previewLink && previewLink["data"]) return previewLink["data"]["title"];
            if (message["data"] && message["data"]["text"]) {
                let url = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getUrl(message["data"]["text"]);
                if (url && url.length > 0) url = url[0];
                if (url) return url;
                return message["data"]["text"];
            }
        }
        // When all else fails, just say who and when
        return `${message?.author?.name}, ${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).humanTime(message.createdAt)}`;
    };
    const loadBreadcrumbs = (ids)=>{
        let breadcrumbs = [];
        Promise.all(ids.map((id)=>(0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/messages/${id}`))).then((messages)=>{
            Promise.all(messages.map((message)=>{
                let previewUrl = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getUrl(message?.data?.text);
                if (previewUrl) return (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(previewUrl[0])}`);
                return Promise.resolve(null);
            })).then((links)=>{
                for(let i = 0; i < ids.length; i++)breadcrumbs[i] = getTitle(messages[i], links[i]);
                setBreadcrumbs(breadcrumbs);
            });
        });
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        loadBreadcrumbs(stack);
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/groups/${props.message.group.id}`).then((group)=>{
            setGroup(group);
        });
    }, []);
    if (stack.length > 0) {
        const stack_truncated = [
            stack[0],
            ...stack.slice(Math.min(3, stack.length) * -1).slice(1)
        ];
        const breadcrumbs_truncated = [
            breadcrumbs[0],
            ...breadcrumbs.slice(Math.min(3, breadcrumbs.length) * -1).slice(1)
        ];
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "message-breadcrumbs"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("nav", {
            style: "--bs-breadcrumb-divider: '>';"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("ol", {
            class: "breadcrumb"
        }, group && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("li", {
            class: "breadcrumb-item"
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
            key: group.id,
            to: `/groups/${group.id}`,
            class: "no-decoration"
        }, (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).limitLength(group.name || group.id.slice(0, 8), 30))), stack_truncated.map((e, i)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), {
                key: e
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, i == 1 && stack.length > 3 && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("li", {
                class: "breadcrumb-item"
            }, "...")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("li", {
                class: "breadcrumb-item"
            }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
                key: e,
                to: `/messages/${e}`,
                class: "no-decoration"
            }, (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).limitLength(breadcrumbs_truncated[i] || e.slice(0, 8), 30))))))));
    }
}







function $30c5ca0a60c8316e$export$2e2bcd8739ae039(props) {
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("me");
    const [author, setAuthor] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [parent, setParent] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [files, setFiles] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [isRemoved, setIsRemoved] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const [edit, setEdit] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const [message, setMessage] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const messageRef = (0, $35130c2d97e6777b$export$b8f5890fc79d6aca)(message);
    const setMessageRef = (message)=>{
        messageRef.current = message;
        setMessage(message);
    };
    const [, forceUpdate] = (0, $35130c2d97e6777b$export$13e3392192263954)((x)=>x + 1, 0);
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        window.addEventListener("newChild", onNewChild);
        window.addEventListener("editMessage", onEditMessage);
        loadMessage();
        (0, $ba05c0ef8a781e02$export$6008d97729a90c74).markAsRead(props.id);
        if (!props.isChild) setTimeout(()=>window.scrollTo(0, 0));
        setTimeout(()=>{
            if (props.id == (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).action) {
                const msgElement = document.getElementById(props.id);
                if (msgElement) {
                    msgElement.scrollIntoView({
                        block: "start",
                        behavior: "smooth"
                    });
                    setTimeout(()=>msgElement.classList.remove("highlight"), 1000);
                }
            }
        }, 1000);
    }, []);
    const hydrateMessage = (m)=>{
        setMessageRef(m);
        if (m?.author?.id) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/users/${m.author.id}`).then((u)=>{
            setAuthor(u);
        });
        if (m?.parent?.id) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/messages/${m.parent.id}`).then((p)=>{
            setParent(p);
        });
        // delay loading of files a little bit
        setTimeout(()=>{
            if (m?.files?.length) Promise.all(m.files.map((f)=>(0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/files/${f.id}`).then((f)=>f))).then((files)=>setFiles(files));
        }, 100);
    };
    const loadMessage = ()=>{
        if (props?.message) {
            if (props?.files?.length) setFiles(props?.message?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(props.message);
        } else if (props?.token) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/public/${props.token}`).then((m)=>{
            if (m?.files?.length) setFiles(m?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(m);
        });
        else (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}`).then((m)=>{
            if (m?.files?.length) setFiles(m?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(m);
        });
    };
    const onNewChild = (event)=>{
        if (!messageRef.current?.id) return;
        const newMsg = event.detail;
        if (newMsg?.parent && (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getId(newMsg?.parent) == props.id) {
            newMsg.author = me;
            let newChildren = messageRef?.current?.children ? [
                ...messageRef.current.children,
                newMsg
            ] : [
                newMsg
            ];
            let newRef = Object.assign(messageRef.current, {
                children: newChildren
            });
            setMessageRef(newRef);
            forceUpdate();
        }
    };
    const openPublicLink = async (event)=>{
        event.preventDefault();
        let newTab = window.open("about:blank", "_blank");
        const res = await (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}/get-public-link`);
        newTab.location = `${document.baseURI}public/${res.token}`;
    };
    const onEditMessage = (event)=>{
        if (event.detail.id == props.id) {
            setEdit(false);
            hydrateMessage(event.detail);
            props.key = +Date.now();
        }
    };
    const getComponentClass = ()=>{
        let cn = "message";
        if (props.isChild) cn += " child";
        if (props.id == (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).action) cn += " highlight";
        return cn;
    };
    const deleteMessage = (event)=>{
        event.preventDefault();
        if (confirm(t("ask_delete_message"))) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).delete(`/api/messages/${props.id}`).then(()=>{
            if (props.isChild) setIsRemoved(true);
            else navigate(`/groups/${message.group.id}`);
        });
    };
    const shareMessage = (event)=>{
        event.preventDefault();
        navigate(`/share?message=${props.id}`);
    };
    const editMessage = (event)=>{
        event.preventDefault();
        setEdit(true);
    };
    const publishInGroup = ()=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).put(`/api/messages/${props.id}`, {
            lastActivityDate: Math.floor(Date.now() / 1000),
            isInFront: true
        }).then((res)=>{
            if (!res) {
                alert.add(t("error"), "alert-danger");
                return;
            }
            navigate(`/groups/${message.group.id}`);
        });
    };
    const cancelEdit = (event)=>{
        event.preventDefault();
        setEdit(false);
    };
    const displayWriter = (isChild, focus)=>{
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $017da47328f74ae1$export$d7a960146e1a269e), {
            cancel: edit ? cancelEdit : null,
            files: edit ? files : [],
            focus: focus || !!edit,
            group: message.group,
            messageId: edit ? props.id : null,
            parent: edit ? parent?.id : props.id,
            text: edit ? message.data["text"] : "",
            title: edit ? message.data["title"] : "",
            isChild: isChild
        });
    };
    if (isRemoved || !message) // placeholder (to be able to target it)
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        id: props.id,
        className: "message"
    });
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, !props?.isChild && !props?.isPublic && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $0329eb4a81e3801e$export$2e2bcd8739ae039), {
        key: message?.id,
        message: message
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        id: props.id,
        className: getComponentClass()
    }, edit && displayWriter(props?.isChild), !edit && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, props.isChild && !props.isPublic && edit && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message-head d-none d-md-block"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
        class: "rounded-circle w-3 material-shadow avatar",
        style: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me.avatar ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(me.avatar?.id, 100, 100) : (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $9b716d635261f1d3$export$2e2bcd8739ae039), {
        author: author,
        message: message,
        isPublic: props?.isPublic,
        isChild: props?.isChild
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "main"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $7128f2b1295b6a89$export$2e2bcd8739ae039), {
        message: message,
        files: files || [],
        isPublic: props?.isPublic,
        isChild: props?.isChild
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $ad65ccb0e164de06$export$2e2bcd8739ae039), {
        author: author,
        message: message,
        editMessage: editMessage,
        deleteMessage: deleteMessage,
        shareMessage: shareMessage,
        publishInGroup: publishInGroup,
        openPublicLink: openPublicLink,
        isPublic: props?.isPublic,
        isChild: props?.isChild
    })))), props?.postMessageComponent, !props?.isChild && !props?.isPublic && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $021afc89466d3c0c$export$2e2bcd8739ae039), {
        childMessages: message?.children,
        key: props.id,
        id: props.id
    }), !edit && !props?.isPublic && !props?.isChild && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message child mt-2"
    }, me?.id && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "message-head d-none d-md-block"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
        class: "rounded-circle w-3 material-shadow avatar",
        style: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me?.avatar ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(me.avatar["id"], 100, 100) : (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar
    })), displayWriter(true, props.focus)));
}











class $035df1b12d129642$export$2e2bcd8739ae039 extends (0, $bc4b82f252aed4aa$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        let loaded = 1 + Math.floor(window.screen.width * window.screen.height / 68800);
        this.state = {
            loaded: loaded,
            messages: [],
            scrollTop: 0,
            totalMessages: 0,
            pageYOffset: 0,
            page: 0
        };
        this.scroll_cooldown = Date.now();
        this.onScroll = this.onScroll.bind(this);
        this.loadMessages = this.loadMessages.bind(this);
        this.onNewParent = this.onNewParent.bind(this);
        window.addEventListener("newParent", this.onNewParent);
    }
    onNewParent() {
        this.loadMessages(0);
    }
    componentDidMount() {
        this.loadMessages(0);
        window.addEventListener("scroll", this.onScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }
    loadMessages(page) {
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/groups/${this.props.id}`).then((res)=>{
            this.setState({
                group: res
            });
        });
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/groups/${this.props.id}/page/${page}`).then((res)=>{
            if (res && Array.isArray(res["messages"])) {
                let new_loaded = Math.max(this.state.loaded, page * 30);
                let msgList = this.state.messages;
                // don't add already added messages
                res["messages"].map((mid)=>!msgList.find((msg)=>msg.id == mid) && msgList.push({
                        id: mid
                    }));
                this.setState({
                    messages: msgList,
                    totalMessages: res["totalItems"],
                    page: page,
                    loaded: new_loaded
                });
                if ((page + 1) * 30 < new_loaded) setTimeout(()=>this.loadMessages(page + 1));
            }
        });
    }
    onScroll() {
        // prevent loading messages if we are in a post
        if (window.getComputedStyle(document.getElementById("group").parentNode).display == "none") return;
        // don't load if on cooldown
        if (this.scroll_cooldown + 100 < Date.now()) {
            this.scroll_cooldown = Date.now();
            this.setState({
                pageYOffset: window.pageYOffset
            });
            // don't load if unecessary
            if (Array.isArray(this.state.messages) && document.body.scrollHeight - window.screen.height - 500 < window.pageYOffset && this.state.loaded < this.state.totalMessages) {
                this.setState((prevState)=>({
                        loaded: prevState.loaded + 10
                    }));
                if (this.state.loaded + 30 > this.state.messages.length) {
                    this.loadMessages(this.state.page + 1);
                    // update page count right away
                    this.setState((prevState)=>({
                            page: prevState.page + 1
                        }));
                }
            }
        }
    }
    render() {
        if (!this.props.id) return;
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, Array.isArray(this.state.messages) && this.state.messages.slice(0, this.state.loaded).map((msg, i)=>{
            return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $19924b6e568a4f60$export$84c965ec8b6b0f92), {
                tabindex: i + 1,
                key: msg.id,
                id: msg.id
            });
        }));
    }
}







function $c9ab4f969fa59a9f$export$2e2bcd8739ae039(props) {
    let params = (0, $405e09292ddca27f$export$99eaa27ddbbb95ef)();
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$42cfbb80f7861e77), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        class: "mb-3 justify-content-center d-flex"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $30c5ca0a60c8316e$export$2e2bcd8739ae039), {
        focus: !!(0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("focus", (0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).search),
        isPublic: false,
        isChild: false,
        message: props?.message,
        id: params.id,
        key: params.id
    })))));
}








function $e595d0422a62521e$export$2e2bcd8739ae039(props) {
    const [author, setAuthor] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [preview, setPreview] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [id, setId] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [data, setData] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [lastActivityDate, setLastActivityDate] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [children, setChildren] = (0, $35130c2d97e6777b$export$60241385465d0a34)(0);
    const [loaded, setLoaded] = (0, $35130c2d97e6777b$export$60241385465d0a34)(false);
    const getAvatar = (user)=>{
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            title: user ? user.name : "--",
            className: `avatar material-shadow${user ? "" : " removed-user"}`,
            style: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).backgroundHash(user ? user.id : ""),
            src: user?.avatar ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(user.avatar["id"], 100, 100) : (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar,
            onError: (e)=>e.currentTarget.src = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar
        });
    };
    const setDefaultMiniature = (e)=>{
        e.currentTarget.src = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar;
        e.currentTarget.style.height = "180px";
        e.currentTarget.style.width = "auto";
        e.currentTarget.style.position = "absolute";
        e.currentTarget.style.left = "50%";
        e.currentTarget.style.transform = "translate(-50%, 0%)";
    };
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}/preview`).then((p)=>{
            if (p?.author?.id) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/users/${p.author.id}`).then((u)=>{
                setAuthor(u);
            });
            setPreview(p?.preview);
            setId(p?.id);
            setChildren(p?.children);
            setLoaded(true);
            setLastActivityDate(p?.lastActivityDate);
            setData(p?.data);
        });
    }, []);
    if (!props?.id || !data) return null;
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        to: `/messages/${id}`,
        class: "d-inline-block seamless-link message-preview unselectable",
        title: data?.title
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        tabindex: props?.tabindex,
        class: "card material-shadow-with-hover"
    }, getAvatar(author), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "card-miniature-loading"
    }, loaded && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $bc4b82f252aed4aa$export$ffb0004e005737fa), null, preview ? (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "card-miniature"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
        width: "320",
        height: "180",
        src: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getId(preview), 320, 180),
        onError: (e)=>setDefaultMiniature(e)
    })) : (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "text-preview"
    }, data?.text))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "card-body border-top d-flex justify-content-between"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", {
        class: "left-buffer"
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", {
        class: "title",
        title: data?.title || (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).humanFullDate(lastActivityDate)
    }, data?.title || (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$35f3ae0a16fef81), {
        timestamp: lastActivityDate
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", {
        class: "children"
    }, children > 0 && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", null, `${children} `, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: (0, $ba05c0ef8a781e02$export$6008d97729a90c74).isNew(id) ? "solid" : "regular",
        icon: "comment"
    }))))));
}







function $4b50a8abb2aa644f$export$2e2bcd8739ae039(props) {
    const [author, setAuthor] = (0, $35130c2d97e6777b$export$60241385465d0a34)(props?.message?.author || null);
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        if (props?.message?.author) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/users/${props.message.author}`).then((author)=>author && setAuthor(author));
    }, []);
    const displayAuthorName = ()=>{
        if (!author?.name) return {
            __html: "--"
        };
        let authorName = author.name;
        // make the search terms stand out
        let words = authorName.split(" ");
        for(let j = 0; j < words.length; j++)if (!words[j].match((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).urlRegExp)) {
            let searchTerms = props.search.split(" ");
            for(let k = 0; k < searchTerms.length; k++)words[j] = words[j].replace(new RegExp((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
        }
        authorName = words.join(" ");
        return {
            __html: authorName
        };
    };
    const displayMessageTitle = ()=>{
        if (!props?.message?.data?.title) return {
            __html: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).humanTime(props?.message?.lastActivityDate)
        };
        // escape html a little (just enough to avoid xss I hope)
        let title = props?.message?.data?.title.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // make the search terms stand out
        let words = title.split(" ");
        let searchTerms = props?.search.split(" ") || [];
        for(let j = 0; j < words.length; j++){
            if (!words[j].match((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).urlRegExp)) for(let k = 0; k < searchTerms.length; k++)words[j] = words[j].replace(new RegExp((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
        }
        title = words.join(" ");
        return {
            __html: title
        };
    };
    const displayMessageText = ()=>{
        if (!props?.message?.data?.text) return "";
        // escape html a little (just enough to avoid xss I hope)
        let txt = props?.message?.data?.text.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // make the search terms stand out for not url words
        let lines = txt.split("\n");
        for(let i = 0; i < lines.length; i++){
            let words = lines[i].split(" ");
            for(let j = 0; j < words.length; j++)if (!words[j].match((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).urlRegExp)) {
                let searchTerms = props.search.split(" ");
                for(let k = 0; k < searchTerms.length; k++){
                    if (!searchTerms[k]) continue;
                    words[j] = words[j].replace(new RegExp((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
                }
                let hashtags = props?.hashtags.split(" ") || [];
                for(let k = 0; k < hashtags.length; k++){
                    if (!hashtags[k]) continue;
                    words[j] = words[j].replace(new RegExp(`#${hashtags[k]}`, "gi"), "<b>$&</b>");
                }
            }
            lines[i] = words.join(" ");
        }
        txt = lines.join("\n");
        // replace url by real links
        let shift = 0;
        let match = null;
        while(match = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).getUrl(txt.slice(shift))){
            let url = match[0];
            if (url.length >= 50) url = `${url.slice(0, 25)}...${url.slice(-24)}`;
            let searchTerms = props?.search.split(" ") || [];
            for(let i = 0; i < searchTerms.length; i++)url = url.replace(new RegExp((0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).escapeRegex(searchTerms[i]), "gi"), "<b>$&</b>");
            let link = `<a href="${match[0]}" target="_blank">${url}</a>`;
            txt = txt.slice(0, match["index"] + shift) + link + txt.slice(match["index"] + shift + match[0].length);
            shift += match["index"] + link.length;
        }
        // replace line returns
        txt = txt.replace(/\n/g, "<br/>");
        return {
            __html: txt
        };
    };
    const getMiniature = ()=>{
        if (props?.preview) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "card-miniature",
            style: `background-image: url('${(0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(props?.preview, 100, 100)}')`
        });
        let avatar = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar;
        if (author?.avatar?.id) avatar = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(author.avatar["id"], 100, 100);
        return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "card-miniature",
            style: `background-image: url('${avatar}')`
        });
    };
    const getLink = ()=>{
        if (props.message.parent && props.message.children == 0) return `/messages/${props.message.parent}/${props.message.id}`;
        return `/messages/${props.message.id}`;
    };
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        class: "d-inline-block seamless-link message-preview unselectable",
        to: getLink(),
        title: props?.title
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        tabindex: props.tabindex,
        class: "card material-shadow-with-hover"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "card-body border-top"
    }, getMiniature(), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "infos"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "title",
        dangerouslySetInnerHTML: displayAuthorName()
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dot"
    }, "\u2022"), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "title",
        title: props?.title || (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).humanFullDate(props.message.lastActivityDate),
        dangerouslySetInnerHTML: displayMessageTitle()
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "text"
    }, props?.message?.data?.text.trim() && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("p", {
        class: "card-text",
        dangerouslySetInnerHTML: displayMessageText()
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "children"
    }, !!props.message.children && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", null, `${props.message.children} `, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $85c05060c4c33f8a$export$8b29a4b6778bf7f), {
        family: (0, $ba05c0ef8a781e02$export$6008d97729a90c74).isNew(props.message.id) ? "solid" : "regular",
        icon: "comment"
    }))))));
}


const $19924b6e568a4f60$export$f69c19e57285b83a = (0, $30c5ca0a60c8316e$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$36e783c4ff07cd7c = (0, $7128f2b1295b6a89$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$ff4023171d74287f = (0, $0329eb4a81e3801e$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$34692698b50bc55e = (0, $c6a97b4c72e49883$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$e4f91797a78e658f = (0, $021afc89466d3c0c$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$448e87951e58f7a8 = (0, $ad65ccb0e164de06$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$14933f4fded8a04f = (0, $9b716d635261f1d3$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$89085c7857c3f940 = (0, $035df1b12d129642$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$4025c8e17986f775 = (0, $c9ab4f969fa59a9f$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$84c965ec8b6b0f92 = (0, $e595d0422a62521e$export$2e2bcd8739ae039);
const $19924b6e568a4f60$export$423dfe6469a8e0dd = (0, $4b50a8abb2aa644f$export$2e2bcd8739ae039);



function $4ea33daa32a5a1fd$export$2e2bcd8739ae039() {
    let params = (0, $405e09292ddca27f$export$99eaa27ddbbb95ef)();
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        class: "justify-content-center d-flex mt-2"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        class: "mb-3 justify-content-center d-flex"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $19924b6e568a4f60$export$f69c19e57285b83a), {
        focus: false,
        isPublic: true,
        isChild: false,
        token: params.token
    })))))));
}


const $7a4a2b5c7de24037$export$21a94553ffa41578 = (0, $0426dbc898a9b87d$export$2e2bcd8739ae039);
const $7a4a2b5c7de24037$export$b44239f84c8f0268 = (0, $d98633f34622d449$export$2e2bcd8739ae039);
const $7a4a2b5c7de24037$export$89200835fb4edfb9 = (0, $4b4c42fcf86b8acc$export$2e2bcd8739ae039);
const $7a4a2b5c7de24037$export$e9e03eeea26d4dee = (0, $f79e9cb5c3dbdf1a$export$2e2bcd8739ae039);
const $7a4a2b5c7de24037$export$68b4491d6924a6d1 = (0, $4ea33daa32a5a1fd$export$2e2bcd8739ae039);











function $eeb1ed40e8ffc517$export$2e2bcd8739ae039() {
    const params = (0, $405e09292ddca27f$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const { me: me, dispatch: dispatch } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("me");
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    const [secretKey, setSecretKey] = (0, $35130c2d97e6777b$export$60241385465d0a34)("");
    const [users, setUsers] = (0, $35130c2d97e6777b$export$60241385465d0a34)([]);
    const [group, setGroup] = (0, $35130c2d97e6777b$export$60241385465d0a34)({});
    const [alertMessage, setAlertMessage] = (0, $35130c2d97e6777b$export$60241385465d0a34)("");
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/groups/${params.id}`).then((group)=>{
            setGroup(group);
            setSecretKey(group.secretKey);
            Promise.all(group.users.map((u)=>(0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).get(`/api/users/${u.id}`).then((u)=>u))).then((users)=>setUsers(users));
        });
        setAlertMessage(t((0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("alert")));
    }, []);
    const resetSecretKey = (event)=>{
        event.preventDefault();
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post(`/api/groups/${group.id}/reset-invite-key`, {}).then((res)=>{
            (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("group_updated"));
            setSecretKey(res["inviteKey"]);
        });
    };
    const updateSettings = (event)=>{
        event.preventDefault();
        const name = document.querySelector("#settings_form input[name='name']").value;
        if (name) group.name = name;
        setGroup(Object.assign({}, group));
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).put(`/api/groups/${group.id}`, group).then((res)=>{
            setGroup(res);
            setAlertMessage(t("group_updated"));
            navigate(`${location.pathname}?alert=group_updated`);
        });
    };
    const leaveGroup = (event)=>{
        event.preventDefault();
        if (me.data?.default_group == group.id) {
            let user = {};
            user.data = {
                default_group: me.groups[0].id
            };
            (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, user).then(()=>{
                dispatch("me/fetch");
                leave();
            });
        } else leave();
    };
    const leave = ()=>{
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post(`/api/groups/${group.id}/leave`, {}).then((res)=>{
            if (!res || !res["entityType"]) (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
            else {
                dispatch("me/fetch");
                (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(t("group_left"));
                navigate("/");
            }
        });
    };
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "group-settings mb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "card"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "card-body"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container-fluid p-1"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "row"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "col-12 col-md-10"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", {
        id: "settings_form",
        class: "mb-1 border-bottom pb-1"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "name"
    }, t("name"), ": "), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "name",
        minlength: "1",
        maxlength: "128",
        placeholder: t("name_input"),
        value: group.name,
        class: "form-control",
        required: true
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        onClick: updateSettings,
        class: "btn btn-outline-secondary"
    }, t("save_changes"))), (0, $ba05c0ef8a781e02$export$644d8ea042df96a6)?.info?.show?.group_invitation_links && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", {
        class: "mb-1 border-bottom pb-1"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "inviteKey"
    }, t("invitation_link"), ":", " "), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "inviteKey",
        value: `${window.location.protocol}//${window.location.host}/invitation/${secretKey}`,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        class: "btn btn-outline-secondary",
        onClick: resetSecretKey
    }, t("reset_invitation_link"))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        onClick: (e)=>leaveGroup(e),
        class: "btn btn-outline-danger"
    }, t("quit_group"))))))))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "user-list mb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("h3", null, t("users")), users.map((user)=>user && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
            class: "user-card",
            key: user.id
        }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
            class: "avatar material-shadow-with-hover",
            style: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).backgroundHash(user.id),
            src: user.avatar ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(user.avatar["id"], 200, 200) : (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar,
            onError: (e)=>e.currentTarget.src = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar
        }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("span", null, user["name"])))), alertMessage && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "global-alert alert alert-success"
    }, alertMessage));
}









function $6b414d55358a8032$export$2e2bcd8739ae039() {
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("me");
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    const location = (0, $405e09292ddca27f$export$45d76561a5302f2b)();
    const [apiKey, setApiKey] = (0, $35130c2d97e6777b$export$60241385465d0a34)(null);
    const [alertMessage, setAlertMessage] = (0, $35130c2d97e6777b$export$60241385465d0a34)("");
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        (0, $ba05c0ef8a781e02$export$ddcffe0146c8f882).get("apiKey").then((apiKey)=>setApiKey(apiKey));
        setAlertMessage(t((0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).getParam("alert")));
    }, []);
    const resetApiKey = (event)=>{
        event.preventDefault();
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post(`/api/users/${me.id}/reset-api-key`, {}).then(()=>(0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).logout());
    };
    const inputAvatar = ()=>{
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.addEventListener("change", (event)=>{
            const formData = new FormData();
            formData.append("file", event.target.files[0]);
            (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).sendFile(formData, (file)=>{
                (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, {
                    avatar: file["id"]
                }).then(()=>{
                    setAlertMessage(t("settings_updated"));
                    navigate(`${location.pathname}?alert=settings_updated`);
                });
            });
        });
        input.click();
    };
    const destroyAccount = (event)=>{
        event.preventDefault();
        let confirmDeletion = confirm(t("are_you_sure"));
        if (confirmDeletion) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).delete(`/api/users/${me.id}`).then(()=>{
            navigate("/logout");
        });
    };
    const updateSettings = (event)=>{
        event.preventDefault();
        const name = document.querySelector("#settings_form input[name='name']").value;
        const login = document.querySelector("#settings_form input[name='email']").value;
        const password = document.querySelector("#settings_form input[name='password']").value;
        const notification_emails = document.querySelector("#settings_form select[name='notification_emails']").value;
        const default_group = document.querySelector("#settings_form select[name='default_group']").value;
        const lang = document.querySelector("#settings_form select[name='lang']").value;
        let user = {};
        if (name) user.name = name;
        if (login) user.login = login;
        if (password) user.password = password;
        user["data"] = {
            notification_emails: notification_emails,
            default_group: default_group,
            lang: lang
        };
        (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, user).then((res)=>{
            if (res["error"]) (0, $ba05c0ef8a781e02$export$5ea928c9faf85bd3).add(res["error"], "alert-danger");
            else {
                setAlertMessage(t("settings_updated"));
                navigate(`${location.pathname}?alert=settings_updated`);
            }
        });
    };
    if (me && me?.data) return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "user-settings"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "card"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "identite card-body"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container-fluid p-1"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "row"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "col-12 col-md-2"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("img", {
        class: "img-fluid rounded-circle material-shadow avatar",
        src: me.avatar ? (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).crop(me.avatar["id"], 100, 100) : (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar,
        style: (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).backgroundHash(me.id || ""),
        onError: (e)=>e.currentTarget.src = (0, $ba05c0ef8a781e02$export$7debb50ef11d5e0b).defaultAvatar,
        onClick: (e)=>inputAvatar(e)
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "col-12 col-md-10"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", {
        id: "settings_form",
        class: "mb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "name"
    }, t("name"), ": "), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "name",
        minlength: "1",
        maxlength: "128",
        placeholder: t("name_input"),
        value: me.name,
        class: "form-control"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "email"
    }, t("email"), ": "), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "email",
        name: "email",
        placeholder: t("email_input"),
        value: me.login,
        class: "form-control"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "password"
    }, t("password"), ": "), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "password",
        name: "password",
        autocomplete: "off",
        minlength: "8",
        maxlength: "128",
        placeholder: t("password_input"),
        class: "form-control"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "notification_emails"
    }, t("notification_emails"), ":"), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("select", {
        name: "notification_emails",
        class: "form-control",
        value: me?.data["notification_emails"]
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("option", {
        value: "none"
    }, t("none")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("option", {
        value: "hourly"
    }, t("hourly")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("option", {
        value: "daily"
    }, t("daily")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("option", {
        value: "weekly"
    }, t("weekly")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("option", {
        value: "monthly"
    }, t("monthly")))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "default_group"
    }, t("default_group"), ":"), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("select", {
        name: "default_group",
        class: "form-control",
        value: me?.data["default_group"]
    }, me.groups?.map((e)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("option", {
            key: e.id,
            value: e.id
        }, e.name)))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        class: "capitalize",
        for: "lang"
    }, t("lang"), ":"), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("select", {
        name: "lang",
        class: "form-control",
        value: (0, $ba05c0ef8a781e02$export$9a771d6906431624).getCurrentLang()
    }, Object.keys((0, $ba05c0ef8a781e02$export$9a771d6906431624).possibleLang).map((k)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("option", {
            key: k,
            value: k
        }, (0, $ba05c0ef8a781e02$export$9a771d6906431624).possibleLang[k])))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        onClick: (e)=>updateSettings(e),
        class: "btn btn-primary"
    }, t("save_changes"))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", {
        id: "api_key_form"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "form-group"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        for: "apiKey"
    }, t("api_key"), ":", " "), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("input", {
        type: "text",
        name: "apiKey",
        value: apiKey,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        class: "btn btn-outline-secondary",
        onClick: resetApiKey
    }, t("reset_api_key"))), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("form", {
        id: "destroy_form"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("label", {
        class: "d-block",
        for: "destroy_account"
    }, t("destroy_account_explain")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("button", {
        onClick: (e)=>destroyAccount(e),
        name: "destroy_account",
        class: "btn btn-danger"
    }, t("destroy_account")))))))), alertMessage && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "global-alert alert alert-success"
    }, alertMessage));
}







function $e445918a5a4228c3$export$2e2bcd8739ae039() {
    const params = (0, $405e09292ddca27f$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $829be5acfdd67d69$export$9fc83ad70ead8663)();
    const { me: me } = (0, $5133ef8bc2964922$export$11aeef812f154e9e)("me");
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("main", null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$42cfbb80f7861e77), null), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "content"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("article", {
        class: "mt-2 justify-content-center d-flex"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "container pb-3"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "settings"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("ul", {
        class: "nav nav-tabs"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("li", {
        class: "nav-item"
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
        class: `nav-link${params.type == "users" ? " active" : ""}`,
        to: `/users/${me.id}/settings`
    }, t("account"))), me.groups?.length > 0 && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("li", {
        class: "nav-item dropdown group-list",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: `nav-link${params.type == "groups" ? " active" : ""}`
    }, t("groups")), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)("div", {
        class: "dropdown-menu"
    }, me.groups?.map((e)=>(0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$a6c7ac8248d6e38a), {
            key: `/groups/${e.id}/settings`,
            class: "seamless-link",
            to: `/groups/${e.id}/settings`
        }, e.name))))), params.type === "users" && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $6b414d55358a8032$export$2e2bcd8739ae039), {
        id: params.id,
        key: params.id
    }), params.type === "groups" && (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $eeb1ed40e8ffc517$export$2e2bcd8739ae039), {
        id: params.id,
        key: params.id
    }))))));
}



const $15e77f43f1e3331f$export$7756bc8dbeb9ec70 = (0, $eeb1ed40e8ffc517$export$2e2bcd8739ae039);
const $15e77f43f1e3331f$export$c72f6eaae7b9adff = (0, $e445918a5a4228c3$export$2e2bcd8739ae039);
const $15e77f43f1e3331f$export$6587c76ebf15601c = (0, $6b414d55358a8032$export$2e2bcd8739ae039);





function $c94d87274290ed2f$var$App() {
    const navigate = (0, $405e09292ddca27f$export$9770f232ac06a008)();
    const location = (0, $405e09292ddca27f$export$45d76561a5302f2b)();
    const toggleDropdowns = (e)=>{
        if (!e.target.closest(".dropdown")) // close dropdowns if we are clicking on something else
        document.querySelectorAll(".dropdown").forEach((n)=>n.classList.remove("active"));
        else // close dropdowns that are not clicked on
        document.querySelectorAll(".dropdown").forEach((n)=>{
            if (n != e.target.closest(".dropdown")) n.classList.remove("active");
        });
    };
    // initial load
    (0, $35130c2d97e6777b$export$6d9c69b0de29b591)(()=>{
        // this test is here to ensure that 'api' gets loaded before
        // this may come from a transpilation issue with parceljs
        if ((0, $ba05c0ef8a781e02$export$644d8ea042df96a6) && typeof (0, $ba05c0ef8a781e02$export$644d8ea042df96a6).update === "function") (0, $ba05c0ef8a781e02$export$644d8ea042df96a6).update();
        else console.error("Could not use api.update()");
        (0, $ba05c0ef8a781e02$export$6008d97729a90c74).update();
        (0, $ba05c0ef8a781e02$export$a4ea57bd994c1f0d).update();
        // manage dropdowns
        window.addEventListener("click", (e)=>toggleDropdowns(e));
        return ()=>{
            window.removeEventListener("click", (e)=>toggleDropdowns(e));
        };
    });
    (0, $ba05c0ef8a781e02$export$3e32638432616b6).fetch().then((user)=>{
        if (location.pathname == "/") {
            let redirect = "/login";
            if (user) {
                redirect = "/create-group";
                if (user.data?.default_group) redirect = `/groups/${user?.data["default_group"]}`;
                else if (user?.groups[0]) redirect = `/groups/${user?.groups[0].id}`;
            }
            navigate(redirect);
        }
        if (location.pathname.match(/^\/invitation/)) {
            if (user) (0, $ba05c0ef8a781e02$export$7d6f1c8842f9f527).post(`/api/groups/invitation/${(0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).id}`, {}).then(()=>{
                navigate("/");
            });
            else navigate(`/signup?inviteKey=${(0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).id}`);
        }
        if (!(0, $ba05c0ef8a781e02$export$5375cda95f0b0eb4).isOutside() && !user) navigate("/login");
    });
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$3565eb3d00ca5a74), null, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/password-reset",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $7a4a2b5c7de24037$export$b44239f84c8f0268), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/public/:token",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $7a4a2b5c7de24037$export$68b4491d6924a6d1), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/share",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$c9915453de10000b), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/signup",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $7a4a2b5c7de24037$export$89200835fb4edfb9), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/stop-notification-emails",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $7a4a2b5c7de24037$export$e9e03eeea26d4dee), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/login",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $7a4a2b5c7de24037$export$21a94553ffa41578), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/logout",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$444b3ab0cb9aec40), {
            replace: true,
            to: "/login"
        })
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/:type/:id/settings",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $15e77f43f1e3331f$export$c72f6eaae7b9adff), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/bookmarks",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$9c257beea3dbd13a), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/create-group",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$1a13290ec7702c7), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/groups/:id",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$959a4441e74dcd2b), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/groups/:id/random",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $e4fc23afeade3f60$export$4b31f5af7c5f8dee), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/groups/:id/search",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $a779245c27c6d4b9$export$5cc34a6155e65c0e), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/groups/:id/write",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $017da47328f74ae1$export$29913b8f065577b2), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/messages/:id",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $19924b6e568a4f60$export$4025c8e17986f775), null)
    }), (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $405e09292ddca27f$export$e7b0ac011bb776c6), {
        path: "/messages/:id/:child_id",
        element: (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $19924b6e568a4f60$export$4025c8e17986f775), null)
    }));
}
var $c94d87274290ed2f$export$2e2bcd8739ae039 = $c94d87274290ed2f$var$App;





const $9a3e4fde01996651$var$router = (0, $4a6806eb551925a6$export$1f3f55432a00e06d)([
    {
        path: "*",
        Component: (0, $c94d87274290ed2f$export$2e2bcd8739ae039)
    }
], {
    basename: `/${document.baseURI.split("/")[3]}`
});
function $9a3e4fde01996651$var$Index() {
    return (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $5133ef8bc2964922$export$554ccc96b126a426).Provider, {
        value: (0, $5e4e939c48db0130$export$2e2bcd8739ae039)
    }, (0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)((0, $4a6806eb551925a6$export$323e4fc2fa4753fb), {
        router: $9a3e4fde01996651$var$router
    }));
}
(0, $bc4b82f252aed4aa$export$b3890eb0ae9dca99)((0, $bc4b82f252aed4aa$export$c8a8987d4410bf2d)($9a3e4fde01996651$var$Index, null), document.body);

})();
//# sourceMappingURL=index.8292cd79.js.map
